import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.calender');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import {
    getKoreaDateKey,
    getKoreaWeekEndKey,
    getKoreaWeekStartKey,
    isDateKeyInKoreaWeek,
    resolveCalendarMoveTarget
} from './calendar-navigation';
import { CalendarHolidayInfo, getCalendarHolidayInfo } from './holiday';
import {
    DEFAULT_PROJECT_GROUP_COLOR,
    DEFAULT_MILESTONE_COLOR,
    DATE_COLUMN_WIDTH_DEFAULT_PX,
    DATE_COLUMN_WIDTH_MAX_PX,
    DATE_COLUMN_WIDTH_MIN_PX,
    DATE_COLUMN_WIDTH_STEP_PX,
    GROUP_SUMMARY_COLUMN_WIDTH_PX,
    MILESTONE_ICON_OPTIONS,
    MILESTONE_SCOPE_OPTIONS,
    PROJECT_COLUMN_WIDTH_DEFAULT_PX,
    PROJECT_COLUMN_WIDTH_MAX_PX,
    PROJECT_COLUMN_WIDTH_MIN_PX,
    PROJECT_COLUMN_WIDTH_STEP_PX,
    PROJECT_HEADER_ROW_HEIGHT_DEFAULT_PX,
    PROJECT_HEADER_ROW_HEIGHT_MAX_PX,
    PROJECT_HEADER_ROW_HEIGHT_MIN_PX,
    PROJECT_HEADER_ROW_HEIGHT_STEP_PX,
    NOTE_COLUMN_WIDTH_DEFAULT_PX,
    NOTE_COLUMN_WIDTH_MAX_PX,
    NOTE_COLUMN_WIDTH_MIN_PX,
    NOTE_COLUMN_WIDTH_STEP_PX,
    PROJECT_ROW_HEADER_WIDTH_PX,
    PROJECT_ROW_HEIGHT_DEFAULT_PX,
    PROJECT_ROW_HEIGHT_MAX_PX,
    PROJECT_ROW_HEIGHT_MIN_PX,
    PROJECT_ROW_HEIGHT_STEP_PX,
    ROW_HEIGHT_DEFAULT_PX,
    ROW_HEIGHT_MAX_PX,
    ROW_HEIGHT_MIN_PX,
    ROW_HEIGHT_PRESETS,
    ROW_HEIGHT_PRESET_OPTIONS,
    SCHEDULE_CELL_COLOR_DEFAULTS,
    SCHEDULE_CELL_COLOR_PRESETS,
    SCHEDULE_QUICK_VIEW_PRESETS,
    buildScheduleTimelineData,
    buildScheduleWorkloadSummary,
    UNGROUPED_PROJECT_GROUP_ID,
    VIEW_DENSITY_OPTIONS,
    addProjectGroupToState,
    applyScheduleQuickViewPreset,
    assignProjectGroupInState,
    clampDateColumnWidthPx,
    clampProjectHeaderRowHeightPx,
    clampProjectColumnWidthPx,
    clampNoteColumnWidthPx,
    clampProjectRowHeightPx,
    clearDateColumnWidth,
    clearDateHeaderColumnWidth,
    clearProjectHeaderRowHeight,
    clearProjectRowHeight,
    clearProjectColumnWidth,
    clearNoteColumnWidth,
    clampRowHeightPx,
    clearRowHeightForDate,
    createScheduleStoragePayload,
    deleteProjectGroupFromState,
    getProjectColumnRenderItems,
    getProjectColumnWidthPx as resolveProjectColumnWidthPx,
    getNoteColumnWidthPx,
    getDateColumnWidthPx,
    getDateHeaderColumnWidthPx,
    getProjectGroupRowId,
    getProjectGroupRenderItems,
    getProjectGroupsWithUngrouped,
    getProjectHeaderRowHeightPx,
    getProjectRenderOrder,
    getProjectRowHeightPx,
    getGlobalRowHeightPx,
    getRowHeightForDate,
    getRowHeightPresetPx,
    getRowHeightPresetKeyByPx,
    getScheduleCellColorPresetColors,
    moveProjectGroupInState,
    moveProjectInGroupToIndexInState,
    moveProjectInGroupInState,
    moveUngroupedProjectInProjectList,
    moveUngroupedProjectInProjectListToIndex,
    normalizeScheduleCellColors,
    normalizeScheduleConvenienceState,
    normalizeMilestones,
    normalizeSavedScheduleViews,
    normalizeScheduleQuickViewKey,
    normalizeViewPrefs,
    setDateColumnWidth,
    setDateHeaderColumnWidth,
    setProjectHeaderRowHeight,
    setProjectColumnWidth,
    setNoteColumnWidth,
    setProjectRowHeight,
    setGlobalRowHeightPreset,
    setGlobalRowHeightPx,
    setRowHeightForDate,
    updateProjectGroupInState
} from './schedule-contract';

const SCHEDULE_LAYOUT_TABLE_DEFAULT_PERCENT = 70;
const SCHEDULE_LAYOUT_TABLE_HEIGHT_PX = 720;
const INITIAL_TODAY_LEADING_ROW_COUNT = 2;

@Component({
    selector: 'wiz-page-calender',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.calender/view.scss */
:host {
  --schedule-page-inline-padding: clamp(10px, 0.7vw, 18px);
  --schedule-page-padding-top: clamp(10px, 1.3vh, 18px);
  --schedule-page-padding-bottom: clamp(10px, 1.4vh, 18px);
  display: block;
  position: fixed;
  inset: 0;
  width: 100vw;
  min-width: 100vw;
  max-width: 100vw;
  height: 100vh;
  min-height: 100vh;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  background: #f4f6f8;
  color: #17191f;
}

.schedule-page {
  width: 100%;
  min-width: 0;
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: var(--schedule-page-padding-top) var(--schedule-page-inline-padding) var(--schedule-page-padding-bottom);
  overflow-x: hidden;
  overflow-y: hidden;
  background: linear-gradient(90deg, rgba(36, 88, 211, 0.07) 1px, transparent 1px), linear-gradient(180deg, rgba(23, 25, 31, 0.05) 1px, transparent 1px), #f4f6f8;
  background-size: 40px 40px;
}

.dashboard-access {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 28px;
  background: #f4f6f8;
}

.dashboard-access__panel {
  width: min(440px, 100%);
  display: grid;
  gap: 14px;
  padding: 24px;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 16px 40px rgba(23, 25, 31, 0.08);
}

.dashboard-access__panel h1 {
  font-size: 24px;
}

.dashboard-access__panel p:not(.schedule-eyebrow) {
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}

.schedule-header {
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  max-width: none;
  margin: 0 auto 10px;
}

.schedule-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.schedule-mark {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #2458d3;
  color: #ffffff;
  font-weight: 800;
  box-shadow: 0 10px 24px rgba(36, 88, 211, 0.22);
}

.schedule-eyebrow {
  margin: 0 0 4px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
}

h1,
h2,
p {
  margin: 0;
  letter-spacing: 0;
}

h1 {
  color: #17191f;
  font-size: 26px;
  line-height: 1.15;
  font-weight: 800;
}

.schedule-subtitle {
  margin-top: 4px;
  color: #667085;
  font-size: 13px;
}

.schedule-actions,
.schedule-essential-actions,
.project-add,
.legend {
  display: flex;
  align-items: center;
  gap: 8px;
}

.schedule-essential-actions {
  justify-content: flex-end;
  flex-wrap: wrap;
}

.schedule-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
}

.top-controls-toggle {
  display: inline-flex;
  align-items: center;
  gap: 9px;
}

.top-controls-toggle[aria-expanded=true] .project-add-chevron {
  transform: translateY(2px) rotate(225deg);
}

.schedule-history-actions {
  display: inline-grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  gap: 6px;
  padding: 4px;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.76);
}

.schedule-history-btn {
  min-width: 82px;
}

.schedule-history-count {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border-radius: 6px;
  background: #eef2f7;
  color: #475467;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.schedule-clipboard-panel {
  display: grid;
  grid-template-columns: minmax(220px, 0.9fr) auto minmax(250px, 1fr) minmax(260px, 1fr);
  align-items: stretch;
  gap: 10px;
  padding: 12px;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.06);
}

.clipboard-selection-summary {
  min-width: 0;
  display: grid;
  align-content: center;
  gap: 4px;
}

.clipboard-selection-summary span,
.clipboard-fill-field span,
.clipboard-paste-field span {
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.clipboard-selection-summary strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clipboard-selection-summary small {
  min-width: 0;
  overflow: hidden;
  color: #475467;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clipboard-selection-summary small.is-warning {
  color: #b45309;
}

.clipboard-selection-summary small.is-error {
  color: #be123c;
}

.clipboard-selection-summary small.is-success {
  color: #0f8b6f;
}

.clipboard-actions {
  display: inline-grid;
  grid-template-columns: repeat(3, auto);
  align-items: center;
  gap: 6px;
}

.clipboard-fill-field,
.clipboard-paste-field {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.clipboard-fill-field {
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
}

.clipboard-fill-field span {
  grid-column: 1/-1;
}

.clipboard-fill-field input,
.clipboard-paste-field textarea {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #fbfcfd;
  color: #17191f;
  font-size: 13px;
  outline: none;
}

.clipboard-fill-field input {
  height: 34px;
  padding: 0 10px;
}

.clipboard-paste-field textarea {
  min-height: 34px;
  max-height: 74px;
  resize: vertical;
  padding: 8px 10px;
  line-height: 1.35;
}

.clipboard-fill-field input:focus,
.clipboard-paste-field textarea:focus {
  border-color: #2458d3;
  box-shadow: 0 0 0 3px rgba(36, 88, 211, 0.12);
}

.schedule-btn {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.schedule-btn--primary {
  border-color: #2458d3;
  background: #2458d3;
  color: #ffffff;
}

.schedule-btn--secondary {
  background: #ffffff;
  color: #293241;
}

.schedule-btn--danger {
  border-color: #f1c7cd;
  background: #fff5f6;
  color: #b42335;
}

.schedule-btn:disabled {
  border-color: #d9dde5;
  background: #f2f4f7;
  color: #98a2b3;
  cursor: not-allowed;
}

.schedule-top-controls {
  width: 100%;
  flex: 0 0 auto;
  max-width: none;
  max-height: min(26vh, 248px);
  margin: 0 auto 10px;
  display: grid;
  gap: 10px;
  overflow: auto;
  overscroll-behavior: contain;
}

.top-controls-grid {
  display: grid;
  grid-template-columns: minmax(260px, 0.9fr) minmax(360px, 1.15fr) minmax(320px, 1fr);
  gap: 10px;
  align-items: stretch;
}

.top-control-card {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: #ffffff;
}

.top-control-card-head {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.top-control-card-head span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.top-control-card-head strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-control-card--actions .schedule-actions {
  justify-content: flex-start;
}

.top-control-switches {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.top-control-switch {
  min-width: 0;
  min-height: 40px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  border: 1px solid #cfd6e2;
  border-radius: 7px;
  background: #fbfcfd;
  color: #344054;
  text-align: left;
}

.top-control-switch strong,
.top-control-switch span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-control-switch strong {
  font-size: 12px;
  font-weight: 900;
}

.top-control-switch span {
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.top-control-switch.is-active {
  border-color: #9db7f6;
  background: #eef6ff;
  color: #1d4ed8;
  box-shadow: inset 0 0 0 1px rgba(36, 88, 211, 0.12);
}

.top-control-switch.is-active span {
  color: #1d4ed8;
}

.top-control-card--cell-colors {
  grid-column: 1/-1;
}

.cell-color-preset-row {
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.cell-color-preset {
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #fbfcfd;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.cell-color-preset.is-active {
  border-color: #2458d3;
  background: #edf5ff;
  color: #1d4ed8;
  box-shadow: inset 0 0 0 1px rgba(36, 88, 211, 0.12);
}

.cell-color-preset:focus-visible,
.cell-color-input:focus-visible,
.cell-color-reset:focus-visible {
  outline: 2px solid rgba(36, 88, 211, 0.32);
  outline-offset: 2px;
}

.cell-color-control-grid {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.cell-color-control {
  min-width: 0;
  min-height: 38px;
  display: grid;
  grid-template-columns: minmax(72px, 1fr) 34px minmax(58px, auto) auto;
  align-items: center;
  gap: 7px;
  padding: 5px 6px;
  border: 1px solid #d9dde5;
  border-radius: 7px;
  background: #fbfcfd;
}

.cell-color-control.is-custom {
  border-color: #9db7f6;
  background: #f5f9ff;
}

.cell-color-label {
  min-width: 0;
  overflow: hidden;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-color-input {
  width: 34px;
  height: 28px;
  padding: 2px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
}

.cell-color-value {
  min-width: 0;
  overflow: hidden;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-color-reset {
  min-height: 26px;
  padding: 0 7px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
}

.cell-color-reset:disabled {
  color: #c7cdd6;
  border-color: #e5e9f0;
  background: #f6f7f9;
  cursor: not-allowed;
}

.cell-color-actions {
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.cell-color-feedback {
  min-width: 0;
  color: #667085;
  font-size: 12px;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-color-feedback.is-success {
  color: #0f8b6f;
}

.cell-color-feedback.is-warning {
  color: #b45309;
}

.cell-color-feedback.is-error {
  color: #be123c;
}

.schedule-top-controls .schedule-summary {
  max-width: none;
  margin: 0;
}

.schedule-summary {
  max-width: none;
  margin: 0 auto 10px;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}

.schedule-summary-head {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
}

.schedule-summary-title {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.schedule-summary-title span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.schedule-summary-title strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-summary-actions {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.summary-status-badge {
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  border: 1px solid #cfd6e2;
  border-radius: 999px;
  background: #f8fafc;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.summary-status-badge.is-server {
  border-color: #a7d9c5;
  background: #effbf5;
  color: #087f5b;
}

.summary-status-badge.is-local,
.summary-status-badge.is-error {
  border-color: #f0b4bd;
  background: #fff5f6;
  color: #b42335;
}

.summary-status-badge.is-saving,
.summary-status-badge.is-retrying,
.summary-status-badge.is-checking {
  border-color: #b9c9f6;
  background: #f4f7ff;
  color: #2458d3;
}

.summary-toggle {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  flex: 0 0 auto;
  padding: 0 13px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #293241;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.summary-toggle:focus {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
  outline: none;
}

.schedule-summary.is-expanded .summary-toggle .project-add-chevron {
  transform: translateY(2px) rotate(225deg);
}

.schedule-summary-panel {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  border-top: 1px solid #edf0f4;
}

.summary-item {
  min-width: 0;
  display: grid;
  gap: 3px;
  padding: 9px 12px;
  border-right: 1px solid #edf0f4;
}

.summary-item:last-child {
  border-right: 0;
}

.summary-item span {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.summary-item strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-item small {
  min-width: 0;
  overflow: hidden;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-item--sync {
  align-content: start;
}

.sync-status-line {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sync-status-line strong {
  min-width: 0;
  flex: 1 1 auto;
}

.sync-retry-button {
  min-height: 24px;
  flex: 0 0 auto;
  padding: 0 8px;
  border: 1px solid #f0b4bd;
  border-radius: 6px;
  background: #fff5f6;
  color: #b42335;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.sync-retry-button:focus {
  border-color: #b42335;
  box-shadow: 0 0 0 2px rgba(180, 35, 53, 0.14);
  outline: none;
}

.summary-item--sync .sync-detail {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: clip;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.summary-item--sync.is-server strong {
  color: #087f5b;
}

.summary-item--sync.is-local strong {
  color: #b45309;
}

.summary-item--sync.is-error strong {
  color: #b42335;
}

.summary-item--sync.is-saving strong,
.summary-item--sync.is-retrying strong,
.summary-item--sync.is-checking strong {
  color: #2458d3;
}

.schedule-projects {
  position: fixed;
  inset: 0;
  z-index: 90;
  display: grid;
  place-items: center;
  padding: 32px 24px;
  border: 0;
  background: rgba(15, 23, 42, 0.38);
  box-sizing: border-box;
}

.project-management-backdrop {
  position: absolute;
  inset: 0;
  z-index: 0;
  border: 0;
  background: transparent;
}

.project-management-window {
  position: relative;
  z-index: 1;
  width: min(1180px, 100vw - 48px);
  max-height: min(84vh, 100vh - 64px, 900px);
  max-height: min(84dvh, 100dvh - 64px, 900px);
  min-height: min(560px, 100vh - 64px);
  min-height: min(560px, 100dvh - 64px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #cfd6e2;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.22);
}

.project-management-head {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid #edf0f4;
}

.project-management-title {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.project-management-title span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.project-management-title strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-management-meta {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.project-management-meta span {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.project-management-toggle {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  flex: 0 0 auto;
  padding: 0 13px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #293241;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.project-management-toggle:focus {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
  outline: none;
}

.schedule-projects.is-expanded .project-management-head .project-add-chevron {
  transform: translateY(2px) rotate(225deg);
}

.project-management-panel {
  min-width: 0;
  flex: 1 1 auto;
  display: grid;
  gap: 14px;
  min-height: 0;
  padding: 16px 18px 18px;
  overflow: auto;
  overscroll-behavior: contain;
}

.project-management-panel .project-add-card {
  margin-bottom: 0;
}

.schedule-utility-dialog {
  position: fixed;
  inset: 0;
  z-index: 88;
  display: grid;
  place-items: center;
  padding: 32px 24px;
  border: 0;
  background: rgba(15, 23, 42, 0.34);
  box-sizing: border-box;
}

.utility-dialog-window {
  width: min(1040px, 100vw - 48px);
  min-height: min(420px, 100vh - 64px);
  min-height: min(420px, 100dvh - 64px);
  max-height: min(82vh, 100vh - 64px, 860px);
  max-height: min(82dvh, 100dvh - 64px, 860px);
}

.utility-dialog-window--compact {
  width: min(780px, 100vw - 48px);
  min-height: auto;
}

.utility-dialog-window--planner,
.utility-dialog-window--transfer,
.utility-dialog-window--group {
  width: min(1240px, 100vw - 48px);
}

.utility-dialog-head {
  grid-template-columns: minmax(0, 1fr) auto;
}

.utility-dialog-title strong {
  white-space: normal;
}

.utility-dialog-panel {
  gap: 14px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: #f8fafc;
}

.utility-dialog-panel > .schedule-row-density,
.utility-dialog-panel > .schedule-bulk-tools,
.utility-dialog-panel > .schedule-quick-filters,
.utility-dialog-panel > .schedule-saved-views,
.utility-dialog-panel > .schedule-filters,
.utility-dialog-panel > .schedule-planner-summary,
.utility-dialog-panel > .schedule-view-options,
.utility-dialog-panel > .schedule-group-manager,
.utility-dialog-panel > .schedule-transfer {
  margin: 0;
  border: 1px solid #e4e7ec;
  box-shadow: none;
}

.project-add {
  flex-wrap: wrap;
}

.project-add-card {
  display: grid;
  gap: 10px;
  margin-bottom: 14px;
}

.project-add-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.project-add-card-title {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.project-add-card-title span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.project-add-card-title strong {
  color: #17191f;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
}

.project-add-toggle {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  flex: 0 0 auto;
  padding: 0 13px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #293241;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.project-add-toggle:focus {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
  outline: none;
}

.project-add-chevron {
  width: 8px;
  height: 8px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: translateY(-2px) rotate(45deg);
  transition: transform 0.18s ease;
}

.project-add-card.is-expanded .project-add-chevron {
  transform: translateY(2px) rotate(225deg);
}

.project-add-panel {
  min-width: 0;
  display: grid;
  gap: 10px;
  padding-top: 10px;
  border-top: 1px solid #edf0f4;
}

.project-add input,
.project-chip input,
.project-chip textarea {
  min-height: 36px;
  border: 1px solid #d9dde5;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  outline: none;
}

.project-add input {
  width: 160px;
  padding: 0 10px;
}

.project-add input:first-child {
  width: 220px;
}

.project-color-picker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.project-color-picker span,
.project-color-picker small {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.color-swatch-list {
  display: flex;
  align-items: center;
  gap: 6px;
}

.color-swatch {
  width: 24px;
  height: 24px;
  border: 2px solid transparent;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
}

.color-swatch.active {
  border-color: #17191f;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.8), 0 0 0 2px rgba(36, 88, 211, 0.18);
}

.project-feedback {
  min-height: 18px;
  margin: 0;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.project-feedback.is-error {
  color: #b42335;
}

.project-feedback.is-warning {
  color: #b45309;
}

.project-feedback.is-success {
  color: #0f8b6f;
}

.project-add input:focus,
.project-chip input:focus,
.project-chip textarea:focus,
.group-field input:focus,
.group-field select:focus,
.group-edit-item input:focus,
.group-assignment-row select:focus,
.saved-view-name-field input:focus,
.saved-view-main:focus-visible,
.saved-view-delete:focus-visible,
.project-visibility-toggle:focus-visible,
.project-column-order-btn:focus-visible,
.project-column-width-nudge:focus-visible,
.project-row-height-reset:focus-visible,
.project-management-row-height-field input:focus,
.schedule-cell-input:focus,
.schedule-note-input:focus,
.schedule-cell-preview:focus,
.cell-detail-open-button:focus,
.cell-detail-textarea:focus,
.cell-detail-select select:focus,
.time-field input:focus,
.dependency-field input:focus,
.dependency-field select:focus,
.cell-dependency-toggle:focus,
.time-clear-button:focus,
.dependency-clear-button:focus,
.empty-cell-button:focus,
.date-row-height-select:focus,
.mobile-row-height-select:focus,
.date-column-resize-handle:focus-visible,
.date-row-height-drag-handle:focus-visible {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
}

.project-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.project-management-window .project-list {
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
}

.project-list.is-dragging {
  user-select: none;
}

.project-chip {
  position: relative;
  display: grid;
  grid-template-columns: 28px 28px 28px 76px 150px 86px 86px 44px 54px 62px 28px;
  align-items: center;
  gap: 7px;
  min-height: 44px;
  padding: 6px 7px;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  background: #fbfcfd;
}

.project-management-window .project-chip {
  width: 100%;
  box-sizing: border-box;
}

.project-chip.is-dragging {
  opacity: 0.58;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.16);
}

.project-chip.is-drop-before::before,
.project-chip.is-drop-after::after {
  content: "";
  position: absolute;
  top: -5px;
  bottom: -5px;
  z-index: 2;
  width: 3px;
  border-radius: 999px;
  background: #2458d3;
  box-shadow: 0 0 0 3px rgba(36, 88, 211, 0.14);
}

.project-chip.is-drop-before::before {
  left: -6px;
}

.project-chip.is-drop-after::after {
  right: -6px;
}

.project-chip.is-hidden {
  border-style: dashed;
  background: #f6f7f9;
}

.project-drag-handle {
  width: 28px;
  height: 28px;
  display: inline-grid;
  place-items: center;
  border: 1px solid #d9dde5;
  border-radius: 6px;
  background: #ffffff;
  color: #667085;
  cursor: grab;
  font-size: 15px;
  font-weight: 900;
  line-height: 1;
  touch-action: none;
}

.project-drag-handle:active {
  cursor: grabbing;
}

.project-drag-handle:focus-visible {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
  outline: none;
}

.project-color {
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6), 0 0 0 1px rgba(17, 24, 39, 0.08);
}

.project-favorite-toggle {
  width: 28px;
  height: 28px;
  display: inline-grid;
  place-items: center;
  border: 1px solid #d9dde5;
  border-radius: 6px;
  background: #ffffff;
  color: #98a2b3;
  font-size: 15px;
  line-height: 1;
}

.project-favorite-toggle.is-active {
  border-color: #f5c84c;
  background: #fff8db;
  color: #9a6700;
  box-shadow: inset 0 0 0 1px rgba(245, 200, 76, 0.22);
}

.project-favorite-toggle:focus-visible {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
  outline: none;
}

.project-visibility-toggle {
  min-width: 0;
  min-height: 28px;
  padding: 0 8px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.project-visibility-toggle.is-hidden {
  border-color: #b9cffd;
  background: #eef4ff;
  color: #1f4fbf;
}

.project-chip input {
  min-width: 0;
  width: 100%;
  padding: 0 8px;
}

.project-chip textarea {
  grid-column: 1/-1;
  min-width: 0;
  width: 100%;
  min-height: 48px;
  resize: vertical;
  padding: 7px 8px;
  line-height: 1.35;
}

.project-visibility-state {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 6px;
  border-radius: 6px;
  background: #f2f4f7;
  color: #667085;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.project-chip.is-hidden .project-visibility-state {
  background: #e6eefc;
  color: #1f4fbf;
}

.project-schedule-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 6px;
  border-radius: 6px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.project-dependency-count {
  position: absolute;
  top: -8px;
  right: 104px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 20px;
  max-width: 120px;
  padding: 0 7px;
  border-radius: 6px;
  background: #fff7e6;
  color: #b45309;
  font-size: 11px;
  font-weight: 900;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: 0 0 0 1px rgba(180, 83, 9, 0.15);
}

.project-column-order-actions {
  display: grid;
  grid-template-columns: repeat(2, 28px);
  gap: 4px;
}

.project-column-order-btn {
  width: 28px;
  height: 28px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
}

.project-column-order-btn:disabled {
  color: #c7cdd6;
  border-color: #e5e9f0;
  background: #f6f7f9;
  cursor: not-allowed;
}

.project-management-row-height-field {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 54px minmax(120px, 1fr) 54px;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding-top: 3px;
}

.project-management-row-height-field > span {
  color: #667085;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.project-management-row-height-field input[type=range] {
  min-width: 0;
  width: 100%;
  min-height: 28px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  accent-color: #2458d3;
}

.chip-delete {
  width: 28px;
  height: 28px;
  border: 1px solid #f1c7cd;
  border-radius: 6px;
  background: #ffffff;
  color: #b42335;
  font-size: 18px;
  line-height: 1;
}

.chip-delete:disabled {
  color: #c7cdd6;
  border-color: #e5e9f0;
  cursor: not-allowed;
}

.schedule-workbench {
  width: 100%;
  max-width: none;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: 0 auto;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(17, 24, 39, 0.09);
}

.schedule-utility-stack {
  --schedule-utility-collapsed-height: 56px;
  flex: 0 0 auto;
  min-height: 0;
  display: grid;
  gap: 0;
  max-height: var(--schedule-utility-collapsed-height) !important;
  overflow: hidden !important;
  border-top: 1px solid #d9dde5;
  background: #ffffff;
}

.schedule-utility-stack.has-open-panel {
  max-height: min(30vh, 300px) !important;
  max-height: min(30dvh, 300px) !important;
  overflow: auto !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
}

.schedule-utility-stack:not(.has-open-panel) > :not(.schedule-utility-strip),
.schedule-utility-stack > .schedule-row-density:not(.is-expanded),
.schedule-utility-stack > .schedule-bulk-tools:not(.is-expanded),
.schedule-utility-stack > .schedule-quick-filters:not(.is-expanded),
.schedule-utility-stack > .schedule-saved-views:not(.is-expanded),
.schedule-utility-stack > .schedule-filters:not(.is-expanded),
.schedule-utility-stack > .schedule-planner-summary:not(.is-expanded),
.schedule-utility-stack > .schedule-transfer:not(.is-expanded),
.schedule-utility-stack > .schedule-projects:not(.is-expanded) {
  display: none !important;
}

.schedule-utility-stack:not(.has-open-panel) .row-density-panel-body,
.schedule-utility-stack:not(.has-open-panel) .row-density-control,
.schedule-utility-stack:not(.has-open-panel) .schedule-clipboard-panel,
.schedule-utility-stack:not(.has-open-panel) .clipboard-selection-summary,
.schedule-utility-stack:not(.has-open-panel) .clipboard-actions,
.schedule-utility-stack:not(.has-open-panel) .clipboard-fill-field,
.schedule-utility-stack:not(.has-open-panel) .clipboard-paste-field,
.schedule-utility-stack:not(.has-open-panel) .schedule-quick-filters,
.schedule-utility-stack:not(.has-open-panel) .quick-filter-grid,
.schedule-utility-stack:not(.has-open-panel) .quick-filter-field,
.schedule-utility-stack:not(.has-open-panel) .favorite-filter-main,
.schedule-utility-stack:not(.has-open-panel) .favorite-project-shortcuts,
.schedule-utility-stack:not(.has-open-panel) .favorite-project-chip,
.schedule-utility-stack:not(.has-open-panel) .favorite-empty,
.schedule-utility-stack:not(.has-open-panel) .quick-filter-options,
.schedule-utility-stack:not(.has-open-panel) .quick-filter-option,
.schedule-utility-stack:not(.has-open-panel) .active-filter-chips,
.schedule-utility-stack:not(.has-open-panel) .active-filter-chip,
.schedule-utility-stack:not(.has-open-panel) .schedule-saved-views,
.schedule-utility-stack:not(.has-open-panel) .saved-view-head,
.schedule-utility-stack:not(.has-open-panel) .saved-view-actions,
.schedule-utility-stack:not(.has-open-panel) .saved-view-name-field,
.schedule-utility-stack:not(.has-open-panel) .saved-view-list,
.schedule-utility-stack:not(.has-open-panel) .saved-view-item,
.schedule-utility-stack:not(.has-open-panel) .saved-view-empty,
.schedule-utility-stack:not(.has-open-panel) .schedule-filters,
.schedule-utility-stack:not(.has-open-panel) .filter-control,
.schedule-utility-stack:not(.has-open-panel) .filter-reset,
.schedule-utility-stack:not(.has-open-panel) .filter-panel-close,
.schedule-utility-stack:not(.has-open-panel) .filter-result,
.schedule-utility-stack:not(.has-open-panel) .selected-project-view,
.schedule-utility-stack:not(.has-open-panel) .schedule-planner-summary,
.schedule-utility-stack:not(.has-open-panel) .planner-summary-grid,
.schedule-utility-stack:not(.has-open-panel) .planner-timeline-panel,
.schedule-utility-stack:not(.has-open-panel) .planner-workload-panel,
.schedule-utility-stack:not(.has-open-panel) .planner-timeline-list,
.schedule-utility-stack:not(.has-open-panel) .planner-workload-list,
.schedule-utility-stack:not(.has-open-panel) .schedule-transfer,
.schedule-utility-stack:not(.has-open-panel) .schedule-transfer-head,
.schedule-utility-stack:not(.has-open-panel) .schedule-transfer-body,
.schedule-utility-stack:not(.has-open-panel) .schedule-transfer-panel,
.schedule-utility-stack:not(.has-open-panel) .schedule-projects,
.schedule-utility-stack:not(.has-open-panel) .project-management-head,
.schedule-utility-stack:not(.has-open-panel) .project-management-panel,
.schedule-utility-stack:not(.has-open-panel) .project-add-card,
.schedule-utility-stack:not(.has-open-panel) .project-list {
  display: none !important;
  visibility: hidden !important;
  height: 0 !important;
  min-height: 0 !important;
  max-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  overflow: hidden !important;
}

.schedule-utility-stack > :last-child {
  border-bottom: 0;
}

.schedule-utility-strip {
  position: relative;
  z-index: 96;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(8, minmax(104px, 1fr));
  gap: 6px;
  padding: 8px 10px;
  border-bottom: 1px solid #d9dde5;
  background: #f8fafc;
}

.utility-strip-button {
  min-width: 0;
  min-height: 38px;
  display: grid;
  align-content: center;
  gap: 2px;
  padding: 5px 8px;
  overflow: hidden;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  text-align: left;
}

.utility-strip-button strong,
.utility-strip-button span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.utility-strip-button strong {
  color: #17191f;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.15;
}

.utility-strip-button span {
  color: #667085;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.15;
}

.utility-strip-button.is-active {
  border-color: #9db7f6;
  background: #eef6ff;
  box-shadow: inset 0 0 0 1px rgba(36, 88, 211, 0.12);
}

.utility-strip-button.is-active strong,
.utility-strip-button.is-active span {
  color: #1d4ed8;
}

.schedule-row-density,
.schedule-bulk-tools,
.schedule-planner-summary {
  display: grid;
  gap: 8px;
  padding: 9px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #ffffff;
}

.utility-toggle-head {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.utility-toggle-head > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.utility-toggle-head strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.utility-panel-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
}

.schedule-row-density.is-expanded .utility-panel-toggle .project-add-chevron,
.schedule-bulk-tools.is-expanded .utility-panel-toggle .project-add-chevron,
.schedule-planner-summary.is-expanded .utility-panel-toggle .project-add-chevron,
.schedule-quick-filters.is-expanded .utility-panel-toggle .project-add-chevron,
.schedule-saved-views.is-expanded .utility-panel-toggle .project-add-chevron,
.schedule-filters.is-expanded .utility-panel-toggle .project-add-chevron {
  transform: translateY(2px) rotate(225deg);
}

.row-density-panel-body {
  min-width: 0;
  padding-top: 2px;
}

.schedule-toolbar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #fbfcfd;
}

.schedule-toolbar h2 {
  color: #17191f;
  font-size: 16px;
  font-weight: 800;
}

.schedule-toolbar-heading {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.schedule-toolbar p {
  margin-top: 2px;
  color: #667085;
  font-size: 12px;
}

.schedule-mobile-context {
  display: none;
}

.schedule-mobile-filter-strip {
  display: none;
}

.schedule-view-controls {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px 10px;
}

.active-cell-coordinate {
  min-width: 0;
  max-width: 280px;
  min-height: 28px;
  display: inline-grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
}

.active-cell-coordinate span {
  color: #667085;
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
}

.active-cell-coordinate strong {
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active-cell-coordinate.is-empty {
  background: #f6f8fb;
  color: #667085;
}

.schedule-quick-view-strip {
  min-width: 0;
  display: inline-grid;
  grid-template-columns: repeat(5, minmax(54px, 1fr));
  align-items: center;
  gap: 3px;
  padding: 2px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #eef2f7;
}

.schedule-quick-view-option {
  min-width: 0;
  min-height: 28px;
  padding: 0 8px;
  overflow: hidden;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-quick-view-option.is-active {
  background: #2458d3;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(36, 88, 211, 0.22);
}

.schedule-quick-view-option:focus-visible {
  outline: 2px solid rgba(36, 88, 211, 0.35);
  outline-offset: 2px;
}

.schedule-mobile-filter-option {
  min-width: 0;
  min-height: 44px;
  padding: 0 10px;
  overflow: hidden;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #ffffff;
  color: #344054;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-mobile-filter-option.is-active {
  border-color: #2458d3;
  background: #2458d3;
  color: #ffffff;
}

.schedule-mobile-filter-option:focus-visible {
  outline: 2px solid rgba(36, 88, 211, 0.35);
  outline-offset: 2px;
}

.row-density-control {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(220px, 280px) auto auto;
  align-items: center;
  gap: 6px;
  padding: 5px 6px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #fbfcfd;
}

.row-height-control {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.row-height-control > span {
  flex: 0 0 auto;
  color: #667085;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.row-height-segment {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #eef2f7;
}

.row-height-option {
  min-width: 54px;
  min-height: 28px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #344054;
  font-size: 12px;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-height-option.is-active {
  background: #2458d3;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(36, 88, 211, 0.22);
}

.row-height-option:focus-visible {
  outline: 2px solid rgba(36, 88, 211, 0.35);
  outline-offset: 2px;
}

.row-height-direct {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(84px, 1fr) auto;
  align-items: center;
  gap: 5px;
}

.row-height-direct > span,
.density-inline-control > span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.row-height-direct input[type=range] {
  min-width: 0;
  width: 100%;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  accent-color: #2458d3;
}

.row-height-direct small {
  min-width: 44px;
  color: #344054;
  font-size: 11px;
  font-weight: 900;
  text-align: right;
  white-space: nowrap;
}

.density-inline-control {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.density-inline-segment {
  min-width: 0;
  display: inline-grid;
  grid-template-columns: repeat(3, minmax(58px, 1fr));
  gap: 3px;
  padding: 2px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #eef2f7;
}

.density-inline-option {
  min-width: 0;
  min-height: 28px;
  padding: 0 7px;
  overflow: hidden;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.density-inline-option.is-active {
  background: #0f8b6f;
  color: #ffffff;
  box-shadow: 0 5px 14px rgba(15, 139, 111, 0.2);
}

.density-inline-option:focus-visible {
  outline: 2px solid rgba(15, 139, 111, 0.3);
  outline-offset: 2px;
}

.row-density-reset {
  min-height: 32px;
  padding: 0 9px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.row-density-reset:disabled {
  color: #c7cdd6;
  border-color: #e5e9f0;
  background: #f6f7f9;
  cursor: not-allowed;
}

.calendar-jump-control {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.calendar-jump-control > span {
  flex: 0 0 auto;
  color: #667085;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.calendar-jump-options {
  min-width: 0;
  display: inline-grid;
  grid-template-columns: repeat(2, minmax(62px, 1fr));
  gap: 4px;
  padding: 2px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #eef2f7;
}

.calendar-jump-option {
  min-width: 0;
  min-height: 28px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #344054;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.calendar-jump-option.is-active {
  background: #0f8b6f;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(15, 139, 111, 0.2);
}

.calendar-jump-option:focus-visible {
  outline: 2px solid rgba(15, 139, 111, 0.32);
  outline-offset: 2px;
}

.legend {
  flex-wrap: wrap;
  justify-content: flex-end;
}

.legend-chip {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.legend-chip--today {
  background: var(--schedule-color-today-cell, #dbeafe);
  color: var(--schedule-color-status-badge-text, #1d4ed8);
}

.legend-chip--holiday {
  background: var(--schedule-color-holiday-cell, #fff1f2);
  color: var(--schedule-color-dependency-badge-text, #be123c);
}

.legend-chip--task {
  background: var(--schedule-color-filled-cell, #e7f5ef);
  color: var(--schedule-color-type-badge-text, #087f5b);
}

.legend-chip--milestone {
  background: var(--schedule-color-milestone-badge, #f5efff);
  color: var(--schedule-color-milestone-badge-text, #6d28d9);
}

.legend-chip--dependency {
  background: var(--schedule-color-time-badge, #fff7e6);
  color: var(--schedule-color-time-badge-text, #b45309);
}

.schedule-detail-toggle {
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 11px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.schedule-detail-toggle.is-active {
  border-color: #2458d3;
  background: #edf5ff;
  color: #1d4ed8;
}

.group-panel-toggle {
  flex: 0 0 auto;
}

.view-options-toggle {
  flex: 0 0 auto;
}

.schedule-view-options {
  padding: 10px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #ffffff;
}

.schedule-navigation-feedback {
  padding: 8px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #eef6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.45;
}

.schedule-history-feedback {
  padding: 8px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #eef6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.45;
}

.schedule-navigation-feedback.is-warning {
  background: #fff7e6;
  color: #b45309;
}

.schedule-history-feedback.is-warning {
  background: #fff7e6;
  color: #b45309;
}

.schedule-navigation-feedback.is-error {
  background: #fff1f2;
  color: #be123c;
}

.schedule-history-feedback.is-error {
  background: #fff1f2;
  color: #be123c;
}

.schedule-history-feedback.is-success {
  background: #e7f5ef;
  color: #087f5b;
}

.view-options-grid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.view-option-toggle {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 0 12px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #fbfcfd;
  color: #344054;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  user-select: none;
}

.view-option-toggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.view-option-switch {
  width: 32px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: 999px;
  background: #cfd6e2;
  transition: background 0.14s ease;
}

.view-option-switch::before {
  content: "";
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(23, 25, 31, 0.22);
  transition: transform 0.14s ease;
}

.view-option-toggle.is-active {
  border-color: #9db7f6;
  background: #eef6ff;
  color: #1d4ed8;
}

.view-option-toggle.is-active .view-option-switch {
  background: #2458d3;
}

.view-option-toggle.is-active .view-option-switch::before {
  transform: translateX(14px);
}

.view-option-toggle:focus-within {
  outline: 2px solid rgba(36, 88, 211, 0.35);
  outline-offset: 2px;
}

.view-option-label {
  white-space: nowrap;
}

.cell-density-control {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 38px;
  padding: 0 12px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #fbfcfd;
}

.cell-density-control > .view-option-label {
  color: #344054;
  font-size: 13px;
  font-weight: 800;
}

.cell-density-segment {
  min-width: 0;
  display: inline-grid;
  grid-template-columns: repeat(3, minmax(46px, 1fr));
  gap: 3px;
  padding: 2px;
  border: 1px solid #cfd6e2;
  border-radius: 7px;
  background: #eef2f7;
}

.cell-density-option {
  min-width: 0;
  min-height: 28px;
  padding: 0 8px;
  overflow: hidden;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-density-option.is-active {
  background: #2458d3;
  color: #ffffff;
  box-shadow: 0 5px 14px rgba(36, 88, 211, 0.2);
}

.cell-density-option:focus-visible {
  outline: 2px solid rgba(36, 88, 211, 0.35);
  outline-offset: 2px;
}

.schedule-quick-filters {
  display: grid;
  grid-template-columns: minmax(250px, 0.34fr) minmax(0, 1fr);
  align-items: end;
  gap: 8px 12px;
  padding: 10px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #fbfcfd;
}

.quick-filter-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.quick-filter-head > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.quick-filter-head strong {
  color: #17191f;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
}

.quick-filter-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.quick-filter-reset:disabled {
  color: #98a2b3;
  background: #f8fafc;
  cursor: not-allowed;
}

.quick-filter-grid {
  display: grid;
  grid-template-columns: minmax(260px, 1.2fr) minmax(250px, 1fr) minmax(220px, 0.8fr) minmax(220px, 0.8fr);
  align-items: end;
  gap: 8px;
}

.quick-filter-field {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.quick-filter-field > span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.quick-filter-options {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(62px, 1fr));
  gap: 6px;
}

.quick-filter-field--favorite {
  align-self: stretch;
}

.favorite-filter-main {
  display: grid;
  gap: 6px;
}

.quick-filter-option--favorite,
.quick-filter-option--milestone {
  display: grid;
  align-content: center;
  gap: 1px;
  text-align: left;
}

.quick-filter-option--favorite small,
.quick-filter-option--milestone small {
  min-width: 0;
  overflow: hidden;
  color: #667085;
  font-size: 10px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quick-filter-option--favorite.is-active small,
.quick-filter-option--milestone.is-active small {
  color: #1d4ed8;
}

.quick-filter-option--favorite:disabled,
.quick-filter-option--milestone:disabled {
  background: #f8fafc;
  color: #98a2b3;
  cursor: not-allowed;
}

.favorite-project-shortcuts {
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.favorite-project-chip {
  min-width: 0;
  max-width: 158px;
  min-height: 28px;
  display: inline-grid;
  grid-template-columns: 8px minmax(0, 1fr) auto;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border: 1px solid #cfd6e2;
  border-radius: 999px;
  background: #ffffff;
  color: #344054;
  font-size: 12px;
  font-weight: 800;
}

.favorite-project-chip i {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}

.favorite-project-chip span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.favorite-project-chip small {
  color: #667085;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.favorite-project-chip.is-active {
  border-color: #9db7f6;
  background: #eef6ff;
  color: #1d4ed8;
}

.favorite-empty {
  margin: 6px 0 0;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
}

.quick-filter-option {
  min-width: 0;
  min-height: 32px;
  padding: 0 9px;
  overflow: hidden;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quick-filter-option.is-active {
  border-color: #9db7f6;
  background: #eef6ff;
  color: #1d4ed8;
  box-shadow: inset 0 0 0 1px rgba(36, 88, 211, 0.12);
}

.quick-filter-field select {
  width: 100%;
  min-width: 0;
  height: 32px;
  padding: 0 34px 0 11px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  outline: none;
}

.quick-filter-option:focus-visible,
.quick-filter-field select:focus {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
}

.active-filter-chips {
  grid-column: 1/-1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.active-filter-chip {
  min-width: 0;
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  padding: 0 9px;
  border: 1px solid #b9cffd;
  border-radius: 999px;
  background: #eef6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
}

.active-filter-chip span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active-filter-chip i {
  flex: 0 0 auto;
  font-style: normal;
  font-size: 14px;
  line-height: 1;
}

.schedule-saved-views {
  display: grid;
  grid-template-columns: minmax(250px, 0.34fr) minmax(280px, 0.5fr) minmax(0, 1fr);
  align-items: start;
  gap: 10px 12px;
  padding: 10px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #ffffff;
}

.saved-view-head {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px;
}

.saved-view-head > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.saved-view-head strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saved-view-head small {
  min-width: 0;
  display: -webkit-box;
  overflow: hidden;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.saved-view-feedback {
  grid-column: 1/-1;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  padding: 0 9px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.25;
}

.saved-view-feedback.is-error {
  background: #fff1f2;
  color: #be123c;
}

.saved-view-feedback.is-warning {
  background: #fff7e6;
  color: #b45309;
}

.saved-view-feedback.is-success {
  background: #e7f5ef;
  color: #087f5b;
}

.saved-view-panel-close {
  align-self: start;
  justify-self: end;
}

.saved-view-actions {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(160px, 1fr) auto;
  align-items: end;
  gap: 8px;
}

.saved-view-name-field {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.saved-view-name-field span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.saved-view-name-field input {
  width: 100%;
  min-width: 0;
  height: 34px;
  padding: 0 11px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  outline: none;
}

.saved-view-list {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 8px;
}

.saved-view-item {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: stretch;
  overflow: hidden;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  background: #fbfcfd;
}

.saved-view-item.is-active {
  border-color: #9db7f6;
  background: #eef6ff;
  box-shadow: inset 0 0 0 1px rgba(36, 88, 211, 0.12);
}

.saved-view-main {
  min-width: 0;
  display: grid;
  gap: 3px;
  padding: 8px 10px;
  border: 0;
  background: transparent;
  text-align: left;
}

.saved-view-main strong,
.saved-view-main span,
.saved-view-main small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saved-view-main strong {
  color: #17191f;
  font-size: 13px;
  font-weight: 900;
}

.saved-view-main span {
  color: #475467;
  font-size: 12px;
  font-weight: 800;
}

.saved-view-main small {
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.saved-view-delete {
  min-width: 52px;
  padding: 0 8px;
  border: 0;
  border-left: 1px solid #e2e6ee;
  background: #ffffff;
  color: #b42335;
  font-size: 12px;
  font-weight: 800;
}

.saved-view-empty {
  min-width: 0;
  padding: 9px 11px;
  border: 1px dashed #cfd6e2;
  border-radius: 8px;
  background: #fbfcfd;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.planner-summary-grid {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(420px, 1.4fr) minmax(320px, 0.9fr);
  gap: 12px;
  padding-top: 4px;
}

.planner-timeline-panel,
.planner-workload-panel {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 8px;
  padding: 10px;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  background: #fbfcfd;
}

.planner-panel-head {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.planner-panel-head > div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.planner-panel-head span,
.planner-panel-head small {
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.planner-panel-head strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.planner-timeline-axis,
.planner-timeline-lane,
.planner-common-milestones {
  position: relative;
  min-width: 0;
}

.planner-timeline-axis {
  height: 22px;
  border-bottom: 1px solid #d9dde5;
}

.planner-axis-label {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  color: #667085;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.planner-axis-label:first-child {
  transform: translateX(0);
}

.planner-axis-label:last-child {
  transform: translateX(-100%);
}

.planner-common-milestones {
  min-height: 26px;
}

.planner-common-milestone {
  position: absolute;
  top: 2px;
  max-width: 150px;
  min-height: 22px;
  transform: translateX(-50%);
  padding: 0 7px;
  overflow: hidden;
  border: 1px solid #7c3aed;
  border-radius: 999px;
  background: #ffffff;
  color: #5b21b6;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.planner-timeline-list,
.planner-workload-list {
  min-width: 0;
  display: grid;
  gap: 7px;
  max-height: 184px;
  overflow: auto;
  padding-right: 2px;
}

.planner-timeline-row {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(150px, 0.34fr) minmax(260px, 1fr);
  align-items: center;
  gap: 10px;
  min-height: 42px;
}

.planner-timeline-project {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.planner-timeline-project strong,
.planner-workload-person strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.planner-timeline-project span,
.planner-workload-person span {
  min-width: 0;
  overflow: hidden;
  color: #667085;
  font-size: 10px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.planner-timeline-lane {
  height: 30px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(102, 112, 133, 0.14) 1px, transparent 1px), #ffffff;
  background-size: 25% 100%;
  box-shadow: inset 0 0 0 1px #e2e6ee;
}

.planner-timeline-bar {
  position: absolute;
  top: 7px;
  height: 16px;
  min-width: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 999px;
  background: var(--planner-project-color, #2458d3);
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}

.planner-timeline-bar span {
  min-width: 0;
  overflow: hidden;
  padding: 0 6px;
  text-overflow: ellipsis;
}

.planner-milestone-marker,
.planner-dependency-marker {
  position: absolute;
  top: 4px;
  width: 22px;
  height: 22px;
  transform: translateX(-50%);
  border-radius: 999px;
  background: #ffffff;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
}

.planner-milestone-marker {
  border: 2px solid #7c3aed;
  color: #5b21b6;
}

.planner-dependency-marker {
  display: inline-grid;
  place-items: center;
  border: 2px solid #f59e0b;
  color: #b45309;
}

.planner-workload-row {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(180px, 1.1fr);
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 7px;
  border: 1px solid #e2e6ee;
  border-left: 4px solid #0f8b6f;
  border-radius: 8px;
  background: #ffffff;
}

.planner-workload-row.is-busy {
  border-left-color: #2458d3;
}

.planner-workload-row.is-risk {
  border-left-color: #dc2626;
  background: #fff7f8;
}

.planner-workload-person {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.planner-workload-counts {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 5px;
}

.planner-workload-counts span {
  min-width: 0;
  display: grid;
  place-items: center;
  gap: 1px;
  min-height: 30px;
  border-radius: 6px;
  background: #eef2f7;
  color: #344054;
}

.planner-workload-counts .is-delayed {
  background: #fff1f2;
  color: #be123c;
}

.planner-workload-counts small {
  font-size: 9px;
  font-weight: 800;
}

.planner-workload-counts strong {
  font-size: 14px;
  font-weight: 900;
}

.planner-empty {
  min-width: 0;
  display: grid;
  gap: 3px;
  padding: 12px;
  border: 1px dashed #cfd6e2;
  border-radius: 8px;
  background: #ffffff;
}

.planner-empty strong {
  color: #17191f;
  font-size: 13px;
  font-weight: 900;
}

.planner-empty span,
.planner-truncated {
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.planner-truncated {
  margin: 0;
}

.schedule-group-manager {
  display: grid;
  gap: 12px;
  padding: 14px 18px 16px;
  border-bottom: 1px solid #d9dde5;
  background: #fbfcfd;
}

.group-manager-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.group-manager-head > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.group-manager-head strong {
  color: #17191f;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
}

.group-manager-feedback {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  max-width: min(520px, 100%);
  padding: 0 9px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.25;
}

.group-manager-feedback.is-error {
  background: #fff1f2;
  color: #be123c;
}

.group-manager-feedback.is-warning {
  background: #fff7e6;
  color: #b45309;
}

.group-manager-feedback.is-success {
  background: #e7f5ef;
  color: #087f5b;
}

.group-manager-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(300px, 0.95fr);
  gap: 14px;
}

.group-create-panel,
.group-assignment-panel {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 10px;
}

.group-create-fields {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(190px, 0.8fr) auto;
  align-items: end;
  gap: 8px;
}

.group-field {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.group-field span,
.group-assignment-head span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.group-field input,
.group-field select,
.group-edit-item input,
.group-assignment-row select {
  width: 100%;
  min-width: 0;
  height: 36px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  outline: none;
}

.group-field input,
.group-edit-item input {
  padding: 0 10px;
}

.group-field select,
.group-assignment-row select {
  padding: 0 30px 0 10px;
}

.group-color-picker {
  min-width: 0;
}

.group-edit-list {
  display: grid;
  gap: 7px;
}

.group-edit-item {
  min-width: 0;
  display: grid;
  grid-template-columns: 26px minmax(130px, 1fr) auto auto auto;
  align-items: center;
  gap: 7px;
  padding: 7px;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  background: #ffffff;
}

.group-edit-color {
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.62), 0 0 0 1px rgba(17, 24, 39, 0.08);
}

.group-edit-count {
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.group-order-actions {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.group-order-btn {
  width: 30px;
  height: 30px;
  display: inline-grid;
  place-items: center;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #293241;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
}

.group-order-btn:disabled {
  background: #f2f4f7;
  color: #98a2b3;
  cursor: not-allowed;
}

.group-delete {
  min-height: 30px;
  padding: 0 9px;
  border: 1px solid #f1c7cd;
  border-radius: 6px;
  background: #ffffff;
  color: #b42335;
  font-size: 12px;
  font-weight: 800;
}

.group-empty {
  padding: 10px 12px;
  border: 1px dashed #cfd6e2;
  border-radius: 8px;
  background: #ffffff;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.group-assignment-head {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.group-assignment-head small {
  color: #667085;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
}

.group-assignment-list {
  max-height: 286px;
  display: grid;
  gap: 6px;
  overflow: auto;
  padding-right: 2px;
}

.group-assignment-row {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(140px, 1fr) minmax(150px, 0.8fr);
  align-items: center;
  gap: 8px;
  padding: 7px;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  background: #ffffff;
}

.group-assignment-project {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.group-assignment-color {
  width: 10px;
  height: 24px;
  flex: 0 0 auto;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.62);
}

.group-assignment-project strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 13px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-project-order-panel {
  min-width: 0;
  display: grid;
  gap: 8px;
  padding-top: 4px;
}

.group-project-order-list {
  max-height: 286px;
  display: grid;
  gap: 8px;
  overflow: auto;
  padding-right: 2px;
}

.group-project-order-item {
  min-width: 0;
  display: grid;
  gap: 7px;
  padding: 8px;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  background: #ffffff;
}

.group-project-order-title,
.group-project-order-project {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.group-project-order-title strong,
.group-project-order-project strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 13px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-project-order-title small {
  flex: 0 0 auto;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.group-project-order-rows {
  display: grid;
  gap: 6px;
}

.group-project-order-row {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(140px, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 6px;
  border-radius: 6px;
  background: #f8fafc;
}

.schedule-transfer {
  display: grid;
  gap: 8px;
  padding: 9px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #ffffff;
}

.schedule-transfer-head {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.schedule-transfer-summary {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.schedule-transfer-summary strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-transfer-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
}

.schedule-transfer.is-expanded .schedule-transfer-toggle .project-add-chevron {
  transform: translateY(2px) rotate(225deg);
}

.schedule-transfer-body {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(260px, 0.7fr) minmax(260px, 0.75fr);
  gap: 10px;
  padding-top: 10px;
  border-top: 1px solid #edf0f4;
}

.schedule-transfer-panel {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(180px, 1fr) auto;
  align-items: center;
  gap: 10px 12px;
  padding: 0;
  background: transparent;
}

.schedule-export {
  grid-template-columns: minmax(0, 1fr) auto;
  align-content: start;
  padding-left: 12px;
  border-left: 1px solid #e5e9f0;
}

.schedule-print-export {
  grid-template-columns: minmax(0, 1fr);
  align-content: start;
  padding-left: 12px;
  border-left: 1px solid #e5e9f0;
}

.import-copy,
.export-copy {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.import-kicker {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.import-copy strong,
.export-copy strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-copy small,
.export-copy small {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
}

.print-export-summary {
  display: block;
  color: #475467 !important;
}

.import-controls,
.export-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.import-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.import-file-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.import-file-meta {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.import-file-meta span {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 0 8px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
}

.import-file-meta .import-file-name {
  max-width: min(460px, 100%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-file-meta.is-ready span {
  background: #e7f5ef;
  color: #087f5b;
}

.import-file-meta.is-warning span {
  background: #fff7e6;
  color: #b45309;
}

.import-file-meta.is-error span {
  background: #fff1f2;
  color: #be123c;
}

.import-file-meta.is-loading span {
  background: #edf5ff;
  color: #2458d3;
}

.export-file-meta {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.export-file-meta span {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 0 8px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.3;
}

.export-file-meta .export-file-name {
  max-width: min(360px, 100%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-export.is-ready .export-file-meta span {
  background: #e7f5ef;
  color: #087f5b;
}

.schedule-print-export.is-ready .export-file-meta span {
  background: #e7f5ef;
  color: #087f5b;
}

.schedule-export.is-loading .export-file-meta span,
.schedule-print-export.is-loading .export-file-meta span {
  background: #edf5ff;
  color: #2458d3;
}

.schedule-export.is-error .export-file-meta span,
.schedule-print-export.is-error .export-file-meta span {
  background: #fff1f2;
  color: #be123c;
}

.import-preview {
  grid-column: 1/-1;
  display: grid;
  gap: 8px;
  min-width: 0;
  padding-top: 2px;
}

.import-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.import-preview-head small {
  color: #98a2b3;
}

.import-preview-scroll {
  max-width: 100%;
  overflow: auto;
  border: 1px solid #e5e9f0;
  border-radius: 8px;
}

.import-preview-table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  background: #fbfcfd;
}

.import-preview-table td {
  max-width: 180px;
  padding: 7px 9px;
  border-right: 1px solid #e5e9f0;
  border-bottom: 1px solid #e5e9f0;
  color: #344054;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-preview-table td:last-child {
  border-right: 0;
}

.import-preview-table tr:last-child td {
  border-bottom: 0;
}

.schedule-filters {
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #d9dde5;
  background: #ffffff;
}

.filter-control {
  display: grid;
  gap: 4px;
}

.filter-control--search {
  min-width: 280px;
  flex: 1 1 320px;
}

.filter-control span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.filter-control input,
.filter-control select {
  height: 34px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  outline: none;
}

.filter-control input {
  width: 100%;
  padding: 0 11px;
}

.filter-control select {
  min-width: 180px;
  padding: 0 34px 0 11px;
}

.filter-control input:focus,
.filter-control select:focus {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
}

.filter-reset:disabled {
  color: #98a2b3;
  background: #f8fafc;
  cursor: not-allowed;
}

.filter-panel-close {
  align-self: end;
}

.filter-result {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
}

.selected-project-view {
  flex: 1 1 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  border: 1px solid #b9cffd;
  border-radius: 8px;
  background: #eef6ff;
}

.selected-project-view-color {
  width: 10px;
  min-height: 32px;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.68);
}

.selected-project-view-copy {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.selected-project-view-copy strong,
.selected-project-view-copy small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-project-view-copy strong {
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 900;
}

.selected-project-view-copy small {
  color: #475467;
  font-size: 12px;
  font-weight: 800;
}

.selected-project-clear {
  justify-self: end;
}

.schedule-board {
  --schedule-row-height: 72px;
  --schedule-row-padding-y: 8px;
  --schedule-date-column-width: 156px;
  --schedule-note-column-width: 190px;
  --schedule-table-width: 536px;
  --schedule-project-header-row-height: 132px;
  --schedule-table-head-height: 176px;
  --schedule-table-fr: 70fr;
  --schedule-detail-fr: 30fr;
  --schedule-table-height: 720px;
  --schedule-color-base-cell: #ffffff;
  --schedule-color-personal-cell: #fbfcfd;
  --schedule-color-project-header-cell: #f0f4f8;
  --schedule-color-project-cell: #ffffff;
  --schedule-color-weekend-cell: #fff8ed;
  --schedule-color-holiday-cell: #fff1f3;
  --schedule-color-today-cell: #e6f2ff;
  --schedule-color-filled-cell: #f2fbf7;
  --schedule-color-selected-cell: #eef6ff;
  --schedule-color-row-highlight: #edf5ff;
  --schedule-color-column-highlight: #f5f9ff;
  --schedule-color-status-badge: #dbeafe;
  --schedule-color-status-badge-text: #1d4ed8;
  --schedule-color-type-badge: #e7f5ef;
  --schedule-color-type-badge-text: #087f5b;
  --schedule-color-dependency-badge: #fff1f2;
  --schedule-color-dependency-badge-text: #be123c;
  --schedule-color-time-badge: #fff7e6;
  --schedule-color-time-badge-text: #b45309;
  --schedule-color-milestone-badge: #f5efff;
  --schedule-color-milestone-badge-text: #6d28d9;
  --schedule-color-selection-border: #2458d3;
  --schedule-color-selection-anchor: #0f8b6f;
  --schedule-color-active-cell-border: #111827;
  --schedule-color-dependency-risk: #f59e0b;
  --schedule-color-dependency-delay: #dc2626;
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
}

.schedule-board.has-detail-panel {
  grid-template-columns: minmax(0, var(--schedule-table-fr)) minmax(300px, var(--schedule-detail-fr));
}

.schedule-board:not(.has-detail-panel) {
  grid-template-columns: minmax(0, 1fr) !important;
}

.schedule-board:not(.has-detail-panel) .cell-detail-panel.is-empty {
  display: none !important;
}

.schedule-board.is-row-height-dragging,
:host-context(.is-schedule-row-height-dragging) .schedule-board {
  cursor: row-resize;
  user-select: none;
}

.schedule-board.is-date-column-resizing,
:host-context(.is-schedule-date-column-resizing) .schedule-board {
  cursor: col-resize;
  user-select: none;
}

.schedule-board.is-project-column-resizing,
:host-context(.is-schedule-project-column-resizing) .schedule-board {
  cursor: col-resize;
  user-select: none;
}

.schedule-board.is-project-row-height-resizing,
:host-context(.is-schedule-project-row-height-resizing) .schedule-board {
  cursor: row-resize;
  user-select: none;
}

.schedule-board.is-row-compact {
  --schedule-row-padding-y: 5px;
}

.schedule-board.is-row-spacious {
  --schedule-row-padding-y: 12px;
}

.schedule-table-wrap {
  position: relative;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  height: 100%;
  max-height: none;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  border-right: 1px solid #b8c1cf;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.92), 0 12px 28px rgba(16, 24, 40, 0.08);
}

.schedule-scroll-context {
  display: none;
}

.schedule-cell-grid {
  min-width: 100%;
  width: max-content;
  background: #ffffff;
}

.schedule-grid-row-layout {
  display: grid;
  grid-template-columns: var(--schedule-project-row-header-width, 220px);
  min-width: max-content;
}

.schedule-grid-header-row {
  position: sticky;
  top: 0;
  z-index: 12;
  min-height: 182px;
}

.schedule-grid-corner,
.schedule-grid-date-head,
.schedule-grid-project-head,
.schedule-grid-cell {
  min-width: 0;
  box-sizing: border-box;
  border-right: 1px solid #d9dde5;
  border-bottom: 1px solid #d9dde5;
}

.schedule-grid-corner,
.schedule-grid-project-head {
  position: sticky;
  left: 0;
  z-index: 8;
}

.schedule-grid-corner {
  min-height: 182px;
  display: grid;
  align-content: center;
  gap: 4px;
  padding: 16px 14px;
  background: #eef2f7;
  color: #293241;
}

.schedule-grid-corner strong,
.schedule-grid-corner span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-grid-corner strong {
  font-size: 14px;
  font-weight: 900;
}

.schedule-grid-corner span {
  color: #667085;
  font-size: 11px;
  font-weight: 900;
}

.schedule-grid-date-head {
  position: relative;
  min-height: 182px;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  gap: 8px;
  padding: 10px 12px 12px;
  overflow: hidden;
  background: #f8fafc;
  color: #293241;
}

.schedule-grid-date-head.is-today {
  background: #eff6ff;
  box-shadow: inset 0 4px 0 #2458d3;
}

.schedule-grid-date-head.is-holiday,
.schedule-grid-date-head.is-weekend {
  background: #fff8f8;
}

.schedule-grid-date-head.is-selected-week {
  box-shadow: inset 0 1px 0 rgba(96, 165, 250, 0.28), inset 0 -1px 0 rgba(96, 165, 250, 0.28);
}

.schedule-grid-date-head.is-selected-date {
  box-shadow: inset 0 0 0 2px rgba(36, 88, 211, 0.52);
}

.schedule-grid-date-head.has-date-column-width-override {
  box-shadow: inset 0 4px 0 #0f8b6f;
}

.schedule-grid-date-main {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 6px;
  padding-right: 18px;
}

.schedule-grid-date-main > strong {
  min-width: 0;
  overflow: hidden;
  color: #1f2937;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-grid-date-meta {
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  max-height: 44px;
  overflow: hidden;
}

.schedule-grid-date-meta > span:first-child {
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.schedule-date-note-input {
  width: 100%;
  min-height: 42px;
  max-height: 58px;
  resize: none;
  box-sizing: border-box;
  padding: 7px 8px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
  outline: none;
}

.empty-date-note-button {
  width: max-content;
  max-width: 100%;
  min-height: 24px;
  padding: 0 8px;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #667085;
  font-size: 10px;
  font-weight: 900;
}

.date-column-size-control,
.project-row-size-control {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.16s ease;
}

.schedule-grid-date-head:hover .date-column-size-control,
.schedule-grid-date-head:focus-within .date-column-size-control,
.schedule-grid-date-head.is-date-column-resizing .date-column-size-control,
.schedule-board.is-date-column-resizing .schedule-grid-date-head.is-date-column-resizing .date-column-size-control,
.schedule-grid-project-head:hover .project-row-size-control,
.schedule-grid-project-head:focus-within .project-row-size-control,
.schedule-grid-project-row.is-project-row-height-dragging .project-row-size-control,
.schedule-board.is-project-row-height-resizing .schedule-grid-project-row.is-project-row-height-dragging .project-row-size-control {
  opacity: 1;
}

.date-column-size-hint,
.project-row-size-hint {
  min-width: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 7px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  color: #344054;
  font-size: 10px;
  font-weight: 900;
  line-height: 1.2;
  white-space: nowrap;
}

.project-row-height-field {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.project-row-height-field span {
  color: #667085;
  font-size: 10px;
  font-weight: 900;
}

.project-row-height-field input {
  width: 100%;
  min-width: 0;
  height: 28px;
  box-sizing: border-box;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #293241;
  font-size: 12px;
  font-weight: 900;
  outline: none;
}

.project-row-height-reset {
  height: 28px;
  padding: 0 8px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 11px;
  font-weight: 900;
}

.project-row-height-reset:disabled {
  color: #98a2b3;
  background: #f6f7f9;
  cursor: not-allowed;
}

.date-column-resize-handle {
  position: absolute;
  top: 0;
  right: -6px;
  bottom: 0;
  z-index: 10;
  width: 12px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: col-resize;
  touch-action: none;
}

.date-column-resize-handle::before {
  content: "";
  position: absolute;
  top: 12px;
  right: 5px;
  bottom: 12px;
  width: 2px;
  border-radius: 999px;
  background: #98a2b3;
  opacity: 0.65;
}

.date-column-resize-handle::after {
  content: attr(data-resize-tooltip);
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 20;
  min-width: 44px;
  padding: 4px 7px;
  transform: translateY(-50%);
  border-radius: 999px;
  background: #111827;
  color: #ffffff;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.1;
  text-align: center;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s ease;
}

.date-column-resize-handle:hover::before,
.date-column-resize-handle:focus-visible::before,
.date-column-resize-handle.is-dragging::before,
.date-head:hover .date-column-resize-handle::before,
.date-head:focus-within .date-column-resize-handle::before,
.date-head.is-date-column-resizing .date-column-resize-handle::before,
.schedule-grid-date-head.is-date-column-resizing .date-column-resize-handle::before {
  width: 3px;
  background: #2458d3;
  opacity: 1;
}

.date-column-resize-handle.is-dragging::after,
.date-head.is-date-column-resizing .date-column-resize-handle::after {
  opacity: 1;
}

.date-column-resize-handle:focus-visible,
.project-row-height-resize-handle:focus-visible {
  outline: none;
}

.schedule-grid-empty {
  min-height: 240px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 6px;
  border-bottom: 1px solid #d9dde5;
  background: #ffffff;
  color: #667085;
}

.schedule-grid-empty strong {
  color: #344054;
  font-size: 14px;
  font-weight: 900;
}

.schedule-grid-empty span {
  font-size: 12px;
  font-weight: 800;
}

.schedule-grid-body {
  display: grid;
}

.schedule-grid-project-row {
  min-height: var(--schedule-project-row-height, 72px);
}

.schedule-grid-project-head {
  position: sticky;
  min-height: var(--schedule-project-row-height, 72px);
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  gap: 6px;
  padding: 10px 12px 12px 14px;
  overflow: hidden;
  border-left: 5px solid #2458d3;
  background: #ffffff;
}

.schedule-grid-project-row.is-group-row .schedule-grid-project-head {
  background: #f8fafc;
}

.schedule-grid-project-row.has-project-row-height-override .schedule-grid-project-head {
  box-shadow: inset 0 -3px 0 #0f8b6f;
}

.schedule-grid-group-toggle {
  min-height: 0;
  padding: 0;
}

.schedule-grid-project-title {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 4px;
}

.schedule-grid-project-title small {
  min-width: 0;
  overflow: hidden;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-row-group-label {
  color: #475467 !important;
}

.project-row-height-resize-handle {
  position: absolute;
  right: 8px;
  bottom: -5px;
  left: 8px;
  z-index: 10;
  height: 10px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  cursor: row-resize;
  touch-action: none;
}

.project-row-height-resize-handle::before {
  content: "";
  position: absolute;
  right: 12px;
  bottom: 4px;
  left: 12px;
  height: 2px;
  border-radius: 999px;
  background: #98a2b3;
  opacity: 0.65;
}

.project-row-height-resize-handle::after {
  content: attr(data-resize-tooltip);
  position: absolute;
  right: 14px;
  bottom: 12px;
  z-index: 20;
  min-width: 44px;
  padding: 4px 7px;
  border-radius: 999px;
  background: #111827;
  color: #ffffff;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.1;
  text-align: center;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s ease;
}

.project-row-height-resize-handle:hover::before,
.project-row-height-resize-handle:focus-visible::before,
.project-row-height-resize-handle.is-dragging::before,
.schedule-grid-project-row.is-project-row-height-dragging .project-row-height-resize-handle::before {
  height: 3px;
  background: #2458d3;
  opacity: 1;
}

.project-row-height-resize-handle.is-dragging::after {
  opacity: 1;
}

.schedule-grid-cell.schedule-cell,
.schedule-grid-cell.group-summary-cell {
  height: var(--schedule-project-row-height, 72px);
}

.schedule-grid-cell.schedule-cell.is-holiday,
.schedule-grid-cell.group-summary-cell.is-holiday {
  background: #fff8f8;
}

.schedule-grid-cell.schedule-cell.is-weekend,
.schedule-grid-cell.group-summary-cell.is-weekend {
  background: #f8fafc;
}

.schedule-grid-cell.schedule-cell.is-today,
.schedule-grid-cell.group-summary-cell.is-today {
  background: #eff6ff;
}

.schedule-cell-grid .schedule-cell-preview,
.schedule-cell-grid .schedule-cell-input,
.schedule-cell-grid .empty-cell-button {
  height: var(--schedule-project-row-height, 72px);
}

.schedule-cell-grid .row-group-summary {
  min-height: calc(var(--schedule-project-row-height, 72px) - var(--schedule-row-padding-y) * 2);
}

.schedule-table {
  width: var(--schedule-table-width);
  min-width: var(--schedule-table-width);
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  --schedule-project-color: #2458d3;
  background: var(--schedule-color-base-cell, #ffffff);
}

.col-date {
  width: var(--schedule-date-column-width);
}

.col-note {
  width: var(--schedule-note-column-width);
}

.col-project {
  width: 190px;
}

.col-group-summary {
  width: 172px;
}

.schedule-table th,
.schedule-table td {
  box-sizing: border-box;
  border-right: 1px solid #cbd4e1;
  border-bottom: 1px solid #d5dce8;
  text-align: center;
  vertical-align: middle;
}

.schedule-table th:last-child,
.schedule-table td:last-child {
  border-right: 0;
}

.schedule-table thead th {
  position: sticky;
  top: 0;
  z-index: 5;
  height: 64px;
  padding: 10px;
  background: var(--schedule-color-project-header-cell, #f0f4f8);
  color: #293241;
  font-size: 13px;
  font-weight: 800;
  text-align: center;
  vertical-align: middle;
  border-bottom-color: #b8c1cf;
  box-shadow: inset 0 -1px 0 #b8c1cf, 0 5px 14px rgba(16, 24, 40, 0.08);
}

.schedule-table thead .group-header-row th {
  top: 0;
  z-index: 7;
  height: 44px;
  padding: 7px 10px;
  background: var(--schedule-color-project-header-cell, #f8fafc);
  box-shadow: inset 0 -1px 0 #c1cbda, 0 4px 12px rgba(16, 24, 40, 0.07);
}

.schedule-table thead .project-header-row th {
  top: 44px;
  z-index: 6;
  height: var(--schedule-project-header-row-height);
  min-height: var(--schedule-project-header-row-height);
  padding: 9px 10px 24px;
  box-shadow: inset 0 -1px 0 #b8c1cf, 0 6px 16px rgba(16, 24, 40, 0.08);
}

.schedule-table thead .date-head,
.schedule-table thead .note-head {
  top: 0;
  height: var(--schedule-table-head-height);
  min-height: var(--schedule-table-head-height);
  background: var(--schedule-color-project-header-cell, #eef2f7);
}

.date-head,
.note-head,
.project-head {
  position: sticky;
}

.date-head,
.note-head {
  overflow: visible;
}

.project-head {
  overflow: visible;
}

.date-head.has-date-column-width-override,
.note-head.has-note-column-width-override,
.project-head.has-project-column-width-override {
  box-shadow: inset 0 4px 0 #0f8b6f;
}

.project-header-row.has-project-header-row-height-override th,
.project-head.has-project-header-row-height-override,
.group-summary-head.has-project-header-row-height-override {
  box-shadow: inset 0 -3px 0 #0f8b6f, 0 6px 16px rgba(16, 24, 40, 0.08);
}

.date-head.is-date-column-resizing,
.note-head.is-note-column-resizing,
.project-head.is-project-column-resizing,
.project-head.is-project-header-row-height-resizing,
.group-summary-head.is-project-header-row-height-resizing,
.schedule-table col.is-column-resizing {
  box-shadow: inset -3px 0 0 #2458d3;
}

.sticky-col {
  position: sticky;
  z-index: 4;
}

.date-head,
.date-cell {
  left: 0;
  width: var(--schedule-date-column-width);
  min-width: var(--schedule-date-column-width);
  max-width: var(--schedule-date-column-width);
  border-right-color: #b5bfce !important;
}

.note-head,
.note-cell {
  left: var(--schedule-date-column-width);
  width: var(--schedule-note-column-width);
  min-width: var(--schedule-note-column-width);
  max-width: var(--schedule-note-column-width);
  border-right-color: #aeb8c7 !important;
  box-shadow: 8px 0 18px -16px rgba(16, 24, 40, 0.46), inset -1px 0 0 #aeb8c7;
}

.date-head,
.note-head {
  z-index: 9 !important;
  box-shadow: 8px 0 18px -16px rgba(16, 24, 40, 0.48), inset -1px 0 0 #aeb8c7, inset 0 -1px 0 #b8c1cf, 0 5px 14px rgba(16, 24, 40, 0.08);
}

.date-head.has-date-column-width-override,
.note-head.has-note-column-width-override {
  box-shadow: inset 0 4px 0 #0f8b6f, 8px 0 18px -16px rgba(16, 24, 40, 0.48), inset -1px 0 0 #aeb8c7, inset 0 -1px 0 #b8c1cf, 0 5px 14px rgba(16, 24, 40, 0.08);
}

.date-head.is-date-column-resizing,
.note-head.is-note-column-resizing {
  box-shadow: inset -3px 0 0 #2458d3, 8px 0 18px -16px rgba(16, 24, 40, 0.48), inset 0 -1px 0 #b8c1cf, 0 5px 14px rgba(16, 24, 40, 0.08);
}

.date-cell,
.note-cell {
  z-index: 4;
  background-clip: padding-box;
}

.group-head {
  border-top: 4px solid #64748b;
  border-bottom-color: #cbd5e1;
  padding: 0 !important;
}

.group-head.is-collapsed {
  background: #eef6ff;
}

.group-toggle {
  width: 100%;
  min-height: 40px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  text-align: center;
}

.group-toggle:focus-visible {
  outline: 2px solid #2458d3;
  outline-offset: -2px;
}

.group-head-inner {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  line-height: 1.2;
}

.group-title {
  min-width: 0;
  max-width: 180px;
  display: block;
  overflow: hidden;
  color: #1f2937;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-count,
.group-total,
.group-toggle-state {
  min-height: 18px;
  display: inline-flex;
  align-items: center;
  padding: 0 6px;
  border-radius: 999px;
  background: #e5eaf2;
  color: #475467;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}

.group-total {
  background: #dbeafe;
  color: #1d4ed8;
}

.group-meta-summary {
  max-width: 100%;
  display: block;
  overflow: hidden;
  color: #64748b;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-toggle-state {
  justify-self: end;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #344054;
}

.project-head {
  border-top: 4px solid #2458d3;
  position: relative;
  background: var(--schedule-color-project-header-cell, #f0f4f8);
}

.project-head.has-project-memo {
  background: #fffbeb !important;
}

.project-head.is-project-memo-open {
  z-index: 20 !important;
}

.project-head::before {
  content: "";
  position: absolute;
  top: -4px;
  right: 0;
  left: 0;
  height: 4px;
  background: var(--schedule-project-color, #2458d3);
  pointer-events: none;
}

.project-head.is-selected-project {
  background: var(--schedule-color-selected-cell, #f3f8ff) !important;
  box-shadow: inset 0 0 0 1px rgba(29, 78, 216, 0.24), inset 0 -2px 0 rgba(29, 78, 216, 0.16);
}

.project-head.is-hovered-project,
.project-head.is-selection-column,
.project-head.is-selection-column-header {
  background: var(--schedule-color-column-highlight, #eef6ff) !important;
  box-shadow: inset 0 0 0 1px rgba(29, 78, 216, 0.26), inset 0 -2px 0 rgba(29, 78, 216, 0.18), 0 6px 14px rgba(29, 78, 216, 0.08);
}

.project-head.is-selection-column::before,
.project-head.is-selection-column-header::before {
  height: 5px;
  box-shadow: 0 2px 6px rgba(36, 88, 211, 0.14);
}

.group-summary-head {
  border-top: 4px solid #64748b;
  position: relative;
  background: #f8fbff !important;
}

.group-summary-head-inner {
  min-width: 0;
  display: grid;
  place-items: center;
  gap: 3px;
  color: #334155;
  line-height: 1.2;
  text-align: center;
}

.group-summary-head-inner strong {
  overflow: hidden;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-summary-head-inner span {
  overflow: hidden;
  color: #64748b;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-title-line {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.project-title {
  min-width: 0;
  display: -webkit-box;
  overflow: hidden;
  font-size: 13px;
  line-height: 1.22;
  overflow-wrap: anywhere;
  word-break: keep-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.project-memo-header-action {
  width: calc(100% - 4px);
  min-height: 28px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  justify-content: center;
  justify-items: center;
  gap: 6px;
  margin: 7px auto 0;
  padding: 4px 8px;
  border: 1px solid #9db7f6;
  border-radius: 7px;
  background: #eef6ff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.1;
  text-align: center;
  box-shadow: inset 0 0 0 1px rgba(36, 88, 211, 0.08);
}

.project-memo-header-action.has-memo {
  border-color: #f5b942;
  background: #fff7d6;
  color: #9a6700;
  box-shadow: inset 0 0 0 1px rgba(245, 185, 66, 0.18);
}

.project-memo-header-icon {
  width: 18px;
  height: 18px;
  display: inline-grid;
  place-items: center;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.72);
  color: inherit;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
}

.project-memo-header-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-memo-header-action:focus-visible,
.project-memo-close:focus-visible,
.project-memo-clear:focus-visible {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
  outline: none;
}

.project-memo-popover {
  position: absolute;
  top: calc(100% - 4px);
  left: 50%;
  z-index: 36;
  width: min(280px, 100vw - 32px);
  min-width: min(230px, 100vw - 32px);
  display: grid;
  gap: 8px;
  padding: 10px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #ffffff;
  color: #17191f;
  text-align: left;
  transform: translateX(-50%);
  box-shadow: 0 18px 44px rgba(16, 24, 40, 0.18);
}

.project-memo-popover::before {
  content: "";
  position: absolute;
  top: -7px;
  left: calc(50% - 7px);
  width: 14px;
  height: 14px;
  border-top: 1px solid #cfd6e2;
  border-left: 1px solid #cfd6e2;
  background: #ffffff;
  transform: rotate(45deg);
}

.project-memo-popover-head,
.project-memo-footer {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.project-memo-popover-head strong {
  min-width: 0;
  overflow: hidden;
  color: #17191f;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-memo-close {
  width: 26px;
  height: 26px;
  border: 1px solid #d9dde5;
  border-radius: 6px;
  background: #ffffff;
  color: #667085;
  font-size: 16px;
  line-height: 1;
}

.project-memo-textarea {
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 96px;
  box-sizing: border-box;
  resize: vertical;
  padding: 8px;
  border: 1px solid #d9dde5;
  border-radius: 6px;
  color: #17191f;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  overflow-wrap: anywhere;
  outline: none;
  text-align: left;
  white-space: pre-wrap;
}

.project-memo-textarea:focus {
  border-color: #2458d3;
  box-shadow: 0 0 0 2px rgba(36, 88, 211, 0.13);
}

.project-memo-footer {
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.project-memo-clear {
  min-height: 26px;
  padding: 0 8px;
  border: 1px solid #d9dde5;
  border-radius: 6px;
  background: #f8fafc;
  color: #344054;
  font-size: 11px;
  font-weight: 900;
}

.project-memo-clear:disabled {
  color: #98a2b3;
  cursor: not-allowed;
}

.favorite-project-badge {
  min-width: 18px;
  min-height: 18px;
  display: inline-grid;
  place-items: center;
  border-radius: 999px;
  background: #fff8db;
  color: #9a6700;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
}

.selected-project-badge {
  min-height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: #2458d3;
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
}

.project-meta-lines {
  min-width: 0;
  display: grid;
  justify-items: center;
  gap: 2px;
  margin-top: 4px;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.16;
  text-align: center;
}

.project-meta-lines span {
  min-width: 0;
  display: -webkit-box;
  overflow: hidden;
  overflow-wrap: anywhere;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: keep-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.date-head-main,
.note-head-main {
  min-width: 0;
  display: grid;
  place-items: center;
  gap: 4px;
  line-height: 1.2;
  text-align: center;
}

.date-head-main strong,
.date-head-main span,
.note-head-main strong,
.note-head-main span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.date-head-main strong,
.note-head-main strong {
  color: #293241;
  font-size: 13px;
  font-weight: 900;
}

.date-head-main span,
.note-head-main span {
  color: #667085;
  font-size: 10px;
  font-weight: 900;
}

.column-size-hint {
  min-width: 0;
  width: fit-content;
  max-width: 100%;
  min-height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
  padding: 0 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 10px;
  font-weight: 900;
  opacity: 0;
  pointer-events: none;
  text-overflow: ellipsis;
  transform: translateY(-2px);
  transition: opacity 0.14s ease, transform 0.14s ease;
  white-space: nowrap;
}

.project-head .column-size-hint {
  position: absolute;
  right: 17px;
  bottom: 43px;
  z-index: 3;
  margin-top: 0;
}

.project-head:hover .column-size-hint,
.project-head:focus-within .column-size-hint,
.project-head.is-project-column-resizing .column-size-hint,
.date-head:hover .column-size-hint,
.date-head:focus-within .column-size-hint,
.date-head.is-date-column-resizing .column-size-hint,
.note-head:hover .column-size-hint,
.note-head:focus-within .column-size-hint,
.note-head.is-note-column-resizing .column-size-hint {
  opacity: 1;
  transform: translateY(0);
}

.project-column-resize-handle {
  position: absolute;
  top: 0;
  right: -6px;
  bottom: 0;
  z-index: 14;
  width: 12px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: col-resize;
  touch-action: none;
}

.note-column-resize-handle {
  right: -8px;
  width: 16px;
}

.project-column-resize-handle::before {
  content: "";
  position: absolute;
  top: 12px;
  right: 5px;
  bottom: 12px;
  width: 2px;
  border-radius: 999px;
  background: #98a2b3;
  opacity: 0;
  transition: background 0.14s ease, opacity 0.14s ease, width 0.14s ease;
}

.note-column-resize-handle::before {
  right: 7px;
  opacity: 0.42;
}

.project-column-resize-handle::after {
  content: attr(data-resize-tooltip);
  position: absolute;
  top: 10px;
  right: 12px;
  min-width: 46px;
  padding: 4px 7px;
  border: 1px solid #b9c9f6;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(16, 24, 40, 0.14);
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  opacity: 0;
  pointer-events: none;
  text-align: center;
  transform: translateX(4px);
  transition: opacity 0.12s ease, transform 0.12s ease;
  white-space: nowrap;
}

.project-head:hover .project-column-resize-handle::before,
.project-head:focus-within .project-column-resize-handle::before,
.note-head:hover .project-column-resize-handle::before,
.note-head:focus-within .project-column-resize-handle::before,
.project-column-resize-handle:hover::before,
.project-column-resize-handle:focus-visible::before,
.project-column-resize-handle.is-dragging::before,
.project-head.is-project-column-resizing .project-column-resize-handle::before,
.note-head.is-note-column-resizing .project-column-resize-handle::before {
  width: 3px;
  background: #2458d3;
  opacity: 1;
}

.project-column-resize-handle:focus-visible {
  outline: none;
}

.project-column-resize-handle.is-dragging::after,
.project-head.is-project-column-resizing .project-column-resize-handle::after,
.note-head.is-note-column-resizing .project-column-resize-handle::after {
  opacity: 1;
  transform: translateX(0);
}

.project-header-height-control {
  position: absolute;
  right: 18px;
  bottom: 4px;
  left: 10px;
  z-index: 16;
  min-width: 0;
  height: 18px;
  display: flex;
  align-items: center;
  gap: 6px;
  pointer-events: none;
}

.project-header-height-hint {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  padding: 0 6px;
  overflow: hidden;
  border: 1px solid #bfd0f7;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-header-row-height-resize-handle {
  position: relative;
  flex: 1 1 auto;
  min-width: 46px;
  height: 16px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  cursor: row-resize;
  pointer-events: auto;
  touch-action: none;
}

.project-header-row-height-resize-handle::before {
  content: "";
  position: absolute;
  top: 7px;
  right: 2px;
  left: 2px;
  height: 2px;
  border-radius: 999px;
  background: #98a2b3;
  opacity: 0.78;
}

.project-header-row-height-resize-handle::after {
  content: attr(data-resize-tooltip);
  position: absolute;
  right: 0;
  bottom: 18px;
  z-index: 24;
  min-width: 46px;
  padding: 4px 7px;
  border: 1px solid #b9c9f6;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(16, 24, 40, 0.14);
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  opacity: 0;
  pointer-events: none;
  text-align: center;
  transform: translateY(4px);
  transition: opacity 0.12s ease, transform 0.12s ease;
  white-space: nowrap;
}

.project-header-row-height-resize-handle:hover::before,
.project-header-row-height-resize-handle:focus-visible::before,
.project-header-row-height-resize-handle.is-dragging::before,
.project-header-row.is-project-header-row-height-resizing .project-header-row-height-resize-handle::before {
  height: 3px;
  background: #2458d3;
  opacity: 1;
}

.project-header-row-height-resize-handle:focus-visible {
  outline: none;
}

.project-header-row-height-resize-handle.is-dragging::after,
.project-header-row.is-project-header-row-height-resizing .project-header-row-height-resize-handle::after,
.schedule-board.is-project-header-row-height-resizing .project-header-row-height-resize-handle::after {
  opacity: 1;
  transform: translateY(0);
}

.date-cell {
  height: var(--schedule-row-height);
  box-sizing: border-box;
  padding: var(--schedule-row-padding-y) 10px;
  background: var(--schedule-row-sticky-bg, #fbfcfd);
  color: #293241;
  text-align: center;
  vertical-align: middle;
}

.date-cell.has-date-row-height-override {
  box-shadow: inset 3px 0 0 #2458d3;
}

.date-cell-main {
  min-width: 0;
  min-height: calc(var(--schedule-row-height) - var(--schedule-row-padding-y) * 2);
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 4px;
  padding: 0 28px;
  text-align: center;
}

.date-cell strong {
  display: block;
  line-height: 1.2;
}

.date-cell strong {
  font-size: 13px;
  font-weight: 800;
}

.date-cell-meta,
.mobile-day-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 0;
}

.date-row-height-tools {
  position: absolute;
  top: var(--schedule-row-padding-y);
  right: 8px;
  display: flex;
  justify-content: flex-end;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-2px);
  transition: opacity 0.14s ease, transform 0.14s ease;
}

.mobile-row-height-select {
  min-width: 0;
  height: 24px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #293241;
  font-size: 11px;
  font-weight: 800;
  outline: none;
}

.mobile-row-height-badge {
  min-height: 18px;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 0 5px;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.1;
  white-space: nowrap;
}

.date-row-size-hint {
  min-height: 22px;
  display: inline-flex;
  align-items: center;
  padding: 0 7px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
}

.date-cell:hover .date-row-height-tools,
.date-cell:focus-within .date-row-height-tools,
tr.is-row-height-dragging .date-row-height-tools {
  opacity: 1;
  transform: translateY(0);
}

.date-row-height-drag-handle {
  position: absolute;
  right: 8px;
  bottom: -5px;
  left: 8px;
  z-index: 9;
  height: 10px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  cursor: row-resize;
  touch-action: none;
}

.date-row-height-drag-handle::before {
  content: "";
  position: absolute;
  right: 12px;
  bottom: 4px;
  left: 12px;
  height: 2px;
  border-radius: 999px;
  background: #98a2b3;
  opacity: 0;
  transition: background 0.14s ease, opacity 0.14s ease, height 0.14s ease;
}

.date-row-height-drag-handle::after {
  content: attr(data-resize-tooltip);
  position: absolute;
  right: 12px;
  bottom: 15px;
  min-width: 46px;
  padding: 4px 7px;
  border: 1px solid #b9c9f6;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(16, 24, 40, 0.14);
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  opacity: 0;
  pointer-events: none;
  text-align: center;
  transform: translateY(4px);
  transition: opacity 0.12s ease, transform 0.12s ease;
  white-space: nowrap;
}

.date-cell:hover .date-row-height-drag-handle::before,
.date-cell:focus-within .date-row-height-drag-handle::before,
.date-row-height-drag-handle:hover::before,
.date-row-height-drag-handle:focus-visible::before,
.date-row-height-drag-handle.is-dragging::before,
tr.is-row-height-dragging .date-row-height-drag-handle::before {
  height: 3px;
  background: #2458d3;
  opacity: 1;
}

.date-row-height-drag-handle:focus-visible {
  outline: none;
}

.date-row-height-drag-handle.is-dragging::after,
tr.is-row-height-dragging .date-row-height-drag-handle::after {
  opacity: 1;
  transform: translateY(0);
}

.date-weekday,
.mobile-day-meta > span:first-child {
  display: block;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.holiday-badge {
  max-width: 100%;
  min-height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border: 1px solid #f4c2ca;
  border-radius: 999px;
  background: var(--schedule-color-holiday-cell, #fff1f2);
  color: var(--schedule-color-dependency-badge-text, #be123c);
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
}

.date-milestone-count {
  min-height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border: 1px solid #c4b5fd;
  border-radius: 999px;
  background: var(--schedule-color-milestone-badge, #ffffff);
  color: var(--schedule-color-milestone-badge-text, #5b21b6);
  font-size: 10px;
  font-weight: 900;
  line-height: 1.2;
  white-space: nowrap;
}

.date-milestone-list {
  min-width: 0;
  max-height: 48px;
  display: grid;
  justify-items: center;
  gap: 4px;
  margin-top: 6px;
  overflow: hidden;
  text-align: center;
}

.milestone-chip,
.mobile-milestone-chip,
.selected-milestone-main {
  min-width: 0;
  display: grid;
  align-items: center;
  border: 1px solid #d8d4ea;
  border-left: 4px solid #7c3aed;
  border-radius: 6px;
  background: #ffffff;
  color: #2f2a45;
  text-align: left;
}

.milestone-chip {
  grid-template-columns: 18px minmax(0, 1fr);
  justify-self: center;
  gap: 5px;
  min-height: 22px;
  padding: 2px 6px 2px 4px;
  text-align: center;
}

.milestone-chip-icon,
.cell-milestone-chip {
  min-width: 0;
  display: inline-grid;
  place-items: center;
  border-radius: 5px;
  color: #ffffff;
  font-size: 9px;
  font-weight: 900;
  line-height: 1;
}

.milestone-chip-icon {
  width: 16px;
  height: 16px;
  background: #6d28d9;
}

.milestone-chip-title {
  min-width: 0;
  overflow: hidden;
  font-size: 11px;
  font-weight: 900;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.date-milestone-add {
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 8;
  min-width: 38px;
  height: 22px;
  border: 1px solid #c4b5fd;
  border-radius: 6px;
  background: #ffffff;
  color: #5b21b6;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.14s ease;
}

.date-cell:hover .date-milestone-add,
.date-cell:focus-within .date-milestone-add,
tr.is-selected-date .date-milestone-add {
  opacity: 1;
  pointer-events: auto;
}

.note-cell {
  position: sticky;
  height: var(--schedule-row-height);
  min-width: 0;
  overflow: hidden;
  background: var(--schedule-row-note-bg, #fbfcfd);
  text-align: center;
  vertical-align: middle;
}

.schedule-cell {
  position: relative;
  height: var(--schedule-row-height);
  min-width: 0;
  overflow: hidden;
  background: var(--schedule-row-cell-bg, #ffffff);
  text-align: center;
  vertical-align: middle;
  transition: background 0.14s ease;
}

.schedule-cell::before {
  content: "";
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: 0;
  z-index: 1;
  width: 3px;
  background: var(--schedule-project-color, #2458d3);
  opacity: 0.32;
  pointer-events: none;
}

.group-summary-cell {
  height: var(--schedule-row-height);
  box-sizing: border-box;
  padding: var(--schedule-row-padding-y) 10px;
  background: var(--schedule-row-summary-bg, #fbfdff);
  text-align: center;
  vertical-align: middle;
}

.row-group-summary {
  min-height: calc(var(--schedule-row-height) - var(--schedule-row-padding-y) * 2);
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 4px;
  color: #344054;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.25;
  text-align: center;
}

.row-group-summary strong,
.row-group-summary span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-group-summary strong {
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 900;
}

.row-group-summary span {
  color: #667085;
}

.row-group-summary .row-group-milestone {
  width: max-content;
  max-width: 100%;
  padding: 2px 6px;
  border: 1px solid #ddd6fe;
  border-radius: 999px;
  background: var(--schedule-color-milestone-badge, #ffffff);
  color: var(--schedule-color-milestone-badge-text, #5b21b6);
}

.row-group-summary .row-group-dependency {
  width: max-content;
  max-width: 100%;
  padding: 2px 6px;
  border: 1px solid #fed7aa;
  border-radius: 999px;
  background: var(--schedule-color-time-badge, #ffffff);
  color: var(--schedule-color-time-badge-text, #b45309);
}

.row-group-summary.is-empty {
  align-content: center;
  color: #98a2b3;
}

.row-group-summary.is-empty span:not(.row-group-milestone):not(.row-group-dependency) {
  display: none;
}

.schedule-table tbody tr {
  --schedule-row-base-cell-bg: var(--schedule-color-project-cell, #ffffff);
  --schedule-row-base-filled-bg: var(--schedule-color-filled-cell, #f2fbf7);
  --schedule-row-cell-bg: var(--schedule-color-project-cell, #ffffff);
  --schedule-row-sticky-bg: var(--schedule-color-base-cell, #fbfcfd);
  --schedule-row-note-bg: var(--schedule-color-personal-cell, #fbfcfd);
  --schedule-row-summary-bg: var(--schedule-color-base-cell, #fbfdff);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #f2fbf7);
  --schedule-column-hover-bg: var(--schedule-color-column-highlight, #f7fbff);
  --schedule-column-selection-bg: var(--schedule-color-column-highlight, #f5f9ff);
}

.schedule-table tbody tr.is-row-odd {
  --schedule-row-base-cell-bg: var(--schedule-color-project-cell, #fbfcff);
  --schedule-row-base-filled-bg: var(--schedule-color-filled-cell, #ecf9f4);
  --schedule-row-cell-bg: var(--schedule-color-project-cell, #fbfcff);
  --schedule-row-sticky-bg: var(--schedule-color-base-cell, #f7f9fc);
  --schedule-row-note-bg: var(--schedule-color-personal-cell, #f7f9fc);
  --schedule-row-summary-bg: var(--schedule-color-base-cell, #f6faff);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #ecf9f4);
}

.schedule-table tbody tr.is-weekend {
  --schedule-row-base-cell-bg: var(--schedule-color-weekend-cell, #fff8ed);
  --schedule-row-base-filled-bg: var(--schedule-color-filled-cell, #ffedd5);
  --schedule-row-cell-bg: var(--schedule-color-weekend-cell, #fff8ed);
  --schedule-row-sticky-bg: var(--schedule-color-weekend-cell, #fff2df);
  --schedule-row-note-bg: var(--schedule-color-weekend-cell, #fff2df);
  --schedule-row-summary-bg: var(--schedule-color-weekend-cell, #fff5e8);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #ffedd5);
}

.schedule-table tbody tr.is-holiday {
  --schedule-row-base-cell-bg: var(--schedule-color-holiday-cell, #fff1f3);
  --schedule-row-base-filled-bg: var(--schedule-color-filled-cell, #ffe1e7);
  --schedule-row-cell-bg: var(--schedule-color-holiday-cell, #fff1f3);
  --schedule-row-sticky-bg: var(--schedule-color-holiday-cell, #ffe7eb);
  --schedule-row-note-bg: var(--schedule-color-holiday-cell, #ffe7eb);
  --schedule-row-summary-bg: var(--schedule-color-holiday-cell, #fff0f2);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #ffe1e7);
}

.schedule-table tbody tr.is-public-holiday {
  --schedule-row-base-cell-bg: var(--schedule-color-holiday-cell, #fff0f3);
  --schedule-row-base-filled-bg: var(--schedule-color-filled-cell, #ffdbe3);
  --schedule-row-cell-bg: var(--schedule-color-holiday-cell, #fff0f3);
  --schedule-row-sticky-bg: var(--schedule-color-holiday-cell, #ffe3e8);
  --schedule-row-note-bg: var(--schedule-color-holiday-cell, #ffe3e8);
  --schedule-row-summary-bg: var(--schedule-color-holiday-cell, #ffeef1);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #ffdbe3);
}

.schedule-table tbody tr.is-weekend:not(.is-public-holiday) {
  --schedule-row-base-cell-bg: var(--schedule-color-weekend-cell, #fff8ed);
  --schedule-row-base-filled-bg: var(--schedule-color-filled-cell, #ffedd5);
  --schedule-row-cell-bg: var(--schedule-color-weekend-cell, #fff8ed);
  --schedule-row-sticky-bg: var(--schedule-color-weekend-cell, #fff2df);
  --schedule-row-note-bg: var(--schedule-color-weekend-cell, #fff2df);
  --schedule-row-summary-bg: var(--schedule-color-weekend-cell, #fff5e8);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #ffedd5);
}

.schedule-table tbody tr.is-today {
  --schedule-row-base-cell-bg: var(--schedule-color-today-cell, #e6f2ff);
  --schedule-row-base-filled-bg: var(--schedule-color-filled-cell, #cceeff);
  --schedule-row-cell-bg: var(--schedule-color-today-cell, #e6f2ff);
  --schedule-row-sticky-bg: var(--schedule-color-today-cell, #d8ebff);
  --schedule-row-note-bg: var(--schedule-color-today-cell, #d8ebff);
  --schedule-row-summary-bg: var(--schedule-color-today-cell, #e1efff);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #cceeff);
}

.schedule-table tbody tr.is-selected-week {
  --schedule-row-cell-bg: var(--schedule-color-row-highlight, #f2f7ff);
  --schedule-row-sticky-bg: var(--schedule-color-row-highlight, #edf4ff);
  --schedule-row-note-bg: var(--schedule-color-row-highlight, #edf4ff);
  --schedule-row-summary-bg: var(--schedule-color-row-highlight, #f0f6ff);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #e2f3ff);
}

.schedule-table tbody tr:hover,
.schedule-table tbody tr.is-hovered-row {
  --schedule-row-cell-bg: var(--schedule-color-row-highlight, #edf5ff);
  --schedule-row-sticky-bg: var(--schedule-color-row-highlight, #e7f0ff);
  --schedule-row-note-bg: var(--schedule-color-row-highlight, #e7f0ff);
  --schedule-row-summary-bg: var(--schedule-color-row-highlight, #eaf3ff);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #dff0ff);
}

.schedule-table tbody tr.is-selection-row,
.schedule-table tbody tr.is-selected-date {
  --schedule-row-cell-bg: var(--schedule-color-row-highlight, #f5f9ff);
  --schedule-row-sticky-bg: var(--schedule-color-row-highlight, #eef6ff);
  --schedule-row-note-bg: var(--schedule-color-row-highlight, #eef6ff);
  --schedule-row-summary-bg: var(--schedule-color-row-highlight, #f3f8ff);
  --schedule-row-filled-bg: var(--schedule-color-filled-cell, #ecf8ff);
}

.schedule-table tbody tr.is-weekend .date-cell,
.schedule-table tbody tr.is-weekend .note-cell,
.schedule-table tbody tr.is-weekend .schedule-cell,
.schedule-table tbody tr.is-weekend .group-summary-cell {
  box-shadow: inset 0 1px 0 color-mix(in srgb, var(--schedule-color-weekend-cell, #fff8ed) 55%, #f97316), inset 0 -1px 0 color-mix(in srgb, var(--schedule-color-weekend-cell, #fff8ed) 55%, #f97316);
}

.schedule-table tbody tr.is-holiday .date-cell,
.schedule-table tbody tr.is-holiday .note-cell,
.schedule-table tbody tr.is-holiday .schedule-cell,
.schedule-table tbody tr.is-holiday .group-summary-cell {
  box-shadow: inset 0 1px 0 color-mix(in srgb, var(--schedule-color-holiday-cell, #fff1f3) 55%, #e11d48), inset 0 -1px 0 color-mix(in srgb, var(--schedule-color-holiday-cell, #fff1f3) 55%, #e11d48);
}

.schedule-table tbody tr.is-weekend:not(.is-public-holiday) .date-cell,
.schedule-table tbody tr.is-weekend:not(.is-public-holiday) .note-cell,
.schedule-table tbody tr.is-weekend:not(.is-public-holiday) .schedule-cell,
.schedule-table tbody tr.is-weekend:not(.is-public-holiday) .group-summary-cell {
  box-shadow: inset 0 1px 0 color-mix(in srgb, var(--schedule-color-weekend-cell, #fff8ed) 48%, #f97316), inset 0 -1px 0 color-mix(in srgb, var(--schedule-color-weekend-cell, #fff8ed) 48%, #f97316);
}

.schedule-table tbody tr.is-today .date-cell,
.schedule-table tbody tr.is-today .note-cell,
.schedule-table tbody tr.is-today .schedule-cell,
.schedule-table tbody tr.is-today .group-summary-cell {
  box-shadow: inset 0 2px 0 color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 42%, var(--schedule-color-selection-border, #2563eb)), inset 0 -2px 0 color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 42%, var(--schedule-color-selection-border, #2563eb)), inset 0 0 0 9999px color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 8%, transparent);
}

.schedule-table tbody tr.is-today .date-cell {
  box-shadow: inset 5px 0 0 color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 30%, var(--schedule-color-selection-border, #2563eb)), inset 0 2px 0 color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 42%, var(--schedule-color-selection-border, #2563eb)), inset 0 -2px 0 color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 42%, var(--schedule-color-selection-border, #2563eb)), inset 0 0 0 9999px color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 10%, transparent);
}

.schedule-cell.is-filled,
.note-cell.is-filled {
  background: var(--schedule-row-filled-bg, #f2fbf7);
}

.schedule-cell.has-milestone {
  box-shadow: inset 0 3px 0 var(--schedule-color-milestone-badge, #7c3aed);
}

.schedule-cell.has-dependency-risk {
  box-shadow: inset 3px 0 0 var(--schedule-color-dependency-risk, #f59e0b);
}

.schedule-cell.has-dependency-delay {
  box-shadow: inset 3px 0 0 var(--schedule-color-dependency-delay, #dc2626);
}

.schedule-cell.has-milestone.has-dependency-risk {
  box-shadow: inset 0 3px 0 var(--schedule-color-milestone-badge, #7c3aed), inset 3px 0 0 var(--schedule-color-dependency-risk, #f59e0b);
}

.schedule-cell.has-milestone.has-dependency-delay {
  box-shadow: inset 0 3px 0 var(--schedule-color-milestone-badge, #7c3aed), inset 3px 0 0 var(--schedule-color-dependency-delay, #dc2626);
}

tr.is-holiday .schedule-cell.has-milestone,
tr.is-holiday .date-cell .milestone-chip {
  background: var(--schedule-color-base-cell, #ffffff);
}

tr.is-holiday .schedule-cell.has-milestone.is-selected,
tr.is-holiday .schedule-cell.has-milestone.is-selected-range,
tr.is-holiday .schedule-cell.has-milestone.is-selection-anchor,
tr.is-holiday .schedule-cell.has-milestone.is-active-cell {
  background: var(--schedule-color-selected-cell, #ffffff) !important;
}

tr.is-today .schedule-cell.has-milestone {
  box-shadow: inset 0 3px 0 var(--schedule-color-milestone-badge, #7c3aed), inset 0 2px 0 color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 42%, var(--schedule-color-selection-border, #2563eb)), inset 0 -2px 0 color-mix(in srgb, var(--schedule-color-today-cell, #e6f2ff) 42%, var(--schedule-color-selection-border, #2563eb));
}

.schedule-cell.is-selected-project {
  background: var(--schedule-row-cell-bg, #ffffff);
}

.schedule-cell.is-selected-project.is-filled {
  background: var(--schedule-row-filled-bg, #f2fbf7);
}

.schedule-cell.is-active,
.note-cell.is-active {
  box-shadow: inset 0 0 0 2px color-mix(in srgb, var(--schedule-color-active-cell-border, #111827) 32%, transparent);
}

.schedule-cell.is-hovered-project {
  background: var(--schedule-column-hover-bg, #f7fbff);
}

.schedule-cell.is-selection-column {
  background: var(--schedule-column-selection-bg, #f5f9ff);
  box-shadow: inset 2px 0 0 var(--schedule-color-selection-border, #2458d3);
}

.schedule-cell.is-selection-column.is-filled {
  background: var(--schedule-color-filled-cell, #f0f8ff);
}

tr.is-selection-row .schedule-cell.is-selection-column,
tr.is-selected-date .schedule-cell.is-selection-column {
  background: var(--schedule-color-selected-cell, #f0f6ff);
  box-shadow: inset 2px 0 0 var(--schedule-color-selection-border, #2458d3), inset 0 1px 0 color-mix(in srgb, var(--schedule-color-selected-cell, #f0f6ff) 60%, var(--schedule-color-selection-border, #2458d3)), inset 0 -1px 0 color-mix(in srgb, var(--schedule-color-selected-cell, #f0f6ff) 60%, var(--schedule-color-selection-border, #2458d3));
}

tr.is-selection-row .note-cell,
tr.is-selection-row .schedule-cell,
tr.is-selection-row .group-summary-cell,
tr.is-selected-date .note-cell,
tr.is-selected-date .schedule-cell,
tr.is-selected-date .group-summary-cell {
  box-shadow: inset 0 1px 0 color-mix(in srgb, var(--schedule-color-row-highlight, #eef6ff) 60%, var(--schedule-color-selection-border, #2458d3)), inset 0 -1px 0 color-mix(in srgb, var(--schedule-color-row-highlight, #eef6ff) 60%, var(--schedule-color-selection-border, #2458d3));
}

.schedule-cell.is-selected,
.schedule-cell.is-selected.is-selected-project,
.schedule-cell.is-selected.is-selection-column {
  background: var(--schedule-color-selected-cell, #ffffff) !important;
  box-shadow: inset 0 0 0 2px var(--schedule-color-selection-border, #2458d3);
}

.schedule-cell.is-selected.is-filled,
.schedule-cell.is-selected.is-filled.is-selected-project,
.schedule-cell.is-selected.is-filled.is-selection-column {
  background: var(--schedule-color-selected-cell, #f2fbf7) !important;
}

.schedule-cell.is-selected-range {
  --schedule-range-selection-border: var(--schedule-color-selection-border, #2563eb);
}

.schedule-cell.is-selected-range,
.schedule-cell.is-selected-range.is-selected-project,
.schedule-cell.is-selected-range.is-selection-column {
  background: var(--schedule-row-base-cell-bg, #ffffff) !important;
  box-shadow: var(--schedule-range-top-shadow, inset 0 0 0 0 transparent), var(--schedule-range-bottom-shadow, inset 0 0 0 0 transparent), var(--schedule-range-left-shadow, inset 0 0 0 0 transparent), var(--schedule-range-right-shadow, inset 0 0 0 0 transparent), inset 0 0 0 1px var(--schedule-range-selection-border, #73baf7);
}

.schedule-cell.is-selected-range.is-filled,
.schedule-cell.is-selected-range.is-filled.is-selected-project,
.schedule-cell.is-selected-range.is-filled.is-selection-column {
  background: var(--schedule-row-base-filled-bg, #f2fbf7) !important;
}

.schedule-cell.is-range-top {
  --schedule-range-top-shadow: inset 0 2px 0 var(--schedule-color-selection-border, #2458d3);
}

.schedule-cell.is-range-bottom {
  --schedule-range-bottom-shadow: inset 0 -2px 0 var(--schedule-color-selection-border, #2458d3);
}

.schedule-cell.is-range-left {
  --schedule-range-left-shadow: inset 2px 0 0 var(--schedule-color-selection-border, #2458d3);
}

.schedule-cell.is-range-right {
  --schedule-range-right-shadow: inset -2px 0 0 var(--schedule-color-selection-border, #2458d3);
}

.schedule-cell.is-selection-anchor {
  background: var(--schedule-color-selected-cell, #ffffff) !important;
  box-shadow: inset 0 0 0 2px var(--schedule-color-selection-anchor, #0f766e);
}

.schedule-cell.is-selection-anchor.is-filled {
  background: var(--schedule-color-selected-cell, #f2fbf7) !important;
}

.schedule-cell.is-active-cell,
.schedule-cell.is-active-cell.is-selected-project,
.schedule-cell.is-active-cell.is-selection-column {
  background: var(--schedule-color-selected-cell, #ffffff) !important;
  box-shadow: inset 0 0 0 3px var(--schedule-color-active-cell-border, #111827), 0 0 0 1px rgba(255, 255, 255, 0.86);
}

.schedule-cell.is-active-cell.is-filled,
.schedule-cell.is-active-cell.is-filled.is-selected-project,
.schedule-cell.is-active-cell.is-filled.is-selection-column {
  background: var(--schedule-color-selected-cell, #f2fbf7) !important;
}

.schedule-cell:focus-within::after,
.schedule-cell.is-selected::after,
.schedule-cell.is-selected-range:focus-within::after,
.schedule-cell.is-selection-anchor::after,
.schedule-cell.is-active-cell::after {
  content: "";
  position: absolute;
  inset: 4px;
  z-index: 8;
  border: 2px solid var(--schedule-color-selection-border, #2458d3);
  border-radius: 6px;
  box-shadow: 0 0 0 3px rgba(36, 88, 211, 0.16);
  pointer-events: none;
}

.schedule-cell.is-selection-anchor::after {
  border-color: var(--schedule-color-selection-anchor, #0f8b6f);
  box-shadow: 0 0 0 3px rgba(15, 139, 111, 0.18);
}

.schedule-cell.is-active-cell::after {
  border-color: var(--schedule-color-active-cell-border, #111827);
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.12);
}

.schedule-cell.is-selected .schedule-cell-preview,
.schedule-cell.is-selected .empty-cell-button,
.schedule-cell.is-selected .schedule-cell-input {
  font-weight: 800;
}

.schedule-cell.is-completed-dimmed .schedule-cell-input,
.schedule-cell.is-completed-dimmed .schedule-cell-preview,
.schedule-cell.is-completed-dimmed .empty-cell-button {
  opacity: 0.48;
}

.schedule-cell.is-completed-dimmed.is-selected .schedule-cell-input,
.schedule-cell.is-completed-dimmed.is-selected .schedule-cell-preview,
.schedule-cell.is-completed-dimmed.is-active .schedule-cell-input,
.schedule-cell.is-completed-dimmed.is-active .schedule-cell-preview {
  opacity: 0.72;
}

.schedule-cell.is-completed-dimmed.is-selected-range .schedule-cell-input,
.schedule-cell.is-completed-dimmed.is-selected-range .schedule-cell-preview,
.schedule-cell.is-completed-dimmed.is-selected-range .empty-cell-button {
  opacity: 0.68;
}

tr.is-selected-week .date-cell,
tr.is-selected-week .note-cell,
tr.is-selected-week .schedule-cell,
tr.is-selected-week .group-summary-cell {
  box-shadow: inset 0 1px 0 rgba(96, 165, 250, 0.26), inset 0 -1px 0 rgba(96, 165, 250, 0.26);
}

tr.is-selected-week .date-cell {
  box-shadow: inset 3px 0 0 var(--schedule-color-selection-border, #60a5fa), inset 0 1px 0 rgba(96, 165, 250, 0.26), inset 0 -1px 0 rgba(96, 165, 250, 0.26);
}

tr.is-selected-week .date-cell.has-date-row-height-override {
  box-shadow: inset 3px 0 0 var(--schedule-color-selection-border, #2458d3), inset 6px 0 0 var(--schedule-color-row-highlight, #60a5fa), inset 0 1px 0 rgba(96, 165, 250, 0.26), inset 0 -1px 0 rgba(96, 165, 250, 0.26);
}

tr.is-selected-date .date-cell,
tr.is-selection-row .date-cell,
.date-cell.is-selection-row-header {
  box-shadow: inset 0 0 0 2px var(--schedule-color-selection-border, #2458d3);
}

tr.is-selected-date .date-cell.has-date-row-height-override,
tr.is-selection-row .date-cell.has-date-row-height-override,
.date-cell.is-selection-row-header.has-date-row-height-override {
  box-shadow: inset 3px 0 0 var(--schedule-color-selection-border, #2458d3), inset 0 0 0 2px var(--schedule-color-selection-border, #2458d3);
}

.schedule-cell-input,
.schedule-note-input {
  width: 100%;
  height: var(--schedule-row-height);
  display: block;
  align-content: center;
  box-sizing: border-box;
  resize: none;
  padding: 10px;
  border: 1px solid transparent;
  background: transparent;
  color: #17191f;
  font-size: 13px;
  line-height: 1.45;
  overflow-wrap: anywhere;
  outline: none;
  text-align: center;
  vertical-align: middle;
}

.schedule-note-input {
  color: #344054;
  font-weight: 700;
}

.schedule-cell-preview {
  width: 100%;
  height: var(--schedule-row-height);
  min-width: 0;
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 4px;
  box-sizing: border-box;
  padding: 8px 9px;
  overflow: hidden;
  border: 1px solid transparent;
  background: transparent;
  color: #17191f;
  text-align: center;
  cursor: pointer;
  outline: none;
}

.schedule-cell-preview:hover {
  background: rgba(36, 88, 211, 0.05);
}

.cell-milestone-list {
  position: absolute;
  top: 4px;
  right: 4px;
  left: 4px;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  max-width: none;
  overflow: hidden;
  pointer-events: auto;
}

.cell-milestone-chip {
  width: 18px;
  height: 18px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.76);
  box-shadow: 0 1px 4px rgba(23, 25, 31, 0.18);
}

.cell-milestone-add {
  position: absolute;
  right: 4px;
  bottom: 4px;
  z-index: 6;
  width: 28px;
  height: 20px;
  padding: 0;
  border: 1px solid #c4b5fd;
  border-radius: 6px;
  background: #ffffff;
  color: #5b21b6;
  font-size: 9px;
  font-weight: 900;
  line-height: 1;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.14s ease;
}

.cell-detail-open-button {
  position: absolute;
  right: 36px;
  bottom: 4px;
  z-index: 6;
  min-width: 34px;
  height: 20px;
  padding: 0 6px;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  background: #ffffff;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 900;
  line-height: 1;
  opacity: 0;
  pointer-events: none;
  outline: none;
  transition: opacity 0.14s ease;
}

.schedule-cell:hover .cell-milestone-add,
.schedule-cell:focus-within .cell-milestone-add,
.schedule-cell.is-selected .cell-milestone-add,
.schedule-cell.is-selection-anchor .cell-milestone-add,
.schedule-cell:hover .cell-detail-open-button,
.schedule-cell:focus-within .cell-detail-open-button,
.schedule-cell.is-selected .cell-detail-open-button,
.schedule-cell.is-selection-anchor .cell-detail-open-button {
  opacity: 1;
  pointer-events: auto;
}

.schedule-cell.has-milestone .schedule-cell-preview {
  padding-top: 26px;
  padding-bottom: 26px;
}

.cell-preview-badges {
  min-width: 0;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3px;
  max-height: 20px;
  overflow: hidden;
}

.cell-status-badge,
.cell-type-badge,
.cell-dependency-badge,
.cell-time-badge {
  min-width: 0;
  max-width: 100%;
  min-height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  overflow: hidden;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-status-badge {
  background: var(--schedule-color-status-badge, #dbeafe);
  color: var(--schedule-color-status-badge-text, #1d4ed8);
}

.cell-type-badge {
  background: var(--schedule-color-type-badge, #e7f5ef);
  color: var(--schedule-color-type-badge-text, #087f5b);
}

.cell-time-badge {
  background: var(--schedule-color-time-badge, #fff7e6);
  color: var(--schedule-color-time-badge-text, #b45309);
}

.cell-dependency-badge {
  background: var(--schedule-color-dependency-badge, #fff1f2);
  color: var(--schedule-color-dependency-badge-text, #be123c);
}

.cell-preview-title,
.cell-preview-body {
  min-width: 0;
  display: -webkit-box;
  overflow: hidden;
  overflow-wrap: anywhere;
  text-align: center;
  text-overflow: ellipsis;
  word-break: keep-all;
  -webkit-box-orient: vertical;
}

.cell-preview-title {
  color: #17191f;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.25;
  -webkit-line-clamp: 2;
}

.cell-preview-body {
  color: #475467;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.25;
  -webkit-line-clamp: 1;
}

.empty-cell-button {
  width: 100%;
  height: var(--schedule-row-height);
  display: grid;
  place-items: center;
  box-sizing: border-box;
  appearance: none;
  padding: 0;
  border: 1px solid transparent;
  background: transparent;
  cursor: text;
  font: inherit;
  outline: none;
  text-align: center;
  vertical-align: middle;
}

.empty-cell-button:hover {
  background: rgba(36, 88, 211, 0.05);
}

.empty-cell-button--note:hover {
  background: rgba(15, 139, 111, 0.06);
}

.schedule-board.is-row-compact .date-cell {
  padding-right: 8px;
  padding-left: 8px;
}

.schedule-board.is-row-compact .date-cell-meta {
  max-height: 18px;
  gap: 4px;
  margin-top: 2px;
  overflow: hidden;
}

.schedule-board.is-row-compact .date-weekday {
  font-size: 11px;
}

.schedule-board.is-row-compact .holiday-badge {
  min-height: 18px;
  padding: 0 5px;
  font-size: 10px;
}

.schedule-board.is-row-compact .schedule-cell-input,
.schedule-board.is-row-compact .schedule-note-input {
  padding: 6px 8px;
  line-height: 1.35;
}

.schedule-board.is-row-compact .schedule-cell-preview,
.schedule-board.is-density-compact .schedule-cell-preview {
  gap: 3px;
  padding: 5px 7px;
}

.schedule-board.is-row-compact .cell-preview-badges,
.schedule-board.is-density-compact .cell-preview-badges {
  max-height: 18px;
  gap: 2px;
}

.schedule-board.is-row-compact .cell-status-badge,
.schedule-board.is-row-compact .cell-type-badge,
.schedule-board.is-row-compact .cell-time-badge,
.schedule-board.is-density-compact .cell-status-badge,
.schedule-board.is-density-compact .cell-type-badge,
.schedule-board.is-density-compact .cell-time-badge {
  min-height: 16px;
  padding: 0 4px;
  font-size: 9px;
}

.schedule-board.is-row-compact .cell-preview-title,
.schedule-board.is-density-compact .cell-preview-title {
  font-size: 11px;
  line-height: 1.2;
  -webkit-line-clamp: 1;
}

.schedule-board.is-row-compact .cell-preview-body,
.schedule-board.is-density-compact .cell-preview-body {
  display: none;
}

.schedule-board.is-row-spacious .schedule-cell-input,
.schedule-board.is-row-spacious .schedule-note-input {
  padding: 12px 10px;
}

.schedule-board.is-row-spacious .schedule-cell-preview,
.schedule-board.is-density-comfortable .schedule-cell-preview {
  gap: 5px;
  padding: 10px;
}

.schedule-board.is-row-spacious .cell-preview-title,
.schedule-board.is-density-comfortable .cell-preview-title {
  font-size: 13px;
  -webkit-line-clamp: 2;
}

.schedule-board.is-row-spacious .cell-preview-body,
.schedule-board.is-density-comfortable .cell-preview-body {
  -webkit-line-clamp: 2;
}

.schedule-board tr.is-date-row-compact .date-cell {
  padding-right: 8px;
  padding-left: 8px;
}

.schedule-board tr.is-date-row-compact .date-cell-main {
  padding: 0 24px;
}

.schedule-board tr.is-date-row-compact .date-row-height-tools {
  right: 6px;
  gap: 2px;
}

.schedule-board tr.is-date-row-compact .date-cell-meta {
  max-height: 18px;
  gap: 4px;
  margin-top: 2px;
  overflow: hidden;
}

.schedule-board tr.is-date-row-compact .date-weekday {
  font-size: 11px;
}

.schedule-board tr.is-date-row-compact .holiday-badge {
  min-height: 18px;
  padding: 0 5px;
  font-size: 10px;
}

.schedule-board tr.is-date-row-compact .schedule-cell-input,
.schedule-board tr.is-date-row-compact .schedule-note-input {
  padding: 6px 8px;
  line-height: 1.35;
}

.schedule-board tr.is-date-row-compact .schedule-cell-preview {
  gap: 3px;
  padding: 5px 7px;
}

.schedule-board tr.is-date-row-compact .cell-preview-badges {
  max-height: 18px;
  gap: 2px;
}

.schedule-board tr.is-date-row-compact .cell-status-badge,
.schedule-board tr.is-date-row-compact .cell-type-badge,
.schedule-board tr.is-date-row-compact .cell-time-badge {
  min-height: 16px;
  padding: 0 4px;
  font-size: 9px;
}

.schedule-board tr.is-date-row-compact .cell-preview-title {
  font-size: 11px;
  line-height: 1.2;
  -webkit-line-clamp: 1;
}

.schedule-board tr.is-date-row-compact .cell-preview-body {
  display: none;
}

.schedule-board tr.is-date-row-default .date-cell {
  padding: 8px 10px;
}

.schedule-board tr.is-date-row-default .date-row-height-tools {
  top: 8px;
}

.schedule-board tr.is-date-row-default .date-cell-meta {
  max-height: none;
  gap: 5px;
  margin-top: 4px;
  overflow: visible;
}

.schedule-board tr.is-date-row-default .date-weekday {
  font-size: 12px;
}

.schedule-board tr.is-date-row-default .holiday-badge {
  min-height: 20px;
  padding: 0 6px;
  font-size: 11px;
}

.schedule-board tr.is-date-row-default .schedule-cell-input,
.schedule-board tr.is-date-row-default .schedule-note-input {
  padding: 10px;
  line-height: 1.45;
}

.schedule-board tr.is-date-row-spacious .date-cell {
  padding-top: 12px;
  padding-bottom: 12px;
}

.schedule-board tr.is-date-row-spacious .date-row-height-tools {
  top: 12px;
}

.schedule-board tr.is-date-row-spacious .schedule-cell-input,
.schedule-board tr.is-date-row-spacious .schedule-note-input {
  padding: 12px 10px;
}

.schedule-mobile-list {
  display: none;
}

.mobile-list-empty {
  display: grid;
  gap: 6px;
  padding: 18px;
  border: 1px dashed #cfd6e2;
  border-radius: 8px;
  background: #ffffff;
  text-align: center;
}

.mobile-list-empty strong {
  color: #17191f;
  font-size: 14px;
  font-weight: 800;
}

.mobile-list-empty span {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.mobile-day-card {
  min-height: var(--schedule-row-height);
  display: grid;
  gap: 10px;
  padding: 12px;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: var(--schedule-color-base-cell, #ffffff);
}

.mobile-day-card.is-holiday {
  border-color: #f3c2c8;
  background: var(--schedule-color-holiday-cell, #fff8f8);
}

.mobile-day-card.is-today {
  border-color: #9ccaff;
  background: var(--schedule-color-today-cell, #eff6ff);
}

.mobile-day-card.is-selected-week {
  border-color: var(--schedule-color-row-highlight, #b9cffd);
  background: var(--schedule-color-row-highlight, #edf5ff);
  box-shadow: inset 0 0 0 1px var(--schedule-color-row-highlight, #b9cffd);
}

.mobile-day-card.is-selected-date {
  border-color: var(--schedule-color-selection-border, #2458d3);
  box-shadow: inset 0 0 0 2px var(--schedule-color-selection-border, #2458d3);
}

.mobile-day-card.has-row-height-override {
  border-left: 4px solid #2458d3;
}

.mobile-day-card.is-row-compact {
  gap: 8px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.mobile-day-card.is-row-spacious {
  gap: 12px;
  padding-top: 14px;
  padding-bottom: 14px;
}

.mobile-day-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.mobile-day-head > div:first-child {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.mobile-day-head strong {
  color: #17191f;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.25;
}

.mobile-day-head span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.mobile-day-count {
  min-height: 24px;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
}

.mobile-display-density {
  min-height: 24px;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 0 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #f1f5f9;
  color: #334155;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-day-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 5px;
  max-width: 150px;
}

.mobile-row-height-select {
  width: 74px;
  padding: 0 5px;
}

.mobile-row-height-badge {
  background: #dbeafe;
}

.mobile-day-head .mobile-row-height-badge {
  color: #1d4ed8;
  font-size: 10px;
}

.mobile-day-note-block {
  min-width: 0;
  display: grid;
  gap: 7px;
}

.mobile-day-note {
  padding: 8px 10px;
  overflow: hidden;
  border-radius: 6px;
  background: #f6f8fb;
  color: #344054;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.mobile-day-note-edit-action {
  min-width: 0;
  min-height: 38px;
  justify-self: start;
  max-width: 100%;
  padding: 0 11px;
  overflow: hidden;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #ffffff;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-day-note-edit-action[aria-pressed=true] {
  border-color: #2458d3;
  background: #eef6ff;
  color: #1d4ed8;
}

.mobile-day-note-inline-editor {
  width: 100%;
  min-width: 0;
  min-height: 92px;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #9ccaff;
  border-radius: 8px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
  resize: vertical;
  overflow-wrap: anywhere;
}

.mobile-milestone-list {
  display: grid;
  gap: 6px;
}

.mobile-milestone-chip {
  grid-template-columns: 22px minmax(0, 1fr) auto;
  gap: 7px;
  min-height: 36px;
  padding: 7px 9px 7px 6px;
}

.mobile-milestone-chip span {
  width: 20px;
  height: 20px;
  display: inline-grid;
  place-items: center;
  border-radius: 6px;
  background: #6d28d9;
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
}

.mobile-milestone-chip strong {
  min-width: 0;
  overflow: hidden;
  color: #211a35;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-milestone-chip small {
  min-width: 0;
  max-width: 92px;
  overflow: hidden;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-group-list {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.mobile-project-group {
  min-width: 0;
  display: grid;
  gap: 8px;
  padding: 9px;
  overflow: hidden;
  border: 1px solid #d9dde5;
  border-left: 4px solid #64748b;
  border-radius: 8px;
  background: #ffffff;
}

.mobile-project-group.is-collapsed {
  background: #f8fbff;
}

.mobile-group-toggle {
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #17191f;
  text-align: left;
}

.mobile-group-toggle:focus-visible {
  outline: 2px solid #2458d3;
  outline-offset: 3px;
  border-radius: 6px;
}

.mobile-group-color {
  width: 10px;
  min-height: 30px;
  align-self: stretch;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.64);
}

.mobile-group-main {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.mobile-group-title {
  min-width: 0;
  display: -webkit-box;
  overflow: hidden;
  color: #17191f;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.25;
  overflow-wrap: anywhere;
  word-break: keep-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.mobile-group-meta {
  min-width: 0;
  display: block;
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-group-state {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid #cfd6e2;
  border-radius: 999px;
  background: #ffffff;
  color: #344054;
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
}

.mobile-group-body {
  min-width: 0;
}

.mobile-group-collapsed-summary {
  min-width: 0;
  display: grid;
  gap: 3px;
  padding: 8px 9px;
  border-radius: 6px;
  background: #eef6ff;
}

.mobile-group-collapsed-summary strong,
.mobile-group-collapsed-summary span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-group-collapsed-summary strong {
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 900;
}

.mobile-group-collapsed-summary span {
  color: #475467;
  font-size: 11px;
  font-weight: 800;
}

.mobile-group-collapsed-summary .mobile-group-milestone {
  width: max-content;
  max-width: 100%;
  padding: 2px 6px;
  border: 1px solid #ddd6fe;
  border-radius: 999px;
  background: #ffffff;
  color: #5b21b6;
}

.mobile-group-collapsed-summary .mobile-group-dependency {
  width: max-content;
  max-width: 100%;
  padding: 2px 6px;
  border: 1px solid #fed7aa;
  border-radius: 999px;
  background: #ffffff;
  color: #b45309;
}

.mobile-collapsed-group-summaries {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 100%;
}

.mobile-group-summary-chip {
  min-width: 0;
  max-width: 100%;
  display: grid;
  grid-template-columns: minmax(0, auto) auto;
  gap: 2px 6px;
  padding: 7px 9px;
  border: 1px solid #d9dde5;
  border-left: 4px solid #64748b;
  border-radius: 8px;
  background: #fbfdff;
  color: #344054;
}

.mobile-group-summary-chip strong,
.mobile-group-summary-chip span,
.mobile-group-summary-chip small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-group-summary-chip strong {
  max-width: 130px;
  color: #1f2937;
  font-size: 11px;
  font-weight: 900;
}

.mobile-group-summary-chip span {
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 900;
}

.mobile-group-summary-chip small {
  grid-column: 1/-1;
  max-width: 220px;
  color: #667085;
  font-size: 10px;
  font-weight: 800;
}

.mobile-entry-list {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.mobile-schedule-entry {
  width: 100%;
  min-height: 64px;
  min-width: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  align-items: start;
  gap: 10px;
  padding: 10px;
  overflow: hidden;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: var(--schedule-color-project-cell, #fbfcfd);
  color: #17191f;
  text-align: left;
}

.mobile-entry-main-button {
  min-width: 0;
  max-width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 10px;
  overflow: hidden;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
}

.mobile-entry-main-button:focus-visible {
  outline: 2px solid #2458d3;
  outline-offset: 3px;
  border-radius: 6px;
}

.mobile-entry-actions {
  min-width: 86px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
}

.mobile-entry-action {
  min-height: 32px;
  padding: 0 9px;
  overflow: hidden;
  border: 1px solid #cfd6e2;
  border-radius: 7px;
  background: #ffffff;
  color: #344054;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-entry-action--milestone {
  border-color: #c4b5fd;
  background: #fbf8ff;
  color: #5b21b6;
}

.mobile-entry-action:focus-visible {
  outline: 2px solid rgba(36, 88, 211, 0.35);
  outline-offset: 2px;
}

.mobile-schedule-entry.is-selected {
  border-color: var(--schedule-color-selection-border, #2458d3);
  background: var(--schedule-color-selected-cell, #eef6ff);
  box-shadow: inset 0 0 0 1px var(--schedule-color-selection-border, #2458d3);
}

.mobile-schedule-entry.is-selected-range {
  border-color: var(--schedule-color-selection-border, #73baf7);
  box-shadow: inset 0 0 0 1px var(--schedule-color-selection-border, #73baf7);
}

.mobile-schedule-entry.is-selection-anchor {
  border-color: var(--schedule-color-selection-anchor, #0f8b6f);
  background: var(--schedule-color-selected-cell, #eef6ff);
  box-shadow: inset 0 0 0 2px var(--schedule-color-selection-anchor, #0f8b6f);
}

.mobile-schedule-entry.is-active-cell {
  border-color: var(--schedule-color-active-cell-border, #111827);
  background: var(--schedule-color-selected-cell, #eef6ff);
  box-shadow: inset 0 0 0 2px var(--schedule-color-active-cell-border, #111827);
}

.mobile-schedule-entry.has-dependency-risk {
  border-left: 4px solid var(--schedule-color-dependency-risk, #f59e0b);
}

.mobile-schedule-entry.has-dependency-delay {
  border-left: 4px solid var(--schedule-color-dependency-delay, #dc2626);
}

.mobile-schedule-entry.is-completed-dimmed {
  opacity: 0.58;
}

.mobile-schedule-entry.is-completed-dimmed.is-selected {
  opacity: 0.76;
}

.mobile-day-card.is-density-compact .mobile-project-group {
  gap: 6px;
  padding: 7px;
}

.mobile-day-card.is-density-compact .mobile-schedule-entry {
  min-height: 52px;
  gap: 8px;
  padding: 8px;
}

.mobile-day-card.is-density-compact .mobile-entry-main strong,
.mobile-day-card.is-density-compact .mobile-entry-main .mobile-entry-title {
  -webkit-line-clamp: 1;
}

.mobile-day-card.is-density-compact .mobile-entry-main .mobile-entry-preview {
  display: none;
}

.mobile-day-card.is-density-comfortable .mobile-schedule-entry {
  min-height: 72px;
  padding: 12px;
}

.mobile-day-card.is-density-comfortable .mobile-entry-main .mobile-entry-title,
.mobile-day-card.is-density-comfortable .mobile-entry-main .mobile-entry-preview {
  -webkit-line-clamp: 3;
}

.mobile-entry-color {
  width: 10px;
  min-height: 42px;
  align-self: stretch;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.64);
}

.mobile-entry-main {
  min-width: 0;
  max-width: 100%;
  display: grid;
  gap: 4px;
}

.mobile-entry-main strong {
  display: -webkit-box;
  overflow: hidden;
  color: #17191f;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.3;
  overflow-wrap: anywhere;
  text-overflow: ellipsis;
  word-break: keep-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.mobile-entry-main span {
  display: -webkit-box;
  overflow: hidden;
  color: #475467;
  font-size: 13px;
  line-height: 1.45;
  text-overflow: ellipsis;
  word-break: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.mobile-entry-main .mobile-entry-title {
  color: #17191f;
  font-weight: 800;
  line-height: 1.35;
}

.mobile-entry-main .mobile-entry-preview {
  color: #667085;
  font-size: 12px;
  line-height: 1.35;
}

.mobile-entry-badges {
  min-width: 0;
  max-width: 120px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 4px;
  overflow: hidden;
}

.mobile-entry-badges span {
  min-width: 0;
  max-width: 100%;
  min-height: 22px;
  display: inline-flex;
  align-items: center;
  padding: 0 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-entry-badges .mobile-status-badge {
  background: var(--schedule-color-status-badge, #dbeafe);
  color: var(--schedule-color-status-badge-text, #1d4ed8);
}

.mobile-entry-badges .mobile-type-badge {
  background: var(--schedule-color-type-badge, #e7f5ef);
  color: var(--schedule-color-type-badge-text, #087f5b);
}

.mobile-entry-badges .mobile-dependency-badge {
  background: var(--schedule-color-dependency-badge, #fff1f2);
  color: var(--schedule-color-dependency-badge-text, #be123c);
}

.mobile-entry-badges .mobile-time-badge {
  background: var(--schedule-color-time-badge, #fff7e6);
  color: var(--schedule-color-time-badge-text, #b45309);
}

.mobile-entry-inline-editor {
  grid-column: 2/-1;
  width: 100%;
  min-width: 0;
  min-height: 96px;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #9ccaff;
  border-radius: 8px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
  resize: vertical;
  overflow-wrap: anywhere;
}

.cell-detail-panel {
  min-width: 0;
  padding: 16px;
  background: #fbfcfd;
}

.cell-detail-panel.is-empty {
  display: grid;
  place-items: center;
}

.cell-detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e9f0;
}

.cell-detail-kicker,
.cell-detail-editor span,
.cell-detail-footer,
.cell-detail-empty span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.cell-detail-head h3 {
  margin: 4px 0 0;
  color: #17191f;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0;
  word-break: keep-all;
}

.cell-detail-head p {
  margin-top: 6px;
  color: #475467;
  font-size: 13px;
  font-weight: 700;
}

.cell-detail-close {
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  border: 1px solid #d9dde5;
  border-radius: 6px;
  background: #ffffff;
  color: #667085;
  font-size: 19px;
  line-height: 1;
}

.cell-detail-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 14px 0;
}

.cell-detail-meta span:not(.cell-detail-color) {
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
}

.cell-detail-meta .cell-detail-dependency-state {
  background: #fff7e6;
  color: #b45309;
}

.cell-detail-color {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.72), 0 0 0 1px rgba(17, 24, 39, 0.08);
}

.cell-detail-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 0 0 14px;
}

.cell-detail-select {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.cell-detail-select span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.cell-detail-select select {
  width: 100%;
  min-width: 0;
  height: 38px;
  padding: 0 10px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  outline: none;
}

.cell-time-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: end;
  gap: 8px;
  margin: 0 0 14px;
  padding: 10px;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  background: #f8fafc;
}

.time-field {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.time-field span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.time-field input {
  width: 100%;
  min-width: 0;
  height: 36px;
  box-sizing: border-box;
  padding: 0 10px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  outline: none;
}

.time-field input[readonly] {
  background: #eef2f7;
  color: #475467;
}

.time-clear-button,
.dependency-clear-button,
.cell-dependency-toggle {
  min-height: 36px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  outline: none;
}

.time-clear-button {
  padding: 0 10px;
  white-space: nowrap;
}

.cell-dependency-editor {
  display: grid;
  gap: 8px;
  margin: 0 0 14px;
  padding: 10px;
  border: 1px solid #f1d7ac;
  border-radius: 8px;
  background: #fffaf2;
}

.cell-dependency-editor:not(.is-open) {
  border-color: #d9dde5;
  background: #ffffff;
}

.dependency-editor-head {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.dependency-editor-head > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.dependency-editor-head strong {
  min-width: 0;
  display: block;
  overflow: hidden;
  color: #92400e;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-dependency-toggle {
  flex: 0 0 auto;
  padding: 0 12px;
}

.dependency-editor-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.dependency-clear-button {
  grid-column: 1/-1;
  justify-self: end;
  padding: 0 12px;
}

.dependency-field {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.dependency-field span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.dependency-field input,
.dependency-field select {
  width: 100%;
  min-width: 0;
  height: 36px;
  box-sizing: border-box;
  padding: 0 10px;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  outline: none;
}

.cell-detail-editor {
  display: grid;
  gap: 8px;
}

.cell-detail-textarea {
  width: 100%;
  min-height: 260px;
  box-sizing: border-box;
  resize: vertical;
  padding: 12px;
  border: 1px solid #cfd6e2;
  border-radius: 8px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  line-height: 1.55;
  overflow-wrap: anywhere;
  outline: none;
  text-align: left;
  white-space: pre-wrap;
}

.cell-detail-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}

.cell-detail-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.cell-detail-message {
  margin-top: 10px;
  color: #0f8b6f;
  font-size: 12px;
  font-weight: 800;
}

.cell-detail-message.is-warning {
  color: #b45309;
}

.cell-detail-message.is-error {
  color: #be123c;
}

.cell-detail-message.is-success {
  color: #0f8b6f;
}

.selected-cell-milestones,
.milestone-editor {
  display: grid;
  gap: 10px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #e5e9f0;
}

.milestone-section-head,
.milestone-editor-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.milestone-section-head strong,
.milestone-editor-head h3 {
  display: block;
  margin-top: 3px;
  color: #17191f;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.25;
}

.selected-milestone-list {
  display: grid;
  gap: 8px;
}

.selected-milestone-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: stretch;
  border: 1px solid #d8d4ea;
  border-left: 4px solid #7c3aed;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
}

.selected-milestone-main {
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 8px;
  padding: 8px 10px;
  border: 0;
  border-left: 0;
  border-radius: 0;
}

.selected-milestone-main span {
  width: 22px;
  height: 22px;
  display: inline-grid;
  place-items: center;
  border-radius: 6px;
  background: #6d28d9;
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
}

.selected-milestone-main strong,
.selected-milestone-main small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-milestone-main strong {
  color: #211a35;
  font-size: 12px;
  font-weight: 900;
}

.selected-milestone-main small {
  grid-column: 2;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.selected-milestone-delete {
  width: 48px;
  border: 0;
  border-left: 1px solid #e5e9f0;
  background: #fff8f8;
  color: #be123c;
  font-size: 11px;
  font-weight: 900;
}

.selected-milestone-empty {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.milestone-editor-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.milestone-field,
.milestone-color-field {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.milestone-field--title,
.milestone-field--note,
.milestone-color-field {
  grid-column: 1/-1;
}

.milestone-field span,
.milestone-color-field > span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.milestone-field input,
.milestone-field select,
.milestone-field textarea {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid #cfd6e2;
  border-radius: 6px;
  background: #ffffff;
  color: #17191f;
  font-size: 13px;
  font-weight: 700;
  outline: none;
}

.milestone-field textarea {
  overflow-wrap: anywhere;
  text-align: left;
  white-space: pre-wrap;
}

.milestone-field input,
.milestone-field select {
  height: 36px;
  padding: 0 10px;
}

.milestone-field textarea {
  resize: vertical;
  min-height: 86px;
  padding: 10px;
  line-height: 1.45;
}

.milestone-color-options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.milestone-color-option {
  width: 26px;
  height: 26px;
  border: 2px solid #ffffff;
  border-radius: 7px;
  box-shadow: 0 0 0 1px #cfd6e2;
}

.milestone-color-option.is-active {
  box-shadow: 0 0 0 2px #17191f;
}

.milestone-editor-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.cell-detail-empty {
  max-width: 260px;
  display: grid;
  gap: 8px;
  text-align: center;
}

.cell-detail-empty strong {
  color: #17191f;
  font-size: 17px;
  font-weight: 800;
}

.cell-detail-empty p {
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}

.filter-empty {
  height: 120px;
  background: #ffffff;
  color: #667085;
  font-size: 13px;
  font-weight: 800;
  text-align: center;
  vertical-align: middle;
}

@media (max-width: 1100px) {
  .top-controls-grid {
    grid-template-columns: 1fr;
  }
  .cell-color-control-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .schedule-quick-filters {
    grid-template-columns: 1fr;
  }
  .schedule-saved-views {
    grid-template-columns: 1fr;
  }
  .planner-summary-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 920px) {
  :host {
    position: static;
    inset: auto;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: auto;
    min-height: 100vh;
    margin-left: 0;
    margin-right: 0;
    overflow-x: hidden;
    overflow-y: visible;
  }
  .schedule-page {
    position: static;
    height: auto;
    min-height: 100vh;
    padding: 14px;
    overflow-x: hidden;
    overflow-y: visible;
  }
  .schedule-top-controls {
    max-height: none;
    overflow: visible;
  }
  .schedule-utility-stack {
    --schedule-utility-collapsed-height: 104px;
  }
  .schedule-workbench {
    display: block;
    flex: 0 1 auto;
    min-height: 0;
    overflow: visible;
  }
  .schedule-header,
  .schedule-toolbar {
    display: grid;
  }
  .schedule-header {
    margin-bottom: 8px;
  }
  .schedule-view-controls {
    justify-content: flex-start;
  }
  .schedule-essential-actions {
    justify-content: flex-start;
  }
  .schedule-clipboard-panel {
    grid-template-columns: 1fr;
  }
  .planner-timeline-row,
  .planner-workload-row {
    grid-template-columns: 1fr;
  }
  .schedule-utility-strip {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .clipboard-actions {
    justify-content: flex-start;
  }
  .schedule-transfer-body {
    grid-template-columns: 1fr;
  }
  .group-manager-grid {
    grid-template-columns: 1fr;
  }
  .quick-filter-grid {
    grid-template-columns: 1fr;
  }
  .schedule-quick-filters {
    grid-template-columns: 1fr;
  }
  .quick-filter-head {
    align-items: flex-start;
  }
  .schedule-saved-views {
    grid-template-columns: 1fr;
  }
  .group-create-fields {
    grid-template-columns: minmax(180px, 1fr) minmax(190px, 1fr) auto;
  }
  .schedule-transfer-panel {
    grid-template-columns: 1fr;
  }
  .schedule-export {
    padding-top: 12px;
    padding-left: 0;
    border-top: 1px solid #e5e9f0;
    border-left: 0;
  }
  .schedule-print-export {
    padding-top: 12px;
    padding-left: 0;
    border-top: 1px solid #e5e9f0;
    border-left: 0;
  }
  .import-controls,
  .export-controls {
    justify-content: flex-start;
  }
  .schedule-summary-panel {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .summary-item:nth-child(2),
  .summary-item:nth-child(4) {
    border-right: 0;
  }
  .project-management-head {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .project-management-meta {
    grid-column: 1/-1;
    justify-content: flex-start;
    order: 3;
  }
  .project-chip {
    grid-template-columns: 28px 28px minmax(120px, 1fr) 74px 74px 50px 28px;
    width: 100%;
  }
  .project-add-panel,
  .project-add {
    min-width: 0;
  }
  .project-add input,
  .project-add input:first-child {
    width: 100%;
    flex: 1 1 160px;
  }
  .schedule-table-wrap {
    height: var(--schedule-table-height);
    max-height: calc(100vh - 300px);
  }
  .schedule-scroll-context {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 18;
    min-height: 28px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: calc(100vw - 28px);
    padding: 0 10px;
    border-right: 1px solid #d9dde5;
    border-bottom: 1px solid #d9dde5;
    border-bottom-right-radius: 8px;
    background: rgba(248, 250, 252, 0.96);
    color: #475467;
    font-size: 11px;
    font-weight: 900;
    white-space: nowrap;
    box-shadow: 0 8px 18px rgba(16, 24, 40, 0.08);
  }
  .schedule-scroll-context strong {
    color: #1d4ed8;
    font-weight: 900;
  }
  .schedule-scroll-context i {
    font-style: normal;
    color: #0f8b6f;
    letter-spacing: 0;
  }
  .schedule-table thead .group-header-row th {
    top: 28px;
  }
  .schedule-table thead .project-header-row th {
    top: 72px;
  }
  .schedule-table thead .date-head,
  .schedule-table thead .note-head {
    top: 28px;
  }
  .schedule-board {
    min-height: 360px;
    overflow: visible;
    grid-template-columns: 1fr;
  }
  .schedule-board.has-detail-panel {
    grid-template-columns: 1fr;
  }
  .schedule-table-wrap {
    border-right: 0;
    border-bottom: 1px solid #d9dde5;
  }
  .cell-detail-panel {
    min-height: 320px;
  }
}
@media (max-width: 620px) {
  .schedule-page {
    padding: 10px;
  }
  .schedule-utility-stack {
    --schedule-utility-collapsed-height: 176px;
  }
  .schedule-header {
    gap: 7px;
  }
  .schedule-title {
    align-items: flex-start;
    min-width: 0;
    gap: 9px;
  }
  .schedule-title > div:last-child {
    min-width: 0;
  }
  .schedule-mark {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }
  h1 {
    font-size: 21px;
  }
  .schedule-eyebrow {
    margin-bottom: 2px;
    font-size: 10px;
  }
  .schedule-subtitle,
  .schedule-toolbar p {
    display: none;
  }
  .planner-summary-grid {
    gap: 8px;
  }
  .planner-timeline-panel,
  .planner-workload-panel {
    padding: 8px;
  }
  .planner-workload-counts {
    grid-template-columns: repeat(3, minmax(54px, 1fr));
  }
  .schedule-essential-actions,
  .top-control-switches,
  .schedule-utility-strip,
  .utility-toggle-head {
    width: 100%;
  }
  .schedule-essential-actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 6px;
  }
  .top-controls-toggle {
    width: auto;
    min-width: 78px;
    min-height: 38px;
    justify-content: center;
    padding: 0 10px;
  }
  .top-control-card,
  .schedule-utility-strip,
  .schedule-row-density,
  .schedule-bulk-tools {
    padding: 10px;
  }
  .top-control-switches {
    grid-template-columns: 1fr;
  }
  .cell-color-control-grid {
    grid-template-columns: 1fr;
  }
  .cell-color-control {
    grid-template-columns: minmax(0, 1fr) 38px auto auto;
  }
  .utility-toggle-head {
    grid-template-columns: 1fr;
  }
  .utility-panel-toggle {
    width: 100%;
  }
  .schedule-utility-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .utility-strip-button {
    min-height: 42px;
  }
  .schedule-summary-panel {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .schedule-summary-head {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 8px 10px;
  }
  .schedule-summary-actions {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: stretch;
  }
  .summary-status-badge,
  .summary-toggle,
  .summary-retry-button {
    width: 100%;
    justify-content: center;
  }
  .schedule-essential-actions .summary-status-badge {
    width: auto;
    min-width: 0;
    overflow: hidden;
    border-radius: 8px;
    text-overflow: ellipsis;
  }
  .schedule-essential-actions .summary-retry-button {
    width: auto;
    min-height: 38px;
  }
  .schedule-toolbar {
    position: sticky;
    top: 0;
    z-index: 32;
    gap: 7px;
    padding: 8px 10px;
    box-shadow: 0 8px 20px rgba(16, 24, 40, 0.08);
  }
  .schedule-toolbar-heading {
    gap: 4px;
  }
  .schedule-mobile-context {
    min-width: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
  }
  .schedule-mobile-context span {
    min-width: 0;
    max-width: 100%;
    min-height: 22px;
    display: inline-flex;
    align-items: center;
    padding: 0 7px;
    overflow: hidden;
    border-radius: 999px;
    background: #eef2f7;
    color: #475467;
    font-size: 11px;
    font-weight: 900;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .schedule-mobile-context span:last-child {
    background: #eef6ff;
    color: #1d4ed8;
  }
  .summary-item,
  .summary-item:nth-child(2),
  .summary-item:nth-child(4) {
    border-right: 1px solid #edf0f4;
    border-bottom: 1px solid #edf0f4;
  }
  .summary-item:nth-child(2n),
  .summary-item--sync {
    border-right: 0;
  }
  .summary-item:last-child {
    border-bottom: 0;
  }
  .summary-item {
    padding: 8px 10px;
  }
  .summary-item strong {
    font-size: 14px;
  }
  .schedule-actions {
    justify-content: stretch;
  }
  .schedule-history-actions {
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .schedule-history-count {
    grid-column: 1/-1;
    justify-content: center;
  }
  .schedule-history-btn {
    min-width: 0;
    width: 100%;
  }
  .schedule-clipboard-panel {
    padding: 10px;
    grid-template-columns: 1fr;
  }
  .clipboard-selection-summary strong,
  .clipboard-selection-summary small {
    white-space: normal;
    word-break: keep-all;
  }
  .clipboard-actions {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .clipboard-actions .schedule-btn {
    width: 100%;
    min-height: 42px;
    padding: 0 8px;
  }
  .clipboard-fill-field {
    grid-template-columns: 1fr;
  }
  .clipboard-fill-field .schedule-btn {
    width: 100%;
    min-height: 42px;
  }
  .schedule-view-controls,
  .schedule-quick-view-strip,
  .schedule-mobile-filter-strip,
  .row-density-control,
  .row-height-control,
  .row-height-segment {
    width: 100%;
  }
  .row-density-control {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
  .row-height-control {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
  }
  .row-height-direct {
    grid-template-columns: auto minmax(0, 1fr) auto;
  }
  .density-inline-control {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
  }
  .density-inline-segment {
    width: 100%;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .row-density-reset {
    width: 100%;
  }
  .calendar-jump-control,
  .calendar-jump-options {
    width: 100%;
  }
  .calendar-jump-control {
    align-items: flex-start;
  }
  .calendar-jump-options {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .schedule-quick-view-strip {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .schedule-quick-view-option {
    padding: 0 5px;
  }
  .calendar-jump-option {
    padding: 0 8px;
  }
  .schedule-view-controls {
    gap: 6px;
  }
  .schedule-mobile-filter-strip {
    order: -1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
  }
  .schedule-mobile-filter-option {
    width: 100%;
    min-height: 44px;
    padding: 0 8px;
  }
  .legend {
    width: 100%;
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 2px;
    scrollbar-width: none;
  }
  .legend::-webkit-scrollbar {
    display: none;
  }
  .legend-chip {
    flex: 0 0 auto;
    min-height: 22px;
    padding: 0 8px;
    font-size: 11px;
  }
  .view-options-toggle,
  .group-panel-toggle {
    width: 100%;
  }
  .schedule-view-options {
    padding: 10px 12px;
  }
  .view-options-grid {
    display: grid;
    grid-template-columns: 1fr;
  }
  .view-option-toggle {
    width: 100%;
    justify-content: flex-start;
  }
  .cell-density-control {
    width: 100%;
    display: grid;
    gap: 7px;
  }
  .cell-density-segment {
    width: 100%;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .schedule-quick-filters {
    padding: 10px 12px 12px;
  }
  .quick-filter-head,
  .quick-filter-actions {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
  }
  .schedule-saved-views {
    padding: 10px 12px 12px;
  }
  .saved-view-head {
    grid-template-columns: 1fr;
  }
  .saved-view-panel-close {
    width: 100%;
    justify-self: stretch;
  }
  .saved-view-actions,
  .saved-view-item {
    grid-template-columns: 1fr;
  }
  .saved-view-list {
    grid-template-columns: 1fr;
  }
  .saved-view-feedback {
    width: 100%;
    border-radius: 8px;
    padding: 7px 9px;
  }
  .saved-view-delete {
    min-height: 32px;
    border-left: 0;
    border-top: 1px solid #e2e6ee;
  }
  .schedule-transfer {
    padding: 9px 12px;
  }
  .schedule-transfer-head {
    grid-template-columns: 1fr;
  }
  .schedule-transfer-summary strong {
    white-space: normal;
    word-break: break-word;
  }
  .schedule-transfer-toggle {
    width: 100%;
  }
  .quick-filter-head {
    display: grid;
    justify-content: stretch;
  }
  .quick-filter-reset {
    width: 100%;
  }
  .quick-filter-options {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .quick-filter-option {
    padding: 0 7px;
  }
  .active-filter-chips {
    display: grid;
    grid-template-columns: 1fr;
  }
  .active-filter-chip {
    width: 100%;
    justify-content: space-between;
    border-radius: 8px;
  }
  .row-height-option {
    flex: 1 1 0;
    min-width: 0;
    padding: 0 8px;
  }
  .schedule-btn {
    flex: 1 1 auto;
  }
  .import-controls .schedule-btn,
  .export-controls .schedule-btn,
  .print-export-controls .schedule-btn,
  .import-file-button {
    width: 100%;
  }
  .import-copy strong,
  .export-copy strong {
    white-space: normal;
    word-break: break-word;
  }
  .import-file-meta .import-file-name,
  .export-file-meta .export-file-name {
    max-width: 100%;
    flex: 1 1 100%;
  }
  .schedule-projects {
    align-items: stretch;
    padding: 10px;
  }
  .schedule-utility-dialog {
    align-items: end;
    padding: 10px;
  }
  .project-management-window {
    width: 100%;
    min-height: 0;
    max-height: calc(100vh - 20px);
    max-height: calc(100dvh - 20px);
    border-radius: 8px;
  }
  .utility-dialog-window {
    width: 100%;
    min-height: 0;
    max-height: calc(100vh - 20px);
    max-height: calc(100dvh - 20px);
  }
  .project-management-head {
    grid-template-columns: 1fr;
    padding: 12px;
  }
  .project-management-toggle {
    width: 100%;
  }
  .project-management-panel {
    padding: 12px;
  }
  .utility-dialog-panel {
    padding: 12px;
  }
  .project-management-meta {
    width: 100%;
  }
  .project-management-meta span {
    flex: 1 1 112px;
    justify-content: center;
    border-radius: 8px;
  }
  .project-add-card-head {
    display: grid;
    gap: 10px;
  }
  .group-manager-head,
  .group-assignment-head {
    display: grid;
    justify-content: stretch;
  }
  .group-manager-feedback {
    max-width: 100%;
    border-radius: 8px;
    padding: 7px 9px;
  }
  .group-create-fields,
  .group-edit-item,
  .group-assignment-row {
    grid-template-columns: 1fr;
  }
  .group-project-order-row {
    grid-template-columns: 1fr;
  }
  .project-chip {
    grid-template-columns: 28px 28px 28px minmax(88px, 1fr) minmax(120px, 1fr) 1fr;
  }
  .project-chip input {
    grid-column: 1/-1;
  }
  .project-visibility-state,
  .project-schedule-count,
  .project-dependency-count {
    min-width: 0;
  }
  .project-dependency-count {
    right: 40px;
    max-width: 96px;
  }
  .project-column-order-actions {
    width: 100%;
    grid-template-columns: 1fr 1fr;
    grid-column: 1/-2;
  }
  .project-column-order-btn {
    width: 100%;
  }
  .project-management-row-height-field {
    grid-template-columns: 1fr;
  }
  .project-row-height-reset {
    width: 100%;
  }
  .group-edit-item {
    align-items: stretch;
  }
  .group-edit-color {
    width: 100%;
    height: 10px;
    border-radius: 999px;
  }
  .group-delete {
    width: 100%;
  }
  .group-order-actions {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .group-order-btn {
    width: 100%;
  }
  .group-project-order-title,
  .group-project-order-project {
    align-items: flex-start;
  }
  .group-project-order-title {
    display: grid;
    grid-template-columns: 10px minmax(0, 1fr);
  }
  .group-project-order-title small {
    grid-column: 2;
  }
  .project-add-toggle {
    width: 100%;
  }
  .project-add {
    display: grid;
    width: 100%;
  }
  .project-color-picker {
    align-items: flex-start;
  }
  .color-swatch-list {
    flex-wrap: wrap;
  }
  .filter-control,
  .filter-control--search,
  .filter-control select,
  .filter-reset,
  .filter-result {
    width: 100%;
    min-width: 0;
  }
  .filter-result {
    margin-left: 0;
  }
  .selected-project-view {
    grid-template-columns: 10px minmax(0, 1fr);
  }
  .selected-project-clear {
    grid-column: 1/-1;
    width: 100%;
  }
  .schedule-table-wrap {
    display: block;
    min-height: min(64vh, 620px);
    height: min(68vh, var(--schedule-table-height));
  }
  .date-row-height-drag-handle {
    display: none;
  }
  .schedule-mobile-list {
    display: none;
  }
  .cell-detail-panel {
    position: sticky;
    bottom: 0;
    z-index: 35;
    max-height: min(78vh, 720px);
    overflow: auto;
    border-top: 1px solid #d9dde5;
    border-radius: 12px 12px 0 0;
    box-shadow: 0 -16px 36px rgba(16, 24, 40, 0.18);
    padding-bottom: calc(16px + env(safe-area-inset-bottom));
  }
  .mobile-schedule-entry {
    grid-template-columns: 10px minmax(0, 1fr);
    gap: 9px;
    padding: 9px;
  }
  .mobile-entry-main-button {
    width: 100%;
    grid-template-columns: 1fr;
    gap: 7px;
  }
  .mobile-entry-main strong,
  .mobile-entry-main .mobile-entry-title,
  .mobile-entry-main .mobile-entry-preview {
    -webkit-line-clamp: 2;
  }
  .mobile-entry-actions {
    grid-column: 2;
    width: 100%;
    min-width: 0;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mobile-entry-action {
    min-height: 40px;
    padding: 0 8px;
    font-size: 12px;
  }
  .mobile-day-note-edit-action {
    width: 100%;
    justify-self: stretch;
  }
  .mobile-entry-inline-editor {
    grid-column: 2;
  }
  .mobile-group-summary-chip {
    max-width: 100%;
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .mobile-group-summary-chip strong,
  .mobile-group-summary-chip small {
    max-width: 100%;
  }
  .mobile-group-toggle {
    grid-template-columns: 10px minmax(0, 1fr);
  }
  .mobile-group-state {
    grid-column: 2;
    justify-self: start;
  }
  .mobile-day-head {
    flex-wrap: wrap;
  }
  .mobile-day-actions {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }
  .mobile-display-density {
    flex: 1 1 160px;
    justify-content: center;
  }
  .mobile-entry-badges {
    grid-column: 2;
    max-width: 100%;
    justify-content: flex-start;
  }
  .mobile-entry-main-button .mobile-entry-badges {
    grid-column: auto;
  }
  .mobile-milestone-chip {
    grid-template-columns: 22px minmax(0, 1fr);
  }
  .mobile-milestone-chip small {
    grid-column: 2;
    max-width: 100%;
  }
  .milestone-editor-grid {
    grid-template-columns: 1fr;
  }
  .selected-milestone-item {
    grid-template-columns: 1fr;
  }
  .selected-milestone-delete {
    width: 100%;
    min-height: 30px;
    border-left: 0;
    border-top: 1px solid #e5e9f0;
  }
  .milestone-editor-actions {
    display: grid;
    grid-template-columns: 1fr;
  }
  .milestone-editor-actions .schedule-btn {
    width: 100%;
  }
  .project-chip {
    grid-template-columns: 28px 28px 28px minmax(120px, 1fr) 50px 28px;
  }
  .project-chip input:nth-of-type(2),
  .project-chip input:nth-of-type(3) {
    display: none;
  }
  .cell-detail-fields {
    grid-template-columns: 1fr;
  }
  .cell-time-editor {
    grid-template-columns: 1fr;
  }
  .time-clear-button,
  .dependency-clear-button {
    width: 100%;
  }
  .project-column-resize-handle,
  .date-column-resize-handle,
  .project-row-height-resize-handle {
    display: none;
  }
  .dependency-editor-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-height: 560px) {
  .schedule-projects,
  .schedule-utility-dialog {
    place-items: end center;
    align-items: end;
    padding: 8px 8px 0;
  }
  .project-management-window,
  .utility-dialog-window {
    width: min(100%, 100vw - 16px);
    min-height: 0;
    max-height: min(88vh, 100vh - 8px);
    max-height: min(88dvh, 100dvh - 8px);
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .project-management-head {
    padding: 10px 12px;
  }
  .project-management-panel,
  .utility-dialog-panel {
    padding: 10px 12px 12px;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
}
@media (hover: none) and (pointer: coarse) {
  .schedule-btn,
  .summary-toggle,
  .top-control-switch,
  .calendar-jump-option,
  .quick-filter-option,
  .view-option-toggle,
  .mobile-row-height-select,
  .mobile-entry-action {
    min-height: 40px;
  }
  .clipboard-actions .schedule-btn,
  .clipboard-fill-field .schedule-btn,
  .milestone-editor-actions .schedule-btn,
  .cell-detail-actions .schedule-btn {
    min-height: 42px;
  }
  .cell-milestone-list {
    top: 6px;
    right: 6px;
    gap: 4px;
  }
  .cell-milestone-chip {
    width: 24px;
    height: 24px;
    font-size: 10px;
  }
  .cell-milestone-add {
    right: 6px;
    bottom: 6px;
    width: 36px;
    height: 28px;
    font-size: 10px;
    opacity: 1;
    pointer-events: auto;
  }
  .date-milestone-add {
    min-width: 42px;
    height: 30px;
    font-size: 11px;
    opacity: 1;
    pointer-events: auto;
  }
  .schedule-cell.has-milestone .schedule-cell-preview {
    padding-top: 34px;
    padding-bottom: 38px;
  }
  .project-column-resize-handle,
  .date-column-resize-handle {
    right: -9px;
    width: 18px;
  }
  .date-row-height-drag-handle,
  .project-row-height-resize-handle {
    bottom: -8px;
    height: 16px;
  }
}
@media print {
  @page {
    size: A4 landscape;
    margin: 10mm;
  }
  :host {
    display: block;
    height: auto;
    overflow: visible;
  }
  .schedule-page {
    width: auto;
    height: auto;
    min-height: auto;
    padding: 0;
    overflow: visible;
    background: #ffffff;
    color: #17191f;
  }
  .schedule-header,
  .schedule-summary,
  .schedule-workbench {
    border: 0;
    box-shadow: none;
  }
  .schedule-header {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #d9dde5;
  }
  .schedule-actions,
  .schedule-view-controls,
  .schedule-utility-strip,
  .schedule-row-density,
  .schedule-bulk-tools,
  .schedule-clipboard-panel,
  .schedule-quick-filters,
  .schedule-saved-views,
  .schedule-filters,
  .schedule-view-options,
  .schedule-group-manager,
  .schedule-transfer,
  .schedule-utility-dialog,
  .schedule-projects,
  .cell-detail-panel,
  .column-size-hint,
  .project-column-resize-handle,
  .date-column-size-control,
  .project-row-size-control,
  .date-column-resize-handle,
  .project-row-height-resize-handle,
  .date-row-height-tools,
  .date-row-height-drag-handle,
  .date-milestone-add,
  .cell-milestone-add,
  .empty-date-note-button,
  .empty-cell-button {
    display: none !important;
  }
  .schedule-toolbar {
    display: block;
    padding: 0 0 8px;
    border: 0;
    background: #ffffff;
  }
  .schedule-toolbar h2 {
    margin: 0;
    color: #17191f;
    font-size: 16px;
  }
  .schedule-toolbar p {
    display: block;
    margin: 3px 0 0;
    color: #667085;
    font-size: 11px;
  }
  .schedule-board {
    display: block;
    min-height: 0;
  }
  .schedule-table-wrap {
    width: var(--schedule-print-table-width);
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    border: 1px solid #d9dde5;
    transform-origin: top left;
    zoom: var(--schedule-print-scale);
  }
  .schedule-table {
    width: var(--schedule-print-table-width);
    min-width: var(--schedule-print-table-width);
    table-layout: fixed;
    background: #ffffff;
    font-size: 10px;
  }
  .schedule-cell-grid {
    width: max-content;
    min-width: 100%;
    background: #ffffff;
    font-size: 10px;
  }
  .schedule-grid-header-row,
  .schedule-grid-corner,
  .schedule-grid-project-head {
    position: static !important;
    left: auto !important;
    top: auto !important;
  }
  .schedule-grid-header-row {
    min-height: 74px;
  }
  .schedule-grid-corner,
  .schedule-grid-date-head {
    min-height: 74px;
    padding: 6px 8px;
    background: #f0f4f8 !important;
  }
  .schedule-date-note-input {
    min-height: 28px;
    max-height: 36px;
    padding: 4px 6px;
    border: 0;
    background: transparent;
  }
  .schedule-grid-project-head {
    padding: 6px 8px 6px 10px;
  }
  .sticky-col,
  .schedule-table thead th {
    position: static !important;
    left: auto !important;
    top: auto !important;
  }
  .schedule-table thead th,
  .schedule-table thead .group-header-row th,
  .schedule-table thead .project-header-row th,
  .schedule-table thead .date-head,
  .schedule-table thead .note-head {
    height: auto;
    min-height: 32px;
    padding: 6px;
    background: #f0f4f8 !important;
  }
  .schedule-table tr,
  .schedule-table th,
  .schedule-table td {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .schedule-cell,
  .note-cell,
  .date-cell,
  .group-summary-cell {
    height: var(--schedule-row-height);
  }
  .schedule-note-input,
  .schedule-cell-input {
    border: 0;
    background: transparent;
    resize: none;
  }
  .schedule-cell-preview {
    border: 0;
    background: transparent;
    box-shadow: none;
  }
  .cell-preview-badges,
  .cell-preview-title,
  .cell-preview-body,
  .date-cell-main,
  .row-group-summary {
    break-inside: avoid;
  }
  .schedule-mobile-list {
    display: none !important;
  }
}`],
})
export class PageCalenderComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public pageTitle: string = "일정 관리 - calender";
    public loading: boolean = true;
    public storageKey: string = "manager.schedule.continuous.v1";
    public storageBackupKey: string = "manager.schedule.continuous.v1.backupBeforeServer";
    public dashboardPanelStateKey: string = "manager.schedule.continuous.v1.dashboardPanels";
    public schemaVersion: number = 1;
    public updatedAt: string = "";
    public lastLocalSavedAtIso: string = "";
    public lastServerSavedAt: string = "";
    public lastServerSavedAtIso: string = "";
    public lastServerRevision: string = "";
    public persistenceStatus: string = "checking";
    public persistenceMessage: string = "저장 상태 확인 중";
    public persistenceDetail: string = "서버 연결 상태를 확인합니다.";
    public serverStorageReady: boolean = false;
    public serverReadOnly: boolean = true;
    public pendingServerSaveCount: number = 0;
    public lastFailedServerSave: any = null;
    public serverSaveSequence: number = 0;
    public lastSuccessfulServerSaveSequence: number = 0;
    public lastFailedServerSaveSequence: number = 0;
    public serverStatusUpdatedAt: string = "";
    public projects: any[] = [];
    public rows: any[] = [];
    public newProjectName: string = "";
    public newProjectPm: string = "";
    public newProjectOwner: string = "";
    public newProjectColor: string = "";
    public projectFormMessage: string = "";
    public projectFormStatus: string = "";
    public scheduleSummaryExpanded: boolean = false;
    public projectManagementExpanded: boolean = false;
    public projectAddExpanded: boolean = false;
    public scheduleTopControlsExpanded: boolean = false;
    public scheduleDetailExpanded: boolean = false;
    public rowDensityPanelExpanded: boolean = false;
    public bulkToolsExpanded: boolean = false;
    public quickFiltersExpanded: boolean = false;
    public savedViewsExpanded: boolean = false;
    public searchFiltersExpanded: boolean = false;
    public plannerSummaryExpanded: boolean = false;
    public lowerUtilityPanelOpenedInSession: boolean = false;
    public activeUtilityDialog: string = "";
    public activeEditKey: string = "";
    public inlineCellEditKey: string = "";
    public inlineCellDraft: string = "";
    public inlineCellOriginalValue: string = "";
    public inlineCellStartedByTyping: boolean = false;
    public inlineCellSuppressBlurCommit: boolean = false;
    public hoveredScheduleDate: string = "";
    public hoveredScheduleProjectId: string = "";
    public saveTimer: any = null;
    public saveDelay: number = 250;
    public extensionDays: number = 30;
    public filledEntryCount: number = 0;
    public projectScheduleCounts: any = {};
    public searchText: string = "";
    public selectedProjectId: string = "";
    public activeCell: any = null;
    public selectedCell: any = null;
    public selectedCellDraft: string = "";
    public selectedCellStatus: string = "예정";
    public selectedCellType: string = "업무";
    public selectedCellTime: string = "";
    public selectedCellDependencyEditorOpen: boolean = false;
    public selectedCellPredecessorDate: string = "";
    public selectedCellPredecessorProjectId: string = "";
    public selectedCellSuccessorDate: string = "";
    public selectedCellSuccessorProjectId: string = "";
    public selectedCellMessage: string = "";
    public defaultCellStatus: string = "예정";
    public defaultCellType: string = "업무";
    public cellStatusOptions: string[] = ["예정", "진행", "완료", "지연", "보류"];
    public cellTypeOptions: string[] = ["업무", "회의", "검토", "이슈"];
    public authReady: boolean = false;
    public authAllowed: boolean = false;
    public dashboardMessage: string = "";
    public projectSaveTimers: any = {};
    public entrySaveTimers: any = {};
    public importState: string = "idle";
    public importMessage: string = "xlsx, xlsm, xls, csv 파일을 선택하세요.";
    public importDetail: string = "선택한 파일은 아직 일정표에 반영하지 않습니다.";
    public importBusy: boolean = false;
    public importFile: any = null;
    public importRowsPreview: any = {
        rows: [],
        rowCount: 0,
        columnCount: 0,
        truncated: false
    };
    public importApiResult: any = null;
    public importAllowedExtensions: string[] = ["xlsx", "xlsm", "xls", "csv"];
    public scheduleTransferExpanded: boolean = false;
    public exportState: string = "idle";
    public exportMessage: string = "CSV 내보내기";
    public exportDetail: string = "Excel에서 바로 열 수 있는 UTF-8 CSV";
    public exportBusy: boolean = false;
    public exportFileName: string = "";
    public printExportState: string = "idle";
    public printExportMessage: string = "인쇄/PDF 이미지 내보내기";
    public printExportDetail: string = "현재 일정표 보기 기준으로 회의 공유용 산출물을 만듭니다.";
    public printExportFileName: string = "";
    public printExportBusy: boolean = false;
    public printExportActive: boolean = false;
    public printExportAfterPrintHandler: any = null;
    public printExportCleanupTimer: any = null;
    public holidayInfoCache: any = {};
    public rowHeightPresetOptions: any = ROW_HEIGHT_PRESET_OPTIONS;
    public scheduleQuickViewOptions: any = SCHEDULE_QUICK_VIEW_PRESETS;
    public mobileQuickFilterOptions: any = SCHEDULE_QUICK_VIEW_PRESETS.filter((preset: any) => ["today", "week", "mine"].indexOf(preset.key) >= 0);
    public cellDensityOptions: any[] = [
        { key: "compact", label: "컴팩트", shortLabel: "촘촘하게" },
        { key: "standard", label: "기본", shortLabel: "기본" },
        { key: "comfortable", label: "넓게", shortLabel: "여유롭게" }
    ];
    public scheduleCellColorPresets: any = SCHEDULE_CELL_COLOR_PRESETS;
    public scheduleCellColorControls: any[] = [
        { key: "baseCell", label: "기본 셀" },
        { key: "personalCell", label: "개인 칸" },
        { key: "projectHeaderCell", label: "프로젝트 헤더" },
        { key: "projectCell", label: "프로젝트 셀" },
        { key: "weekendCell", label: "주말" },
        { key: "holidayCell", label: "휴일" },
        { key: "todayCell", label: "오늘" },
        { key: "filledCell", label: "일정 있음" },
        { key: "selectedCell", label: "선택 셀" },
        { key: "rowHighlight", label: "행 강조" },
        { key: "columnHighlight", label: "열 강조" },
        { key: "statusBadge", label: "상태 배지" },
        { key: "typeBadge", label: "유형 배지" },
        { key: "dependencyBadge", label: "의존성 배지" },
        { key: "timeBadge", label: "시간 배지" },
        { key: "milestoneBadge", label: "마일스톤 배지" },
        { key: "selectionBorder", label: "선택 테두리" },
        { key: "selectionAnchor", label: "기준 셀" },
        { key: "activeCellBorder", label: "활성 셀" },
        { key: "dependencyRisk", label: "의존성 위험" },
        { key: "dependencyDelay", label: "의존성 지연" }
    ];
    public scheduleCellColorMessage: string = "";
    public scheduleCellColorStatus: string = "";
    public viewPrefs: any = normalizeViewPrefs({});
    public projectGroups: any[] = [];
    public savedViews: any[] = [];
    public milestones: any[] = [];
    public rowHeightMinPx: number = ROW_HEIGHT_MIN_PX;
    public rowHeightMaxPx: number = ROW_HEIGHT_MAX_PX;
    public rowHeightDefaultPx: number = ROW_HEIGHT_DEFAULT_PX;
    public rowHeightDirectStepPx: number = 2;
    public rowHeightKeyboardStepPx: number = 8;
    public mobileRowHeightMinPx: number = 76;
    public projectColumnWidthMinPx: number = PROJECT_COLUMN_WIDTH_MIN_PX;
    public projectColumnWidthMaxPx: number = PROJECT_COLUMN_WIDTH_MAX_PX;
    public projectColumnWidthDefaultPx: number = PROJECT_COLUMN_WIDTH_DEFAULT_PX;
    public projectColumnWidthStepPx: number = PROJECT_COLUMN_WIDTH_STEP_PX;
    public noteColumnWidthMinPx: number = NOTE_COLUMN_WIDTH_MIN_PX;
    public noteColumnWidthMaxPx: number = NOTE_COLUMN_WIDTH_MAX_PX;
    public noteColumnWidthDefaultPx: number = NOTE_COLUMN_WIDTH_DEFAULT_PX;
    public noteColumnWidthStepPx: number = NOTE_COLUMN_WIDTH_STEP_PX;
    public dateColumnWidthMinPx: number = DATE_COLUMN_WIDTH_MIN_PX;
    public dateColumnWidthMaxPx: number = DATE_COLUMN_WIDTH_MAX_PX;
    public dateColumnWidthDefaultPx: number = DATE_COLUMN_WIDTH_DEFAULT_PX;
    public dateColumnWidthStepPx: number = DATE_COLUMN_WIDTH_STEP_PX;
    public projectRowHeaderWidthPx: number = PROJECT_ROW_HEADER_WIDTH_PX;
    public projectRowHeightMinPx: number = PROJECT_ROW_HEIGHT_MIN_PX;
    public projectRowHeightMaxPx: number = PROJECT_ROW_HEIGHT_MAX_PX;
    public projectRowHeightDefaultPx: number = PROJECT_ROW_HEIGHT_DEFAULT_PX;
    public projectRowHeightStepPx: number = PROJECT_ROW_HEIGHT_STEP_PX;
    public projectHeaderRowHeightMinPx: number = PROJECT_HEADER_ROW_HEIGHT_MIN_PX;
    public projectHeaderRowHeightMaxPx: number = PROJECT_HEADER_ROW_HEIGHT_MAX_PX;
    public projectHeaderRowHeightDefaultPx: number = PROJECT_HEADER_ROW_HEIGHT_DEFAULT_PX;
    public projectHeaderRowHeightStepPx: number = PROJECT_HEADER_ROW_HEIGHT_STEP_PX;
    public rowHeightDragState: any = null;
    public isRowHeightDragging: boolean = false;
    public rowHeightPointerMoveHandler: any = null;
    public rowHeightPointerUpHandler: any = null;
    public rowHeightPointerCancelHandler: any = null;
    public dateColumnResizeState: any = null;
    public isDateColumnResizing: boolean = false;
    public dateColumnPointerMoveHandler: any = null;
    public dateColumnPointerUpHandler: any = null;
    public dateColumnPointerCancelHandler: any = null;
    public lastDateColumnResizePointerDown: any = null;
    public projectColumnResizeState: any = null;
    public isProjectColumnResizing: boolean = false;
    public projectColumnPointerMoveHandler: any = null;
    public projectColumnPointerUpHandler: any = null;
    public projectColumnPointerCancelHandler: any = null;
    public lastScheduleColumnResizePointerDown: any = null;
    public resizeDoubleClickWindowMs: number = 450;
    public resizeDoubleClickDistancePx: number = 8;
    public lastResizePointerDown: any = null;
    public projectRowHeightResizeState: any = null;
    public isProjectRowHeightResizing: boolean = false;
    public projectRowHeightPointerMoveHandler: any = null;
    public projectRowHeightPointerUpHandler: any = null;
    public projectRowHeightPointerCancelHandler: any = null;
    public lastProjectRowHeightResizePointerDown: any = null;
    public projectHeaderRowHeightResizeState: any = null;
    public isProjectHeaderRowHeightResizing: boolean = false;
    public projectHeaderRowHeightPointerMoveHandler: any = null;
    public projectHeaderRowHeightPointerUpHandler: any = null;
    public projectHeaderRowHeightPointerCancelHandler: any = null;
    public projectCardDragState: any = null;
    public groupPanelExpanded: boolean = false;
    public viewOptionsPanelExpanded: boolean = false;
    public newGroupName: string = "";
    public newGroupColor: string = "";
    public newGroupProjectId: string = "";
    public groupFormMessage: string = "";
    public groupFormStatus: string = "";
    public savedViewName: string = "";
    public savedViewMessage: string = "";
    public savedViewStatus: string = "";
    public ungroupedProjectGroupId: string = UNGROUPED_PROJECT_GROUP_ID;
    public scheduleFocusDateKey: string = "";
    public scheduleFocusWeekStartKey: string = "";
    public scheduleFocusWeekEndKey: string = "";
    public scheduleFocusMode: string = "";
    public scheduleNavigationMessage: string = "";
    public scheduleNavigationStatus: string = "";
    public undoStack: any[] = [];
    public redoStack: any[] = [];
    public undoStackLimit: number = 40;
    public undoCoalesceKey: string = "";
    public undoCoalesceTimer: any = null;
    public historyKeydownHandler: any = null;
    public historyFeedbackMessage: string = "";
    public historyFeedbackStatus: string = "";
    public isHistoryRestoring: boolean = false;
    public selectedCellKeys: string[] = [];
    public selectionAnchorCell: any = null;
    public clipboardCopyHandler: any = null;
    public clipboardPasteHandler: any = null;
    public cellWorkflowKeydownHandler: any = null;
    public cellWorkflowRenderFrame: any = null;
    public cellWorkflowRenderDelayMs: number = 48;
    public activeCellScrollTimer: any = null;
    public activeCellScrollFollowupTimer: any = null;
    public cellRangeDragState: any = null;
    public cellRangeDragEndHandler: any = null;
    public suppressCellActivationKey: string = "";
    public clipboardPasteText: string = "";
    public clipboardFillValue: string = "";
    public clipboardMessage: string = "";
    public clipboardStatus: string = "";
    public clipboardOverwriteConfirmThreshold: number = 4;
    public milestonePanelOpen: boolean = false;
    public selectedMilestoneId: string = "";
    public milestoneDraftTitle: string = "";
    public milestoneDraftDate: string = "";
    public milestoneDraftScope: string = "common";
    public milestoneDraftProjectId: string = "";
    public milestoneDraftColor: string = DEFAULT_MILESTONE_COLOR;
    public milestoneDraftIcon: string = "flag";
    public milestoneDraftNote: string = "";
    public milestoneMessage: string = "";
    public milestoneStatus: string = "";
    public activeProjectMemoProjectId: string = "";
    public projectMemoMaxLength: number = 500;
    public milestoneIconOptions: any[] = [
        { key: "flag", label: "Flag" },
        { key: "diamond", label: "Diamond" },
        { key: "pin", label: "Pin" },
        { key: "star", label: "Star" }
    ];
    public milestoneScopeOptions: any[] = [
        { key: "common", label: "공통" },
        { key: "project", label: "프로젝트" }
    ];
    public plannerSummaryCache: any = {
        key: "",
        data: null
    };
    public plannerSummaryRevision: number = 0;

    public palette: string[] = [
        "#2458d3",
        "#0f8b6f",
        "#b45309",
        "#7c3aed",
        "#c2410c",
        "#be123c",
        "#047857",
        "#0369a1"
    ];

    public async ngOnInit() {
        this.applyPageTitle();
        await this.service.init();
        await this.service.auth.init();
        this.authReady = true;
        this.authAllowed = !!this.service.auth.check();
        if (!this.authAllowed) {
            this.loading = false;
            this.dashboardMessage = "로그인 후 일정 관리 화면을 사용할 수 있습니다.";
            await this.service.render();
            return;
        }

        const sheet = await this.loadInitialSheet();
        this.applySheetState(sheet);
        this.applyDashboardPanelState(this.readDashboardPanelState());
        this.clearScheduleHistory();
        this.installUndoRedoShortcuts();
        this.installScheduleClipboardHandlers();
        this.installCellWorkflowKeyboardHandlers();
        this.refreshMetrics();
        this.loading = false;
        await this.service.render();
        this.scheduleInitialTodayScroll();
    }

    public applyPageTitle() {
        try {
            if (typeof document !== "undefined") {
                document.title = this.pageTitle;
                const appTitle = document.querySelector("meta[name='apple-mobile-web-app-title']");
                if (appTitle) appTitle.setAttribute("content", this.pageTitle);
            }
            if (typeof window !== "undefined" && window.parent && window.parent !== window) {
                window.parent.postMessage({
                    type: "reviewops:title",
                    title: this.pageTitle,
                    path: "/calender"
                }, "*");
                window.parent.postMessage({
                    type: "wiz:frame-title",
                    title: this.pageTitle,
                    path: "/calender"
                }, "*");
            }
        } catch (e) {
            // Title updates should not block dashboard rendering.
        }
    }

    public ngOnDestroy() {
        this.removeUndoRedoShortcuts();
        this.removeScheduleClipboardHandlers();
        this.removeCellWorkflowKeyboardHandlers();
        this.clearCellWorkflowRenderFrame();
        this.clearActiveCellScrollTimer();
        this.cleanupCellRangeDrag();
        this.clearUndoCoalesceTimer();
        this.finishPrintExportSession(false);
        this.cleanupDateRowHeightDrag();
        this.cleanupDateColumnResize();
        this.cleanupProjectColumnResize();
        this.cleanupProjectHeaderRowHeightResize();
        this.cleanupProjectRowHeightResize();
        this.resetCellInlineDraft();
        this.projectCardDragState = null;
        this.activeProjectMemoProjectId = "";
    }

    public async goAccess() {
        this.service.href("/access");
        await this.service.render();
    }

    public applySheetState(sheet: any) {
        const normalized = sheet && Array.isArray(sheet.projects) && Array.isArray(sheet.rows) ? sheet : this.defaultSheet();
        this.projects = normalized.projects;
        this.rows = normalized.rows;
        this.milestones = normalizeMilestones(normalized.milestones, this.projects);
        const convenience = normalizeScheduleConvenienceState(normalized, this.projects, this.rows);
        this.viewPrefs = convenience.viewPrefs;
        this.projectGroups = convenience.projectGroups;
        this.savedViews = convenience.savedViews;
        this.syncFilterInputsFromViewPrefs();
    }

    public readDashboardPanelState() {
        try {
            const saved = localStorage.getItem(this.dashboardPanelStateKey);
            if (!saved) return null;
            const parsed = JSON.parse(saved);
            return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null;
        } catch (e) {
            return null;
        }
    }

    public isDashboardPanelOpenFlag(value: any) {
        return value === true;
    }

    public applyDashboardPanelState(state: any) {
        void state;
        this.scheduleSummaryExpanded = false;
        this.projectManagementExpanded = false;
        this.projectAddExpanded = false;
        this.scheduleTopControlsExpanded = false;
        this.scheduleDetailExpanded = false;
        this.rowDensityPanelExpanded = false;
        this.bulkToolsExpanded = false;
        this.quickFiltersExpanded = false;
        this.savedViewsExpanded = false;
        this.searchFiltersExpanded = false;
        this.plannerSummaryExpanded = false;
        this.lowerUtilityPanelOpenedInSession = false;
        this.activeUtilityDialog = "";
        this.viewOptionsPanelExpanded = false;
        this.groupPanelExpanded = false;
        this.scheduleTransferExpanded = false;
        this.clearSelectedCellState();
        this.resetMilestoneDraft();
        this.saveDashboardPanelState();
    }

    public saveDashboardPanelState() {
        try {
            localStorage.setItem(this.dashboardPanelStateKey, JSON.stringify({
                version: 2,
                scheduleSummaryExpanded: this.scheduleSummaryExpanded === true,
                projectManagementExpanded: this.projectManagementExpanded === true,
                projectAddExpanded: this.projectAddExpanded === true,
                scheduleTopControlsExpanded: this.scheduleTopControlsExpanded === true,
                scheduleDetailExpanded: this.scheduleDetailExpanded === true,
                rowDensityPanelExpanded: this.rowDensityPanelExpanded === true,
                bulkToolsExpanded: this.bulkToolsExpanded === true,
                quickFiltersExpanded: this.quickFiltersExpanded === true,
                savedViewsExpanded: this.savedViewsExpanded === true,
                searchFiltersExpanded: this.searchFiltersExpanded === true,
                plannerSummaryExpanded: this.plannerSummaryExpanded === true,
                viewOptionsPanelExpanded: this.viewOptionsPanelExpanded === true,
                groupPanelExpanded: this.groupPanelExpanded === true,
                scheduleTransferExpanded: this.scheduleTransferExpanded === true
            }));
        } catch (e) {
            // Panel preference persistence is non-critical.
        }
    }

    public normalizeCurrentConvenienceState() {
        const convenience = normalizeScheduleConvenienceState({
            viewPrefs: this.viewPrefs,
            projectGroups: this.projectGroups,
            savedViews: this.savedViews
        }, this.projects, this.rows);
        this.viewPrefs = convenience.viewPrefs;
        this.projectGroups = convenience.projectGroups;
        this.savedViews = convenience.savedViews;
        return convenience;
    }

    public installUndoRedoShortcuts() {
        if (this.historyKeydownHandler || typeof window === "undefined") return;
        this.historyKeydownHandler = (event: KeyboardEvent) => this.handleUndoRedoShortcut(event);
        window.addEventListener("keydown", this.historyKeydownHandler);
    }

    public removeUndoRedoShortcuts() {
        if (!this.historyKeydownHandler || typeof window === "undefined") return;
        window.removeEventListener("keydown", this.historyKeydownHandler);
        this.historyKeydownHandler = null;
    }

    public async handleUndoRedoShortcut(event: KeyboardEvent) {
        if (!event || event.defaultPrevented || !this.authAllowed || this.loading || this.isHistoryRestoring) return;
        if (!(event.ctrlKey || event.metaKey) || event.altKey) return;

        const key = String(event.key || "").toLowerCase();
        const shouldUndo = key === "z" && !event.shiftKey;
        const shouldRedo = key === "y" || (key === "z" && event.shiftKey);
        if (!shouldUndo && !shouldRedo) return;

        event.preventDefault();
        event.stopPropagation();
        if (shouldUndo) await this.undoScheduleChange();
        else await this.redoScheduleChange();
    }

    public installScheduleClipboardHandlers() {
        if (this.clipboardCopyHandler || typeof window === "undefined") return;
        this.clipboardCopyHandler = (event: ClipboardEvent) => this.handleScheduleCopy(event);
        this.clipboardPasteHandler = (event: ClipboardEvent) => this.handleSchedulePaste(event);
        window.addEventListener("copy", this.clipboardCopyHandler);
        window.addEventListener("paste", this.clipboardPasteHandler);
    }

    public removeScheduleClipboardHandlers() {
        if (typeof window === "undefined") return;
        if (this.clipboardCopyHandler) {
            window.removeEventListener("copy", this.clipboardCopyHandler);
            this.clipboardCopyHandler = null;
        }
        if (this.clipboardPasteHandler) {
            window.removeEventListener("paste", this.clipboardPasteHandler);
            this.clipboardPasteHandler = null;
        }
    }

    public installCellWorkflowKeyboardHandlers() {
        if (this.cellWorkflowKeydownHandler || typeof window === "undefined") return;
        this.cellWorkflowKeydownHandler = (event: KeyboardEvent) => {
            void this.handleCellWorkflowKeydown(event);
        };
        window.addEventListener("keydown", this.cellWorkflowKeydownHandler);
    }

    public removeCellWorkflowKeyboardHandlers() {
        if (!this.cellWorkflowKeydownHandler || typeof window === "undefined") return;
        window.removeEventListener("keydown", this.cellWorkflowKeydownHandler);
        this.cellWorkflowKeydownHandler = null;
    }

    public scheduleNextFrame(callback: any, delay: number = 0) {
        if (typeof window !== "undefined" && delay <= 0 && typeof window.requestAnimationFrame === "function") {
            return {
                type: "animationFrame",
                id: window.requestAnimationFrame(callback)
            };
        }
        return {
            type: "timeout",
            id: setTimeout(callback, Math.max(0, delay))
        };
    }

    public cancelScheduledFrame(frame: any) {
        if (!frame) return;
        if (frame.type === "animationFrame" && typeof window !== "undefined" && typeof window.cancelAnimationFrame === "function") {
            window.cancelAnimationFrame(frame.id);
            return;
        }
        clearTimeout(frame.id);
    }

    public requestCellWorkflowRender() {
        this.clearCellWorkflowRenderFrame();
        const render = async () => {
            this.cellWorkflowRenderFrame = null;
            try {
                await this.service.render();
                const key = this.activeCell ? String(this.activeCell.key || "") : "";
                if (key) {
                    this.focusActiveCellElement(key, { immediate: true, scroll: false });
                    this.requestActiveCellScrollIntoView();
                }
            } catch (e) {
                // Navigation should stay responsive even if a scheduled render is interrupted.
            }
        };
        this.cellWorkflowRenderFrame = this.scheduleNextFrame(() => {
            void render();
        }, this.cellWorkflowRenderDelayMs);
    }

    public clearCellWorkflowRenderFrame() {
        this.cancelScheduledFrame(this.cellWorkflowRenderFrame);
        this.cellWorkflowRenderFrame = null;
    }

    public async handleCellWorkflowKeydown(event: KeyboardEvent) {
        if (!event || event.defaultPrevented || !this.authAllowed || this.loading || this.isHistoryRestoring) return;
        const key = String(event.key || "");
        if (key === "Escape" && (this.projectManagementExpanded || this.hasActiveUtilityDialog)) {
            event.preventDefault();
            event.stopPropagation();
            await this.closeOpenUtilityWindows();
            return;
        }
        if (this.isInlineCellEditorTarget(event.target)) return;
        if (this.isEditableClipboardTarget(event.target)) return;

        if (this.isCellWorkflowBoundaryTarget(event.target)) return;

        if (this.isDirectCellTypingKey(event)) {
            const target = this.getDirectCellEditTarget();
            if (target) {
                await this.startDirectCellTyping(target.row, target.project, event);
                return;
            }
        }

        if (this.isActiveCellDetailShortcut(event) && this.isActiveCellKeyboardTarget(event.target)) {
            await this.openActiveCellDetailByShortcut(event);
            return;
        }
        if (this.isCellRangeExtensionKey(event)) {
            const extended = await this.extendCellRangeByKeyboard(event);
            if (extended) return;
        }
        if (this.isActiveCellNavigationKey(event) && this.isActiveCellKeyboardTarget(event.target)) {
            const moved = await this.moveActiveCellByKeyboard(event);
            if (moved) return;
        }

        const isEditKey = (key === "Enter" && !(event.ctrlKey || event.metaKey) && !event.altKey) || key === "F2";
        const isClearKey = key === "Backspace" || key === "Delete";

        if (isEditKey && this.hasCellSelection) {
            event.preventDefault();
            event.stopPropagation();
            await this.editSelectedCellInline();
            return;
        }
        if (!this.hasCellSelection) return;

        if (!isEditKey && !isClearKey && key !== "Escape") return;

        event.preventDefault();
        event.stopPropagation();

        if (key === "Escape") {
            this.activeEditKey = "";
            this.resetCellInlineDraft();
            await this.service.render();
            return;
        }

        if (isEditKey) {
            await this.editSelectedCellInline();
            return;
        }

        const selected = this.getSelectedCellsInVisibleOrder();
        const targets = selected.map(cell => ({
            row: cell.row,
            project: cell.project,
            value: ""
        }));
        await this.applyClipboardTargets(targets, "선택 셀 비우기");
    }

    public isInlineCellEditorTarget(target: any) {
        if (!target) return false;
        const element = target as HTMLElement;
        return this.hasAncestorClass(element, "schedule-cell-input")
            || (typeof element.getAttribute === "function" && element.getAttribute("data-inline-cell-editor") === "true");
    }

    public isCellWorkflowBoundaryTarget(target: any) {
        if (!target) return false;
        const boundaryClasses = [
            "project-column-resize-handle",
            "date-row-height-drag-handle",
            "date-column-resize-handle",
            "project-row-height-resize-handle",
            "cell-detail-open-button",
            "cell-milestone-add",
            "date-milestone-add",
            "mobile-entry-action",
            "project-drag-handle"
        ];
        return boundaryClasses.some(className => this.hasAncestorClass(target, className));
    }

    public isDirectCellTypingKey(event: KeyboardEvent) {
        if (!event || event.ctrlKey || event.metaKey || event.altKey || (event as any).isComposing) return false;
        const key = String(event.key || "");
        return key.length === 1 && key !== "\t" && key !== "\r" && key !== "\n";
    }

    public getDirectCellEditTarget() {
        const selected = this.hasCellSelection ? this.getPrimarySelectedCellForEdit() : null;
        if (selected && this.isActiveCellNavigationTarget(selected.row, selected.project)) return selected;
        const active = this.getVisibleActiveCell();
        if (!active) return null;
        const row = this.findRowById(active.rowId);
        const project = this.findProjectById(active.projectId);
        return row && project ? { row, project } : null;
    }

    public async startDirectCellTyping(row: any, project: any, event: KeyboardEvent) {
        if (!row || !project || !event) return;
        event.preventDefault();
        event.stopPropagation();
        await this.openCellInlineEditorWithOptions(row, project, null, {
            replace: true,
            initialValue: String(event.key || ""),
            startedByTyping: true,
            cursorEnd: true
        });
    }

    public isEditableClipboardTarget(target: any) {
        if (!target) return false;
        const element = target as HTMLElement;
        const tagName = String(element.tagName || "").toLowerCase();
        if (tagName === "textarea" || tagName === "input" || tagName === "select") return true;
        return element.isContentEditable === true;
    }

    public isActiveCellKeyboardTarget(target: any) {
        if (!target) return false;
        if (this.hasAncestorClass(target, "schedule-cell-preview")
            || this.hasAncestorClass(target, "empty-cell-button")
            || this.hasAncestorClass(target, "mobile-entry-main-button")) {
            return true;
        }
        return this.isDocumentKeyboardFallbackTarget(target) && !!this.getVisibleActiveCell();
    }

    public isDocumentKeyboardFallbackTarget(target: any) {
        if (typeof document === "undefined" || !target) return false;
        return target === document.body || target === document.documentElement;
    }

    public hasAncestorClass(target: any, className: string) {
        let element = target as HTMLElement;
        while (element) {
            if (element.classList && element.classList.contains(className)) return true;
            element = element.parentElement as HTMLElement;
        }
        return false;
    }

    public isActiveCellNavigationKey(event: KeyboardEvent) {
        if (!event || event.ctrlKey || event.metaKey || event.altKey) return false;
        const key = String(event.key || "");
        return key === "ArrowLeft"
            || key === "ArrowRight"
            || key === "ArrowUp"
            || key === "ArrowDown"
            || key === "Tab"
            || key === "Enter";
    }

    public isActiveCellDetailShortcut(event: KeyboardEvent) {
        if (!event) return false;
        const key = String(event.key || "");
        return key === "Enter" && (event.ctrlKey || event.metaKey) && !event.shiftKey && !event.altKey;
    }

    public isCellRangeExtensionKey(event: KeyboardEvent) {
        if (!event || !event.shiftKey || event.ctrlKey || event.metaKey || event.altKey) return false;
        const key = String(event.key || "");
        return key === "ArrowLeft" || key === "ArrowRight" || key === "ArrowUp" || key === "ArrowDown";
    }

    public resolveCellRangeKeyboardTarget(event: KeyboardEvent) {
        if (!this.isCellRangeExtensionKey(event)) return null;
        const key = String(event.key || "");
        const rowDelta = key === "ArrowUp" ? -1 : key === "ArrowDown" ? 1 : 0;
        const columnDelta = key === "ArrowLeft" ? -1 : key === "ArrowRight" ? 1 : 0;
        return this.resolveActiveCellNavigationTarget(rowDelta, columnDelta, false);
    }

    public async extendCellRangeByKeyboard(event: KeyboardEvent) {
        if (!this.hasCellSelection && !this.getVisibleActiveCell()) return false;
        const source = this.getActiveCellNavigationSource();
        const target = this.resolveCellRangeKeyboardTarget(event);
        if (!source || !target) return false;

        event.preventDefault();
        event.stopPropagation();
        if (!this.selectionAnchorCell) this.setSingleCellSelection(source.row, source.project);
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        this.selectCellRange(target.row, target.project);
        await this.service.render();
        this.focusActiveCellElement(this.activeCell ? this.activeCell.key : "");
        return true;
    }

    public get activeCellCoordinateLabel() {
        const cell = this.getVisibleActiveCell();
        if (!cell) return "활성 셀 없음";
        return `${cell.dateLabel || cell.date} · ${cell.projectName || "프로젝트"}`;
    }

    public get activeCellAriaLabel() {
        const cell = this.getVisibleActiveCell();
        if (!cell) return "현재 활성 셀이 없습니다.";
        const group = cell.projectGroupName ? `${cell.projectGroupName} 그룹, ` : "";
        return `현재 활성 셀: ${cell.dateLabel || cell.date}, ${group}${cell.projectName || "프로젝트"}`;
    }

    public getVisibleActiveCell(grid: any = null) {
        if (!this.activeCell) return null;
        const navigationGrid = grid || this.getActiveCellNavigationGrid();
        const row = navigationGrid.rows.find((item: any) => item && item.id === this.activeCell.rowId);
        const project = navigationGrid.projects.find((item: any) => item && item.id === this.activeCell.projectId);
        if (!row || !project) return null;
        return this.createActiveCell(row, project);
    }

    public createActiveCell(row: any, project: any) {
        return {
            key: this.getCellKey(row, project),
            rowId: row.id,
            date: row.date,
            dateLabel: row.dateLabel,
            weekday: row.weekday,
            projectId: project.id,
            projectName: project.name,
            projectColor: project.color,
            projectGroupName: this.getProjectAssignedGroupName(project)
        };
    }

    public setActiveCell(row: any, project: any, options: any = {}) {
        if (!this.isActiveCellNavigationTarget(row, project, options.grid || null)) return false;
        this.activeCell = this.createActiveCell(row, project);
        if (options.select !== false) this.setSingleCellSelection(row, project);
        this.setScheduleRowHover(row);
        this.hoveredScheduleProjectId = String(project.id || "");
        if (options.scroll !== false) this.requestActiveCellScrollIntoView();
        return true;
    }

    public focusActiveCell(row: any, project: any) {
        const previousActiveCell = this.activeCell ? { ...this.activeCell } : null;
        if (!this.setActiveCell(row, project, { scroll: false })) return;
        this.syncActiveCellNavigationDom(previousActiveCell, this.activeCell);
        this.scrollActiveCellIntoView();
        this.requestCellWorkflowRender();
    }

    public clearActiveCell() {
        this.activeCell = null;
    }

    public clearActiveCellIfProject(projectId: string) {
        if (this.activeCell && this.activeCell.projectId === projectId) this.clearActiveCell();
    }

    public isActiveCell(row: any, project: any) {
        if (!row || !project || !this.activeCell) return false;
        return this.activeCell.key === this.getCellKey(row, project);
    }

    public getScheduleTableWrap() {
        if (typeof document === "undefined") return null;
        return document.querySelector(".schedule-table-wrap") as HTMLElement;
    }

    public escapeAttributeSelectorValue(value: any) {
        return String(value === undefined || value === null ? "" : value)
            .replace(/\\/g, "\\\\")
            .replace(/"/g, '\\"')
            .replace(/\n/g, "\\A ")
            .replace(/\r/g, "\\D ")
            .replace(/\f/g, "\\C ");
    }

    public getActiveCellElementByKey(key: string, root: any = null) {
        if (!key || typeof document === "undefined") return null;
        const scope = root || this.getScheduleTableWrap() || document;
        const selector = `[data-active-cell-key="${this.escapeAttributeSelectorValue(key)}"]`;
        const element = scope.querySelector(selector) as HTMLElement;
        return element && this.isVisibleElement(element) ? element : null;
    }

    public getActiveCellFocusElement(key: string) {
        if (!key || typeof document === "undefined") return null;
        const selector = `[data-cell-focus-key="${this.escapeAttributeSelectorValue(key)}"]`;
        const tableWrap = this.getScheduleTableWrap();
        const scopedElement = tableWrap ? tableWrap.querySelector(selector) as HTMLElement : null;
        if (scopedElement && this.isVisibleElement(scopedElement)) return scopedElement;

        const element = document.querySelector(selector) as HTMLElement;
        return element && this.isVisibleElement(element) ? element : null;
    }

    public syncActiveCellNavigationDom(previousCell: any, nextCell: any) {
        const tableWrap = this.getScheduleTableWrap();
        if (!tableWrap) return;
        this.clearActiveCellNavigationDom(tableWrap, previousCell);
        this.applyActiveCellNavigationDom(tableWrap, nextCell);
    }

    public clearActiveCellNavigationDom(tableWrap: HTMLElement, previousCell: any = null) {
        const selectors = [
            ".schedule-cell.is-active-cell",
            ".schedule-cell.is-selected",
            ".schedule-cell.is-selection-anchor",
            ".schedule-cell.is-active",
            "[data-active-cell=\"true\"]",
            "[data-cell-selection=\"selected\"]",
            "tbody tr.is-selection-row",
            ".schedule-cell.is-selection-column",
            ".project-head.is-selection-column",
            ".project-head.is-selection-column-header"
        ].join(", ");
        const elements = Array.prototype.slice.call(tableWrap.querySelectorAll(selectors)) as HTMLElement[];
        elements.forEach(element => {
            element.classList.remove(
                "is-active-cell",
                "is-selected",
                "is-selection-anchor",
                "is-active",
                "is-selection-row",
                "is-selection-column",
                "is-selection-column-header"
            );
            if (element.getAttribute("data-active-cell") === "true") element.removeAttribute("data-active-cell");
            if (element.getAttribute("data-cell-selection") === "selected") element.removeAttribute("data-cell-selection");
            if (element.getAttribute("aria-current") === "true") element.removeAttribute("aria-current");
        });

        if (previousCell && previousCell.key) {
            const previous = this.getActiveCellElementByKey(previousCell.key, tableWrap);
            if (previous) {
                previous.removeAttribute("data-active-cell");
                previous.removeAttribute("data-cell-selection");
                previous.removeAttribute("aria-current");
            }
        }
    }

    public applyActiveCellNavigationDom(tableWrap: HTMLElement, nextCell: any) {
        if (!nextCell || !nextCell.key) return;
        const activeCell = this.getActiveCellElementByKey(nextCell.key, tableWrap);
        if (activeCell) {
            activeCell.classList.add("is-active-cell", "is-selected", "is-selection-anchor", "is-selection-column");
            activeCell.setAttribute("data-active-cell", "true");
            activeCell.setAttribute("data-cell-selection", "selected");
            activeCell.setAttribute("aria-current", "true");
        }

        if (nextCell.rowId) {
            const row = tableWrap.querySelector(`tbody tr[data-schedule-row-id="${this.escapeAttributeSelectorValue(nextCell.rowId)}"]`) as HTMLElement;
            if (row) row.classList.add("is-selection-row");
        }

        if (nextCell.projectId) {
            const selector = `[data-schedule-project-id="${this.escapeAttributeSelectorValue(nextCell.projectId)}"]`;
            const columnElements = Array.prototype.slice.call(tableWrap.querySelectorAll(selector)) as HTMLElement[];
            columnElements.forEach(element => {
                if (element.classList.contains("project-head")) {
                    element.classList.add("is-selection-column", "is-selection-column-header");
                } else if (element.classList.contains("schedule-cell")) {
                    element.classList.add("is-selection-column");
                }
            });
        }
    }

    public getActiveCellNavigationRows() {
        return this.visibleRows;
    }

    public getActiveCellNavigationProjects() {
        return this.visibleScheduleProjects;
    }

    public getActiveCellNavigationGrid() {
        return {
            rows: this.getActiveCellNavigationRows(),
            projects: this.getActiveCellNavigationProjects()
        };
    }

    public isActiveCellNavigationTarget(row: any, project: any, grid: any = null) {
        if (!row || !project || !project.id) return false;
        const navigationGrid = grid || this.getActiveCellNavigationGrid();
        return navigationGrid.rows.some((item: any) => item && item.id === row.id)
            && navigationGrid.projects.some((item: any) => item && item.id === project.id);
    }

    public getActiveCellNavigationSource(grid: any = null) {
        const navigationGrid = grid || this.getActiveCellNavigationGrid();
        const rows = navigationGrid.rows;
        const projects = navigationGrid.projects;
        if (rows.length === 0 || projects.length === 0) return null;

        const active = this.getVisibleActiveCell(navigationGrid);
        if (active) {
            const activeRow = rows.find((row: any) => row && row.id === active.rowId);
            const activeProject = projects.find((project: any) => project && project.id === active.projectId);
            if (activeRow && activeProject) return { row: activeRow, project: activeProject };
        }

        const selected = this.getPrimarySelectedCellForEdit();
        if (selected && this.isActiveCellNavigationTarget(selected.row, selected.project, navigationGrid)) return selected;

        return {
            row: rows[0],
            project: projects[0]
        };
    }

    public resolveActiveCellNavigationTarget(rowDelta: number, columnDelta: number, wrapColumns: boolean = false, grid: any = null) {
        const navigationGrid = grid || this.getActiveCellNavigationGrid();
        const rows = navigationGrid.rows;
        const projects = navigationGrid.projects;
        const source = this.getActiveCellNavigationSource(navigationGrid);
        if (!source || rows.length === 0 || projects.length === 0) return null;

        const rowIndex = rows.findIndex((row: any) => row && row.id === source.row.id);
        const columnIndex = projects.findIndex((project: any) => project && project.id === source.project.id);
        if (rowIndex < 0 || columnIndex < 0) return {
            row: rows[0],
            project: projects[0]
        };

        if (wrapColumns && columnDelta !== 0) {
            const total = rows.length * projects.length;
            const flatIndex = this.clampNumber((rowIndex * projects.length) + columnIndex + columnDelta, 0, total - 1);
            return {
                row: rows[Math.floor(flatIndex / projects.length)],
                project: projects[flatIndex % projects.length]
            };
        }

        const nextRowIndex = this.clampNumber(rowIndex + rowDelta, 0, rows.length - 1);
        const nextColumnIndex = this.clampNumber(columnIndex + columnDelta, 0, projects.length - 1);
        return {
            row: rows[nextRowIndex],
            project: projects[nextColumnIndex]
        };
    }

    public async moveActiveCellByKeyboard(event: KeyboardEvent) {
        if (!event) return false;
        const key = String(event.key || "");
        let rowDelta = 0;
        let columnDelta = 0;
        let wrapColumns = false;

        if (key === "ArrowLeft") columnDelta = -1;
        else if (key === "ArrowRight") columnDelta = 1;
        else if (key === "ArrowUp") rowDelta = -1;
        else if (key === "ArrowDown") rowDelta = 1;
        else if (key === "Tab") {
            columnDelta = event.shiftKey ? -1 : 1;
            wrapColumns = true;
        } else if (key === "Enter") {
            rowDelta = event.shiftKey ? -1 : 1;
        } else {
            return false;
        }

        const grid = this.getActiveCellNavigationGrid();
        const target = this.resolveActiveCellNavigationTarget(rowDelta, columnDelta, wrapColumns, grid);
        if (!target) return false;

        event.preventDefault();
        event.stopPropagation();
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        const previousActiveCell = this.activeCell ? { ...this.activeCell } : null;
        this.setActiveCell(target.row, target.project, { scroll: false, grid });
        this.syncActiveCellNavigationDom(previousActiveCell, this.activeCell);
        this.focusActiveCellElement(this.activeCell ? this.activeCell.key : "", { immediate: true, scroll: false });
        this.scrollActiveCellIntoView();
        this.requestCellWorkflowRender();
        return true;
    }

    public focusActiveCellElement(key: string, options: any = {}) {
        if (!key || typeof document === "undefined") return;
        const focus = () => {
            const target = this.getActiveCellFocusElement(key);
            if (!target) return;
            try {
                (target as any).focus({ preventScroll: true });
            } catch (e) {
                target.focus();
            }
            if (!options || options.scroll !== false) this.requestActiveCellScrollIntoView();
        };
        if (options && options.immediate === true) {
            focus();
            return;
        }
        this.scheduleNextFrame(focus);
    }

    public requestActiveCellScrollIntoView() {
        if (typeof document === "undefined") return;
        this.clearActiveCellScrollTimer();
        this.activeCellScrollTimer = this.scheduleNextFrame(() => {
            this.activeCellScrollTimer = null;
            this.scrollActiveCellIntoView();
            this.activeCellScrollFollowupTimer = this.scheduleNextFrame(() => {
                this.activeCellScrollFollowupTimer = null;
                this.scrollActiveCellIntoView();
            }, 80);
        });
    }

    public clearActiveCellScrollTimer() {
        this.cancelScheduledFrame(this.activeCellScrollTimer);
        this.cancelScheduledFrame(this.activeCellScrollFollowupTimer);
        this.activeCellScrollTimer = null;
        this.activeCellScrollFollowupTimer = null;
    }

    public scrollActiveCellIntoView() {
        if (typeof document === "undefined" || !this.activeCell) return;

        const activeKey = String(this.activeCell.key || "");
        const tableWrap = this.getScheduleTableWrap();
        const activeCell = this.getActiveCellElementByKey(activeKey, tableWrap)
            || (tableWrap ? tableWrap.querySelector('[data-active-cell="true"]') as HTMLElement : null);

        if (!activeCell) return;
        const scrollWrap = tableWrap || activeCell.closest(".schedule-table-wrap") as HTMLElement;
        if (!scrollWrap) return;

        const wrapRect = scrollWrap.getBoundingClientRect();
        const cellRect = activeCell.getBoundingClientRect();
        const header = scrollWrap.querySelector("thead") as HTMLElement;
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const stickyLeftWidth = Math.max(0, this.scheduleDateColumnWidthPx + this.noteColumnWidthPx);
        const margin = 12;
        const visibleLeft = wrapRect.left + stickyLeftWidth + margin;
        const visibleRight = wrapRect.right - margin;
        const visibleTop = wrapRect.top + headerHeight + margin;
        const visibleBottom = wrapRect.bottom - margin;
        let nextLeft = scrollWrap.scrollLeft;
        let nextTop = scrollWrap.scrollTop;

        if (cellRect.left < visibleLeft) nextLeft -= visibleLeft - cellRect.left;
        else if (cellRect.right > visibleRight) nextLeft += cellRect.right - visibleRight;

        if (cellRect.top < visibleTop) nextTop -= visibleTop - cellRect.top;
        else if (cellRect.bottom > visibleBottom) nextTop += cellRect.bottom - visibleBottom;

        nextLeft = Math.max(0, Math.round(nextLeft));
        nextTop = Math.max(0, Math.round(nextTop));
        const shouldMove = Math.abs(nextLeft - scrollWrap.scrollLeft) > 1 || Math.abs(nextTop - scrollWrap.scrollTop) > 1;
        if (shouldMove) scrollWrap.scrollTo({ left: nextLeft, top: nextTop, behavior: "auto" });
    }

    public async openActiveCellDetailByShortcut(event: any = null) {
        const source = this.getActiveCellNavigationSource();
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!source) {
            this.setClipboardFeedback("상세를 열 활성 셀이 없습니다.", "warning");
            await this.service.render();
            return;
        }
        await this.openCellDetail(source.row, source.project);
    }

    public async handleScheduleCopy(event: ClipboardEvent) {
        if (!event || event.defaultPrevented || !this.authAllowed || this.loading) return;
        if (this.isEditableClipboardTarget(event.target)) return;
        if (!this.hasCellSelection) return;
        const text = this.createSelectedCellsTsv();
        if (event.clipboardData) {
            event.clipboardData.setData("text/plain", text);
            event.preventDefault();
            this.setClipboardFeedback(`${this.cellSelectionCount}개 셀을 복사했습니다.`, "success");
            await this.service.render();
        }
    }

    public async handleSchedulePaste(event: ClipboardEvent) {
        if (!event || event.defaultPrevented || !this.authAllowed || this.loading || this.isHistoryRestoring) return;
        if (this.isEditableClipboardTarget(event.target)) return;
        if (!this.hasCellSelection) return;
        const text = event.clipboardData ? event.clipboardData.getData("text/plain") : "";
        if (!String(text || "").length) return;
        event.preventDefault();
        await this.applyClipboardText(text, "keyboard");
    }

    public setClipboardFeedback(message: string, status: string = "") {
        this.clipboardMessage = message;
        this.clipboardStatus = status;
    }

    public get hasCellSelection() {
        return this.cellSelectionCount > 0;
    }

    public get cellSelectionCount() {
        return this.getSelectedCellsInVisibleOrder().length;
    }

    public get cellSelectionSummaryLabel() {
        const selected = this.getSelectedCellsInVisibleOrder();
        if (selected.length === 0) return "선택 없음";
        if (selected.length === 1) {
            const cell = selected[0];
            return `${cell.row.dateLabel || cell.row.date} · ${cell.project.name || "프로젝트"}`;
        }
        const bounds = this.getSelectionBounds(selected);
        if (!bounds) return `${selected.length}개 셀`;
        const rowCount = bounds.maxRowIndex - bounds.minRowIndex + 1;
        const columnCount = bounds.maxColumnIndex - bounds.minColumnIndex + 1;
        return `${selected.length}개 셀 · ${rowCount}행 x ${columnCount}열`;
    }

    public get canApplyClipboardFill() {
        return this.hasCellSelection && String(this.clipboardFillValue || "").length > 0;
    }

    public get visibleScheduleProjects() {
        return this.scheduleTableColumns
            .filter((column: any) => this.isProjectColumn(column))
            .map((column: any) => column.project)
            .filter((project: any) => this.isProjectVisible(project));
    }

    public setSingleCellSelection(row: any, project: any) {
        if (!row || !project) return;
        const key = this.getCellKey(row, project);
        this.selectedCellKeys = [key];
        this.selectionAnchorCell = {
            key,
            rowId: row.id,
            projectId: project.id
        };
    }

    public syncSelectedCellMetaDraft(row: any, projectId: string) {
        const meta = this.getCellMeta(row, projectId);
        const predecessor = this.getFirstCellDependency(meta.dependencies, "predecessors");
        const successor = this.getFirstCellDependency(meta.dependencies, "successors");
        this.selectedCellStatus = meta.status;
        this.selectedCellType = meta.type;
        this.selectedCellTime = meta.time || "";
        this.selectedCellDependencyEditorOpen = this.hasCellDependencies(meta.dependencies);
        this.selectedCellPredecessorDate = predecessor ? predecessor.date : "";
        this.selectedCellPredecessorProjectId = predecessor ? predecessor.projectId : "";
        this.selectedCellSuccessorDate = successor ? successor.date : "";
        this.selectedCellSuccessorProjectId = successor ? successor.projectId : "";
    }

    public clearCellSelection() {
        this.selectedCellKeys = [];
        this.selectionAnchorCell = null;
    }

    public getCellSelectionMap() {
        const map: any = {};
        this.selectedCellKeys.forEach(key => {
            if (key) map[key] = true;
        });
        return map;
    }

    public setScheduleRowHover(row: any) {
        this.hoveredScheduleDate = row && row.date ? String(row.date) : "";
    }

    public clearScheduleRowHover(row: any = null) {
        if (row && row.date && this.hoveredScheduleDate !== String(row.date)) return;
        this.hoveredScheduleDate = "";
        this.hoveredScheduleProjectId = "";
    }

    public setScheduleCellHover(row: any, column: any) {
        this.setScheduleRowHover(row);
        this.hoveredScheduleProjectId = this.isProjectColumn(column) && column.project && column.project.id
            ? String(column.project.id)
            : "";
    }

    public clearScheduleCellHover(row: any, column: any) {
        if (row && row.date && this.hoveredScheduleDate !== String(row.date)) return;
        if (this.isProjectColumn(column) && column.project && column.project.id) {
            if (this.hoveredScheduleProjectId === String(column.project.id)) this.hoveredScheduleProjectId = "";
            return;
        }
        this.hoveredScheduleProjectId = "";
    }

    public isScheduleHoverRow(row: any) {
        return !!(row && row.date && this.hoveredScheduleDate === String(row.date));
    }

    public isScheduleHoverColumn(column: any) {
        return this.isProjectColumn(column)
            && !!column.project
            && !!column.project.id
            && this.hoveredScheduleProjectId === String(column.project.id);
    }

    public isScheduleSelectionRow(row: any) {
        if (!row || !row.id) return false;
        const rowId = String(row.id);
        if (this.selectedCell && this.selectedCell.rowId === rowId) return true;
        return this.selectedCellKeys.some(key => String(key || "").indexOf(`${rowId}-`) === 0);
    }

    public isProjectInScheduleSelection(project: any) {
        if (!project || !project.id) return false;
        const projectId = String(project.id);
        if (this.selectedCell && this.selectedCell.projectId === projectId) return true;
        return this.selectedCellKeys.some(key => String(key || "").endsWith(`-${projectId}`));
    }

    public isScheduleSelectionColumn(column: any) {
        return this.isProjectColumn(column) && this.isProjectInScheduleSelection(column.project);
    }

    public getSelectedCellsInVisibleOrder() {
        const selectedMap = this.getCellSelectionMap();
        const projects = this.visibleScheduleProjects;
        const cells: any[] = [];
        this.visibleRows.forEach((row: any, rowIndex: number) => {
            projects.forEach((project: any, columnIndex: number) => {
                const key = this.getCellKey(row, project);
                if (!selectedMap[key]) return;
                cells.push({ key, row, project, rowIndex, columnIndex });
            });
        });
        return cells;
    }

    public getSelectionBounds(selectedCells: any[] = this.getSelectedCellsInVisibleOrder()) {
        if (!selectedCells || selectedCells.length === 0) return null;
        const rowIndexes = selectedCells.map(cell => cell.rowIndex);
        const columnIndexes = selectedCells.map(cell => cell.columnIndex);
        return {
            minRowIndex: Math.min(...rowIndexes),
            maxRowIndex: Math.max(...rowIndexes),
            minColumnIndex: Math.min(...columnIndexes),
            maxColumnIndex: Math.max(...columnIndexes)
        };
    }

    public getSelectionAnchorOrCell(row: any, project: any) {
        if (this.selectionAnchorCell) return this.selectionAnchorCell;
        if (this.selectedCell) return this.selectedCell;
        return {
            key: this.getCellKey(row, project),
            rowId: row.id,
            projectId: project.id
        };
    }

    public selectCellRange(row: any, project: any) {
        if (!row || !project) return;
        const anchor = this.getSelectionAnchorOrCell(row, project);
        const rows = this.visibleRows;
        const projects = this.visibleScheduleProjects;
        const startRowIndex = rows.findIndex((item: any) => item && item.id === anchor.rowId);
        const endRowIndex = rows.findIndex((item: any) => item && item.id === row.id);
        const startColumnIndex = projects.findIndex((item: any) => item && item.id === anchor.projectId);
        const endColumnIndex = projects.findIndex((item: any) => item && item.id === project.id);

        if (startRowIndex < 0 || endRowIndex < 0 || startColumnIndex < 0 || endColumnIndex < 0) {
            this.setSingleCellSelection(row, project);
            return;
        }

        const minRow = Math.min(startRowIndex, endRowIndex);
        const maxRow = Math.max(startRowIndex, endRowIndex);
        const minColumn = Math.min(startColumnIndex, endColumnIndex);
        const maxColumn = Math.max(startColumnIndex, endColumnIndex);
        const keys: string[] = [];
        for (let rowIndex = minRow; rowIndex <= maxRow; rowIndex++) {
            for (let columnIndex = minColumn; columnIndex <= maxColumn; columnIndex++) {
                keys.push(this.getCellKey(rows[rowIndex], projects[columnIndex]));
            }
        }
        this.selectedCellKeys = keys;
        this.selectionAnchorCell = anchor;
        this.setActiveCell(row, project, { select: false });
        this.selectedCell = this.createSelectedCell(row, project);
        this.selectedCellDraft = this.getCellValue(row, project.id);
        this.syncSelectedCellMetaDraft(row, project.id);
        this.selectedCellMessage = "";
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        this.setClipboardFeedback(`${keys.length}개 셀을 선택했습니다.`, "success");
    }

    public toggleCellSelection(row: any, project: any) {
        if (!row || !project) return;
        const key = this.getCellKey(row, project);
        const exists = this.selectedCellKeys.indexOf(key) >= 0;
        const nextKeys = exists
            ? this.selectedCellKeys.filter(item => item !== key)
            : this.selectedCellKeys.concat([key]);
        this.selectedCellKeys = nextKeys.length > 0 ? nextKeys : [key];
        this.selectionAnchorCell = this.selectionAnchorCell || { key, rowId: row.id, projectId: project.id };
        this.setActiveCell(row, project, { select: false });
        this.selectedCell = this.createSelectedCell(row, project);
        this.selectedCellDraft = this.getCellValue(row, project.id);
        this.syncSelectedCellMetaDraft(row, project.id);
        this.selectedCellMessage = "";
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        this.setClipboardFeedback(`${this.selectedCellKeys.length}개 셀을 선택했습니다.`, "success");
    }

    public shouldExtendCellSelection(event: any) {
        return !!event && event.shiftKey === true;
    }

    public shouldToggleCellSelection(event: any) {
        return !!event && !event.shiftKey && (event.ctrlKey === true || event.metaKey === true);
    }

    public isSelectionAnchorCell(row: any, project: any) {
        return !!this.selectionAnchorCell && this.selectionAnchorCell.key === this.getCellKey(row, project);
    }

    public isSelectedRangeCell(row: any, project: any) {
        return this.selectedCellKeys.length > 1 && this.selectedCellKeys.indexOf(this.getCellKey(row, project)) >= 0;
    }

    public getCellRangeSelectionBounds() {
        const selected = this.getSelectedCellsInVisibleOrder();
        if (selected.length <= 1) return null;
        return this.getSelectionBounds(selected);
    }

    public getCellRangePosition(row: any, project: any) {
        if (!row || !project) return null;
        const rows = this.visibleRows;
        const projects = this.visibleScheduleProjects;
        const rowIndex = rows.findIndex((item: any) => item && item.id === row.id);
        const columnIndex = projects.findIndex((item: any) => item && item.id === project.id);
        if (rowIndex < 0 || columnIndex < 0) return null;
        return { rowIndex, columnIndex };
    }

    public isRangeBoundaryCell(row: any, project: any, edge: string) {
        if (!this.isSelectedRangeCell(row, project)) return false;
        const bounds = this.getCellRangeSelectionBounds();
        const position = this.getCellRangePosition(row, project);
        if (!bounds || !position) return false;
        if (edge === "top") return position.rowIndex === bounds.minRowIndex;
        if (edge === "bottom") return position.rowIndex === bounds.maxRowIndex;
        if (edge === "left") return position.columnIndex === bounds.minColumnIndex;
        if (edge === "right") return position.columnIndex === bounds.maxColumnIndex;
        return false;
    }

    public installCellRangeDragEndHandler() {
        if (this.cellRangeDragEndHandler || typeof window === "undefined") return;
        this.cellRangeDragEndHandler = (event: PointerEvent) => {
            void this.finishCellRangeDrag(null, null, event);
        };
        window.addEventListener("pointerup", this.cellRangeDragEndHandler);
        window.addEventListener("pointercancel", this.cellRangeDragEndHandler);
    }

    public cleanupCellRangeDrag() {
        if (this.cellRangeDragEndHandler && typeof window !== "undefined") {
            window.removeEventListener("pointerup", this.cellRangeDragEndHandler);
            window.removeEventListener("pointercancel", this.cellRangeDragEndHandler);
        }
        this.cellRangeDragEndHandler = null;
        this.cellRangeDragState = null;
    }

    public startCellRangeDrag(row: any, project: any, event: any) {
        if (!row || !project || !event) return;
        if (this.isCellWorkflowBoundaryTarget(event.target)) return;
        if (event.button !== undefined && event.button !== 0) return;
        const key = this.getCellKey(row, project);
        this.suppressCellActivationKey = "";
        this.cellRangeDragState = {
            pointerId: event.pointerId === undefined ? null : event.pointerId,
            anchorKey: key,
            rowId: row.id,
            projectId: project.id,
            lastKey: key,
            hasMoved: false
        };
        this.setSingleCellSelection(row, project);
        this.setActiveCell(row, project, { select: false });
        this.selectedCell = this.createSelectedCell(row, project);
        this.selectedCellDraft = this.getCellValue(row, project.id);
        this.syncSelectedCellMetaDraft(row, project.id);
        this.installCellRangeDragEndHandler();
    }

    public async extendCellRangeDrag(row: any, project: any, event: any) {
        const state = this.cellRangeDragState;
        if (!state || !row || !project) return;
        if (event && state.pointerId !== null && event.pointerId !== undefined && event.pointerId !== state.pointerId) return;
        if (event && event.buttons !== undefined && event.buttons === 0) return;
        const key = this.getCellKey(row, project);
        if (key === state.lastKey) return;
        state.lastKey = key;
        state.hasMoved = true;
        this.selectCellRange(row, project);
        await this.service.render();
        this.requestActiveCellScrollIntoView();
    }

    public async finishCellRangeDrag(row: any = null, project: any = null, event: any = null) {
        const state = this.cellRangeDragState;
        if (!state) {
            this.cleanupCellRangeDrag();
            return;
        }
        const endKey = row && project ? this.getCellKey(row, project) : state.lastKey;
        const shouldSuppressClick = state.hasMoved === true && !!endKey;
        this.cleanupCellRangeDrag();
        if (!shouldSuppressClick) return;

        this.suppressCellActivationKey = endKey;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (typeof window !== "undefined") {
            window.setTimeout(() => {
                if (this.suppressCellActivationKey === endKey) this.suppressCellActivationKey = "";
            }, 0);
        }
    }

    public shouldSuppressActivationAfterRangeDrag(row: any, project: any, event: any = null) {
        const key = row && project ? this.getCellKey(row, project) : "";
        if (!key || this.suppressCellActivationKey !== key) return false;
        this.suppressCellActivationKey = "";
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return true;
    }

    public async clearCellSelectionFromUi() {
        this.clearCellSelection();
        this.clearSelectedCellState();
        this.setClipboardFeedback("셀 선택을 해제했습니다.", "warning");
        await this.service.render();
    }

    public createSelectedCellsGrid() {
        const selected = this.getSelectedCellsInVisibleOrder();
        const bounds = this.getSelectionBounds(selected);
        if (!bounds) return [];
        const selectedMap = this.getCellSelectionMap();
        const rows = this.visibleRows;
        const projects = this.visibleScheduleProjects;
        const grid: string[][] = [];
        for (let rowIndex = bounds.minRowIndex; rowIndex <= bounds.maxRowIndex; rowIndex++) {
            const values: string[] = [];
            for (let columnIndex = bounds.minColumnIndex; columnIndex <= bounds.maxColumnIndex; columnIndex++) {
                const row = rows[rowIndex];
                const project = projects[columnIndex];
                const key = row && project ? this.getCellKey(row, project) : "";
                values.push(selectedMap[key] && row && project ? this.getCellValue(row, project.id) : "");
            }
            grid.push(values);
        }
        return grid;
    }

    public createSelectedCellsTsv() {
        const grid = this.createSelectedCellsGrid();
        if (!grid || grid.length === 0) return "";
        return this.serializeClipboardGrid(grid);
    }

    public serializeClipboardGrid(grid: any[]) {
        return grid.map(row => {
            return (row || []).map((cell: any) => this.escapeClipboardCell(cell)).join("\t");
        }).join("\r\n");
    }

    public escapeClipboardCell(value: any) {
        const text = String(value === undefined || value === null ? "" : value)
            .replace(/\r\n/g, "\n")
            .replace(/\r/g, "\n");
        if (/[\t\n"]/.test(text)) return `"${text.replace(/"/g, "\"\"")}"`;
        return text;
    }

    public async copySelectedCells() {
        if (!this.hasCellSelection) {
            this.setClipboardFeedback("복사할 셀이 없습니다.", "warning");
            await this.service.render();
            return;
        }
        const text = this.createSelectedCellsTsv();

        try {
            const clipboard = typeof navigator !== "undefined" ? (navigator as any).clipboard : null;
            if (!clipboard || !clipboard.writeText) throw new Error("clipboard unavailable");
            await clipboard.writeText(text);
            this.setClipboardFeedback(`${this.cellSelectionCount}개 셀을 복사했습니다.`, "success");
        } catch (e) {
            this.clipboardPasteText = text;
            this.setClipboardFeedback("브라우저 클립보드 권한이 없어 아래 입력칸에 복사 내용을 준비했습니다.", "warning");
        }
        await this.service.render();
    }

    public async pasteFromClipboardButton() {
        let text = "";
        try {
            const clipboard = typeof navigator !== "undefined" ? (navigator as any).clipboard : null;
            if (clipboard && clipboard.readText) text = await clipboard.readText();
        } catch (e) {
            text = "";
        }
        if (!String(text || "").length) text = this.clipboardPasteText;
        await this.applyClipboardText(text, "button");
    }

    public async applyClipboardFillValue() {
        if (!this.canApplyClipboardFill) {
            this.setClipboardFeedback("입력할 값과 대상 셀을 확인해 주세요.", "warning");
            await this.service.render();
            return;
        }
        const targets = this.getSelectedCellsInVisibleOrder().map(cell => ({
            row: cell.row,
            project: cell.project,
            value: String(this.clipboardFillValue || "")
        }));
        await this.applyClipboardTargets(targets, "선택 셀 일괄 입력");
    }

    public parseClipboardGrid(text: string) {
        const source = String(text || "")
            .replace(/\r\n/g, "\n")
            .replace(/\r/g, "\n");
        if (!source.length) return [];

        const delimiter = "\t";
        const rows: string[][] = [];
        let currentRow: string[] = [];
        let currentCell = "";
        let inQuotes = false;

        const pushCell = () => {
            currentRow.push(currentCell);
            currentCell = "";
        };
        const pushRow = () => {
            pushCell();
            if (rows.length === 0 && currentRow.length > 0) {
                currentRow[0] = currentRow[0].replace(/^\ufeff/, "");
            }
            rows.push(currentRow);
            currentRow = [];
        };

        for (let index = 0; index < source.length; index++) {
            const char = source.charAt(index);
            if (inQuotes) {
                if (char === "\"") {
                    if (source.charAt(index + 1) === "\"") {
                        currentCell += "\"";
                        index += 1;
                    } else {
                        inQuotes = false;
                    }
                } else {
                    currentCell += char;
                }
                continue;
            }

            if (char === "\"" && currentCell.length === 0) {
                inQuotes = true;
            } else if (char === delimiter) {
                pushCell();
            } else if (char === "\n") {
                pushRow();
            } else {
                currentCell += char;
            }
        }

        if (currentCell.length > 0 || currentRow.length > 0 || !source.endsWith("\n")) pushRow();
        return rows;
    }

    public async applyClipboardText(text: any, source: string = "button") {
        if (!this.hasCellSelection) {
            this.setClipboardFeedback("먼저 붙여넣을 셀을 선택해 주세요.", "warning");
            await this.service.render();
            return;
        }

        const grid = this.parseClipboardGrid(String(text || ""));
        if (!grid || grid.length === 0) {
            this.setClipboardFeedback("붙여넣을 데이터가 없습니다.", "warning");
            await this.service.render();
            return;
        }

        const targets = this.createClipboardPasteTargets(grid);
        const changed = await this.applyClipboardTargets(targets, source === "keyboard" ? "셀 붙여넣기" : "클립보드 붙여넣기");
        if (changed) this.clipboardPasteText = "";
    }

    public createClipboardPasteTargets(grid: any[]) {
        const rows = this.visibleRows;
        const projects = this.visibleScheduleProjects;
        const selected = this.getSelectedCellsInVisibleOrder();
        if (!grid || grid.length === 0 || !selected.length) return [];

        const isSingleValuePaste = grid.length === 1 && (grid[0] || []).length === 1 && selected.length > 1;
        if (isSingleValuePaste) {
            const value = String(grid[0][0] || "");
            return selected.map(cell => ({ row: cell.row, project: cell.project, value }));
        }

        const bounds = this.getSelectionBounds(selected);
        if (!bounds) return [];
        const targets: any[] = [];
        grid.forEach((gridRow: any[], rowOffset: number) => {
            (gridRow || []).forEach((value: any, columnOffset: number) => {
                const row = rows[bounds.minRowIndex + rowOffset];
                const project = projects[bounds.minColumnIndex + columnOffset];
                if (!row || !project) return;
                targets.push({
                    row,
                    project,
                    value: String(value === undefined || value === null ? "" : value)
                });
            });
        });
        return targets;
    }

    public async applyClipboardTargets(targets: any[], label: string) {
        const normalizedTargets = (targets || []).filter(target => target && target.row && target.project);
        if (normalizedTargets.length === 0) {
            this.setClipboardFeedback("붙여넣을 범위가 현재 보기 밖입니다.", "warning");
            await this.service.render();
            return false;
        }

        const changedTargets = normalizedTargets.filter(target => this.getCellValue(target.row, target.project.id) !== String(target.value === undefined || target.value === null ? "" : target.value));
        if (changedTargets.length === 0) {
            this.setClipboardFeedback("변경된 셀이 없습니다.", "warning");
            await this.service.render();
            return false;
        }

        if (!this.confirmClipboardOverwrite(changedTargets)) {
            this.setClipboardFeedback("붙여넣기를 취소했습니다.", "warning");
            await this.service.render();
            return false;
        }

        this.recordScheduleHistory(label);
        changedTargets.forEach(target => {
            if (!target.row.cells) target.row.cells = {};
            target.row.cells[target.project.id] = String(target.value === undefined || target.value === null ? "" : target.value);
            this.queueEntrySave(this.makeCellEntryPayload(target.row, target.project));
        });
        this.refreshSelectedCellDetails();
        this.queueSaveSheet();
        this.setClipboardFeedback(`${changedTargets.length}개 셀을 변경했습니다.`, "success");
        await this.service.render();
        return true;
    }

    public confirmClipboardOverwrite(targets: any[]) {
        const overwriteCount = (targets || []).filter(target => {
            const currentValue = this.getCellValue(target.row, target.project.id);
            return currentValue.trim().length > 0 && currentValue !== String(target.value === undefined || target.value === null ? "" : target.value);
        }).length;
        if (overwriteCount === 0 || typeof window === "undefined") return true;
        if (overwriteCount < this.clipboardOverwriteConfirmThreshold) return true;
        return window.confirm(`${overwriteCount}개 기존 값을 덮어쓸까요? Undo/Redo로 복구할 수 있습니다.`);
    }

    public refreshSelectedCellDetails() {
        if (!this.selectedCell) return;
        const row = this.findRowById(this.selectedCell.rowId);
        const project = this.findProjectById(this.selectedCell.projectId);
        if (!row || !project) return;
        this.selectedCell = this.createSelectedCell(row, project);
        this.selectedCellDraft = this.getCellValue(row, project.id);
        this.syncSelectedCellMetaDraft(row, project.id);
        this.selectedCellMessage = "";
    }

    public clearScheduleHistory() {
        this.undoStack = [];
        this.redoStack = [];
        this.historyFeedbackMessage = "";
        this.historyFeedbackStatus = "";
        this.resetUndoCoalesce();
    }

    public resetUndoCoalesce() {
        this.undoCoalesceKey = "";
        this.clearUndoCoalesceTimer();
    }

    public clearUndoCoalesceTimer() {
        if (!this.undoCoalesceTimer) return;
        window.clearTimeout(this.undoCoalesceTimer);
        this.undoCoalesceTimer = null;
    }

    public armUndoCoalesce(key: string = "") {
        this.clearUndoCoalesceTimer();
        this.undoCoalesceKey = key;
        if (!key) return;
        this.undoCoalesceTimer = window.setTimeout(() => {
            this.undoCoalesceKey = "";
            this.undoCoalesceTimer = null;
        }, 1200);
    }

    public cloneHistoryData(data: any) {
        try {
            return JSON.parse(JSON.stringify(data || {}));
        } catch (e) {
            return data || {};
        }
    }

    public createScheduleHistorySnapshot(label: string = "변경") {
        const convenience = this.normalizeCurrentConvenienceState();
        const sheet = createScheduleStoragePayload({
            version: this.schemaVersion,
            projects: this.projects,
            rows: this.rows,
            milestones: this.milestones,
            viewPrefs: convenience.viewPrefs,
            projectGroups: convenience.projectGroups,
            savedViews: convenience.savedViews
        });
        return {
            label: label || "변경",
            createdAt: new Date().toISOString(),
            sheet: this.cloneHistoryData(sheet)
        };
    }

    public areHistorySnapshotsEqual(left: any, right: any) {
        if (!left || !right) return false;
        return JSON.stringify(left.sheet || left) === JSON.stringify(right.sheet || right);
    }

    public recordScheduleHistory(label: string, coalesceKey: string = "") {
        if (this.isHistoryRestoring) return;

        const snapshot = this.createScheduleHistorySnapshot(label);
        const lastSnapshot = this.undoStack.length > 0 ? this.undoStack[this.undoStack.length - 1] : null;
        if (this.areHistorySnapshotsEqual(lastSnapshot, snapshot)) {
            this.armUndoCoalesce(coalesceKey);
            return;
        }
        if (coalesceKey && this.undoCoalesceKey === coalesceKey && lastSnapshot) {
            this.armUndoCoalesce(coalesceKey);
            return;
        }

        this.undoStack.push(snapshot);
        if (this.undoStack.length > this.undoStackLimit) {
            this.undoStack = this.undoStack.slice(this.undoStack.length - this.undoStackLimit);
        }
        this.redoStack = [];
        this.armUndoCoalesce(coalesceKey);
    }

    public get canUndoSchedule() {
        return this.undoStack.length > 0 && !this.isHistoryRestoring;
    }

    public get canRedoSchedule() {
        return this.redoStack.length > 0 && !this.isHistoryRestoring;
    }

    public get undoScheduleTitle() {
        if (!this.canUndoSchedule) return "되돌릴 변경이 없습니다.";
        const snapshot = this.undoStack[this.undoStack.length - 1];
        return `${snapshot.label || "변경"} 되돌리기 (Ctrl+Z)`;
    }

    public get redoScheduleTitle() {
        if (!this.canRedoSchedule) return "다시 실행할 변경이 없습니다.";
        const snapshot = this.redoStack[this.redoStack.length - 1];
        return `${snapshot.label || "변경"} 다시 실행 (Ctrl+Y 또는 Ctrl+Shift+Z)`;
    }

    public get scheduleHistorySummaryLabel() {
        return `되돌리기 ${this.undoStack.length} · 다시 실행 ${this.redoStack.length}`;
    }

    public setHistoryFeedback(message: string, status: string = "") {
        this.historyFeedbackMessage = message;
        this.historyFeedbackStatus = status;
    }

    public async undoScheduleChange() {
        if (!this.canUndoSchedule) {
            this.setHistoryFeedback("되돌릴 변경이 없습니다.", "warning");
            await this.service.render();
            return;
        }

        this.resetUndoCoalesce();
        const currentSnapshot = this.createScheduleHistorySnapshot("현재 상태");
        const targetSnapshot = this.undoStack.pop();
        if (!this.areHistorySnapshotsEqual(currentSnapshot, targetSnapshot)) {
            this.redoStack.push(currentSnapshot);
        }
        await this.restoreScheduleHistorySnapshot(targetSnapshot, currentSnapshot, "undo");
    }

    public async redoScheduleChange() {
        if (!this.canRedoSchedule) {
            this.setHistoryFeedback("다시 실행할 변경이 없습니다.", "warning");
            await this.service.render();
            return;
        }

        this.resetUndoCoalesce();
        const currentSnapshot = this.createScheduleHistorySnapshot("현재 상태");
        const targetSnapshot = this.redoStack.pop();
        if (!this.areHistorySnapshotsEqual(currentSnapshot, targetSnapshot)) {
            this.undoStack.push(currentSnapshot);
        }
        await this.restoreScheduleHistorySnapshot(targetSnapshot, currentSnapshot, "redo");
    }

    public async restoreScheduleHistorySnapshot(targetSnapshot: any, currentSnapshot: any, mode: string) {
        if (!targetSnapshot || !targetSnapshot.sheet) return;

        const recovered = this.recoverSheet(targetSnapshot.sheet);
        if (!recovered) {
            this.setHistoryFeedback("변경 이력을 복구하지 못했습니다.", "error");
            await this.service.render();
            return;
        }

        try {
            this.isHistoryRestoring = true;
            this.clearPendingHistorySaveTimers();
            this.applySheetState(recovered);
            this.refreshMetrics();
            this.syncSelectedCellAfterHistory();
            this.activeEditKey = "";
            this.resetCellInlineDraft();
            this.resetExportState();
            this.persistSheet(this.projects, this.rows, this.viewPrefs, this.projectGroups, this.savedViews);
            this.markLocalSaved();
            const action = mode === "redo" ? "다시 실행했습니다." : "되돌렸습니다.";
            this.setHistoryFeedback(`${targetSnapshot.label || "변경"}을 ${action}`, mode === "redo" ? "success" : "warning");
        } finally {
            this.isHistoryRestoring = false;
        }

        await this.service.render();
        this.syncHistoryDeltaToServer(currentSnapshot ? currentSnapshot.sheet : null, targetSnapshot.sheet);
    }

    public clearPendingHistorySaveTimers() {
        if (this.saveTimer) {
            window.clearTimeout(this.saveTimer);
            this.saveTimer = null;
        }
        Object.keys(this.projectSaveTimers || {}).forEach(key => {
            window.clearTimeout(this.projectSaveTimers[key]);
            delete this.projectSaveTimers[key];
        });
        Object.keys(this.entrySaveTimers || {}).forEach(key => {
            window.clearTimeout(this.entrySaveTimers[key]);
            delete this.entrySaveTimers[key];
        });
    }

    public syncSelectedCellAfterHistory() {
        if (!this.selectedCell) return;
        const row = this.findRowById(this.selectedCell.rowId);
        const project = this.findProjectById(this.selectedCell.projectId);
        if (!row || !project || !this.isProjectVisible(project)) {
            this.clearSelectedCellState();
            return;
        }
        this.selectCell(row, project);
    }

    public normalizeHistorySheet(sheet: any) {
        if (!sheet || !Array.isArray(sheet.projects) || !Array.isArray(sheet.rows)) return null;
        const normalized = this.normalizeSheet(sheet.projects, sheet.rows);
        return {
            ...normalized,
            milestones: normalizeMilestones(sheet.milestones, normalized.projects),
            ...normalizeScheduleConvenienceState(sheet, normalized.projects, normalized.rows)
        };
    }

    public syncHistoryDeltaToServer(beforeSheet: any, afterSheet: any) {
        const before = this.normalizeHistorySheet(beforeSheet);
        const after = this.normalizeHistorySheet(afterSheet);
        if (!before || !after) return;

        const projectDelta = this.collectHistoryProjectDelta(before, after);
        const entryPayloads = this.collectHistoryEntryPayloads(before, after, projectDelta.deletedProjectIds);
        const milestoneDelta = this.collectHistoryMilestoneDelta(before, after);
        const hasServerWork = projectDelta.deletedProjects.length > 0
            || projectDelta.savedProjects.length > 0
            || entryPayloads.length > 0
            || milestoneDelta.deletedMilestones.length > 0
            || milestoneDelta.savedMilestones.length > 0;
        if (!hasServerWork) return;

        if (!this.serverStorageReady || this.serverReadOnly) {
            this.setPersistenceStatus("local", "로컬 저장 사용 중", "되돌리기/다시 실행 변경은 로컬에 저장되었고 서버에는 아직 반영되지 않았습니다.");
            void this.service.render();
            return;
        }

        projectDelta.deletedProjects.forEach((project: any) => {
            this.clearPendingProjectSaves(project.id);
            void this.deleteProjectFromServer(project);
        });
        projectDelta.savedProjects.forEach((project: any) => {
            void this.saveProjectToServer(project);
        });
        entryPayloads.forEach((payload: any) => {
            void this.saveEntryPayloadToServer(payload);
        });
        milestoneDelta.deletedMilestones.forEach((milestone: any) => {
            void this.deleteMilestoneFromServer(milestone);
        });
        milestoneDelta.savedMilestones.forEach((milestone: any) => {
            void this.saveMilestoneToServer(milestone);
        });
    }

    public collectHistoryProjectDelta(before: any, after: any) {
        const beforeMap = this.createHistoryProjectMap(before.projects);
        const afterMap = this.createHistoryProjectMap(after.projects);
        const deletedProjectIds: any = {};
        const deletedProjects: any[] = [];
        const savedProjects: any[] = [];

        Object.keys(beforeMap).forEach(projectId => {
            if (afterMap[projectId]) return;
            deletedProjectIds[projectId] = true;
            deletedProjects.push(beforeMap[projectId].project);
        });

        Object.keys(afterMap).forEach(projectId => {
            const beforeProject = beforeMap[projectId];
            const afterProject = afterMap[projectId];
            if (beforeProject && beforeProject.signature === afterProject.signature) return;
            const currentProject = this.findProjectById(projectId);
            if (currentProject) savedProjects.push(currentProject);
        });

        return { deletedProjectIds, deletedProjects, savedProjects };
    }

    public createHistoryProjectMap(projects: any[] = []) {
        const map: any = {};
        projects.forEach((project: any, index: number) => {
            if (!project || !project.id) return;
            const id = String(project.id);
            map[id] = {
                project,
                signature: this.createHistoryProjectSignature(project, index)
            };
        });
        return map;
    }

    public createHistoryProjectSignature(project: any, index: number = 0) {
        return JSON.stringify({
            id: String(project && project.id ? project.id : ""),
            name: String(project && project.name ? project.name : ""),
            pm: String(project && project.pm ? project.pm : ""),
            owner: String(project && project.owner ? project.owner : ""),
            color: String(project && project.color ? project.color : ""),
            sortOrder: this.numberOrDefault(project ? project.sortOrder : index, index),
            hidden: !!(project && project.hidden),
            favorite: this.isFavoriteProject(project)
        });
    }

    public collectHistoryMilestoneDelta(before: any, after: any) {
        const beforeMap = this.createHistoryMilestoneMap(before.milestones);
        const afterMap = this.createHistoryMilestoneMap(after.milestones);
        const deletedMilestones: any[] = [];
        const savedMilestones: any[] = [];

        Object.keys(beforeMap).forEach(milestoneId => {
            if (!afterMap[milestoneId]) deletedMilestones.push(beforeMap[milestoneId].milestone);
        });

        Object.keys(afterMap).forEach(milestoneId => {
            const beforeMilestone = beforeMap[milestoneId];
            const afterMilestone = afterMap[milestoneId];
            if (beforeMilestone && beforeMilestone.signature === afterMilestone.signature) return;
            savedMilestones.push(this.findMilestoneById(milestoneId) || afterMilestone.milestone);
        });

        return { deletedMilestones, savedMilestones };
    }

    public createHistoryMilestoneMap(milestones: any[] = []) {
        const map: any = {};
        normalizeMilestones(milestones, this.projects).forEach((milestone: any) => {
            if (!milestone || !milestone.id) return;
            map[milestone.id] = {
                milestone,
                signature: this.createHistoryMilestoneSignature(milestone)
            };
        });
        return map;
    }

    public createHistoryMilestoneSignature(milestone: any) {
        return JSON.stringify({
            id: String(milestone && milestone.id ? milestone.id : ""),
            title: String(milestone && milestone.title ? milestone.title : ""),
            date: String(milestone && milestone.date ? milestone.date : ""),
            scope: String(milestone && milestone.scope ? milestone.scope : "common"),
            projectId: String(milestone && milestone.projectId ? milestone.projectId : ""),
            color: String(milestone && milestone.color ? milestone.color : ""),
            icon: String(milestone && milestone.icon ? milestone.icon : ""),
            note: String(milestone && milestone.note ? milestone.note : "")
        });
    }

    public collectHistoryEntryPayloads(before: any, after: any, deletedProjectIds: any = {}) {
        const payloads: any[] = [];
        const beforeRows = this.createHistoryRowMap(before.rows);
        const afterRows = this.createHistoryRowMap(after.rows);
        const dateSet: any = {};
        const projectIdSet: any = {};

        Object.keys(beforeRows).forEach(date => dateSet[date] = true);
        Object.keys(afterRows).forEach(date => dateSet[date] = true);
        (before.projects || []).concat(after.projects || []).forEach((project: any) => {
            if (project && project.id) projectIdSet[project.id] = true;
        });

        Object.keys(dateSet).forEach(date => {
            const beforeRow = beforeRows[date] || null;
            const afterRow = afterRows[date] || null;
            if (this.getHistoryDayNote(beforeRow) !== this.getHistoryDayNote(afterRow)) {
                payloads.push(this.createHistoryDayPayload(date));
            }

            Object.keys(projectIdSet).forEach(projectId => {
                if (deletedProjectIds[projectId]) return;
                if (this.getHistoryCellSignature(beforeRow, projectId) === this.getHistoryCellSignature(afterRow, projectId)) return;
                const payload = this.createHistoryCellPayload(date, projectId);
                if (payload) payloads.push(payload);
            });
        });

        return payloads;
    }

    public createHistoryRowMap(rows: any[] = []) {
        const map: any = {};
        rows.forEach((row: any) => {
            if (row && row.date) map[row.date] = row;
        });
        return map;
    }

    public getHistoryDayNote(row: any) {
        return String(row && row.note !== undefined && row.note !== null ? row.note : "");
    }

    public createHistoryDayPayload(date: string) {
        const row = this.rows.find(item => item && item.date === date);
        if (row) return this.makeDayEntryPayload(row);
        return {
            scope: "day",
            date,
            note: ""
        };
    }

    public getHistoryCellSignature(row: any, projectId: string) {
        if (!row) {
            return JSON.stringify({
                value: "",
                status: this.defaultCellStatus,
                type: this.defaultCellType,
                time: "",
                dependencies: this.normalizeCellDependencies({})
            });
        }
        const cells = row.cells || {};
        const metaMap = row.cellMeta || {};
        const rawCell = cells[projectId];
        const meta = this.normalizeCellMeta(rawCell, metaMap[projectId]);
        return JSON.stringify({
            value: this.extractCellMemo(rawCell),
            status: meta.status,
            type: meta.type,
            time: meta.time,
            dependencies: meta.dependencies
        });
    }

    public createHistoryCellPayload(date: string, projectId: string) {
        const row = this.rows.find(item => item && item.date === date);
        const project = this.findProjectById(projectId);
        if (row && project) return this.makeCellEntryPayload(row, project);
        if (!project) return null;
        return {
            scope: "cell",
            date,
            projectId,
            value: "",
            comment: "",
            entryType: this.defaultCellType,
            taskStatus: this.defaultCellStatus,
            scheduleTime: "",
            dependencies: this.normalizeCellDependencies({})
        };
    }

    public get scheduleProjectGroupsWithUngrouped() {
        return getProjectGroupsWithUngrouped(this.projectGroups, this.projects, this.viewPrefs);
    }

    public get visibleProjects() {
        return this.projects.filter(project => this.isProjectVisible(project));
    }

    public get hiddenProjects() {
        return this.projects.filter(project => this.isProjectHidden(project));
    }

    public get projectManagementProjects() {
        const seen: any = {};
        const ordered = this.groupProjectOrderGroups
            .reduce((items: any[], group: any) => items.concat(this.getGroupOrderProjects(group)), [])
            .filter((project: any) => {
                if (!project || !project.id || seen[project.id]) return false;
                seen[project.id] = true;
                return true;
            });

        return ordered.concat(this.projects.filter(project => {
            if (!project || !project.id || seen[project.id]) return false;
            seen[project.id] = true;
            return true;
        }));
    }

    public get visibleProjectCount() {
        return this.visibleProjects.length;
    }

    public get hiddenProjectCount() {
        return this.hiddenProjects.length;
    }

    public get projectManagementSummaryLabel() {
        return `표시 ${this.visibleProjectCount}개 · 숨김 ${this.hiddenProjectCount}개`;
    }

    public get visibleProjectGroupsWithUngrouped() {
        const prefs = normalizeViewPrefs(this.viewPrefs);
        const allGroupPrefs = normalizeViewPrefs({
            ...prefs,
            filters: {
                ...prefs.filters,
                selectedProjectId: "",
                groupId: "",
                favoriteOnly: false
            }
        });
        return getProjectGroupRenderItems(this.projectGroups, this.projects, allGroupPrefs);
    }

    public get scheduleTableViewPrefs() {
        const prefs = normalizeViewPrefs(this.viewPrefs);
        const selectedProject = this.selectedProjectId ? this.findProjectById(this.selectedProjectId) : null;
        return normalizeViewPrefs({
            ...prefs,
            filters: {
                ...prefs.filters,
                selectedProjectId: this.isProjectVisible(selectedProject) ? this.selectedProjectId : ""
            }
        });
    }

    public get scheduleTableProjectGroups() {
        return getProjectGroupRenderItems(this.projectGroups, this.projects, this.scheduleTableViewPrefs);
    }

    public get scheduleProjectColumns() {
        const projectMap: any = {};
        this.projects.forEach(project => {
            if (project && project.id) projectMap[project.id] = project;
        });

        return getProjectRenderOrder(this.projectGroups, this.projects, this.viewPrefs)
            .map(projectId => projectMap[projectId])
            .filter(project => !!project);
    }

    public get scheduleTableColumns() {
        return getProjectColumnRenderItems(this.projectGroups, this.projects, this.scheduleTableViewPrefs);
    }

    public get scheduleTableColumnCount() {
        return this.scheduleTableColumns.length;
    }

    public get scheduleDateColumnWidthPx() {
        return getDateHeaderColumnWidthPx(this.viewPrefs);
    }

    public get scheduleTableWidthPx() {
        return this.scheduleDateColumnWidthPx
            + this.noteColumnWidthPx
            + this.scheduleTableColumns.reduce((total: number, column: any) => total + this.getScheduleColumnWidthPx(column), 0);
    }

    public get projectHeaderRowHeightPx() {
        return getProjectHeaderRowHeightPx(this.viewPrefs);
    }

    public get scheduleTableHeadHeightPx() {
        return 44 + this.projectHeaderRowHeightPx;
    }

    public get projectHeaderRowHeightLabel() {
        return this.hasCustomProjectHeaderRowHeight ? "사용자 지정 높이" : "기본 높이";
    }

    public get hasCustomProjectHeaderRowHeight() {
        return this.projectHeaderRowHeightPx !== PROJECT_HEADER_ROW_HEIGHT_DEFAULT_PX;
    }

    public getProjectHeaderRowHeightAriaLabel() {
        return `프로젝트 헤더 행 높이 조절, 현재 ${this.projectHeaderRowHeightLabel}`;
    }

    public getProjectHeaderRowHeightTooltip() {
        if (this.isProjectHeaderRowHeightResizing && this.projectHeaderRowHeightResizeState) return "높이 조절 중";
        return "드래그로 높이 조절";
    }

    public persistProjectHeaderRowHeightOverride(heightPx: any, historyLabel: string = "프로젝트 헤더 행 높이 변경") {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setProjectHeaderRowHeight(currentPrefs, heightPx);
        if (nextPrefs.projectHeaderRowHeightPx === currentPrefs.projectHeaderRowHeightPx) return false;

        this.recordScheduleHistory(historyLabel, "project-header-row-height");
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        return true;
    }

    public async setProjectHeaderRowHeightPx(heightPx: any) {
        if (this.persistProjectHeaderRowHeightOverride(heightPx)) await this.service.render();
    }

    public async resetProjectHeaderRowHeight(event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.clearResizeDoubleClickGesture("project-header-row-height");
        if (!this.hasCustomProjectHeaderRowHeight) return;

        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = clearProjectHeaderRowHeight(currentPrefs);
        if (nextPrefs.projectHeaderRowHeightPx === currentPrefs.projectHeaderRowHeightPx) return;

        this.recordScheduleHistory("프로젝트 헤더 행 높이 기본값", "project-header-row-height");
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public startProjectHeaderRowHeightResize(event: PointerEvent) {
        if (!event) return;
        if (event.button !== undefined && event.button !== 0) return;
        const resizeKey = "project-header-row-height";
        if (this.isResizeDoubleClickGesture(resizeKey, event)) {
            void this.resetProjectHeaderRowHeight(event);
            return;
        }

        this.cleanupProjectHeaderRowHeightResize();

        const handleElement = event.currentTarget as HTMLElement;
        const boardElement = handleElement && handleElement.closest ? handleElement.closest(".schedule-board") as HTMLElement : null;
        const startHeight = this.projectHeaderRowHeightPx;
        const body = document.body;

        this.projectHeaderRowHeightResizeState = {
            startHeight,
            currentHeight: startHeight,
            startY: event.clientY,
            boardElement,
            handleElement,
            previousBodyCursor: body ? body.style.cursor : "",
            previousBodyUserSelect: body ? body.style.userSelect : ""
        };
        this.isProjectHeaderRowHeightResizing = true;

        if (boardElement) boardElement.classList.add("is-project-header-row-height-resizing");
        if (handleElement) {
            handleElement.classList.add("is-dragging");
            handleElement.setAttribute("data-resize-tooltip", "높이 조절 중");
            handleElement.setAttribute("aria-valuetext", "높이 조절 중");
        }
        if (body) {
            body.classList.add("is-schedule-project-header-row-height-resizing");
            body.style.cursor = "row-resize";
            body.style.userSelect = "none";
        }

        this.projectHeaderRowHeightPointerMoveHandler = (moveEvent: PointerEvent) => this.updateProjectHeaderRowHeightResize(moveEvent);
        this.projectHeaderRowHeightPointerUpHandler = (upEvent: PointerEvent) => this.finishProjectHeaderRowHeightResize(upEvent);
        this.projectHeaderRowHeightPointerCancelHandler = (cancelEvent: PointerEvent) => this.finishProjectHeaderRowHeightResize(cancelEvent);
        document.addEventListener("pointermove", this.projectHeaderRowHeightPointerMoveHandler, { passive: false });
        document.addEventListener("pointerup", this.projectHeaderRowHeightPointerUpHandler, { passive: false });
        document.addEventListener("pointercancel", this.projectHeaderRowHeightPointerCancelHandler, { passive: false });

        event.preventDefault();
        event.stopPropagation();
    }

    public updateProjectHeaderRowHeightResize(event: PointerEvent) {
        const state = this.projectHeaderRowHeightResizeState;
        if (!state || !event) return;

        const nextHeight = clampProjectHeaderRowHeightPx(state.startHeight + event.clientY - state.startY);
        state.currentHeight = nextHeight;
        if (state.boardElement) {
            state.boardElement.style.setProperty("--schedule-project-header-row-height", `${nextHeight}px`);
            state.boardElement.style.setProperty("--schedule-table-head-height", `${44 + nextHeight}px`);
        }
        if (state.handleElement) {
            state.handleElement.setAttribute("aria-valuenow", String(nextHeight));
            state.handleElement.setAttribute("aria-valuetext", "높이 조절 중");
            state.handleElement.setAttribute("data-resize-tooltip", "높이 조절 중");
        }

        event.preventDefault();
        event.stopPropagation();
    }

    public finishProjectHeaderRowHeightResize(event: PointerEvent) {
        const state = this.projectHeaderRowHeightResizeState;
        if (!state) return;

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const changed = this.persistProjectHeaderRowHeightOverride(state.currentHeight);
        this.cleanupProjectHeaderRowHeightResize();
        if (changed) void this.service.render();
    }

    public cleanupProjectHeaderRowHeightResize() {
        const state = this.projectHeaderRowHeightResizeState;
        if (this.projectHeaderRowHeightPointerMoveHandler) document.removeEventListener("pointermove", this.projectHeaderRowHeightPointerMoveHandler);
        if (this.projectHeaderRowHeightPointerUpHandler) document.removeEventListener("pointerup", this.projectHeaderRowHeightPointerUpHandler);
        if (this.projectHeaderRowHeightPointerCancelHandler) document.removeEventListener("pointercancel", this.projectHeaderRowHeightPointerCancelHandler);

        if (state && state.boardElement) {
            state.boardElement.classList.remove("is-project-header-row-height-resizing");
            state.boardElement.style.removeProperty("--schedule-project-header-row-height");
            state.boardElement.style.removeProperty("--schedule-table-head-height");
        }
        if (state && state.handleElement) state.handleElement.classList.remove("is-dragging");
        if (document.body) {
            document.body.classList.remove("is-schedule-project-header-row-height-resizing");
            if (state) {
                document.body.style.cursor = state.previousBodyCursor || "";
                document.body.style.userSelect = state.previousBodyUserSelect || "";
            }
        }

        this.projectHeaderRowHeightPointerMoveHandler = null;
        this.projectHeaderRowHeightPointerUpHandler = null;
        this.projectHeaderRowHeightPointerCancelHandler = null;
        this.projectHeaderRowHeightResizeState = null;
        this.isProjectHeaderRowHeightResizing = false;
    }

    public handleProjectHeaderRowHeightResizeClick(event: any) {
        if (!event || event.detail < 2) return;
        void this.resetProjectHeaderRowHeight(event);
    }

    public async handleProjectHeaderRowHeightResizeKeydown(event: KeyboardEvent) {
        if (!event) return;

        const currentHeight = this.projectHeaderRowHeightPx;
        const step = event.shiftKey ? this.projectHeaderRowHeightStepPx * 2 : this.projectHeaderRowHeightStepPx;
        let nextHeight = currentHeight;

        if (event.key === "ArrowUp") nextHeight = currentHeight - step;
        else if (event.key === "ArrowDown") nextHeight = currentHeight + step;
        else if (event.key === "PageUp") nextHeight = currentHeight - (step * 3);
        else if (event.key === "PageDown") nextHeight = currentHeight + (step * 3);
        else if (event.key === "Home") nextHeight = this.projectHeaderRowHeightMinPx;
        else if (event.key === "End") nextHeight = this.projectHeaderRowHeightMaxPx;
        else return;

        event.preventDefault();
        event.stopPropagation();
        await this.setProjectHeaderRowHeightPx(nextHeight);
    }

    public get dateHeaderColumnWidthLabel() {
        return this.hasCustomDateHeaderColumnWidth ? "사용자 지정 너비" : "기본 너비";
    }

    public get hasCustomDateHeaderColumnWidth() {
        return this.scheduleDateColumnWidthPx !== DATE_COLUMN_WIDTH_DEFAULT_PX;
    }

    public getDateHeaderColumnResizeKey() {
        return "date";
    }

    public isDateHeaderColumnBeingResized() {
        return !!this.projectColumnResizeState && this.projectColumnResizeState.columnType === "date";
    }

    public getDateHeaderColumnResizeAriaLabel() {
        return `날짜 컬럼 너비 조절, 현재 ${this.dateHeaderColumnWidthLabel}`;
    }

    public getDateHeaderColumnResizeTooltip() {
        if (this.isDateHeaderColumnBeingResized() && this.projectColumnResizeState) {
            const currentWidth = this.projectColumnResizeState.currentWidth;
            return currentWidth >= 0 ? "너비 조절 중" : "너비 조절 중";
        }
        return "드래그로 너비 조절";
    }

    public persistDateHeaderColumnWidthOverride(widthPx: any, historyLabel: string = "날짜 컬럼 너비 변경") {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setDateHeaderColumnWidth(currentPrefs, widthPx);
        if (nextPrefs.dateColumnWidthPx === currentPrefs.dateColumnWidthPx) return false;

        this.recordScheduleHistory(historyLabel, "date-header-column-width");
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        return true;
    }

    public async setDateHeaderColumnWidthPx(widthPx: any) {
        if (this.persistDateHeaderColumnWidthOverride(widthPx)) await this.service.render();
    }

    public async resetDateHeaderColumnWidth(event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.clearResizeDoubleClickGesture(this.getDateHeaderColumnResizeKey());
        if (!this.hasCustomDateHeaderColumnWidth) return;
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = clearDateHeaderColumnWidth(currentPrefs);
        if (nextPrefs.dateColumnWidthPx === currentPrefs.dateColumnWidthPx) return;

        this.recordScheduleHistory("날짜 컬럼 너비 기본값", "date-header-column-width");
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public get scheduleMobileProjectColumns() {
        return this.scheduleProjectColumns;
    }

    public get mobileCollapsedGroups() {
        return this.scheduleProjectGroupsWithUngrouped.filter(group => this.isProjectGroupCollapsed(group));
    }

    public getProjectGroupColspan(group: any) {
        if (!group || !Array.isArray(group.projectIds)) return 0;
        return this.isProjectGroupCollapsed(group) ? 1 : group.projectIds.length;
    }

    public getProjectGroupAriaControls(group: any) {
        const id = group && group.id ? String(group.id) : "unknown";
        return `schedule-group-columns-${this.makeDomSafeId(id)}`;
    }

    public makeDomSafeId(value: any) {
        return String(value || "unknown").replace(/[^A-Za-z0-9_-]/g, "-") || "unknown";
    }

    public isProjectGroupCollapsed(group: any) {
        return !!group && group.collapsed === true;
    }

    public isProjectColumn(column: any) {
        return !!column && column.type === "project" && !!column.project;
    }

    public isGroupSummaryColumn(column: any) {
        return !!column && column.type === "groupSummary" && !!column.group;
    }

    public isSelectedProjectColumn(column: any) {
        return this.isProjectColumn(column) && !!this.selectedProjectId && column.project.id === this.selectedProjectId;
    }

    public getScheduleColumnColor(column: any) {
        if (this.isProjectColumn(column)) return column.project.color;
        if (this.isGroupSummaryColumn(column)) return column.group.color;
        return "#64748b";
    }

    public getScheduleColumnWidthPx(column: any) {
        if (this.isProjectColumn(column)) return this.getProjectColumnWidthPx(column.project);
        if (this.isGroupSummaryColumn(column)) return GROUP_SUMMARY_COLUMN_WIDTH_PX;
        return PROJECT_COLUMN_WIDTH_DEFAULT_PX;
    }

    public getProjectColumnWidthPx(project: any) {
        const projectId = project && project.id ? project.id : "";
        return resolveProjectColumnWidthPx(this.viewPrefs, projectId);
    }

    public getProjectColumnWidthLabel(project: any) {
        return this.hasProjectColumnCustomWidth(project) ? "사용자 지정 너비" : "기본 너비";
    }

    public getProjectColumnResizeTooltip(project: any) {
        if (this.isProjectColumnBeingResized(project) && this.projectColumnResizeState) {
            const currentWidth = this.projectColumnResizeState.currentWidth;
            return currentWidth >= 0 ? "너비 조절 중" : "너비 조절 중";
        }
        return "드래그로 너비 조절";
    }

    public getProjectColumnWidthInputName(project: any) {
        const projectId = project && project.id ? String(project.id) : "unknown";
        return `project-column-width-${this.makeDomSafeId(projectId)}`;
    }

    public getProjectColumnWidthAriaLabel(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        return `${name} 컬럼 너비, 현재 ${this.getProjectColumnWidthLabel(project)}`;
    }

    public hasProjectColumnCustomWidth(project: any) {
        const projectId = project && project.id ? String(project.id) : "";
        if (!projectId) return false;
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return Object.prototype.hasOwnProperty.call(prefs.projectColumnWidths, projectId);
    }

    public canShrinkProjectColumn(project: any) {
        return this.getProjectColumnWidthPx(project) > this.projectColumnWidthMinPx;
    }

    public canExpandProjectColumn(project: any) {
        return this.getProjectColumnWidthPx(project) < this.projectColumnWidthMaxPx;
    }

    public async nudgeProjectColumnWidth(project: any, deltaPx: number) {
        if (!project || !project.id) return;
        await this.setProjectColumnWidthPx(project, this.getProjectColumnWidthPx(project) + deltaPx);
    }

    public persistProjectColumnWidthOverride(project: any, widthPx: any, historyLabel: string = "") {
        if (!project || !project.id) return;
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setProjectColumnWidth(currentPrefs, project.id, widthPx);
        if (JSON.stringify(nextPrefs.projectColumnWidths) === JSON.stringify(currentPrefs.projectColumnWidths)) return false;

        this.recordScheduleHistory(historyLabel || `${project.name || "프로젝트"} 컬럼 너비 변경`, `project-column-width-${project.id}`);
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        return true;
    }

    public async setProjectColumnWidthPx(project: any, widthPx: any) {
        if (this.persistProjectColumnWidthOverride(project, widthPx)) await this.service.render();
    }

    public async resetProjectColumnWidth(project: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.cleanupProjectColumnResize();
        this.clearResizeDoubleClickGesture(project && project.id ? this.getProjectColumnResizeKey(project) : "");
        if (!project || !project.id || !this.hasProjectColumnCustomWidth(project)) return;
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = clearProjectColumnWidth(currentPrefs, project.id);
        if (JSON.stringify(nextPrefs.projectColumnWidths) === JSON.stringify(currentPrefs.projectColumnWidths)) return;

        this.recordScheduleHistory(`${project.name || "프로젝트"} 컬럼 너비 기본값`, `project-column-width-${project.id}`);
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public get noteColumnWidthPx() {
        return getNoteColumnWidthPx(this.viewPrefs);
    }

    public get noteColumnWidthLabel() {
        return this.hasCustomNoteColumnWidth ? "사용자 지정 너비" : "기본 너비";
    }

    public get hasCustomNoteColumnWidth() {
        return this.noteColumnWidthPx !== NOTE_COLUMN_WIDTH_DEFAULT_PX;
    }

    public getNoteColumnWidthAriaLabel() {
        return `개인 컬럼 너비, 현재 ${this.noteColumnWidthLabel}`;
    }

    public persistNoteColumnWidthOverride(widthPx: any, historyLabel: string = "개인 컬럼 너비 변경") {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setNoteColumnWidth(currentPrefs, widthPx);
        if (nextPrefs.noteColumnWidthPx === currentPrefs.noteColumnWidthPx) return false;

        this.recordScheduleHistory(historyLabel, "note-column-width");
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        return true;
    }

    public async setNoteColumnWidthPx(widthPx: any) {
        if (this.persistNoteColumnWidthOverride(widthPx)) await this.service.render();
    }

    public async resetNoteColumnWidth(event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.clearResizeDoubleClickGesture(this.getNoteColumnResizeKey());
        if (!this.hasCustomNoteColumnWidth) return;
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = clearNoteColumnWidth(currentPrefs);
        if (nextPrefs.noteColumnWidthPx === currentPrefs.noteColumnWidthPx) return;

        this.recordScheduleHistory("개인 컬럼 너비 기본값", "note-column-width");
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public getProjectColumnResizeKey(project: any) {
        return `project-${this.makeDomSafeId(project && project.id ? project.id : "")}`;
    }

    public getNoteColumnResizeKey() {
        return "note";
    }

    public isProjectColumnBeingResized(project: any) {
        return !!project && !!this.projectColumnResizeState && this.projectColumnResizeState.columnType === "project" && this.projectColumnResizeState.projectId === project.id;
    }

    public isNoteColumnBeingResized() {
        return !!this.projectColumnResizeState && this.projectColumnResizeState.columnType === "note";
    }

    public getProjectColumnResizeAriaLabel(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        return `${name} 컬럼 너비 조절, 현재 ${this.getProjectColumnWidthLabel(project)}`;
    }

    public getNoteColumnResizeAriaLabel() {
        return `개인 컬럼 너비 조절, 현재 ${this.noteColumnWidthLabel}`;
    }

    public getNoteColumnResizeTooltip() {
        if (this.isNoteColumnBeingResized() && this.projectColumnResizeState) {
            const currentWidth = this.projectColumnResizeState.currentWidth;
            return currentWidth >= 0 ? "너비 조절 중" : "너비 조절 중";
        }
        return "드래그로 너비 조절";
    }

    public isResizeDoubleClickGesture(key: string, event: PointerEvent) {
        if (!key || !event) return false;
        const now = Date.now();
        const current = {
            key,
            time: now,
            x: event.clientX,
            y: event.clientY
        };
        const previous = this.lastResizePointerDown;
        const repeatedByDetail = event.detail > 1;
        const repeatedByTiming = previous
            && previous.key === key
            && now - previous.time <= this.resizeDoubleClickWindowMs
            && Math.abs(previous.x - current.x) <= this.resizeDoubleClickDistancePx
            && Math.abs(previous.y - current.y) <= this.resizeDoubleClickDistancePx;

        this.lastResizePointerDown = current;
        return repeatedByDetail || repeatedByTiming;
    }

    public clearResizeDoubleClickGesture(key: string = "") {
        if (!key || !this.lastResizePointerDown || this.lastResizePointerDown.key === key) {
            this.lastResizePointerDown = null;
        }
    }

    public startDateHeaderColumnResize(event: PointerEvent) {
        if (!event) return;
        const resizeKey = this.getDateHeaderColumnResizeKey();
        if (this.isResizeDoubleClickGesture(resizeKey, event)) {
            void this.resetDateHeaderColumnWidth(event);
            return;
        }
        this.startScheduleColumnResize({
            columnType: "date",
            key: resizeKey,
            label: "날짜",
            startWidth: this.scheduleDateColumnWidthPx,
            minWidth: this.dateColumnWidthMinPx,
            maxWidth: this.dateColumnWidthMaxPx,
            clamp: (widthPx: any) => clampDateColumnWidthPx(widthPx),
            persist: (widthPx: any) => this.persistDateHeaderColumnWidthOverride(widthPx)
        }, event);
    }

    public startProjectColumnResize(project: any, event: PointerEvent) {
        if (!project || !project.id || !event) return;
        const resizeKey = this.getProjectColumnResizeKey(project);
        if (event.detail > 1) {
            void this.resetProjectColumnWidth(project, event);
            return;
        }
        if (this.isResizeDoubleClickGesture(resizeKey, event)) {
            void this.resetProjectColumnWidth(project, event);
            return;
        }
        this.startScheduleColumnResize({
            columnType: "project",
            project,
            projectId: project.id,
            key: resizeKey,
            label: project.name || "프로젝트",
            startWidth: this.getProjectColumnWidthPx(project),
            minWidth: this.projectColumnWidthMinPx,
            maxWidth: this.projectColumnWidthMaxPx,
            clamp: (widthPx: any) => clampProjectColumnWidthPx(widthPx),
            persist: (widthPx: any) => this.persistProjectColumnWidthOverride(project, widthPx, `${project.name || "프로젝트"} 컬럼 너비 변경`)
        }, event);
    }

    public startNoteColumnResize(event: PointerEvent) {
        if (!event) return;
        const resizeKey = this.getNoteColumnResizeKey();
        if (this.isResizeDoubleClickGesture(resizeKey, event)) {
            void this.resetNoteColumnWidth(event);
            return;
        }
        this.startScheduleColumnResize({
            columnType: "note",
            key: resizeKey,
            label: "개인",
            startWidth: this.noteColumnWidthPx,
            minWidth: this.noteColumnWidthMinPx,
            maxWidth: this.noteColumnWidthMaxPx,
            clamp: (widthPx: any) => clampNoteColumnWidthPx(widthPx),
            persist: (widthPx: any) => this.persistNoteColumnWidthOverride(widthPx)
        }, event);
    }

    public handleProjectColumnResizeClick(project: any, event: any) {
        if (!event || event.detail < 2) return;
        void this.resetProjectColumnWidth(project, event);
    }

    public handleNoteColumnResizeClick(event: any) {
        if (!event || event.detail < 2) return;
        void this.resetNoteColumnWidth(event);
    }

    public handleDateHeaderColumnResizeClick(event: any) {
        if (!event || event.detail < 2) return;
        void this.resetDateHeaderColumnWidth(event);
    }

    public startScheduleColumnResize(config: any, event: PointerEvent) {
        if (!config || !config.key || !event) return;
        if (event.button !== undefined && event.button !== 0) return;
        const now = Date.now();
        const previousPointerDown = this.lastScheduleColumnResizePointerDown;
        const isRepeatedPointerDown = !!previousPointerDown && previousPointerDown.key === config.key && now - previousPointerDown.time <= 500;
        this.lastScheduleColumnResizePointerDown = { key: config.key, time: now };
        if ((event as any).detail >= 2 || isRepeatedPointerDown) {
            if (config.columnType === "project" && config.project) void this.resetProjectColumnWidth(config.project, event);
            else if (config.columnType === "note") void this.resetNoteColumnWidth(event);
            else if (config.columnType === "date") void this.resetDateHeaderColumnWidth(event);
            return;
        }

        this.cleanupProjectColumnResize();

        const handleElement = event.currentTarget as HTMLElement;
        const elements = Array.prototype.slice.call(document.querySelectorAll(`[data-schedule-column-resize-key="${config.key}"]`)) as HTMLElement[];
        const body = document.body;
        this.projectColumnResizeState = {
            ...config,
            startX: event.clientX,
            currentWidth: config.startWidth,
            handleElement,
            elements,
            previousBodyCursor: body ? body.style.cursor : "",
            previousBodyUserSelect: body ? body.style.userSelect : ""
        };
        this.isProjectColumnResizing = true;
        if (config.columnType === "date") this.isDateColumnResizing = true;

        if (handleElement) {
            handleElement.classList.add("is-dragging");
            handleElement.setAttribute("data-resize-tooltip", "너비 조절 중");
            handleElement.setAttribute("aria-valuetext", "너비 조절 중");
        }
        elements.forEach((element: HTMLElement) => {
            if (element && element.classList) element.classList.add("is-column-resizing");
        });
        if (body) {
            body.classList.add("is-schedule-project-column-resizing");
            body.style.cursor = "col-resize";
            body.style.userSelect = "none";
        }

        this.projectColumnPointerMoveHandler = (moveEvent: PointerEvent) => this.updateProjectColumnResize(moveEvent);
        this.projectColumnPointerUpHandler = (upEvent: PointerEvent) => this.finishProjectColumnResize(upEvent);
        this.projectColumnPointerCancelHandler = (cancelEvent: PointerEvent) => this.finishProjectColumnResize(cancelEvent);
        document.addEventListener("pointermove", this.projectColumnPointerMoveHandler, { passive: false });
        document.addEventListener("pointerup", this.projectColumnPointerUpHandler, { passive: false });
        document.addEventListener("pointercancel", this.projectColumnPointerCancelHandler, { passive: false });

        event.preventDefault();
        event.stopPropagation();
    }

    public updateProjectColumnResize(event: PointerEvent) {
        const state = this.projectColumnResizeState;
        if (!state || !event) return;

        const nextWidth = state.clamp(state.startWidth + event.clientX - state.startX);
        state.currentWidth = nextWidth;
        (state.elements || []).forEach((element: HTMLElement) => {
            if (element) element.style.width = `${nextWidth}px`;
        });
        if (state.handleElement) {
            state.handleElement.setAttribute("aria-valuenow", String(nextWidth));
            state.handleElement.setAttribute("aria-valuetext", "너비 조절 중");
            state.handleElement.setAttribute("data-resize-tooltip", "너비 조절 중");
        }

        event.preventDefault();
        event.stopPropagation();
    }

    public finishProjectColumnResize(event: PointerEvent) {
        const state = this.projectColumnResizeState;
        if (!state) return;

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const changed = state.currentWidth !== state.startWidth && state.persist ? state.persist(state.currentWidth) : false;
        this.cleanupProjectColumnResize();
        if (changed) void this.service.render();
    }

    public cleanupProjectColumnResize() {
        const state = this.projectColumnResizeState;
        if (this.projectColumnPointerMoveHandler) document.removeEventListener("pointermove", this.projectColumnPointerMoveHandler);
        if (this.projectColumnPointerUpHandler) document.removeEventListener("pointerup", this.projectColumnPointerUpHandler);
        if (this.projectColumnPointerCancelHandler) document.removeEventListener("pointercancel", this.projectColumnPointerCancelHandler);

        if (state && state.handleElement) state.handleElement.classList.remove("is-dragging");
        if (state && state.elements) {
            const restoreStartWidth = state.currentWidth === state.startWidth;
            state.elements.forEach((element: HTMLElement) => {
                if (element && element.classList) element.classList.remove("is-column-resizing");
                if (element && element.style) element.style.width = restoreStartWidth ? `${state.startWidth}px` : "";
            });
        }
        if (document.body) {
            document.body.classList.remove("is-schedule-project-column-resizing");
            if (state) {
                document.body.style.cursor = state.previousBodyCursor || "";
                document.body.style.userSelect = state.previousBodyUserSelect || "";
            }
        }

        this.projectColumnPointerMoveHandler = null;
        this.projectColumnPointerUpHandler = null;
        this.projectColumnPointerCancelHandler = null;
        if (state && state.columnType === "date") this.isDateColumnResizing = false;
        this.projectColumnResizeState = null;
        this.isProjectColumnResizing = false;
    }

    public async handleDateHeaderColumnResizeKeydown(event: KeyboardEvent) {
        if (!event) return;
        const currentWidth = this.scheduleDateColumnWidthPx;
        const step = event.shiftKey ? this.dateColumnWidthStepPx * 2 : this.dateColumnWidthStepPx;
        let nextWidth = currentWidth;

        if (event.key === "ArrowLeft") nextWidth = currentWidth - step;
        else if (event.key === "ArrowRight") nextWidth = currentWidth + step;
        else if (event.key === "PageUp") nextWidth = currentWidth - (step * 3);
        else if (event.key === "PageDown") nextWidth = currentWidth + (step * 3);
        else if (event.key === "Home") nextWidth = this.dateColumnWidthMinPx;
        else if (event.key === "End") nextWidth = this.dateColumnWidthMaxPx;
        else return;

        event.preventDefault();
        event.stopPropagation();
        await this.setDateHeaderColumnWidthPx(nextWidth);
    }

    public async handleProjectColumnResizeKeydown(project: any, event: KeyboardEvent) {
        if (!project || !project.id || !event) return;
        const currentWidth = this.getProjectColumnWidthPx(project);
        const step = event.shiftKey ? this.projectColumnWidthStepPx * 2 : this.projectColumnWidthStepPx;
        let nextWidth = currentWidth;

        if (event.key === "ArrowLeft") nextWidth = currentWidth - step;
        else if (event.key === "ArrowRight") nextWidth = currentWidth + step;
        else if (event.key === "PageUp") nextWidth = currentWidth - (step * 3);
        else if (event.key === "PageDown") nextWidth = currentWidth + (step * 3);
        else if (event.key === "Home") nextWidth = this.projectColumnWidthMinPx;
        else if (event.key === "End") nextWidth = this.projectColumnWidthMaxPx;
        else return;

        event.preventDefault();
        event.stopPropagation();
        await this.setProjectColumnWidthPx(project, nextWidth);
    }

    public async handleNoteColumnResizeKeydown(event: KeyboardEvent) {
        if (!event) return;
        const currentWidth = this.noteColumnWidthPx;
        const step = event.shiftKey ? this.noteColumnWidthStepPx * 2 : this.noteColumnWidthStepPx;
        let nextWidth = currentWidth;

        if (event.key === "ArrowLeft") nextWidth = currentWidth - step;
        else if (event.key === "ArrowRight") nextWidth = currentWidth + step;
        else if (event.key === "PageUp") nextWidth = currentWidth - (step * 3);
        else if (event.key === "PageDown") nextWidth = currentWidth + (step * 3);
        else if (event.key === "Home") nextWidth = this.noteColumnWidthMinPx;
        else if (event.key === "End") nextWidth = this.noteColumnWidthMaxPx;
        else return;

        event.preventDefault();
        event.stopPropagation();
        await this.setNoteColumnWidthPx(nextWidth);
    }

    public get scheduleDateColumns() {
        return this.visibleRows.slice();
    }

    public get scheduleProjectRowItems() {
        const projectMap: any = {};
        this.projects.forEach(project => {
            if (project && project.id) projectMap[project.id] = project;
        });

        const items: any[] = [];
        this.scheduleTableProjectGroups.forEach(group => {
            if (!group || !group.id || !Array.isArray(group.projectIds)) return;
            const projectIds = group.projectIds.filter((projectId: string) => !!projectMap[projectId] && this.isProjectVisible(projectMap[projectId]));
            if (projectIds.length === 0) return;

            items.push({
                type: "group",
                id: getProjectGroupRowId(group.id),
                rowId: getProjectGroupRowId(group.id),
                group,
                projectIds,
                color: group.color,
                collapsed: this.isProjectGroupCollapsed(group)
            });

            if (this.isProjectGroupCollapsed(group)) return;
            projectIds.forEach((projectId: string) => {
                const project = projectMap[projectId];
                items.push({
                    type: "project",
                    id: project.id,
                    rowId: project.id,
                    group,
                    project,
                    color: project.color
                });
            });
        });
        return items;
    }

    public get scheduleCellGridTemplateColumns() {
        return this.buildScheduleCellGridTemplateColumns();
    }

    public get scheduleCellGridStyle() {
        return {
            "grid-template-columns": this.scheduleCellGridTemplateColumns,
            "--schedule-project-row-header-width": `${this.projectRowHeaderWidthPx}px`
        };
    }

    public buildScheduleCellGridTemplateColumns(overrides: any = {}) {
        const dateColumns = this.scheduleDateColumns.map(row => {
            const dateKey = row && row.date ? String(row.date) : "";
            const width = overrides && Object.prototype.hasOwnProperty.call(overrides, dateKey)
                ? clampDateColumnWidthPx(overrides[dateKey])
                : this.getScheduleDateColumnWidthPx(row);
            return `${width}px`;
        });
        return [`${this.projectRowHeaderWidthPx}px`].concat(dateColumns).join(" ");
    }

    public getScheduleProjectRowStyle(rowItem: any) {
        return {
            "grid-template-columns": this.scheduleCellGridTemplateColumns,
            "--schedule-project-row-height": `${this.getScheduleProjectRowHeightPx(rowItem)}px`
        };
    }

    public getScheduleDateColumnWidthPx(row: any) {
        return getDateColumnWidthPx(this.viewPrefs, row && row.date ? row.date : "");
    }

    public getDateColumnWidthLabel(row: any) {
        return this.hasDateColumnCustomWidth(row) ? "사용자 지정 너비" : "기본 너비";
    }

    public hasDateColumnCustomWidth(row: any) {
        if (!row || !row.date) return false;
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return Object.prototype.hasOwnProperty.call(prefs.columnWidthsByDate, row.date);
    }

    public getDateColumnResizeAriaLabel(row: any) {
        const label = row && row.dateLabel ? row.dateLabel : "날짜";
        return `${label} 날짜 열 너비 조절, 현재 ${this.getDateColumnWidthLabel(row)}`;
    }

    public getDateColumnResizeTooltip(row: any) {
        if (this.isDateColumnBeingResized(row) && this.dateColumnResizeState) {
            const currentWidth = this.dateColumnResizeState.currentWidth;
            return currentWidth >= 0 ? "너비 조절 중" : "너비 조절 중";
        }
        return "드래그로 너비 조절";
    }

    public handleDateColumnResizeClick(row: any, event: any) {
        if (!event || event.detail < 2) return;
        void this.resetDateColumnWidth(row, event);
    }

    public isDateColumnBeingResized(row: any) {
        return !!this.dateColumnResizeState && !!row && this.dateColumnResizeState.dateKey === row.date;
    }

    public persistDateColumnWidthOverride(dateKey: string, widthPx: any, historyLabel: string = "날짜 열 너비 변경") {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setDateColumnWidth(currentPrefs, dateKey, widthPx);
        if (JSON.stringify(nextPrefs.columnWidthsByDate) === JSON.stringify(currentPrefs.columnWidthsByDate)) return false;

        this.recordScheduleHistory(historyLabel, `date-column-width-${dateKey}`);
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        return true;
    }

    public async setDateColumnWidthPx(row: any, widthPx: any) {
        if (!row || !row.date) return;
        const label = `${row.dateLabel || row.date} 날짜 열 너비 변경`;
        if (this.persistDateColumnWidthOverride(row.date, widthPx, label)) await this.service.render();
    }

    public async resetDateColumnWidth(row: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!row || !row.date || !this.hasDateColumnCustomWidth(row)) return;

        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = clearDateColumnWidth(currentPrefs, row.date);
        if (JSON.stringify(nextPrefs.columnWidthsByDate) === JSON.stringify(currentPrefs.columnWidthsByDate)) return;

        this.recordScheduleHistory(`${row.dateLabel || row.date} 날짜 열 너비 기본값`, `date-column-width-${row.date}`);
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public startDateColumnResize(row: any, event: PointerEvent) {
        if (!row || !row.date || !event) return;
        if (event.button !== undefined && event.button !== 0) return;
        const now = Date.now();
        const previousPointerDown = this.lastDateColumnResizePointerDown;
        const isRepeatedPointerDown = !!previousPointerDown && previousPointerDown.dateKey === row.date && now - previousPointerDown.time <= 500;
        this.lastDateColumnResizePointerDown = { dateKey: row.date, time: now };
        if ((event as any).detail >= 2 || isRepeatedPointerDown) {
            void this.resetDateColumnWidth(row, event);
            return;
        }

        this.cleanupDateColumnResize();

        const handleElement = event.currentTarget as HTMLElement;
        const rowElements = Array.prototype.slice.call(document.querySelectorAll(".schedule-grid-row-layout")) as HTMLElement[];
        const startWidth = this.getScheduleDateColumnWidthPx(row);
        const startX = event.clientX;
        const body = document.body;

        this.dateColumnResizeState = {
            dateKey: row.date,
            startWidth,
            currentWidth: startWidth,
            startX,
            handleElement,
            rowElements,
            previousBodyCursor: body ? body.style.cursor : "",
            previousBodyUserSelect: body ? body.style.userSelect : ""
        };
        this.isDateColumnResizing = true;

        if (handleElement) {
            handleElement.classList.add("is-dragging");
            handleElement.setAttribute("data-resize-tooltip", "너비 조절 중");
        }
        if (body) {
            body.classList.add("is-schedule-date-column-resizing");
            body.style.cursor = "col-resize";
            body.style.userSelect = "none";
        }

        this.dateColumnPointerMoveHandler = (moveEvent: PointerEvent) => this.updateDateColumnResize(moveEvent);
        this.dateColumnPointerUpHandler = (upEvent: PointerEvent) => this.finishDateColumnResize(upEvent);
        this.dateColumnPointerCancelHandler = (cancelEvent: PointerEvent) => this.finishDateColumnResize(cancelEvent);
        document.addEventListener("pointermove", this.dateColumnPointerMoveHandler, { passive: false });
        document.addEventListener("pointerup", this.dateColumnPointerUpHandler, { passive: false });
        document.addEventListener("pointercancel", this.dateColumnPointerCancelHandler, { passive: false });

        event.preventDefault();
        event.stopPropagation();
    }

    public updateDateColumnResize(event: PointerEvent) {
        const state = this.dateColumnResizeState;
        if (!state || !event) return;

        const nextWidth = clampDateColumnWidthPx(state.startWidth + event.clientX - state.startX);
        state.currentWidth = nextWidth;
        const template = this.buildScheduleCellGridTemplateColumns({ [state.dateKey]: nextWidth });
        (state.rowElements || []).forEach((element: HTMLElement) => {
            if (element) element.style.gridTemplateColumns = template;
        });
        if (state.handleElement) {
            state.handleElement.setAttribute("aria-valuenow", String(nextWidth));
            state.handleElement.setAttribute("aria-valuetext", "너비 조절 중");
            state.handleElement.setAttribute("data-resize-tooltip", "너비 조절 중");
        }

        event.preventDefault();
        event.stopPropagation();
    }

    public finishDateColumnResize(event: PointerEvent) {
        const state = this.dateColumnResizeState;
        if (!state) return;

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const changed = this.persistDateColumnWidthOverride(state.dateKey, state.currentWidth, `${state.dateKey} 날짜 열 너비 변경`);
        this.cleanupDateColumnResize();
        if (changed) void this.service.render();
    }

    public cleanupDateColumnResize() {
        const state = this.dateColumnResizeState;
        if (this.dateColumnPointerMoveHandler) document.removeEventListener("pointermove", this.dateColumnPointerMoveHandler);
        if (this.dateColumnPointerUpHandler) document.removeEventListener("pointerup", this.dateColumnPointerUpHandler);
        if (this.dateColumnPointerCancelHandler) document.removeEventListener("pointercancel", this.dateColumnPointerCancelHandler);

        if (state && state.handleElement) state.handleElement.classList.remove("is-dragging");
        if (document.body) {
            document.body.classList.remove("is-schedule-date-column-resizing");
            if (state) {
                document.body.style.cursor = state.previousBodyCursor || "";
                document.body.style.userSelect = state.previousBodyUserSelect || "";
            }
        }

        this.dateColumnPointerMoveHandler = null;
        this.dateColumnPointerUpHandler = null;
        this.dateColumnPointerCancelHandler = null;
        this.dateColumnResizeState = null;
        this.isDateColumnResizing = false;
    }

    public async handleDateColumnResizeKeydown(row: any, event: KeyboardEvent) {
        if (!row || !row.date || !event) return;

        const currentWidth = this.getScheduleDateColumnWidthPx(row);
        const step = event.shiftKey ? this.dateColumnWidthStepPx * 2 : this.dateColumnWidthStepPx;
        let nextWidth = currentWidth;

        if (event.key === "ArrowLeft") nextWidth = currentWidth - step;
        else if (event.key === "ArrowRight") nextWidth = currentWidth + step;
        else if (event.key === "PageUp") nextWidth = currentWidth - (step * 3);
        else if (event.key === "PageDown") nextWidth = currentWidth + (step * 3);
        else if (event.key === "Home") nextWidth = this.dateColumnWidthMinPx;
        else if (event.key === "End") nextWidth = this.dateColumnWidthMaxPx;
        else return;

        event.preventDefault();
        event.stopPropagation();
        await this.setDateColumnWidthPx(row, nextWidth);
    }

    public isProjectGridRow(rowItem: any) {
        return !!rowItem && rowItem.type === "project" && !!rowItem.project;
    }

    public isProjectGroupGridRow(rowItem: any) {
        return !!rowItem && rowItem.type === "group" && !!rowItem.group;
    }

    public getScheduleProjectRowId(rowItem: any) {
        return rowItem && rowItem.rowId ? String(rowItem.rowId) : "";
    }

    public getScheduleProjectRowHeightPx(rowItem: any) {
        return getProjectRowHeightPx(this.viewPrefs, this.getScheduleProjectRowId(rowItem));
    }

    public getProjectRowHeightLabel(rowItem: any) {
        return this.hasProjectRowCustomHeight(rowItem) ? "사용자 지정 높이" : "기본 높이";
    }

    public hasProjectRowCustomHeight(rowItem: any) {
        const rowId = this.getScheduleProjectRowId(rowItem);
        if (!rowId) return false;
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return Object.prototype.hasOwnProperty.call(prefs.rowHeightsByProject, rowId);
    }

    public getScheduleProjectRowLabel(rowItem: any) {
        if (this.isProjectGridRow(rowItem)) return rowItem.project.name || rowItem.project.id || "프로젝트";
        if (this.isProjectGroupGridRow(rowItem)) return rowItem.group.name || "프로젝트 그룹";
        return "프로젝트 행";
    }

    public getProjectRowHeightAriaLabel(rowItem: any) {
        return `${this.getScheduleProjectRowLabel(rowItem)} 행 높이 조절, 현재 ${this.getProjectRowHeightLabel(rowItem)}`;
    }

    public getProjectRowHeightResizeTooltip(rowItem: any) {
        if (this.isProjectRowHeightBeingResized(rowItem) && this.projectRowHeightResizeState) {
            const currentHeight = this.projectRowHeightResizeState.currentHeight;
            return currentHeight >= 0 ? "높이 조절 중" : "높이 조절 중";
        }
        return "드래그로 높이 조절";
    }

    public handleProjectRowHeightResizeClick(rowItem: any, event: any) {
        if (!event || event.detail < 2) return;
        void this.resetProjectRowHeight(rowItem, event);
    }

    public isProjectRowHeightBeingResized(rowItem: any) {
        const rowId = this.getScheduleProjectRowId(rowItem);
        return !!rowId && !!this.projectRowHeightResizeState && this.projectRowHeightResizeState.rowId === rowId;
    }

    public persistProjectRowHeightOverride(rowId: string, heightPx: any, historyLabel: string = "프로젝트 행 높이 변경") {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setProjectRowHeight(currentPrefs, rowId, heightPx);
        if (JSON.stringify(nextPrefs.rowHeightsByProject) === JSON.stringify(currentPrefs.rowHeightsByProject)) return false;

        this.recordScheduleHistory(historyLabel, `project-row-height-${rowId}`);
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        return true;
    }

    public async setProjectRowHeightPx(rowItem: any, heightPx: any) {
        const rowId = this.getScheduleProjectRowId(rowItem);
        if (!rowId) return;
        const label = `${this.getScheduleProjectRowLabel(rowItem)} 행 높이 변경`;
        if (this.persistProjectRowHeightOverride(rowId, heightPx, label)) await this.service.render();
    }

    public async resetProjectRowHeight(rowItem: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const rowId = this.getScheduleProjectRowId(rowItem);
        if (!rowId || !this.hasProjectRowCustomHeight(rowItem)) return;

        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = clearProjectRowHeight(currentPrefs, rowId);
        if (JSON.stringify(nextPrefs.rowHeightsByProject) === JSON.stringify(currentPrefs.rowHeightsByProject)) return;

        this.recordScheduleHistory(`${this.getScheduleProjectRowLabel(rowItem)} 행 높이 기본값`, `project-row-height-${rowId}`);
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public startProjectRowHeightResize(rowItem: any, event: PointerEvent) {
        const rowId = this.getScheduleProjectRowId(rowItem);
        if (!rowId || !event) return;
        if (event.button !== undefined && event.button !== 0) return;
        const now = Date.now();
        const previousPointerDown = this.lastProjectRowHeightResizePointerDown;
        const isRepeatedPointerDown = !!previousPointerDown && previousPointerDown.rowId === rowId && now - previousPointerDown.time <= 500;
        this.lastProjectRowHeightResizePointerDown = { rowId, time: now };
        if ((event as any).detail >= 2 || isRepeatedPointerDown) {
            void this.resetProjectRowHeight(rowItem, event);
            return;
        }

        this.cleanupProjectRowHeightResize();

        const handleElement = event.currentTarget as HTMLElement;
        const rowElement = handleElement && handleElement.closest ? handleElement.closest(".schedule-grid-project-row") as HTMLElement : null;
        const startHeight = this.getScheduleProjectRowHeightPx(rowItem);
        const startY = event.clientY;
        const body = document.body;

        this.projectRowHeightResizeState = {
            rowId,
            label: this.getScheduleProjectRowLabel(rowItem),
            startHeight,
            currentHeight: startHeight,
            startY,
            rowElement,
            handleElement,
            previousBodyCursor: body ? body.style.cursor : "",
            previousBodyUserSelect: body ? body.style.userSelect : ""
        };
        this.isProjectRowHeightResizing = true;

        if (rowElement) rowElement.classList.add("is-project-row-height-dragging");
        if (handleElement) {
            handleElement.classList.add("is-dragging");
            handleElement.setAttribute("data-resize-tooltip", "높이 조절 중");
        }
        if (body) {
            body.classList.add("is-schedule-project-row-height-resizing");
            body.style.cursor = "row-resize";
            body.style.userSelect = "none";
        }

        this.projectRowHeightPointerMoveHandler = (moveEvent: PointerEvent) => this.updateProjectRowHeightResize(moveEvent);
        this.projectRowHeightPointerUpHandler = (upEvent: PointerEvent) => this.finishProjectRowHeightResize(upEvent);
        this.projectRowHeightPointerCancelHandler = (cancelEvent: PointerEvent) => this.finishProjectRowHeightResize(cancelEvent);
        document.addEventListener("pointermove", this.projectRowHeightPointerMoveHandler, { passive: false });
        document.addEventListener("pointerup", this.projectRowHeightPointerUpHandler, { passive: false });
        document.addEventListener("pointercancel", this.projectRowHeightPointerCancelHandler, { passive: false });

        event.preventDefault();
        event.stopPropagation();
    }

    public updateProjectRowHeightResize(event: PointerEvent) {
        const state = this.projectRowHeightResizeState;
        if (!state || !event) return;

        const nextHeight = clampProjectRowHeightPx(state.startHeight + event.clientY - state.startY);
        state.currentHeight = nextHeight;
        if (state.rowElement) state.rowElement.style.setProperty("--schedule-project-row-height", `${nextHeight}px`);
        if (state.handleElement) {
            state.handleElement.setAttribute("aria-valuenow", String(nextHeight));
            state.handleElement.setAttribute("aria-valuetext", "높이 조절 중");
            state.handleElement.setAttribute("data-resize-tooltip", "높이 조절 중");
        }

        event.preventDefault();
        event.stopPropagation();
    }

    public finishProjectRowHeightResize(event: PointerEvent) {
        const state = this.projectRowHeightResizeState;
        if (!state) return;

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const changed = this.persistProjectRowHeightOverride(state.rowId, state.currentHeight, `${state.label || "프로젝트"} 행 높이 변경`);
        this.cleanupProjectRowHeightResize();
        if (changed) void this.service.render();
    }

    public cleanupProjectRowHeightResize() {
        const state = this.projectRowHeightResizeState;
        if (this.projectRowHeightPointerMoveHandler) document.removeEventListener("pointermove", this.projectRowHeightPointerMoveHandler);
        if (this.projectRowHeightPointerUpHandler) document.removeEventListener("pointerup", this.projectRowHeightPointerUpHandler);
        if (this.projectRowHeightPointerCancelHandler) document.removeEventListener("pointercancel", this.projectRowHeightPointerCancelHandler);

        if (state && state.rowElement) state.rowElement.classList.remove("is-project-row-height-dragging");
        if (state && state.handleElement) state.handleElement.classList.remove("is-dragging");
        if (document.body) {
            document.body.classList.remove("is-schedule-project-row-height-resizing");
            if (state) {
                document.body.style.cursor = state.previousBodyCursor || "";
                document.body.style.userSelect = state.previousBodyUserSelect || "";
            }
        }

        this.projectRowHeightPointerMoveHandler = null;
        this.projectRowHeightPointerUpHandler = null;
        this.projectRowHeightPointerCancelHandler = null;
        this.projectRowHeightResizeState = null;
        this.isProjectRowHeightResizing = false;
    }

    public async handleProjectRowHeightResizeKeydown(rowItem: any, event: KeyboardEvent) {
        if (!rowItem || !event) return;

        const currentHeight = this.getScheduleProjectRowHeightPx(rowItem);
        const step = event.shiftKey ? this.projectRowHeightStepPx * 2 : this.projectRowHeightStepPx;
        let nextHeight = currentHeight;

        if (event.key === "ArrowUp") nextHeight = currentHeight - step;
        else if (event.key === "ArrowDown") nextHeight = currentHeight + step;
        else if (event.key === "PageUp") nextHeight = currentHeight - (step * 3);
        else if (event.key === "PageDown") nextHeight = currentHeight + (step * 3);
        else if (event.key === "Home") nextHeight = this.projectRowHeightMinPx;
        else if (event.key === "End") nextHeight = this.projectRowHeightMaxPx;
        else return;

        event.preventDefault();
        event.stopPropagation();
        await this.setProjectRowHeightPx(rowItem, nextHeight);
    }

    public getScheduleGridCellClass(row: any, rowItem: any) {
        const project = this.isProjectGridRow(rowItem) ? rowItem.project : null;
        return {
            "schedule-cell": !!project,
            "group-summary-cell": this.isProjectGroupGridRow(rowItem),
            "is-filled": !!project && this.hasCellContent(row, project.id),
            "has-milestone": !!project && this.getProjectMilestones(row, project).length > 0,
            "has-dependency-risk": !!project && this.hasCellDependencyRisk(row, project.id),
            "has-dependency-delay": !!project && this.hasCellDependencyDelay(row, project.id),
            "is-active": !!project && this.activeEditKey === row.id + "-" + project.id,
            "is-selected": !!project && this.isSelectedCell(row, project),
            "is-selected-range": !!project && this.isSelectedRangeCell(row, project),
            "is-selection-anchor": !!project && this.isSelectionAnchorCell(row, project),
            "is-selected-project": !!project && !!this.selectedProjectId && project.id === this.selectedProjectId,
            "is-completed-dimmed": !!project && this.shouldDimCompletedCell(row, project.id)
        };
    }

    public getScheduleGridCellAriaLabel(row: any, rowItem: any) {
        if (this.isProjectGridRow(rowItem)) return this.getCellPreviewAriaLabel(row, rowItem.project);
        if (this.isProjectGroupGridRow(rowItem)) return `${row.dateLabel || row.date} ${rowItem.group.name} 그룹 요약`;
        return `${row.dateLabel || row.date} 셀`;
    }

    public getScheduleGridCellTitle(row: any, rowItem: any) {
        if (this.isProjectGridRow(rowItem)) return this.getCellPreviewTooltip(row, rowItem.project);
        if (this.isProjectGroupGridRow(rowItem)) return `${this.getRowGroupScheduleCountText(row, rowItem.group)} · ${this.getRowGroupStatusSummaryText(row, rowItem.group)} · ${this.getRowGroupTypeSummaryText(row, rowItem.group)}`;
        return "";
    }

    public getProjectManagementRowHeightPx(project: any) {
        return getProjectRowHeightPx(this.viewPrefs, project && project.id ? project.id : "");
    }

    public getProjectManagementRowHeightLabel(project: any) {
        return this.hasProjectManagementCustomRowHeight(project) ? "사용자 지정 높이" : "기본 높이";
    }

    public getProjectRowHeightInputName(project: any) {
        const projectId = project && project.id ? String(project.id) : "unknown";
        return `project-row-height-${this.makeDomSafeId(projectId)}`;
    }

    public getProjectManagementRowHeightAriaLabel(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        return `${name} 행 높이, 현재 ${this.getProjectManagementRowHeightLabel(project)}`;
    }

    public hasProjectManagementCustomRowHeight(project: any) {
        if (!project || !project.id) return false;
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return Object.prototype.hasOwnProperty.call(prefs.rowHeightsByProject, project.id);
    }

    public async setProjectManagementRowHeightPx(project: any, heightPx: any) {
        if (!project || !project.id) return;
        const rowItem = { type: "project", id: project.id, rowId: project.id, project };
        await this.setProjectRowHeightPx(rowItem, heightPx);
    }

    public async resetProjectManagementRowHeight(project: any) {
        if (!project || !project.id) return;
        const rowItem = { type: "project", id: project.id, rowId: project.id, project };
        await this.resetProjectRowHeight(rowItem);
    }

    public isProjectHidden(project: any) {
        return !!project && project.hidden === true;
    }

    public isProjectVisible(project: any) {
        return !!project && !!project.id && !this.isProjectHidden(project);
    }

    public getProjectVisibilityLabel(project: any) {
        return this.isProjectHidden(project) ? "다시 보이기" : "숨김";
    }

    public getProjectVisibilityStateLabel(project: any) {
        return this.isProjectHidden(project) ? "숨김" : "표시";
    }

    public getProjectVisibilityAriaLabel(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        const action = this.isProjectHidden(project) ? "다시 보이기" : "행 숨기기";
        return `${name} 프로젝트 ${action}`;
    }

    public trackByScheduleColumn(index: number, column: any) {
        return column && column.id ? column.id : index;
    }

    public async toggleProjectGroupCollapse(group: any) {
        if (!group || !group.id) return;
        const groupId = String(group.id);
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const collapsedIds = currentPrefs.collapsedGroupIds.filter((id: string) => id !== groupId);
        if (!this.isProjectGroupCollapsed(group)) collapsedIds.push(groupId);

        this.viewPrefs = normalizeViewPrefs({
            ...currentPrefs,
            collapsedGroupIds: collapsedIds
        });
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        await this.service.render();
    }

    public async toggleScheduleTopControls() {
        this.scheduleTopControlsExpanded = !this.scheduleTopControlsExpanded;
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public get isScheduleDetailPanelVisible() {
        return this.scheduleDetailExpanded === true || this.milestonePanelOpen === true;
    }

    public get isLowerUtilityPanelExpanded() {
        return this.lowerUtilityPanelOpenedInSession === true
            && (this.hasActiveUtilityDialog === true
            || this.rowDensityPanelExpanded === true
            || this.bulkToolsExpanded === true
            || this.quickFiltersExpanded === true
            || this.savedViewsExpanded === true
            || this.searchFiltersExpanded === true
            || this.plannerSummaryExpanded === true
            || this.viewOptionsPanelExpanded === true
            || this.groupPanelExpanded === true
            || this.scheduleTransferExpanded === true);
    }

    public markLowerUtilityPanelOpened() {
        this.lowerUtilityPanelOpenedInSession = true;
    }

    public get hasActiveUtilityDialog() {
        return !!this.activeUtilityDialog && this.isUtilityDialogExpanded(this.activeUtilityDialog);
    }

    public get activeUtilityDialogTitleId() {
        return `schedule-${this.activeUtilityDialog || "utility"}-dialog-title`;
    }

    public get activeUtilityDialogTitle() {
        switch (this.activeUtilityDialog) {
            case "rowDensity":
                return "행/밀도";
            case "bulk":
                return "일괄";
            case "quickFilters":
                return "빠른 필터";
            case "savedViews":
                return "저장 보기";
            case "searchFilters":
                return "검색/프로젝트";
            case "plannerSummary":
                return "Timeline/Workload";
            case "scheduleTransfer":
                return "엑셀/CSV";
            case "viewOptions":
                return "보기 옵션";
            case "group":
                return "프로젝트 그룹";
            default:
                return "보조 도구";
        }
    }

    public get activeUtilityDialogSummary() {
        switch (this.activeUtilityDialog) {
            case "rowDensity":
                return this.scheduleRowDensitySummaryLabel;
            case "bulk":
                return this.cellSelectionSummaryLabel;
            case "quickFilters":
                return this.activeQuickFilterSummaryLabel;
            case "savedViews":
                return this.savedViewSummaryLabel;
            case "searchFilters":
                return this.searchFilterSummaryLabel;
            case "plannerSummary":
                return this.plannerSummarySummaryLabel;
            case "scheduleTransfer":
                return this.scheduleTransferSummaryLabel;
            case "viewOptions":
                return this.currentViewSummaryLabel;
            case "group":
                return `${this.projectGroups.length}개 그룹 · 미분류 ${this.ungroupedProjectCount}개`;
            default:
                return "창 열림";
        }
    }

    public get activeUtilityDialogWindowClass() {
        return {
            "utility-dialog-window--planner": this.activeUtilityDialog === "plannerSummary",
            "utility-dialog-window--transfer": this.activeUtilityDialog === "scheduleTransfer",
            "utility-dialog-window--group": this.activeUtilityDialog === "group",
            "utility-dialog-window--compact": this.activeUtilityDialog === "rowDensity" || this.activeUtilityDialog === "bulk"
        };
    }

    public isUtilityDialogExpanded(key: string) {
        switch (key) {
            case "rowDensity":
                return this.rowDensityPanelExpanded === true;
            case "bulk":
                return this.bulkToolsExpanded === true;
            case "quickFilters":
                return this.quickFiltersExpanded === true;
            case "savedViews":
                return this.savedViewsExpanded === true;
            case "searchFilters":
                return this.searchFiltersExpanded === true;
            case "plannerSummary":
                return this.plannerSummaryExpanded === true;
            case "scheduleTransfer":
                return this.scheduleTransferExpanded === true;
            case "viewOptions":
                return this.viewOptionsPanelExpanded === true;
            case "group":
                return this.groupPanelExpanded === true;
            default:
                return false;
        }
    }

    public setUtilityDialogExpanded(key: string, expanded: boolean) {
        switch (key) {
            case "rowDensity":
                this.rowDensityPanelExpanded = expanded;
                return;
            case "bulk":
                this.bulkToolsExpanded = expanded;
                return;
            case "quickFilters":
                this.quickFiltersExpanded = expanded;
                return;
            case "savedViews":
                this.savedViewsExpanded = expanded;
                return;
            case "searchFilters":
                this.searchFiltersExpanded = expanded;
                return;
            case "plannerSummary":
                this.plannerSummaryExpanded = expanded;
                return;
            case "scheduleTransfer":
                this.scheduleTransferExpanded = expanded;
                return;
            case "viewOptions":
                this.viewOptionsPanelExpanded = expanded;
                return;
            case "group":
                this.groupPanelExpanded = expanded;
                return;
        }
    }

    public closeAllUtilityDialogs() {
        this.rowDensityPanelExpanded = false;
        this.bulkToolsExpanded = false;
        this.quickFiltersExpanded = false;
        this.savedViewsExpanded = false;
        this.searchFiltersExpanded = false;
        this.plannerSummaryExpanded = false;
        this.viewOptionsPanelExpanded = false;
        this.groupPanelExpanded = false;
        this.scheduleTransferExpanded = false;
        this.activeUtilityDialog = "";
    }

    public closeAllUtilityWindows() {
        this.closeAllUtilityDialogs();
        this.projectManagementExpanded = false;
        this.projectAddExpanded = false;
    }

    public async toggleUtilityDialog(key: string) {
        const wasOpen = this.activeUtilityDialog === key && this.isUtilityDialogExpanded(key);
        this.closeAllUtilityWindows();
        if (!wasOpen) {
            this.markLowerUtilityPanelOpened();
            this.activeUtilityDialog = key;
            this.setUtilityDialogExpanded(key, true);
            if (key === "group") this.setGroupFeedback("", "");
        }
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public async closeActiveUtilityDialog() {
        if (!this.hasActiveUtilityDialog) return;
        this.closeAllUtilityDialogs();
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public async closeOpenUtilityWindows() {
        if (!this.hasActiveUtilityDialog && !this.projectManagementExpanded) return;
        this.closeAllUtilityWindows();
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public async toggleScheduleDetailPanel() {
        if (this.isScheduleDetailPanelVisible) {
            this.clearSelectedCellState();
            this.resetMilestoneDraft();
            this.scheduleDetailExpanded = false;
        } else {
            const activeTarget = this.getVisibleActiveCell();
            if (activeTarget) {
                const row = this.findRowById(activeTarget.rowId);
                const project = this.findProjectById(activeTarget.projectId);
                if (row && project) this.selectCell(row, project);
            }
            this.scheduleDetailExpanded = true;
        }
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public async toggleRowDensityPanel() {
        await this.toggleUtilityDialog("rowDensity");
    }

    public async toggleBulkToolsPanel() {
        await this.toggleUtilityDialog("bulk");
    }

    public async toggleQuickFiltersPanel() {
        await this.toggleUtilityDialog("quickFilters");
    }

    public async toggleSavedViewsPanel() {
        await this.toggleUtilityDialog("savedViews");
    }

    public async toggleSearchFiltersPanel() {
        await this.toggleUtilityDialog("searchFilters");
    }

    public async togglePlannerSummaryPanel() {
        await this.toggleUtilityDialog("plannerSummary");
    }

    public async toggleGroupPanel() {
        await this.toggleUtilityDialog("group");
    }

    public async toggleViewOptionsPanel() {
        await this.toggleUtilityDialog("viewOptions");
    }

    public async toggleScheduleTransferTools() {
        await this.toggleUtilityDialog("scheduleTransfer");
    }

    public syncFilterInputsFromViewPrefs() {
        const prefs = normalizeViewPrefs(this.viewPrefs);
        const selectedProjectId = String(prefs.filters.selectedProjectId || "").trim();
        this.searchText = String(prefs.filters.searchText || "");
        const selectedProject = this.findProjectById(selectedProjectId);
        this.selectedProjectId = this.isProjectVisible(selectedProject) ? selectedProjectId : "";
    }

    public get activeScheduleQuickViewKey() {
        return normalizeScheduleQuickViewKey(normalizeViewPrefs(this.viewPrefs).filters.quickView);
    }

    public isScheduleQuickViewActive(presetKey: string) {
        return this.activeScheduleQuickViewKey === normalizeScheduleQuickViewKey(presetKey);
    }

    public trackByScheduleQuickView(index: number, preset: any) {
        return preset && preset.key ? preset.key : index;
    }

    public getScheduleQuickViewLabel(presetKey: string) {
        const key = normalizeScheduleQuickViewKey(presetKey);
        const preset = this.scheduleQuickViewOptions.find((item: any) => item && item.key === key);
        return preset && preset.label ? preset.label : "기본";
    }

    public getScheduleQuickViewAriaLabel(preset: any) {
        const label = preset && preset.label ? preset.label : "기본";
        const emptyRows = preset && preset.hideEmptyRows === true ? "빈 행 축약 포함" : "전체 행 표시";
        return `${label} 빠른 보기 적용, ${emptyRows}`;
    }

    public async applyScheduleQuickView(presetKey: string) {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = applyScheduleQuickViewPreset(currentPrefs, presetKey);
        const changed = JSON.stringify(nextPrefs) !== JSON.stringify(currentPrefs);
        const dateScope = this.normalizeQuickViewDateScope(nextPrefs.filters.dateScope);

        this.viewPrefs = nextPrefs;
        this.syncFilterInputsFromViewPrefs();
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        if (this.selectedCell && this.selectedProjectId && this.selectedCell.projectId !== this.selectedProjectId) {
            this.clearSelectedCellState();
        }
        this.resetExportState();

        if (changed) {
            const convenience = this.normalizeCurrentConvenienceState();
            this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
            this.markLocalSaved();
        }

        this.scheduleNavigationStatus = "success";
        this.scheduleNavigationMessage = `${this.getScheduleQuickViewLabel(nextPrefs.filters.quickView)} 빠른 보기를 적용했습니다.`;

        if (dateScope === "today") {
            await this.navigateCalendar("today");
            return;
        }
        if (dateScope === "week") {
            await this.navigateCalendar("week");
            return;
        }

        this.scheduleFocusDateKey = "";
        this.scheduleFocusWeekStartKey = "";
        this.scheduleFocusWeekEndKey = "";
        this.scheduleFocusMode = "";
        await this.service.render();
    }

    public normalizeQuickViewDateScope(value: any) {
        const scope = String(value || "").trim();
        if (scope === "today" || scope === "week") return scope;
        return "";
    }

    public matchesQuickViewDateScope(row: any, context: any) {
        const dateKey = row && row.date ? String(row.date) : "";
        if (!dateKey) return false;
        if (context.dateScope === "today") return dateKey === context.todayKey;
        if (context.dateScope === "week") return isDateKeyInKoreaWeek(dateKey, context.weekStartKey);
        return true;
    }

    public getCurrentAssigneeTokens() {
        const session = this.service && this.service.auth && this.service.auth.session ? this.service.auth.session : {};
        const values = [
            session.name,
            session.email,
            session.id,
            session.user_id,
            session.username,
            session.nickname
        ];
        return this.uniqueAssigneeTokens(values.reduce((tokens: string[], value: any) => tokens.concat(this.splitAssigneeTokens(value)), []));
    }

    public getProjectAssigneeTokens(project: any) {
        if (!project) return [];
        const values = [
            project.pm,
            project.owner,
            project.assignee,
            project.manager,
            project.email
        ];
        return this.uniqueAssigneeTokens(values.reduce((tokens: string[], value: any) => tokens.concat(this.splitAssigneeTokens(value)), []));
    }

    public splitAssigneeTokens(value: any) {
        const text = String(value || "").trim();
        if (!text || text === "-") return [];
        const parts = text.split(/[,\s/|]+/).map(part => this.normalizeAssigneeToken(part)).filter(part => part.length > 0);
        if (text.indexOf("@") > 0) {
            const localPart = text.split("@")[0];
            parts.push(this.normalizeAssigneeToken(localPart));
        }
        return parts;
    }

    public normalizeAssigneeToken(value: any) {
        return String(value || "").trim().toLowerCase();
    }

    public uniqueAssigneeTokens(tokens: string[]) {
        const seen: any = {};
        return tokens.filter(token => {
            if (!token || seen[token]) return false;
            seen[token] = true;
            return true;
        });
    }

    public getMyAssignedProjectIds(projectIds: any[] = []) {
        const ids = Array.isArray(projectIds) && projectIds.length > 0
            ? projectIds.map(id => String(id || "")).filter(id => id.length > 0)
            : this.visibleProjects.map(project => project.id);
        const userTokens = this.getCurrentAssigneeTokens();
        if (userTokens.length === 0) return [];
        return ids.filter(projectId => this.isProjectAssignedToCurrentUser(this.findProjectById(projectId), userTokens));
    }

    public isProjectAssignedToCurrentUser(project: any, userTokens: string[] = this.getCurrentAssigneeTokens()) {
        if (!project || userTokens.length === 0) return false;
        const projectTokens = this.getProjectAssigneeTokens(project);
        return projectTokens.some(token => userTokens.indexOf(token) >= 0);
    }

    public get hasSavedViews() {
        return this.savedViews.length > 0;
    }

    public get savedViewSummaryLabel() {
        const count = this.savedViews.length;
        const active = this.activeSavedView;
        if (active) return `${count}개 저장 · ${active.name} 적용 중`;
        return count > 0 ? `${count}개 저장됨` : "저장된 보기가 없습니다";
    }

    public get currentViewSummaryLabel() {
        return this.getSavedViewPrefsSummary(this.createCurrentSavedViewPrefs());
    }

    public get activeSavedView() {
        const currentKey = this.getSavedViewPrefsKey(this.createCurrentSavedViewPrefs());
        return this.savedViews.find(view => this.getSavedViewPrefsKey(view.viewPrefs) === currentKey) || null;
    }

    public isSavedViewActive(view: any) {
        const active = this.activeSavedView;
        return !!active && !!view && active.id === view.id;
    }

    public trackBySavedView(index: number, view: any) {
        return view && view.id ? view.id : index;
    }

    public createCurrentSavedViewPrefs() {
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return normalizeViewPrefs({
            ...prefs,
            dateColumnWidthPx: DATE_COLUMN_WIDTH_DEFAULT_PX,
            noteColumnWidthPx: NOTE_COLUMN_WIDTH_DEFAULT_PX,
            projectHeaderRowHeightPx: PROJECT_HEADER_ROW_HEIGHT_DEFAULT_PX,
            projectColumnWidths: {},
            columnWidthsByDate: {},
            rowHeightsByProject: {},
            filters: {
                ...prefs.filters,
                searchText: this.searchText,
                selectedProjectId: this.selectedProjectId
            }
        });
    }

    public getSavedViewPrefsKey(viewPrefs: any) {
        return JSON.stringify(this.normalizeSavedViewPrefsForCurrentState(viewPrefs));
    }

    public normalizeSavedViewPrefsForCurrentState(viewPrefs: any) {
        const normalized = normalizeSavedScheduleViews([{
            id: "current",
            name: "current",
            viewPrefs
        }], this.projects, this.projectGroups);
        return normalized.length > 0 ? normalized[0].viewPrefs : normalizeViewPrefs({});
    }

    public getSavedViewSummary(view: any) {
        return this.getSavedViewPrefsSummary(view && view.viewPrefs ? view.viewPrefs : {});
    }

    public getSavedViewPrefsSummary(viewPrefs: any) {
        const prefs = this.normalizeSavedViewPrefsForCurrentState(viewPrefs);
        const filters = prefs.filters || {};
        const parts: string[] = [];
        const keyword = String(filters.searchText || "").trim();
        const selectedProject = filters.selectedProjectId ? this.findProjectById(filters.selectedProjectId) : null;
        const group = filters.groupId ? this.getFilterProjectGroup(filters.groupId) : null;

        if (keyword) parts.push(`검색 ${keyword}`);
        if (filters.quickView && filters.quickView !== "default") parts.push(`빠른 보기 ${this.getScheduleQuickViewLabel(filters.quickView)}`);
        if (this.isProjectVisible(selectedProject)) parts.push(`프로젝트 ${selectedProject.name}`);
        if (group) parts.push(`그룹 ${group.name || "프로젝트 그룹"}`);
        if (filters.dateScope === "today") parts.push("오늘 행");
        if (filters.dateScope === "week") parts.push("이번 주 행");
        if (filters.ownerOnly === true) parts.push("내 담당");
        if (filters.favoriteOnly === true) parts.push("즐겨찾기");
        if (filters.milestoneOnly === true) parts.push("마일스톤");
        if (filters.status) parts.push(`상태 ${filters.status}`);
        if (filters.type) parts.push(`유형 ${filters.type}`);
        if (prefs.options.showWeekends === false) parts.push("주말 숨김");
        if (prefs.options.showEmptyRows === false || prefs.filters.hideEmptyRows === true) parts.push("빈 행 숨김");
        if (prefs.options.dimCompletedEntries === true) parts.push("완료 흐림");
        parts.push(`행 ${this.getRowHeightLabelFromPrefs(prefs)}`);
        parts.push(`밀도 ${this.getCellDensityLabel(prefs.density)}`);

        return parts.length > 0 ? parts.slice(0, 7).join(" · ") : "기본 보기";
    }

    public getSavedViewUpdatedLabel(view: any) {
        const timestamp = view && (view.updatedAt || view.createdAt) ? String(view.updatedAt || view.createdAt) : "";
        const parsed = this.parseServerTimestamp(timestamp);
        if (!parsed) return "저장 시각 없음";
        return `${this.formatSavedTime(parsed)} 저장`;
    }

    public getSavedViewApplyAriaLabel(view: any) {
        const name = view && view.name ? view.name : "저장된 보기";
        return `${name} 보기 적용`;
    }

    public getSavedViewDeleteAriaLabel(view: any) {
        const name = view && view.name ? view.name : "저장된 보기";
        return `${name} 보기 삭제`;
    }

    public setSavedViewFeedback(message: string, status: string = "") {
        this.savedViewMessage = message;
        this.savedViewStatus = status;
    }

    public async saveCurrentView() {
        const name = String(this.savedViewName || "").trim().replace(/\s+/g, " ");
        if (!name) {
            this.setSavedViewFeedback("저장할 보기 이름을 입력해 주세요.", "error");
            await this.service.render();
            return;
        }
        if (name.length > 32) {
            this.setSavedViewFeedback("보기 이름은 32자 이내로 입력해 주세요.", "error");
            await this.service.render();
            return;
        }

        const now = new Date().toISOString();
        const normalizedName = name;
        const existing = this.savedViews.find(view => this.normalizeProjectName(view.name) === this.normalizeProjectName(normalizedName));
        const nextView = {
            id: existing ? existing.id : this.makeId("view"),
            name: normalizedName,
            viewPrefs: this.createCurrentSavedViewPrefs(),
            createdAt: existing ? existing.createdAt : now,
            updatedAt: now
        };

        this.savedViews = normalizeSavedScheduleViews(
            this.savedViews.filter(view => !existing || view.id !== existing.id).concat([nextView]),
            this.projects,
            this.projectGroups
        );
        this.savedViewName = "";
        await this.persistSavedViews(existing ? `${normalizedName} 보기를 덮어썼습니다.` : `${normalizedName} 보기를 저장했습니다.`, "success");
    }

    public async applySavedView(view: any) {
        if (!view || !view.id) return;
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = normalizeViewPrefs({
            ...this.normalizeSavedViewPrefsForCurrentState(view.viewPrefs),
            dateColumnWidthPx: currentPrefs.dateColumnWidthPx,
            noteColumnWidthPx: currentPrefs.noteColumnWidthPx,
            projectHeaderRowHeightPx: currentPrefs.projectHeaderRowHeightPx,
            projectColumnWidths: currentPrefs.projectColumnWidths,
            columnWidthsByDate: currentPrefs.columnWidthsByDate,
            rowHeightsByProject: currentPrefs.rowHeightsByProject,
            cellColors: currentPrefs.cellColors
        });
        this.viewPrefs = nextPrefs;
        this.syncFilterInputsFromViewPrefs();
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        if (this.selectedCell && this.selectedProjectId && this.selectedCell.projectId !== this.selectedProjectId) {
            this.clearSelectedCellState();
        }
        this.resetExportState();
        await this.persistSavedViews(`${view.name || "저장된 보기"} 보기를 적용했습니다.`, "success");
    }

    public async deleteSavedView(view: any) {
        if (!view || !view.id) return;
        const confirmed = window.confirm(`${view.name || "저장된 보기"} 보기를 삭제할까요?`);
        if (!confirmed) return;
        this.savedViews = this.savedViews.filter(item => item && item.id !== view.id);
        await this.persistSavedViews(`${view.name || "저장된 보기"} 보기를 삭제했습니다.`, "warning");
    }

    public async persistSavedViews(message: string = "", status: string = "") {
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        if (message) this.setSavedViewFeedback(message, status);
        await this.service.render();
    }

    public get quickFilterGroupOptions() {
        return this.visibleProjectGroupsWithUngrouped;
    }

    public get quickFilterStatusValue() {
        return this.getVisibleRowFilterContext().status;
    }

    public get quickFilterTypeValue() {
        return this.getVisibleRowFilterContext().type;
    }

    public get quickFilterGroupId() {
        return this.getVisibleRowFilterContext().groupId;
    }

    public get quickFilterFavoriteOnly() {
        return this.getVisibleRowFilterContext().favoriteOnly;
    }

    public get quickFilterMilestoneOnly() {
        return this.getVisibleRowFilterContext().milestoneOnly;
    }

    public get favoriteProjects() {
        return this.projects.filter(project => this.isFavoriteProject(project)).filter(project => this.isProjectVisible(project));
    }

    public get hasFavoriteProjects() {
        return this.favoriteProjects.length > 0;
    }

    public get favoriteProjectSummaryLabel() {
        const count = this.favoriteProjects.length;
        return count > 0 ? `${count}개 즐겨찾기` : "즐겨찾기 없음";
    }

    public get hasActiveQuickFilters() {
        const context = this.getVisibleRowFilterContext();
        return !!(context.favoriteOnly || context.milestoneOnly || context.status || context.type || context.groupId);
    }

    public get activeQuickFilterSummaryLabel() {
        if (!this.hasActiveQuickFilters) return "적용 없음";
        return this.activeQuickFilterChips.map((chip: any) => chip.label).slice(0, 3).join(" · ");
    }

    public get activeQuickFilterChips() {
        const context = this.getVisibleRowFilterContext();
        const chips: any[] = [];
        if (context.favoriteOnly) {
            chips.push({
                key: "favoriteOnly",
                label: "즐겨찾기 프로젝트",
                ariaLabel: "즐겨찾기 프로젝트 필터 해제"
            });
        }
        if (context.milestoneOnly) {
            chips.push({
                key: "milestoneOnly",
                label: "마일스톤만",
                ariaLabel: "마일스톤만 보기 필터 해제"
            });
        }
        if (context.status) {
            chips.push({
                key: "status",
                label: `상태 ${context.status}`,
                ariaLabel: `상태 필터 ${context.status} 해제`
            });
        }
        if (context.type) {
            chips.push({
                key: "type",
                label: `유형 ${context.type}`,
                ariaLabel: `유형 필터 ${context.type} 해제`
            });
        }
        if (context.groupId && context.group) {
            chips.push({
                key: "groupId",
                label: `그룹 ${context.group.name || "프로젝트 그룹"}`,
                ariaLabel: `그룹 필터 ${context.group.name || "프로젝트 그룹"} 해제`
            });
        }
        return chips;
    }

    public isQuickStatusFilterActive(status: string) {
        return this.quickFilterStatusValue === status;
    }

    public isQuickTypeFilterActive(type: string) {
        return this.quickFilterTypeValue === type;
    }

    public isFavoriteProject(project: any) {
        return !!project && (project.isFavorite === true || project.favorite === true);
    }

    public isFavoriteProjectShortcutActive(project: any) {
        return !!project && !!project.id && this.selectedProjectId === project.id;
    }

    public getFavoriteProjectToggleAriaLabel(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        const action = this.isFavoriteProject(project) ? "즐겨찾기 해제" : "즐겨찾기 추가";
        return `${name} ${action}`;
    }

    public getFavoriteProjectShortcutAriaLabel(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        return `${name} 즐겨찾기 프로젝트만 보기`;
    }

    public trackByQuickFilterChip(index: number, chip: any) {
        return chip && chip.key ? chip.key : index;
    }

    public async toggleFavoriteOnlyQuickFilter() {
        await this.setQuickFilter("favoriteOnly", !this.quickFilterFavoriteOnly);
    }

    public async toggleMilestoneOnlyQuickFilter() {
        await this.setQuickFilter("milestoneOnly", !this.quickFilterMilestoneOnly);
    }

    public async selectFavoriteProject(project: any) {
        if (!project || !project.id) return;
        await this.setSelectedProject(this.selectedProjectId === project.id ? "" : project.id);
    }

    public async toggleProjectFavorite(project: any) {
        if (!project || !project.id) return;
        const wasFavoriteOnly = this.quickFilterFavoriteOnly;
        const nextFavorite = !this.isFavoriteProject(project);
        this.recordScheduleHistory(`${project.name || "프로젝트"} 즐겨찾기 변경`);
        project.isFavorite = nextFavorite;
        project.favorite = nextFavorite;

        if (!nextFavorite && this.selectedProjectId === project.id && wasFavoriteOnly) {
            this.selectedProjectId = "";
        }

        if (wasFavoriteOnly && this.favoriteProjects.length === 0) {
            const prefs = normalizeViewPrefs(this.viewPrefs);
            this.viewPrefs = normalizeViewPrefs({
                ...prefs,
                filters: {
                    ...prefs.filters,
                    favoriteOnly: false
                }
            });
        }

        this.setProjectFeedback(
            nextFavorite ? `${project.name} 프로젝트를 즐겨찾기에 추가했습니다.` : `${project.name} 프로젝트 즐겨찾기를 해제했습니다.`,
            nextFavorite ? "success" : "warning"
        );
        await this.saveSheet();
        void this.saveProjectToServer(project);
    }

    public async toggleStatusQuickFilter(status: string) {
        const nextStatus = this.quickFilterStatusValue === status ? "" : status;
        await this.setQuickFilter("status", nextStatus);
    }

    public async toggleTypeQuickFilter(type: string) {
        const nextType = this.quickFilterTypeValue === type ? "" : type;
        await this.setQuickFilter("type", nextType);
    }

    public async setGroupQuickFilter(groupId: string) {
        await this.setQuickFilter("groupId", groupId);
    }

    public async clearQuickFilter(key: string) {
        await this.setQuickFilter(key, "");
    }

    public async clearQuickFilters() {
        await this.updateQuickFilters({
            favoriteOnly: false,
            milestoneOnly: false,
            status: "",
            type: "",
            groupId: ""
        });
    }

    public async setQuickFilter(key: string, value: any) {
        if (key === "favoriteOnly") {
            await this.updateQuickFilters({ favoriteOnly: value });
            return;
        }
        if (key === "milestoneOnly") {
            await this.updateQuickFilters({ milestoneOnly: value });
            return;
        }
        if (key === "status") {
            await this.updateQuickFilters({ status: value });
            return;
        }
        if (key === "type") {
            await this.updateQuickFilters({ type: value });
            return;
        }
        if (key === "groupId") {
            await this.updateQuickFilters({ groupId: value });
        }
    }

    public async updateQuickFilters(changes: any) {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextFilters = {
            ...currentPrefs.filters
        };

        if (Object.prototype.hasOwnProperty.call(changes || {}, "favoriteOnly")) {
            nextFilters.favoriteOnly = this.normalizeQuickFilterValue("favoriteOnly", changes.favoriteOnly);
        }
        if (Object.prototype.hasOwnProperty.call(changes || {}, "milestoneOnly")) {
            nextFilters.milestoneOnly = this.normalizeQuickFilterValue("milestoneOnly", changes.milestoneOnly);
        }
        if (Object.prototype.hasOwnProperty.call(changes || {}, "status")) {
            nextFilters.status = this.normalizeQuickFilterValue("status", changes.status);
        }
        if (Object.prototype.hasOwnProperty.call(changes || {}, "type")) {
            nextFilters.type = this.normalizeQuickFilterValue("type", changes.type);
        }
        if (Object.prototype.hasOwnProperty.call(changes || {}, "groupId")) {
            nextFilters.groupId = this.normalizeQuickFilterValue("groupId", changes.groupId);
        }

        const nextPrefs = normalizeViewPrefs({
            ...currentPrefs,
            filters: nextFilters
        });
        const changed = nextPrefs.filters.favoriteOnly !== currentPrefs.filters.favoriteOnly
            || nextPrefs.filters.milestoneOnly !== currentPrefs.filters.milestoneOnly
            || nextPrefs.filters.status !== currentPrefs.filters.status
            || nextPrefs.filters.type !== currentPrefs.filters.type
            || nextPrefs.filters.groupId !== currentPrefs.filters.groupId;
        if (!changed) return;

        this.viewPrefs = nextPrefs;
        if (nextPrefs.filters.favoriteOnly === true && this.selectedProjectId && !this.isFavoriteProject(this.findProjectById(this.selectedProjectId))) {
            this.selectedProjectId = "";
        }
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public normalizeQuickFilterValue(key: string, value: any) {
        if (key === "favoriteOnly") return this.coerceBoolean(value) && this.hasFavoriteProjects;
        if (key === "milestoneOnly") return this.coerceBoolean(value) && this.hasMilestones;
        if (key === "status") return this.normalizeFilterOption(value, this.cellStatusOptions);
        if (key === "type") return this.normalizeFilterOption(value, this.cellTypeOptions);
        if (key === "groupId") {
            const id = String(value || "").trim();
            if (!id) return "";
            const group = this.getFilterProjectGroup(id);
            return group ? group.id : "";
        }
        return "";
    }

    public get hideWeekendsOption() {
        return normalizeViewPrefs(this.viewPrefs).options.showWeekends === false;
    }

    public get hideEmptyRowsOption() {
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return prefs.options.showEmptyRows === false || prefs.filters.hideEmptyRows === true;
    }

    public get dimCompletedEntriesOption() {
        return normalizeViewPrefs(this.viewPrefs).options.dimCompletedEntries === true;
    }

    public get scheduleCellDensity() {
        return normalizeViewPrefs(this.viewPrefs).density;
    }

    public async setHideWeekendsOption(value: any) {
        await this.updateViewOptions({
            showWeekends: !this.coerceBoolean(value)
        });
    }

    public async setHideEmptyRowsOption(value: any) {
        await this.updateViewOptions({
            showEmptyRows: !this.coerceBoolean(value)
        });
    }

    public async setDimCompletedEntriesOption(value: any) {
        await this.updateViewOptions({
            dimCompletedEntries: this.coerceBoolean(value)
        });
    }

    public isScheduleCellDensitySelected(density: string) {
        return this.scheduleCellDensity === this.normalizeCellDensity(density);
    }

    public async setScheduleCellDensity(density: string) {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextDensity = this.normalizeCellDensity(density);
        if (currentPrefs.density === nextDensity) return;

        this.viewPrefs = normalizeViewPrefs({
            ...currentPrefs,
            density: nextDensity
        });
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        await this.service.render();
    }

    public get scheduleCellColors() {
        return normalizeScheduleCellColors(normalizeViewPrefs(this.viewPrefs).cellColors);
    }

    public get scheduleCellColorSummaryLabel() {
        const preset = this.getActiveScheduleCellColorPreset();
        if (preset) return `${preset.label} 프리셋`;
        const changedCount = this.scheduleCellColorControls.filter(control => !this.isScheduleCellColorDefault(control.key)).length;
        return changedCount > 0 ? `${changedCount}개 변경` : "기본";
    }

    public get hasCustomScheduleCellColors() {
        return this.scheduleCellColorControls.some(control => !this.isScheduleCellColorDefault(control.key));
    }

    public trackByScheduleCellColorControl(index: number, control: any) {
        return control && control.key ? control.key : index;
    }

    public trackByScheduleCellColorPreset(index: number, preset: any) {
        return preset && preset.key ? preset.key : index;
    }

    public getScheduleCellColorLabel(key: string) {
        const control = this.scheduleCellColorControls.find(item => item.key === key);
        return control ? control.label : "셀";
    }

    public getScheduleCellColor(key: string) {
        const colors = this.scheduleCellColors;
        return colors[key] || SCHEDULE_CELL_COLOR_DEFAULTS[key] || "#ffffff";
    }

    public getScheduleCellColorDefault(key: string) {
        return SCHEDULE_CELL_COLOR_DEFAULTS[key] || "#ffffff";
    }

    public isScheduleCellColorDefault(key: string) {
        return this.getScheduleCellColor(key) === this.getScheduleCellColorDefault(key);
    }

    public getActiveScheduleCellColorPreset() {
        const currentKey = JSON.stringify(this.scheduleCellColors);
        return this.scheduleCellColorPresets.find((preset: any) => {
            return JSON.stringify(normalizeScheduleCellColors(preset.colors)) === currentKey;
        }) || null;
    }

    public isScheduleCellColorPresetActive(presetKey: string) {
        const preset = this.getActiveScheduleCellColorPreset();
        return !!preset && preset.key === presetKey;
    }

    public async setScheduleCellColor(key: string, value: any) {
        if (!Object.prototype.hasOwnProperty.call(SCHEDULE_CELL_COLOR_DEFAULTS, key)) return;
        const currentColors = this.scheduleCellColors;
        const nextColor = this.normalizeScheduleCellColorInput(value, currentColors[key]);
        if (nextColor === currentColors[key]) return;

        await this.applyScheduleCellColors({
            ...currentColors,
            [key]: nextColor
        }, `${this.getScheduleCellColorLabel(key)} 색상을 저장했습니다.`, "success");
    }

    public async resetScheduleCellColor(key: string) {
        if (!Object.prototype.hasOwnProperty.call(SCHEDULE_CELL_COLOR_DEFAULTS, key)) return;
        const currentColors = this.scheduleCellColors;
        const defaultColor = this.getScheduleCellColorDefault(key);
        if (currentColors[key] === defaultColor) return;

        await this.applyScheduleCellColors({
            ...currentColors,
            [key]: defaultColor
        }, `${this.getScheduleCellColorLabel(key)} 색상을 기본값으로 되돌렸습니다.`, "warning");
    }

    public async applyScheduleCellColorPreset(presetKey: string) {
        const nextColors = getScheduleCellColorPresetColors(presetKey);
        const preset = this.scheduleCellColorPresets.find((item: any) => item.key === presetKey);
        await this.applyScheduleCellColors(nextColors, `${preset ? preset.label : "기본"} 프리셋을 적용했습니다.`, "success");
    }

    public async resetScheduleCellColors() {
        await this.applyScheduleCellColors(
            normalizeScheduleCellColors(SCHEDULE_CELL_COLOR_DEFAULTS),
            "셀 색상을 모두 기본값으로 되돌렸습니다.",
            "warning"
        );
    }

    public async applyScheduleCellColors(colors: any, message: string = "", status: string = "") {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const currentColors = normalizeScheduleCellColors(currentPrefs.cellColors);
        const nextColors = normalizeScheduleCellColors(colors);
        if (JSON.stringify(currentColors) === JSON.stringify(nextColors)) return;

        this.viewPrefs = normalizeViewPrefs({
            ...currentPrefs,
            cellColors: nextColors
        });
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        if (message) this.setScheduleCellColorFeedback(message, status);
        await this.service.render();
    }

    public setScheduleCellColorFeedback(message: string, status: string = "") {
        this.scheduleCellColorMessage = message;
        this.scheduleCellColorStatus = status;
    }

    public normalizeScheduleCellColorInput(value: any, fallback: string = "#ffffff") {
        const text = String(value || "").trim();
        if (/^#[0-9A-Fa-f]{6}$/.test(text)) return text.toLowerCase();
        return this.normalizeScheduleCellColorInput(fallback, "#ffffff");
    }

    public getReadableScheduleCellTextColor(value: any) {
        const rgb = this.hexToRgb(value);
        if (!rgb) return "#1f2937";
        const luminance = ((rgb.r * 299) + (rgb.g * 587) + (rgb.b * 114)) / 1000;
        return luminance >= 156 ? "#1f2937" : "#ffffff";
    }

    public hexToRgb(value: any) {
        const text = String(value || "").trim();
        const match = text.match(/^#([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
        if (!match) return null;
        return {
            r: parseInt(match[1], 16),
            g: parseInt(match[2], 16),
            b: parseInt(match[3], 16)
        };
    }

    public normalizeCellDensity(value: any) {
        const density = String(value || "").trim();
        return VIEW_DENSITY_OPTIONS.indexOf(density) >= 0 ? density : "standard";
    }

    public async updateViewOptions(changes: any) {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = normalizeViewPrefs({
            ...currentPrefs,
            options: {
                ...currentPrefs.options,
                ...(changes || {})
            }
        });

        if (JSON.stringify(nextPrefs.options) === JSON.stringify(currentPrefs.options)
            && nextPrefs.filters.hideEmptyRows === currentPrefs.filters.hideEmptyRows) {
            return;
        }

        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public coerceBoolean(value: any) {
        return value === true || value === "true" || value === 1 || value === "1";
    }

    public resetNewGroupForm() {
        this.newGroupName = "";
        this.newGroupColor = "";
        this.newGroupProjectId = "";
    }

    public setGroupFeedback(message: string, status: string = "") {
        this.groupFormMessage = message;
        this.groupFormStatus = status;
    }

    public async selectNewGroupColor(color: string) {
        this.newGroupColor = color;
        this.setGroupFeedback("", "");
        await this.service.render();
    }

    public async addProjectGroup() {
        const name = String(this.newGroupName || "").trim();
        const projectId = String(this.newGroupProjectId || "").trim();

        if (!name) {
            this.setGroupFeedback("그룹 이름을 입력해 주세요.", "error");
            await this.service.render();
            return;
        }

        if (name.length > 32) {
            this.setGroupFeedback("그룹 이름은 32자 이내로 입력해 주세요.", "error");
            await this.service.render();
            return;
        }

        if (this.hasDuplicateProjectGroupName(name)) {
            this.setGroupFeedback("이미 같은 이름의 그룹이 있습니다.", "error");
            await this.service.render();
            return;
        }

        if (!this.findProjectById(projectId)) {
            this.setGroupFeedback("새 그룹에 넣을 프로젝트를 선택해 주세요.", "error");
            await this.service.render();
            return;
        }

        this.recordScheduleHistory("프로젝트 그룹 추가");
        this.projectGroups = addProjectGroupToState(this.projectGroups, this.projects, {
            id: this.makeId("group"),
            name,
            color: this.selectedNewGroupColor,
            projectIds: [projectId],
            order: this.projectGroups.length
        }, this.viewPrefs);
        const project = this.findProjectById(projectId);
        this.resetNewGroupForm();
        await this.persistGroupConfig(`${name} 그룹을 추가하고 ${project ? project.name : "프로젝트"} 프로젝트를 배정했습니다.`, "success");
    }

    public async commitProjectGroupName(group: any) {
        if (!group || group.id === UNGROUPED_PROJECT_GROUP_ID) return;
        const name = String(group.name || "").trim();
        const normalizedName = name || "프로젝트 그룹";
        const duplicate = this.hasDuplicateProjectGroupName(normalizedName, group.id);
        this.projectGroups = updateProjectGroupInState(this.projectGroups, this.projects, group.id, {
            name: normalizedName
        }, this.viewPrefs);
        await this.persistGroupConfig(
            duplicate ? "같은 이름의 그룹이 있어 구분해서 확인해 주세요." : `${normalizedName} 그룹 이름을 저장했습니다.`,
            duplicate ? "warning" : "success"
        );
    }

    public handleProjectGroupNameInput(group: any, value: any) {
        if (!group || group.id === UNGROUPED_PROJECT_GROUP_ID) return;
        const nextName = value === undefined || value === null ? "" : String(value);
        if (String(group.name || "") === nextName) return;
        this.recordScheduleHistory(`${group.name || "프로젝트 그룹"} 그룹 이름 변경`, `group-name-${group.id}`);
        group.name = nextName;
    }

    public async cycleProjectGroupColor(group: any) {
        if (!group || group.id === UNGROUPED_PROJECT_GROUP_ID) return;
        const currentIndex = this.palette.indexOf(group.color);
        const nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % this.palette.length;
        const nextColor = this.palette[nextIndex] || DEFAULT_PROJECT_GROUP_COLOR;
        this.recordScheduleHistory(`${group.name || "프로젝트 그룹"} 그룹 색상 변경`);
        this.projectGroups = updateProjectGroupInState(this.projectGroups, this.projects, group.id, {
            color: nextColor
        }, this.viewPrefs);
        await this.persistGroupConfig(`${group.name || "프로젝트 그룹"} 그룹 색상을 변경했습니다.`, "success");
    }

    public async deleteProjectGroup(group: any) {
        if (!group || group.id === UNGROUPED_PROJECT_GROUP_ID) return;
        const projectCount = Array.isArray(group.projectIds) ? group.projectIds.length : 0;
        const confirmed = window.confirm(`${group.name || "프로젝트 그룹"} 그룹을 삭제할까요?\n프로젝트 ${projectCount}개와 일정 데이터는 삭제하지 않고 미분류로 이동합니다.`);
        if (!confirmed) return;

        this.recordScheduleHistory(`${group.name || "프로젝트 그룹"} 그룹 삭제`);
        const result = deleteProjectGroupFromState(this.projectGroups, this.projects, group.id, this.viewPrefs);
        this.projectGroups = result.projectGroups;
        this.viewPrefs = result.viewPrefs;
        await this.persistGroupConfig(`${group.name || "프로젝트 그룹"} 그룹을 삭제하고 프로젝트를 미분류로 이동했습니다.`, "warning");
    }

    public async setProjectGroupAssignment(project: any, groupId: string) {
        if (!project || !project.id) return;
        const nextGroupId = String(groupId || UNGROUPED_PROJECT_GROUP_ID);
        if (nextGroupId === this.getProjectAssignedGroupId(project)) return;
        this.recordScheduleHistory(`${project.name || "프로젝트"} 그룹 변경`);
        this.projectGroups = assignProjectGroupInState(this.projectGroups, this.projects, project.id, nextGroupId, this.viewPrefs);
        const targetName = this.getProjectGroupOptionName(nextGroupId);
        await this.persistGroupConfig(`${project.name || "프로젝트"} 프로젝트를 ${targetName} 그룹으로 이동했습니다.`, "success");
    }

    public canMoveProjectGroup(group: any, direction: string) {
        if (!group || !group.id || group.id === UNGROUPED_PROJECT_GROUP_ID) return false;
        const index = this.projectGroups.findIndex(item => item && item.id === group.id);
        if (direction === "up") return index > 0;
        if (direction === "down") return index >= 0 && index < this.projectGroups.length - 1;
        return false;
    }

    public async moveProjectGroup(group: any, direction: string) {
        if (!this.canMoveProjectGroup(group, direction)) return;
        this.recordScheduleHistory(`${group.name || "프로젝트 그룹"} 그룹 순서 변경`);
        this.projectGroups = moveProjectGroupInState(this.projectGroups, this.projects, group.id, direction, this.viewPrefs);
        const action = direction === "up" ? "위로" : "아래로";
        await this.persistGroupConfig(`${group.name || "프로젝트 그룹"} 그룹을 ${action} 이동했습니다.`, "success");
    }

    public get groupProjectOrderGroups() {
        const projectMap: any = {};
        this.projects.forEach(project => {
            if (project && project.id) projectMap[project.id] = project;
        });

        return this.scheduleProjectGroupsWithUngrouped
            .map(group => ({
                ...group,
                projects: this.getGroupProjectIds(group)
                    .map((projectId: string) => projectMap[projectId])
                    .filter((project: any) => !!project)
            }))
            .filter(group => group.projects.length > 0);
    }

    public getGroupOrderProjects(group: any) {
        if (group && Array.isArray(group.projects)) return group.projects;
        const projectMap: any = {};
        this.projects.forEach(project => {
            if (project && project.id) projectMap[project.id] = project;
        });
        return this.getGroupProjectIds(group)
            .map((projectId: string) => projectMap[projectId])
            .filter((project: any) => !!project);
    }

    public canMoveProjectWithinGroup(group: any, project: any, direction: string) {
        if (!group || !project || !project.id) return false;
        const projects = this.getGroupOrderProjects(group);
        const index = projects.findIndex((item: any) => item && item.id === project.id);
        if (direction === "up") return index > 0;
        if (direction === "down") return index >= 0 && index < projects.length - 1;
        return false;
    }

    public async moveProjectWithinGroup(group: any, project: any, direction: string) {
        if (!this.canMoveProjectWithinGroup(group, project, direction)) return;
        const groupId = String(group.id || "");
        const action = direction === "up" ? "위로" : "아래로";
        this.recordScheduleHistory(`${project.name || "프로젝트"} 프로젝트 순서 변경`);

        if (groupId === UNGROUPED_PROJECT_GROUP_ID) {
            this.projects = moveUngroupedProjectInProjectList(this.projects, this.projectGroups, project.id, direction);
            await this.persistGroupConfig(`${project.name || "프로젝트"} 프로젝트를 미분류 안에서 ${action} 이동했습니다.`, "success");
            return;
        }

        this.projectGroups = moveProjectInGroupInState(this.projectGroups, this.projects, groupId, project.id, direction, this.viewPrefs);
        await this.persistGroupConfig(`${project.name || "프로젝트"} 프로젝트를 ${group.name || "프로젝트 그룹"} 안에서 ${action} 이동했습니다.`, "success");
    }

    public getProjectGroupMoveAriaLabel(group: any, direction: string) {
        const name = group && group.name ? group.name : "프로젝트 그룹";
        const action = direction === "up" ? "위로 이동" : "아래로 이동";
        return `${name} 그룹 ${action}`;
    }

    public getProjectOrderMoveAriaLabel(group: any, project: any, direction: string) {
        const groupName = group && group.name ? group.name : "프로젝트 그룹";
        const projectName = project && project.name ? project.name : "프로젝트";
        const action = direction === "up" ? "위로 이동" : "아래로 이동";
        return `${groupName} 안에서 ${projectName} ${action}`;
    }

    public async persistGroupConfig(message: string = "", status: string = "") {
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        if (message) this.setGroupFeedback(message, status);
        await this.service.render();
    }

    public hasDuplicateProjectGroupName(name: string, exceptGroupId: string = "") {
        const normalizedName = this.normalizeProjectName(name);
        if (!normalizedName) return false;
        return this.projectGroups.some(group => {
            if (!group || group.id === exceptGroupId) return false;
            return this.normalizeProjectName(group.name) === normalizedName;
        });
    }

    public getProjectAssignedGroupId(project: any) {
        if (!project || !project.id) return UNGROUPED_PROJECT_GROUP_ID;
        const group = this.projectGroups.find(item => {
            return item && Array.isArray(item.projectIds) && item.projectIds.indexOf(project.id) >= 0;
        });
        return group ? group.id : UNGROUPED_PROJECT_GROUP_ID;
    }

    public getProjectAssignedGroupName(project: any) {
        return this.getProjectGroupOptionName(this.getProjectAssignedGroupId(project));
    }

    public getProjectGroupOptionName(groupId: string) {
        if (groupId === UNGROUPED_PROJECT_GROUP_ID) return "미분류";
        const group = this.projectGroups.find(item => item && item.id === groupId);
        return group && group.name ? group.name : "프로젝트 그룹";
    }

    public getProjectAssignmentLabel(project: any) {
        return this.getProjectGroupOptionName(this.getProjectAssignedGroupId(project));
    }

    public getProjectGroupToggleLabel(group: any) {
        return this.isProjectGroupCollapsed(group) ? "펼치기" : "접기";
    }

    public getProjectGroupToggleAriaLabel(group: any) {
        const name = group && group.name ? group.name : "프로젝트 그룹";
        const action = this.isProjectGroupCollapsed(group) ? "펼치기" : "접기";
        return `${name} 그룹 ${action}`;
    }

    public getGroupProjectIds(group: any) {
        if (!group || !Array.isArray(group.projectIds)) return [];
        const projectIds: string[] = [];
        const projectSet: any = {};
        this.projects.forEach(project => {
            if (project && project.id) projectSet[project.id] = true;
        });
        group.projectIds.forEach((projectId: any) => {
            const id = String(projectId || "").trim();
            if (id && projectSet[id] && projectIds.indexOf(id) < 0) projectIds.push(id);
        });
        return projectIds;
    }

    public getVisibleGroupProjectIds(group: any) {
        return this.getGroupProjectIds(group)
            .filter(projectId => this.isProjectVisible(this.findProjectById(projectId)));
    }

    public getFilteredGroupProjectIds(group: any, context: any = this.getVisibleRowFilterContext()) {
        const projectIds = this.getVisibleGroupProjectIds(group);
        if (!context) return projectIds;
        const filterProjectIds = Array.isArray(context.projectIds) ? context.projectIds : [];
        const hasScopedProjectFilter = !!(context.selectedProject || context.groupId || context.favoriteOnly);
        if (filterProjectIds.length === 0 && hasScopedProjectFilter) return [];
        if (filterProjectIds.length === 0) return projectIds;
        return projectIds.filter(projectId => filterProjectIds.indexOf(projectId) >= 0);
    }

    public getGroupScheduleSummary(group: any, rows: any[] = this.visibleRows) {
        const projectIds = this.getFilteredGroupProjectIds(group);
        const statusCounts: any = {};
        const typeCounts: any = {};
        let total = 0;

        rows.forEach(row => {
            projectIds.forEach(projectId => {
                if (!this.hasCellContent(row, projectId)) return;
                const status = this.getVisibleCellStatus(row, projectId);
                const type = this.getVisibleCellType(row, projectId);
                total += 1;
                if (status) statusCounts[status] = (statusCounts[status] || 0) + 1;
                if (type) typeCounts[type] = (typeCounts[type] || 0) + 1;
            });
        });

        return { total, statusCounts, typeCounts };
    }

    public getGroupScheduleCount(group: any) {
        return this.getGroupScheduleSummary(group).total;
    }

    public getGroupScheduleCountText(group: any) {
        return `일정 ${this.getGroupScheduleCount(group)}건`;
    }

    public getGroupStatusSummaryText(group: any) {
        return this.formatSummaryCounts(this.getGroupScheduleSummary(group).statusCounts, this.cellStatusOptions, "상태 없음");
    }

    public getGroupTypeSummaryText(group: any) {
        return this.formatSummaryCounts(this.getGroupScheduleSummary(group).typeCounts, this.cellTypeOptions, "유형 없음");
    }

    public getGroupSummaryAriaLabel(group: any) {
        const name = group && group.name ? group.name : "프로젝트 그룹";
        const projectIds = this.getFilteredGroupProjectIds(group);
        const projects = projectIds.map((projectId: string) => this.findProjectById(projectId)).filter((project: any) => this.isProjectVisible(project));
        const dependencyCount = this.getDependencyAlertCount(this.visibleRows, projects);
        const dependencyText = dependencyCount > 0 ? `의존성 위험 ${dependencyCount}개` : "의존성 위험 없음";
        return `${name}, ${this.getGroupScheduleCountText(group)}, ${this.getGroupStatusSummaryText(group)}, ${this.getGroupTypeSummaryText(group)}, ${dependencyText}`;
    }

    public getRowGroupScheduleSummary(row: any, group: any) {
        return this.getGroupScheduleSummary(group, row ? [row] : []);
    }

    public getRowGroupScheduleCount(row: any, group: any) {
        return this.getRowGroupScheduleSummary(row, group).total;
    }

    public getRowGroupScheduleCountText(row: any, group: any) {
        return `일정 ${this.getRowGroupScheduleCount(row, group)}건`;
    }

    public getRowGroupStatusSummaryText(row: any, group: any) {
        return this.formatSummaryCounts(this.getRowGroupScheduleSummary(row, group).statusCounts, this.cellStatusOptions, "상태 없음");
    }

    public getRowGroupTypeSummaryText(row: any, group: any) {
        return this.formatSummaryCounts(this.getRowGroupScheduleSummary(row, group).typeCounts, this.cellTypeOptions, "유형 없음");
    }

    public hasMobileCollapsedGroupSummaries(row: any) {
        return this.mobileCollapsedGroups.some(group => this.getRowGroupScheduleCount(row, group) > 0);
    }

    public getMobileProjectGroupPanelId(row: any, group: any) {
        const rowKey = row && (row.id || row.date) ? row.id || row.date : "row";
        const groupKey = group && group.id ? group.id : "group";
        return `mobile-group-${this.makeDomSafeId(rowKey)}-${this.makeDomSafeId(groupKey)}`;
    }

    public getMobileProjectGroupToggleAriaLabel(row: any, group: any) {
        const dateLabel = row && row.dateLabel ? row.dateLabel : "날짜";
        const groupName = group && group.name ? group.name : "프로젝트 그룹";
        const action = this.isProjectGroupCollapsed(group) ? "펼치기" : "접기";
        return `${dateLabel} ${groupName} 그룹 ${action}`;
    }

    public getMobileEntryAriaLabel(row: any, group: any, project: any) {
        const projectId = project && project.id ? project.id : "";
        const status = this.getVisibleCellStatus(row, projectId);
        const type = this.getVisibleCellType(row, projectId);
        const timeText = this.getCellTimeText(row, projectId);
        const parts = [
            row && row.dateLabel ? row.dateLabel : "",
            group && group.name ? `${group.name} 그룹` : "프로젝트 그룹",
            project && project.name ? project.name : "프로젝트",
            this.getCellPreviewTitle(row, projectId),
            status ? `상태 ${status}` : "",
            type ? `유형 ${type}` : "",
            this.getCellDependencySearchText(row, projectId),
            timeText
        ].filter(part => String(part || "").trim().length > 0);
        return `${parts.join(" ")} 상세 편집`;
    }

    public getMobileGroupProjects(group: any) {
        const projectMap: any = {};
        this.projects.forEach(project => {
            if (project && project.id) projectMap[project.id] = project;
        });
        return this.getGroupProjectIds(group)
            .map((projectId: string) => projectMap[projectId])
            .filter((project: any) => this.isProjectVisible(project));
    }

    public getMobileVisibleProjects(row: any, group: any) {
        const context = this.getVisibleRowFilterContext();
        return this.getMobileGroupProjects(group)
            .filter((project: any) => this.shouldShowMobileProjectEntry(row, project, context));
    }

    public hasMobileGroupEntries(row: any, group: any) {
        return this.getMobileVisibleProjects(row, group).length > 0;
    }

    public getMobileGroupEntryCount(row: any, group: any) {
        return this.getMobileVisibleProjects(row, group).length;
    }

    public getMobileGroupScheduleSummary(row: any, group: any) {
        const statusCounts: any = {};
        const typeCounts: any = {};
        const projects = this.getMobileVisibleProjects(row, group);

        projects.forEach((project: any) => {
            const status = this.getVisibleCellStatus(row, project.id);
            const type = this.getVisibleCellType(row, project.id);
            if (status) statusCounts[status] = (statusCounts[status] || 0) + 1;
            if (type) typeCounts[type] = (typeCounts[type] || 0) + 1;
        });

        return { total: projects.length, statusCounts, typeCounts };
    }

    public getMobileGroupScheduleCountText(row: any, group: any) {
        return `일정 ${this.getMobileGroupScheduleSummary(row, group).total}건`;
    }

    public getMobileGroupStatusSummaryText(row: any, group: any) {
        return this.formatSummaryCounts(this.getMobileGroupScheduleSummary(row, group).statusCounts, this.cellStatusOptions, "상태 없음");
    }

    public getMobileGroupTypeSummaryText(row: any, group: any) {
        return this.formatSummaryCounts(this.getMobileGroupScheduleSummary(row, group).typeCounts, this.cellTypeOptions, "유형 없음");
    }

    public formatSummaryCounts(counts: any, orderedKeys: string[], emptyLabel: string) {
        const parts: string[] = [];
        orderedKeys.forEach(key => {
            if (counts[key] > 0) parts.push(`${key} ${counts[key]}`);
        });
        Object.keys(counts).forEach(key => {
            if (orderedKeys.indexOf(key) < 0 && counts[key] > 0) parts.push(`${key} ${counts[key]}`);
        });
        if (parts.length === 0) return emptyLabel;
        const visibleParts = parts.slice(0, 2);
        if (parts.length > 2) visibleParts.push(`+${parts.length - 2}`);
        return visibleParts.join(" · ");
    }

    public async loadInitialSheet() {
        this.setPersistenceStatus("checking", "저장 상태 확인 중", "서버 연결 상태를 확인합니다.");

        const localSheet = this.readLocalSheet();
        const fallbackSheet = localSheet || this.defaultSheet();
        const serverResult = await this.loadServerSheet(fallbackSheet);

        if (serverResult.ok && serverResult.sheet) {
            if (localSheet) this.backupLocalSheet(localSheet);
            this.applyServerLoadSuccess(serverResult, "initial");
            this.persistSheet(serverResult.sheet.projects, serverResult.sheet.rows, serverResult.sheet.viewPrefs, serverResult.sheet.projectGroups, serverResult.sheet.savedViews, serverResult.sheet.milestones);
            return serverResult.sheet;
        }

        this.serverStorageReady = false;
        this.serverReadOnly = true;
        this.rememberFailedServerSave("load", this.createLoadPayload(fallbackSheet), serverResult.message || "");
        this.setPersistenceStatus("local", "로컬 저장 사용 중", this.buildLocalPersistenceDetail(serverResult.message));
        this.persistSheet(fallbackSheet.projects, fallbackSheet.rows, fallbackSheet.viewPrefs, fallbackSheet.projectGroups, fallbackSheet.savedViews, fallbackSheet.milestones);
        return fallbackSheet;
    }

    public readLocalSheet() {
        try {
            const saved = localStorage.getItem(this.storageKey);
            if (!saved) return null;
            const parsed = JSON.parse(saved);
            return this.recoverSheet(parsed);
        } catch (e) {
            return null;
        }
    }

    public loadSheet() {
        try {
            const saved = localStorage.getItem(this.storageKey);
            if (saved) {
                const parsed = JSON.parse(saved);
                const recovered = this.recoverSheet(parsed);
                if (recovered) {
                    this.persistSheet(recovered.projects, recovered.rows, recovered.viewPrefs, recovered.projectGroups, recovered.savedViews, recovered.milestones);
                    return recovered;
                }
                localStorage.removeItem(this.storageKey);
            }
        } catch (e) {
            localStorage.removeItem(this.storageKey);
        }

        const fallback = this.defaultSheet();
        this.persistSheet(fallback.projects, fallback.rows, fallback.viewPrefs, fallback.projectGroups, fallback.savedViews, fallback.milestones);
        return fallback;
    }

    public async loadServerSheet(fallbackSheet: any) {
        const payload = this.createLoadPayload(fallbackSheet);
        const result = await this.callScheduleApi("load", payload);
        if (!result.ok) {
            return {
                ok: false,
                storageReady: false,
                readOnly: true,
                sheet: null,
                message: result.message || "서버 데이터 불러오기 실패"
            };
        }

        const data = result.data || {};
        const sync = data.sync || {};
        const sheet = this.recoverServerSheet(data, fallbackSheet);
        if (!sheet) {
            return {
                ok: false,
                storageReady: false,
                readOnly: true,
                sheet: null,
                message: "서버 저장 상태를 확인하지 못했습니다."
            };
        }

        return {
            ok: true,
            storageReady: this.isServerSyncStorageReady(sync),
            readOnly: this.isServerSyncReadOnly(sync),
            sheet,
            serverRevision: data.serverRevision || "",
            message: "server"
        };
    }

    public isServerSyncStorageReady(sync: any = {}) {
        return !this.isApiFalse(sync && sync.storageReady) && !this.isApiTrue(sync && sync.readOnly);
    }

    public isServerSyncReadOnly(sync: any = {}) {
        return this.isApiTrue(sync && sync.readOnly) || this.isApiFalse(sync && sync.storageReady);
    }

    public isApiTrue(value: any) {
        if (value === true) return true;
        if (value === 1) return true;
        const text = String(value || "").trim().toLowerCase();
        return text === "true" || text === "1" || text === "yes" || text === "y" || text === "on";
    }

    public isApiFalse(value: any) {
        if (value === false) return true;
        if (value === 0) return true;
        const text = String(value || "").trim().toLowerCase();
        return text === "false" || text === "0" || text === "no" || text === "n" || text === "off";
    }

    public applyServerLoadSuccess(serverResult: any, mode: string = "initial") {
        this.serverStorageReady = !!(serverResult && serverResult.storageReady);
        this.serverReadOnly = !!(serverResult && serverResult.readOnly);
        this.clearFailedServerSave();
        this.markServerSaved({ serverRevision: serverResult && serverResult.serverRevision });
        const detail = this.serverStorageReady
            ? (mode === "retry" ? "서버에서 다시 불러왔고 로컬 백업도 갱신했습니다." : "서버에서 불러왔고 로컬 백업도 갱신했습니다.")
            : "서버 데이터를 불러왔습니다. 저장할 로컬 변경은 없습니다.";
        this.setPersistenceStatus("server", "동기화 완료", detail);
    }

    public createLoadPayload(sheet: any) {
        const rows = sheet && Array.isArray(sheet.rows) ? sheet.rows : [];
        return {
            from: rows.length > 0 ? rows[0].date : "",
            to: rows.length > 0 ? rows[rows.length - 1].date : "",
            includeHiddenProjects: true,
            includeEmptyDays: true,
            clientSchemaVersion: this.schemaVersion
        };
    }

    public recoverSheet(data: any) {
        if (!data || typeof data !== "object") return null;
        if (!this.isSupportedVersion(data.version)) return null;
        if (!Array.isArray(data.projects) || !Array.isArray(data.rows)) return null;
        const sheet = this.normalizeSheet(data.projects, data.rows);
        return {
            ...sheet,
            milestones: normalizeMilestones(data.milestones, sheet.projects),
            ...normalizeScheduleConvenienceState(data, sheet.projects, sheet.rows)
        };
    }

    public recoverServerSheet(data: any, fallbackSheet: any = null) {
        if (!data || typeof data !== "object") return null;
        if (!Array.isArray(data.projects) || !Array.isArray(data.rows)) return null;
        const sheet = this.normalizeSheet(data.projects, data.rows);
        const fallback = fallbackSheet && typeof fallbackSheet === "object" ? { ...fallbackSheet } : {};
        const canReuseFallbackConvenience = this.hasSameProjectIdOrder(sheet.projects, fallback.projects);
        if (!canReuseFallbackConvenience) {
            fallback.viewPrefs = {};
            fallback.projectGroups = [];
            fallback.savedViews = [];
        }
        const convenienceSource = {
            viewPrefs: data.viewPrefs === undefined ? fallback.viewPrefs : data.viewPrefs,
            projectGroups: data.projectGroups === undefined ? fallback.projectGroups : data.projectGroups,
            savedViews: data.savedViews === undefined ? fallback.savedViews : data.savedViews
        };
        return {
            ...sheet,
            milestones: normalizeMilestones(data.milestones === undefined ? fallback.milestones : data.milestones, sheet.projects),
            ...normalizeScheduleConvenienceState(convenienceSource, sheet.projects, sheet.rows)
        };
    }

    public hasSameProjectIdOrder(leftProjects: any[] = [], rightProjects: any[] = []) {
        if (!Array.isArray(leftProjects) || !Array.isArray(rightProjects)) return false;
        if (leftProjects.length !== rightProjects.length) return false;
        return leftProjects.every((project, index) => {
            const leftId = project && project.id ? String(project.id) : "";
            const right = rightProjects[index];
            const rightId = right && right.id ? String(right.id) : "";
            return !!leftId && leftId === rightId;
        });
    }

    public isSupportedVersion(version: any) {
        const numericVersion = Number(version);
        return Number.isInteger(numericVersion) && numericVersion === this.schemaVersion;
    }

    public defaultSheet() {
        const projects = this.defaultProjects();
        const sheet = {
            projects,
            rows: this.defaultRows(projects),
            milestones: []
        };
        return {
            ...sheet,
            ...normalizeScheduleConvenienceState({}, projects, sheet.rows)
        };
    }

    public normalizeSheet(projects: any[], rows: any[]) {
        const seenProjects: any = {};
        const normalizedProjects = projects
            .filter(project => project && project.id)
            .filter(project => {
                if (seenProjects[project.id]) return false;
                seenProjects[project.id] = true;
                return true;
            })
            .map((project, index) => {
                const name = String(project.name || "").trim();
                const sortOrder = this.numberOrDefault(project.sortOrder === undefined ? project.sort_order : project.sortOrder, index);
                const version = this.numberOrDefault(project.version, 0);
                return {
                    id: String(project.id),
                    name: name || `프로젝트 ${index + 1}`,
                    pm: String(project.pm || ""),
                    owner: String(project.owner || ""),
                    memo: this.normalizeProjectMemo(project.memo === undefined ? (project.note === undefined ? project.description : project.note) : project.memo),
                    color: String(project.color || this.palette[index % this.palette.length]),
                    sortOrder,
                    hidden: !!project.hidden,
                    isFavorite: project.isFavorite === true || project.favorite === true,
                    version,
                    updatedAt: String(project.updatedAt || project.updated_at || "")
                };
            });

        const projectList = normalizedProjects.length > 0 ? normalizedProjects : this.defaultProjects();
        const seenDates: any = {};
        const normalizedRows = rows
            .filter(row => row && this.isValidDate(row.date))
            .filter(row => {
                if (seenDates[row.date]) return false;
                seenDates[row.date] = true;
                return true;
            })
            .map(row => {
                const date = this.parseDate(row.date);
                const note = row.note === undefined || row.note === null ? "" : String(row.note);
                const normalized = this.buildRow(date, projectList, note, row.cells || {}, row.cellVersions || {}, row.dayVersion, row.cellMeta || row.cell_meta || {});
                return normalized;
            })
            .sort((a, b) => a.date.localeCompare(b.date));

        return {
            projects: projectList,
            rows: normalizedRows.length > 0 ? normalizedRows : this.defaultRows(projectList)
        };
    }

    public defaultProjects() {
        return [
            { id: "kiom", name: "한의학 LLM", pm: "김영주", owner: "임희진", color: "#2458d3", isFavorite: true },
            { id: "gsdc", name: "GSDC", pm: "김영주", owner: "김보미", color: "#0f8b6f", isFavorite: true },
            { id: "patent", name: "특허", pm: "김보미", owner: "-", color: "#b45309" },
            { id: "safety", name: "시설물", pm: "이재문", owner: "-", color: "#7c3aed" },
            { id: "ict_innovation", name: "ICT 이노베이션", pm: "최강", owner: "김지원", color: "#c2410c" },
            { id: "history", name: "동북아역사재단", pm: "김지원", owner: "김보미", color: "#0369a1" },
            { id: "kiom_trauma_vl", name: "한의학 트라우마 VL", pm: "김보미", owner: "임희진", color: "#be123c" },
            { id: "cellytics", name: "Cellytics", pm: "임희진", owner: "-", color: "#047857", isFavorite: true },
            { id: "hyundai_mepo", name: "현대메포", pm: "최강", owner: "-", color: "#2458d3" },
            { id: "tips", name: "TIPS", pm: "-", owner: "-", color: "#0f8b6f" },
            { id: "ulji", name: "울지대", pm: "최강", owner: "-", color: "#b45309" },
            { id: "rda", name: "농진청", pm: "최강", owner: "-", color: "#7c3aed" },
            { id: "ondras", name: "온드라스", pm: "최강", owner: "-", color: "#c2410c" }
        ];
    }

    public defaultRows(projects: any[]) {
        const rows = this.generateRows(this.parseDate(this.todayKey()), 75, projects);
        this.setCell(rows, 0, "kiom", "주간 운영 점검");
        this.setCell(rows, 1, "gsdc", "진행 상황 공유");
        this.setCell(rows, 2, "cellytics", "계약 및 일정 확인");
        this.setCell(rows, 4, "ict_innovation", "결과 보고 준비");
        return rows;
    }

    public generateRows(start: Date, count: number, projects: any[]) {
        const rows: any[] = [];
        for (let index = 0; index < count; index++) {
            rows.push(this.buildRow(this.addDays(start, index), projects));
        }
        return rows;
    }

    public buildRow(date: Date, projects: any[], note: string = "", cells: any = {}, cellVersions: any = {}, dayVersion: any = 0, cellMeta: any = {}) {
        const dateKey = this.formatDate(date);
        const rowCells: any = {};
        const rowCellVersions: any = {};
        const rowCellMeta: any = {};
        projects.forEach(project => {
            const rawCell = cells[project.id];
            const normalizedMeta = this.normalizeCellMeta(rawCell, cellMeta[project.id]);
            rowCells[project.id] = this.extractCellMemo(rawCell);
            if (!this.isDefaultCellMeta(normalizedMeta)) rowCellMeta[project.id] = normalizedMeta;
            const version = this.numberOrDefault(cellVersions[project.id], 0);
            if (version > 0) rowCellVersions[project.id] = version;
        });

        const holidayInfo = getCalendarHolidayInfo(dateKey);

        return {
            id: `date-${dateKey}`,
            date: dateKey,
            dateLabel: this.formatDisplayDate(date),
            weekday: this.getWeekday(date),
            note,
            dayVersion: this.numberOrDefault(dayVersion, 0),
            cells: rowCells,
            cellMeta: rowCellMeta,
            cellVersions: rowCellVersions,
            isWeekend: holidayInfo.isWeekend,
            isToday: dateKey === this.todayKey()
        };
    }

    public setCell(rows: any[], offset: number, projectId: string, value: string) {
        if (!rows[offset]) return;
        rows[offset].cells[projectId] = value;
    }

    public async saveSheet() {
        if (this.saveTimer) {
            window.clearTimeout(this.saveTimer);
            this.saveTimer = null;
        }

        const sheet = this.normalizeSheet(this.projects, this.rows);
        this.projects = sheet.projects;
        this.rows = sheet.rows;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.refreshMetrics();
        this.markLocalSaved();
        await this.service.render();
    }

    public queueSaveSheet() {
        if (this.saveTimer) window.clearTimeout(this.saveTimer);
        this.saveTimer = window.setTimeout(async () => {
            this.saveTimer = null;
            const convenience = this.normalizeCurrentConvenienceState();
            this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
            this.refreshMetrics();
            this.markLocalSaved();
            await this.service.render();
        }, this.saveDelay);
    }

    public persistSheet(projects: any[], rows: any[], viewPrefs: any = this.viewPrefs, projectGroups: any = this.projectGroups, savedViews: any = this.savedViews, milestones: any = this.milestones) {
        const payload = createScheduleStoragePayload({
            version: this.schemaVersion,
            projects,
            rows,
            milestones,
            viewPrefs,
            projectGroups,
            savedViews
        });
        localStorage.setItem(this.storageKey, JSON.stringify(payload));
    }

    public backupLocalSheet(sheet: any) {
        if (!sheet) return;
        const projects = sheet.projects || [];
        const payload = createScheduleStoragePayload({
            ...sheet,
            version: this.schemaVersion,
            projects,
            rows: sheet.rows || []
        });
        try {
            localStorage.setItem(this.storageBackupKey, JSON.stringify({
                ...payload,
                backedUpAt: new Date().toISOString()
            }));
        } catch (e) {
            // localStorage backup failure should never block schedule usage.
        }
    }

    public async callScheduleApi(functionName: string, payload: any = {}) {
        try {
            const response = this.normalizeApiPayloadValue(await wiz.call(functionName, {
                payload: JSON.stringify(payload || {})
            }));
            const data = this.extractApiData(response);
            const code = this.extractApiStatusCode(response, data);
            const ok = this.isApiSuccessResponse(response, code, data);
            if (ok) {
                return { ok: true, code, data, message: "" };
            }
            return {
                ok: false,
                code,
                data,
                message: this.getApiResponseMessage(response, data, `${functionName} 호출 실패`)
            };
        } catch (e) {
            return {
                ok: false,
                code: 0,
                data: null,
                message: this.getErrorMessage(e, `${functionName} 네트워크 실패`)
            };
        }
    }

    public async handleImportFileChange(event: any) {
        const input = event && event.target ? event.target as HTMLInputElement : null;
        const file = input && input.files && input.files.length > 0 ? input.files[0] : null;
        this.importApiResult = null;
        this.importRowsPreview = this.emptyImportRowsPreview();

        if (!file) {
            this.clearImportState();
            await this.service.render();
            return;
        }

        const fileInfo = this.normalizeImportFile(file);
        this.importFile = fileInfo;
        this.importState = "selected";
        this.importMessage = `${fileInfo.name} 선택됨`;
        this.importDetail = "확장자 확인 중";

        if (!this.isAllowedImportExtension(fileInfo.extension)) {
            this.importState = "invalid";
            this.importMessage = "지원하지 않는 파일입니다.";
            this.importDetail = "허용 확장자: xlsx, xlsm, xls, csv";
            if (input) input.value = "";
            await this.service.render();
            return;
        }

        if (fileInfo.extension === "csv") {
            this.importState = "parsing";
            this.importDetail = "CSV 앞부분을 읽는 중";
            await this.service.render();

            try {
                const text = await this.readImportFileText(file);
                this.importRowsPreview = this.parseDelimitedRowsPreview(text, 8, 8);
                this.importState = "previewReady";
                this.importMessage = "CSV 미리보기 준비됨";
                this.importDetail = this.importRowsPreview.rowCount > 0
                    ? `${this.importRowsPreview.rowCount}행 확인, 서버 저장은 실행하지 않음`
                    : "읽을 수 있는 행이 없습니다.";
            } catch (e) {
                this.importState = "previewBlocked";
                this.importMessage = "CSV 미리보기를 만들 수 없습니다.";
                this.importDetail = this.getErrorMessage(e, "파일 읽기 실패");
            }
            await this.service.render();
            return;
        }

        this.importState = "ready";
        this.importMessage = "파일 선택 완료";
        this.importDetail = "xlsx 파싱은 서버/파서 연결 후 미리보기됩니다.";
        await this.service.render();
    }

    public async requestImportPreview() {
        if (!this.importFile || !this.isAllowedImportExtension(this.importFile.extension)) {
            this.importState = "invalid";
            this.importMessage = "가져올 파일을 다시 선택해 주세요.";
            this.importDetail = "허용 확장자: xlsx, xlsm, xls, csv";
            await this.service.render();
            return;
        }

        this.importBusy = true;
        this.importState = "apiPending";
        this.importMessage = "가져오기 API 확인 중";
        this.importDetail = "preview 요청만 보내며 기존 일정은 유지합니다.";
        await this.service.render();

        const result = await this.callScheduleApi("importExcel", this.createImportPreviewPayload());
        this.importBusy = false;

        if (result.ok) {
            this.importApiResult = result.data || {};
            const sync = this.importApiResult.sync || {};
            if (sync.readOnly) {
                this.importState = "apiUnsupported";
                this.importMessage = "서버가 읽기 전용입니다.";
                this.importDetail = sync.message || "DB 저장 연결 후 가져오기를 사용할 수 있습니다.";
            } else {
                this.importState = "apiReady";
                this.importMessage = "서버 미리보기 응답 수신";
                this.importDetail = this.importPreviewSummaryText(this.importApiResult.summary);
            }
        } else if (result.code === 501) {
            this.importApiResult = result.data || {};
            this.importState = "apiUnsupported";
            this.importMessage = "서버 가져오기 준비 중";
            this.importDetail = result.message || "importExcel API가 아직 미구현입니다.";
        } else if (result.code === 0) {
            this.importState = "apiError";
            this.importMessage = "API 연결 실패";
            this.importDetail = result.message || "네트워크 확인 후 다시 시도해 주세요.";
        } else {
            this.importState = "apiError";
            this.importMessage = "미리보기 요청 실패";
            this.importDetail = result.message || "기존 일정은 유지됩니다.";
        }

        await this.service.render();
    }

    public async clearImportFile() {
        this.clearImportState();
        const input = document.getElementById("schedule-import-file") as HTMLInputElement;
        if (input) input.value = "";
        await this.service.render();
    }

    public clearImportState() {
        this.importState = "idle";
        this.importMessage = "xlsx, xlsm, xls, csv 파일을 선택하세요.";
        this.importDetail = "선택한 파일은 아직 일정표에 반영하지 않습니다.";
        this.importBusy = false;
        this.importFile = null;
        this.importApiResult = null;
        this.importRowsPreview = this.emptyImportRowsPreview();
    }

    public resetExportState() {
        if (this.exportBusy) return;
        this.exportState = "idle";
        this.exportMessage = "CSV 내보내기";
        this.exportDetail = "Excel에서 바로 열 수 있는 UTF-8 CSV";
        this.exportFileName = "";
    }

    public emptyImportRowsPreview() {
        return {
            rows: [],
            rowCount: 0,
            columnCount: 0,
            truncated: false
        };
    }

    public normalizeImportFile(file: File) {
        return {
            name: String(file.name || ""),
            size: Number(file.size || 0),
            type: String(file.type || ""),
            extension: this.getImportFileExtension(file.name),
            lastModified: file.lastModified || 0
        };
    }

    public getImportFileExtension(name: any) {
        const text = String(name || "").toLowerCase();
        const dotIndex = text.lastIndexOf(".");
        if (dotIndex < 0) return "";
        return text.slice(dotIndex + 1);
    }

    public isAllowedImportExtension(extension: string) {
        return this.importAllowedExtensions.indexOf(String(extension || "").toLowerCase()) >= 0;
    }

    public readImportFileText(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ""));
            reader.onerror = () => reject(reader.error || new Error("파일을 읽을 수 없습니다."));
            reader.readAsText(file, "utf-8");
        });
    }

    public parseDelimitedRowsPreview(text: string, maxRows: number, maxColumns: number) {
        const delimiter = this.detectDelimitedSeparator(text);
        const rows: any[] = [];
        let currentRow: string[] = [];
        let currentCell = "";
        let inQuotes = false;
        let rowCount = 0;
        let columnCount = 0;
        let stopped = false;

        const pushRow = () => {
            currentRow.push(currentCell);
            if (rowCount === 0 && currentRow.length > 0) {
                currentRow[0] = currentRow[0].replace(/^\ufeff/, "");
            }
            columnCount = Math.max(columnCount, currentRow.length);
            rowCount += 1;
            if (rows.length < maxRows) {
                rows.push(currentRow.slice(0, maxColumns));
            }
            currentRow = [];
            currentCell = "";
            return rowCount > maxRows;
        };

        for (let index = 0; index < text.length; index++) {
            const char = text.charAt(index);

            if (inQuotes) {
                if (char === "\"") {
                    if (text.charAt(index + 1) === "\"") {
                        currentCell += "\"";
                        index += 1;
                    } else {
                        inQuotes = false;
                    }
                } else {
                    currentCell += char;
                }
                continue;
            }

            if (char === "\"") {
                inQuotes = true;
            } else if (char === delimiter) {
                currentRow.push(currentCell);
                currentCell = "";
            } else if (char === "\r" || char === "\n") {
                if (char === "\r" && text.charAt(index + 1) === "\n") index += 1;
                stopped = pushRow();
                if (stopped) break;
            } else {
                currentCell += char;
            }
        }

        if (!stopped && (currentCell.length > 0 || currentRow.length > 0)) {
            pushRow();
        }

        return {
            rows,
            rowCount: Math.min(rowCount, maxRows),
            columnCount,
            truncated: rowCount > rows.length
        };
    }

    public detectDelimitedSeparator(text: string) {
        const firstLine = String(text || "").split(/\r?\n/).find(line => line.trim().length > 0) || "";
        const candidates = [",", "\t", ";"];
        let selected = ",";
        let selectedCount = -1;
        candidates.forEach(candidate => {
            const count = firstLine.split(candidate).length - 1;
            if (count > selectedCount) {
                selected = candidate;
                selectedCount = count;
            }
        });
        return selected;
    }

    public createImportPreviewPayload() {
        const convenience = this.normalizeCurrentConvenienceState();
        return {
            mode: "preview",
            parserContractVersion: 1,
            viewPrefs: convenience.viewPrefs,
            projectGroups: convenience.projectGroups,
            savedViews: convenience.savedViews,
            file: this.importFile,
            source: {
                kind: this.importRowsPreview.rows.length > 0 ? "clientRowsPreview" : "fileMetadataOnly",
                rows: this.importRowsPreview.rows,
                rowCount: this.importRowsPreview.rowCount,
                columnCount: this.importRowsPreview.columnCount,
                truncated: this.importRowsPreview.truncated
            },
            options: {
                headerRowCount: 4,
                firstProjectColumn: 3,
                expectedDateFrom: "2025-07-10",
                expectedDateTo: "2027-10-13",
                existingProjects: this.projects.map(project => ({
                    id: project.id,
                    name: project.name,
                    pm: project.pm,
                    owner: project.owner,
                    color: project.color,
                    isFavorite: this.isFavoriteProject(project)
                }))
            }
        };
    }

    public importPreviewSummaryText(summary: any) {
        if (!summary || typeof summary !== "object") return "preview 응답을 확인했습니다.";
        const projectCount = summary.projectCount === undefined ? "-" : summary.projectCount;
        const rowCount = summary.rowCount === undefined ? "-" : summary.rowCount;
        const entryCount = summary.entryCount === undefined ? "-" : summary.entryCount;
        return `프로젝트 ${projectCount}개, 행 ${rowCount}개, 일정 ${entryCount}건`;
    }

    public formatFileSize(size: any) {
        const bytes = Number(size || 0);
        if (!Number.isFinite(bytes) || bytes <= 0) return "0 KB";
        if (bytes < 1024 * 1024) return `${Math.ceil(bytes / 1024)} KB`;
        return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    }

    public async requestScheduleExport() {
        if (!this.canExportSchedule) {
            this.exportState = "blocked";
            this.exportMessage = "내보낼 표시 행이 없습니다.";
            this.exportDetail = "검색 필터를 해제하거나 일정 행을 확인해 주세요.";
            await this.service.render();
            return;
        }

        const exportRows = this.getExportRows();
        this.exportBusy = true;
        this.exportState = "apiPending";
        this.exportMessage = "내보내기 준비 중";
        this.exportDetail = "서버 API 확인 후 브라우저 CSV로 내려받습니다.";
        await this.service.render();

        const result = await this.callScheduleApi("exportExcel", this.createExportPayload(exportRows));
        if (result.ok && this.tryServerExportDownload(result.data)) {
            this.exportBusy = false;
            await this.service.render();
            return;
        }

        const fallbackReason = this.getExportFallbackReason(result);
        try {
            const downloaded = this.downloadScheduleCsv(exportRows);
            this.exportState = "downloaded";
            this.exportMessage = "CSV 다운로드 완료";
            this.exportFileName = downloaded.fileName;
            this.exportDetail = `${downloaded.rowCount}행, 프로젝트 ${downloaded.projectCount}개 - ${fallbackReason}`;
        } catch (e) {
            this.exportState = "error";
            this.exportMessage = "다운로드 실패";
            this.exportDetail = this.getErrorMessage(e, "브라우저 다운로드를 시작하지 못했습니다.");
        }

        this.exportBusy = false;
        await this.service.render();
    }

    public getExportRows() {
        return this.visibleRows.slice();
    }

    public getExportProjects() {
        const projectMap: any = {};
        this.projects.forEach(project => {
            if (project && project.id) projectMap[project.id] = project;
        });
        return getProjectRenderOrder(this.projectGroups, this.projects, this.scheduleTableViewPrefs)
            .map(projectId => projectMap[projectId])
            .filter(project => this.isProjectVisible(project));
    }

    public createExportPayload(rows: any[]) {
        const from = rows.length > 0 ? rows[0].date : "";
        const to = rows.length > 0 ? rows[rows.length - 1].date : "";
        const convenience = this.normalizeCurrentConvenienceState();
        const filterContext = this.getVisibleRowFilterContext();
        const exportProjects = this.getExportProjects();
        return {
            format: "csv",
            scope: "visibleRows",
            from,
            to,
            projectIds: exportProjects.map(project => project.id),
            projectGroups: convenience.projectGroups,
            savedViews: convenience.savedViews,
            includeHiddenProjects: false,
            clientFallback: true,
            filters: {
                searchText: this.searchText,
                selectedProjectId: filterContext.selectedProject ? filterContext.selectedProject.id : "",
                quickView: filterContext.quickView,
                dateScope: filterContext.dateScope,
                ownerOnly: filterContext.ownerOnly,
                favoriteOnly: filterContext.favoriteOnly,
                milestoneOnly: filterContext.milestoneOnly,
                status: filterContext.status,
                type: filterContext.type,
                groupId: filterContext.groupId,
                hideWeekends: filterContext.hideWeekends,
                hideEmptyRows: filterContext.hideEmptyRows
            },
            viewPrefs: convenience.viewPrefs,
            milestones: this.getExportMilestones(rows, exportProjects),
            summary: {
                rowCount: rows.length,
                totalLoadedRows: this.rows.length,
                projectCount: exportProjects.length,
                milestoneCount: this.getExportMilestones(rows, exportProjects).length,
                dependencyAlertCount: this.getDependencyAlertCount(rows, exportProjects),
                filtered: this.hasActiveFilters
            }
        };
    }

    public tryServerExportDownload(data: any) {
        if (!data || typeof data !== "object") return false;
        const sync = data.sync || {};
        if (sync.readOnly) return false;

        const fileName = this.sanitizeExportFileName(data.fileName || data.filename || this.createExportFileName(this.getExportRows()));
        if (data.downloadUrl) {
            this.downloadByUrl(String(data.downloadUrl), fileName);
            this.exportState = "server";
            this.exportMessage = "서버 내보내기 요청 완료";
            this.exportFileName = fileName;
            this.exportDetail = "서버가 제공한 다운로드 링크를 열었습니다.";
            return true;
        }

        if (data.csv !== undefined) {
            const content = String(data.csv || "");
            this.downloadTextFile(fileName, content, "text/csv;charset=utf-8");
            this.exportState = "server";
            this.exportMessage = "서버 CSV 다운로드 완료";
            this.exportFileName = fileName;
            this.exportDetail = "서버가 생성한 CSV를 내려받았습니다.";
            return true;
        }

        return false;
    }

    public getExportFallbackReason(result: any) {
        if (!result) return "브라우저 CSV fallback";
        if (result.ok) return "서버 파일 응답 없음, 브라우저 CSV fallback";
        if (result.code === 501) return "서버 exportExcel 미구현, 브라우저 CSV fallback";
        if (result.code === 0) return "네트워크 실패, 브라우저 CSV fallback";
        const message = result.message || "서버 응답 실패";
        return `${message}, 브라우저 CSV fallback`;
    }

    public downloadScheduleCsv(rows: any[]) {
        const fileName = this.createExportFileName(rows);
        const projects = this.getExportProjects();
        const csv = this.buildScheduleExportCsv(projects, rows);
        this.downloadTextFile(fileName, csv, "text/csv;charset=utf-8");
        return {
            fileName,
            rowCount: rows.length,
            projectCount: projects.length
        };
    }

    public buildScheduleExportCsv(projects: any[], rows: any[]) {
        const header = ["날짜", "요일", "개인", "마일스톤", "의존성/지연"].concat(projects.map(project => project.name || project.id));
        const body = rows.map(row => {
            return [
                row.date || "",
                row.weekday || "",
                row.note || "",
                this.getMilestoneExportText(row, projects),
                this.getDependencyExportText(row, projects)
            ].concat(projects.map(project => this.getCellValue(row, project.id)));
        });
        const lines = [header].concat(body).map(row => row.map(cell => this.escapeCsvCell(cell)).join(","));
        return "\ufeff" + lines.join("\r\n") + "\r\n";
    }

    public getExportMilestones(rows: any[], projects: any[]) {
        const dateSet: any = {};
        const projectIdSet: any = {};
        (rows || []).forEach(row => {
            if (row && row.date) dateSet[row.date] = true;
        });
        (projects || []).forEach(project => {
            if (project && project.id) projectIdSet[project.id] = true;
        });
        return this.milestones.filter(milestone => {
            if (!milestone || !dateSet[milestone.date]) return false;
            if (milestone.scope === "common") return true;
            return projectIdSet[milestone.projectId] === true;
        });
    }

    public getMilestoneExportText(row: any, projects: any[]) {
        const projectIdSet: any = {};
        (projects || []).forEach(project => {
            if (project && project.id) projectIdSet[project.id] = true;
        });
        return this.getMilestonesForDate(row && row.date ? row.date : "")
            .filter(milestone => milestone.scope === "common" || projectIdSet[milestone.projectId] === true)
            .map(milestone => {
                const scope = this.getMilestoneScopeLabel(milestone);
                const note = milestone.note ? ` - ${milestone.note}` : "";
                return `[${scope}] ${milestone.title} (${milestone.icon}/${milestone.color})${note}`;
            })
            .join("; ");
    }

    public escapeCsvCell(value: any) {
        const text = String(value === undefined || value === null ? "" : value)
            .replace(/\r\n/g, "\n")
            .replace(/\r/g, "\n")
            .replace(/"/g, "\"\"");
        return `"${text}"`;
    }

    public createExportFileName(rows: any[]) {
        const exportedAt = this.todayKey();
        if (!rows || rows.length === 0) return `schedule-export-${exportedAt}.csv`;
        const from = this.isValidDate(rows[0].date) ? rows[0].date : "unknown";
        const to = this.isValidDate(rows[rows.length - 1].date) ? rows[rows.length - 1].date : "unknown";
        return this.sanitizeExportFileName(`schedule-export-${exportedAt}-${from}_${to}.csv`);
    }

    public sanitizeExportFileName(value: any) {
        const name = String(value || "schedule-export.csv").trim() || "schedule-export.csv";
        return name.replace(/[^A-Za-z0-9._-]/g, "-");
    }

    public downloadTextFile(fileName: string, content: string, mimeType: string) {
        const blob = new Blob([content], { type: mimeType });
        const url = URL.createObjectURL(blob);
        try {
            this.downloadByUrl(url, fileName);
        } finally {
            window.setTimeout(() => URL.revokeObjectURL(url), 0);
        }
    }

    public downloadByUrl(url: string, fileName: string) {
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = fileName;
        anchor.rel = "noopener";
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
    }

    public getPrintExportRows() {
        return this.visibleRows.slice();
    }

    public getPrintExportColumns() {
        return this.scheduleTableColumns.slice();
    }

    public getPrintExportProjectRows() {
        return this.scheduleProjectRowItems.slice();
    }

    public getCustomDateColumnWidthCount() {
        return Object.keys(normalizeViewPrefs(this.viewPrefs).columnWidthsByDate || {}).length;
    }

    public getCustomProjectRowHeightCount() {
        return Object.keys(normalizeViewPrefs(this.viewPrefs).rowHeightsByProject || {}).length;
    }

    public getCustomProjectColumnWidthCount() {
        return Object.keys(normalizeViewPrefs(this.viewPrefs).projectColumnWidths || {}).length;
    }

    public getCustomDateRowHeightCount() {
        return Object.keys(normalizeViewPrefs(this.viewPrefs).rowHeightByDate || {}).length;
    }

    public getPrintExportFilterLabels() {
        const context = this.getVisibleRowFilterContext();
        const labels: string[] = [];
        if (context.keyword) labels.push(`검색 "${String(this.searchText || "").trim()}"`);
        if (context.quickView && context.quickView !== "default") labels.push(`빠른 보기 ${this.getScheduleQuickViewLabel(context.quickView)}`);
        if (context.dateScope === "today") labels.push("오늘 행");
        if (context.dateScope === "week") labels.push("이번 주 행");
        if (context.ownerOnly) labels.push("내 담당");
        if (context.selectedProject) labels.push(`프로젝트 ${context.selectedProject.name || context.selectedProject.id}`);
        this.activeQuickFilterChips.forEach((chip: any) => labels.push(chip.label));
        if (context.hideWeekends) labels.push("주말 숨김");
        if (context.hideEmptyRows) labels.push("빈 일정 행 숨김");
        if (labels.length === 0) labels.push("필터 없음");
        return labels;
    }

    public createPrintExportFileName(extension: string = "svg") {
        const rows = this.getPrintExportRows();
        const suffix = String(extension || "svg").replace(/^\./, "") || "svg";
        const exportedAt = this.todayKey();
        if (!rows || rows.length === 0) return this.sanitizeExportFileName(`schedule-print-${exportedAt}.${suffix}`);
        const from = this.isValidDate(rows[0].date) ? rows[0].date : "unknown";
        const to = this.isValidDate(rows[rows.length - 1].date) ? rows[rows.length - 1].date : "unknown";
        return this.sanitizeExportFileName(`schedule-print-${exportedAt}-${from}_${to}.${suffix}`);
    }

    public async requestSchedulePrintExport() {
        if (!this.canPrintExportSchedule) {
            this.printExportState = "blocked";
            this.printExportMessage = "인쇄할 표시 행이 없습니다.";
            this.printExportDetail = "검색 필터를 해제하거나 표시 프로젝트/행을 확인해 주세요.";
            await this.service.render();
            return;
        }

        this.printExportBusy = true;
        this.printExportActive = true;
        this.printExportState = "printPending";
        this.printExportFileName = this.createPrintExportFileName("pdf");
        this.printExportMessage = "인쇄 미리보기 준비 중";
        this.printExportDetail = `${this.printExportScopeLabel} · 브라우저 인쇄에서 PDF로 저장하세요.`;
        this.applyPrintExportClass(true);
        this.armPrintExportCleanup();
        await this.service.render();

        if (typeof window === "undefined" || typeof window.print !== "function") {
            this.printExportState = "error";
            this.printExportMessage = "브라우저 인쇄를 사용할 수 없습니다.";
            this.printExportDetail = "현재 실행 환경이 window.print를 지원하지 않습니다.";
            this.printExportBusy = false;
            this.finishPrintExportSession(false);
            await this.service.render();
            return;
        }

        window.setTimeout(() => {
            try {
                window.print();
                this.printExportState = "printReady";
                this.printExportMessage = "인쇄 미리보기를 열었습니다.";
                this.printExportDetail = `${this.printExportScopeLabel} · 현재 보기 기준과 행/열 크기를 반영했습니다.`;
            } catch (e) {
                this.printExportState = "error";
                this.printExportMessage = "인쇄 미리보기 실패";
                this.printExportDetail = this.getErrorMessage(e, "브라우저 인쇄를 시작하지 못했습니다.");
                this.finishPrintExportSession(false);
            }
            this.printExportBusy = false;
            void this.service.render();
        }, 40);
    }

    public async requestScheduleSvgExport() {
        if (!this.canPrintExportSchedule) {
            this.printExportState = "blocked";
            this.printExportMessage = "이미지로 내보낼 표시 행이 없습니다.";
            this.printExportDetail = "검색 필터를 해제하거나 표시 프로젝트/행을 확인해 주세요.";
            await this.service.render();
            return;
        }

        this.printExportBusy = true;
        this.printExportState = "imagePending";
        this.printExportMessage = "SVG 이미지 생성 중";
        this.printExportDetail = "스크롤 영역을 잘라내지 않고 전체 표를 하나의 SVG 이미지로 만듭니다.";
        await this.service.render();

        try {
            const rows = this.getPrintExportRows();
            const columns = this.getPrintExportColumns();
            const fileName = this.createPrintExportFileName("svg");
            const svg = this.buildSchedulePrintSvg(rows, columns);
            this.downloadTextFile(fileName, svg, "image/svg+xml;charset=utf-8");
            this.printExportState = "imageDownloaded";
            this.printExportMessage = "SVG 이미지 다운로드 완료";
            this.printExportFileName = fileName;
            this.printExportDetail = `날짜 ${rows.length}행, 개인/프로젝트 ${columns.length + 1}열 전체 이미지를 생성했습니다.`;
        } catch (e) {
            this.printExportState = "error";
            this.printExportMessage = "이미지 생성 실패";
            this.printExportDetail = this.getErrorMessage(e, "SVG 이미지를 생성하지 못했습니다.");
        }

        this.printExportBusy = false;
        await this.service.render();
    }

    public applyPrintExportClass(active: boolean) {
        if (typeof document === "undefined" || !document.body || !document.body.classList) return;
        document.body.classList.toggle("is-schedule-print-export", active);
    }

    public armPrintExportCleanup() {
        this.clearPrintExportCleanup();
        this.printExportActive = true;
        this.applyPrintExportClass(true);
        if (typeof window === "undefined") return;
        this.printExportAfterPrintHandler = () => this.finishPrintExportSession();
        window.addEventListener("afterprint", this.printExportAfterPrintHandler, { once: true });
        this.printExportCleanupTimer = window.setTimeout(() => this.finishPrintExportSession(), 45000);
    }

    public clearPrintExportCleanup() {
        if (typeof window !== "undefined") {
            if (this.printExportAfterPrintHandler) {
                window.removeEventListener("afterprint", this.printExportAfterPrintHandler);
                this.printExportAfterPrintHandler = null;
            }
            if (this.printExportCleanupTimer) {
                window.clearTimeout(this.printExportCleanupTimer);
                this.printExportCleanupTimer = null;
            }
        }
    }

    public finishPrintExportSession(render: boolean = true) {
        this.clearPrintExportCleanup();
        this.printExportActive = false;
        this.printExportBusy = false;
        this.applyPrintExportClass(false);
        if (render && this.service) void this.service.render();
    }

    public buildSchedulePrintSvg(rows: any[], columns: any[]) {
        const dateRows = Array.isArray(rows) ? rows : [];
        const tableColumns = Array.isArray(columns) ? columns : [];
        const dateColumnWidth = this.scheduleDateColumnWidthPx;
        const noteColumnWidth = this.noteColumnWidthPx;
        const titleHeight = 98;
        const headerHeight = Math.max(92, this.projectHeaderRowHeightPx);
        const footerHeight = 40;
        const columnLayouts: any[] = [];
        let cursorX = dateColumnWidth + noteColumnWidth;
        tableColumns.forEach(column => {
            const width = this.getScheduleColumnWidthPx(column);
            columnLayouts.push({ column, x: cursorX, width });
            cursorX += width;
        });
        const tableWidth = Math.max(cursorX, dateColumnWidth + noteColumnWidth + 320);
        const rowHeights = dateRows.map(row => Math.max(ROW_HEIGHT_MIN_PX, this.getRowHeightPxForRow(row)));
        const tableBodyHeight = rowHeights.reduce((total, height) => total + height, 0);
        const svgWidth = tableWidth;
        const svgHeight = titleHeight + headerHeight + tableBodyHeight + footerHeight;
        const parts: string[] = [];
        const tableY = titleHeight;
        const bodyY = tableY + headerHeight;

        parts.push(`<?xml version="1.0" encoding="UTF-8"?>`);
        parts.push(`<svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">`);
        parts.push(this.createSvgRect(0, 0, svgWidth, svgHeight, "#ffffff", "none"));
        parts.push(this.createSvgText("ReviewOps 일정표", 24, 34, svgWidth - 48, { fontSize: 22, fontWeight: 800, fill: "#17191f" }));
        parts.push(this.createSvgText(this.printExportScopeLabel, 24, 58, svgWidth - 48, { fontSize: 13, fontWeight: 700, fill: "#475467" }));
        parts.push(this.createSvgText(this.printExportViewSummary, 24, 80, svgWidth - 48, { fontSize: 12, fontWeight: 700, fill: "#667085" }));

        parts.push(this.createSvgRect(0, tableY, dateColumnWidth, headerHeight, "#eef2f7", "#cbd5e1"));
        parts.push(this.createSvgText("날짜", 14, tableY + 31, dateColumnWidth - 28, { fontSize: 13, fontWeight: 900, fill: "#293241" }));
        parts.push(this.createSvgText("행 높이 반영", 14, tableY + 55, dateColumnWidth - 28, { fontSize: 11, fontWeight: 800, fill: "#667085" }));
        parts.push(this.createSvgRect(dateColumnWidth, tableY, noteColumnWidth, headerHeight, "#eef2f7", "#cbd5e1"));
        parts.push(this.createSvgText("개인", dateColumnWidth + 10, tableY + 31, noteColumnWidth - 20, { fontSize: 13, fontWeight: 900, fill: "#293241" }));
        parts.push(this.createSvgText(this.noteColumnWidthLabel, dateColumnWidth + 10, tableY + 55, noteColumnWidth - 20, { fontSize: 10, fontWeight: 900, fill: "#667085" }));

        columnLayouts.forEach(layout => {
            const column = layout.column;
            const x = layout.x;
            const width = layout.width;
            const accentColor = this.sanitizeSvgColor(this.getScheduleColumnColor(column), "#64748b");
            const title = this.isProjectColumn(column) ? (column.project.name || column.project.id || "프로젝트") : (column.group.name || "그룹 요약");
            parts.push(this.createSvgRect(x, tableY, width, headerHeight, "#f8fafc", "#cbd5e1"));
            parts.push(this.createSvgRect(x, tableY, width, 4, accentColor, "none"));
            parts.push(this.createSvgText(title, x + 10, tableY + 27, width - 20, { fontSize: 12, fontWeight: 900, fill: "#1f2937" }));
            if (this.isProjectColumn(column)) {
                parts.push(this.createSvgText(`PM ${column.project.pm || "-"} · 담당 ${column.project.owner || "-"}`, x + 10, tableY + 47, width - 20, { fontSize: 10, fontWeight: 800, fill: "#667085" }));
                parts.push(this.createSvgText(this.getProjectColumnWidthLabel(column.project), x + 10, tableY + 68, width - 20, { fontSize: 10, fontWeight: 900, fill: "#475467" }));
            } else {
                parts.push(this.createSvgText(this.getGroupStatusSummaryText(column.group), x + 10, tableY + 47, width - 20, { fontSize: 10, fontWeight: 800, fill: "#667085" }));
                parts.push(this.createSvgText(`${width}px`, x + 10, tableY + 68, width - 20, { fontSize: 10, fontWeight: 900, fill: "#475467" }));
            }
        });

        let rowY = bodyY;
        dateRows.forEach((row, rowIndex) => {
            const rowHeight = rowHeights[rowIndex];
            const dateFill = this.getScheduleSvgRowFill(row);
            parts.push(this.createSvgRect(0, rowY, dateColumnWidth, rowHeight, dateFill, "#d9dde5"));
            if (row && row.isToday) parts.push(this.createSvgRect(0, rowY, 5, rowHeight, "#2458d3", "none"));
            parts.push(this.createSvgText(row.dateLabel || row.date || "", 14, rowY + 22, dateColumnWidth - 28, { fontSize: 12, fontWeight: 900, fill: "#1f2937" }));
            parts.push(this.createSvgText([row.weekday || "", this.getHolidayBadge(row)].filter(part => !!part).join(" · "), 14, rowY + 42, dateColumnWidth - 28, { fontSize: 10, fontWeight: 800, fill: "#667085" }));
            parts.push(this.createSvgText(this.getDateRowHeightLabel(row), 14, rowY + 60, dateColumnWidth - 28, { fontSize: 10, fontWeight: 900, fill: "#475467" }));

            parts.push(this.createSvgRect(dateColumnWidth, rowY, noteColumnWidth, rowHeight, dateFill, "#d9dde5"));
            if (row && row.note) parts.push(this.createSvgText(row.note, dateColumnWidth + 10, rowY + 22, noteColumnWidth - 20, { fontSize: 10, fontWeight: 800, fill: "#475467" }));

            columnLayouts.forEach(layout => {
                const x = layout.x;
                const width = layout.width;
                const column = layout.column;
                const cellFill = this.getScheduleSvgCellFill(row, column);
                parts.push(this.createSvgRect(x, rowY, width, rowHeight, cellFill, "#d9dde5"));
                if (this.isProjectColumn(column)) {
                    this.appendProjectSvgCell(parts, row, column.project, x, rowY, width, rowHeight);
                } else if (this.isGroupSummaryColumn(column)) {
                    this.appendGroupSummarySvgCell(parts, row, column.group, x, rowY, width, rowHeight);
                }
            });
            rowY += rowHeight;
        });

        const footerY = svgHeight - footerHeight + 24;
        parts.push(this.createSvgText(`생성일 ${this.formatNavigationDateLabel(this.todayKey())} · 날짜 ${dateRows.length}/${this.rows.length}행 · 개인/프로젝트 ${tableColumns.length + 1}열 · 숨김 프로젝트 ${this.hiddenProjectCount}개`, 24, footerY, svgWidth - 48, { fontSize: 11, fontWeight: 700, fill: "#667085" }));
        parts.push(`</svg>`);
        return parts.join("\n");
    }

    public appendProjectSvgCell(parts: string[], row: any, project: any, x: number, y: number, width: number, height: number) {
        if (!project || !project.id) return;
        const projectId = project.id;
        const hasContent = this.hasCellContent(row, projectId);
        const hasMeta = this.hasExplicitCellMeta(row, projectId);
        const milestones = this.getProjectMilestones(row, project);
        const hasDependencyRisk = this.hasCellDependencyRisk(row, projectId);
        const hasDependencyDelay = this.hasCellDependencyDelay(row, projectId);
        if (hasDependencyDelay) parts.push(this.createSvgRect(x, y, 5, height, "#dc2626", "none"));
        else if (hasDependencyRisk) parts.push(this.createSvgRect(x, y, 5, height, "#f59e0b", "none"));

        milestones.slice(0, 4).forEach((milestone: any, index: number) => {
            parts.push(this.createSvgRect(x + 9 + index * 16, y + 7, 11, 11, this.sanitizeSvgColor(milestone.color, DEFAULT_MILESTONE_COLOR), "none", `rx="5"`));
        });

        if (!hasContent && !hasMeta && milestones.length === 0) return;

        const meta = this.getCellMeta(row, projectId);
        const dependencyLabel = this.getCellDependencyBadgeLabel(row, projectId);
        const badgeText = [meta.status, meta.type, dependencyLabel].filter(part => !!part).join(" · ");
        const startY = milestones.length > 0 ? y + 34 : y + 20;
        if (badgeText) parts.push(this.createSvgText(badgeText, x + 10, startY, width - 20, { fontSize: 10, fontWeight: 800, fill: dependencyLabel ? "#be123c" : "#475467" }));

        const title = hasContent ? this.getCellPreviewTitle(row, projectId) : (milestones.length > 0 ? `마일스톤 ${milestones.length}개` : "메타 정보");
        parts.push(this.createSvgText(title, x + 10, startY + 18, width - 20, { fontSize: 11, fontWeight: 800, fill: "#17191f" }));
        const body = this.getCellPreviewBody(row, projectId);
        if (body && height >= 70) {
            parts.push(this.createSvgText(body, x + 10, startY + 36, width - 20, { fontSize: 10, fontWeight: 700, fill: "#667085" }));
        }
    }

    public appendGroupSummarySvgCell(parts: string[], row: any, group: any, x: number, y: number, width: number, height: number) {
        if (!group) return;
        const lines = [
            this.getRowGroupScheduleCountText(row, group),
            this.getRowGroupStatusSummaryText(row, group),
            this.getRowGroupTypeSummaryText(row, group),
            this.getRowGroupMilestoneCount(row, group) > 0 ? this.getRowGroupMilestoneCountText(row, group) : "",
            this.getRowGroupDependencyAlertCount(row, group) > 0 ? this.getRowGroupDependencyAlertText(row, group) : ""
        ].filter(line => !!line);
        lines.slice(0, height >= 96 ? 5 : 3).forEach((line, index) => {
            const fill = String(line).indexOf("의존성") >= 0 ? "#b45309" : (String(line).indexOf("마일스톤") >= 0 ? "#5b21b6" : "#475467");
            parts.push(this.createSvgText(line, x + 10, y + 20 + index * 15, width - 20, { fontSize: 10, fontWeight: index === 0 ? 900 : 700, fill }));
        });
    }

    public getScheduleSvgRowFill(row: any) {
        const holiday = this.getHolidayInfo(row);
        if (row && row.isToday) return "#eff6ff";
        if (holiday.isHoliday) return "#fff7ed";
        if (row && row.isWeekend) return "#f8fafc";
        return "#ffffff";
    }

    public getScheduleSvgCellFill(row: any, column: any) {
        if (!this.isProjectColumn(column)) return this.getScheduleSvgRowFill(row);
        if (this.hasCellDependencyDelay(row, column.project.id)) return "#fff1f2";
        if (this.hasCellDependencyRisk(row, column.project.id)) return "#fffbeb";
        if (this.getProjectMilestones(row, column.project).length > 0) return "#f5f3ff";
        if (this.shouldDimCompletedCell(row, column.project.id)) return "#f8fafc";
        return this.getScheduleSvgRowFill(row);
    }

    public getSvgTextLines(value: any, limit: number = 2) {
        return String(value || "")
            .replace(/\r\n/g, "\n")
            .replace(/\r/g, "\n")
            .split("\n")
            .map(line => this.compactCellDisplayText(line))
            .filter(line => line.length > 0)
            .slice(0, Math.max(1, limit));
    }

    public createSvgRect(x: number, y: number, width: number, height: number, fill: string, stroke: string = "#d9dde5", extraAttributes: string = "") {
        const strokeValue = stroke === "none" ? "none" : this.sanitizeSvgColor(stroke, "#d9dde5");
        const extra = extraAttributes ? ` ${extraAttributes}` : "";
        return `<rect x="${Math.round(x)}" y="${Math.round(y)}" width="${Math.max(0, Math.round(width))}" height="${Math.max(0, Math.round(height))}" fill="${this.sanitizeSvgColor(fill, "#ffffff")}" stroke="${strokeValue}" stroke-width="1"${extra}/>`;
    }

    public createSvgText(value: any, x: number, y: number, width: number, options: any = {}) {
        const fontSize = this.numberOrDefault(options.fontSize, 12);
        const fontWeight = this.numberOrDefault(options.fontWeight, 700);
        const fill = this.sanitizeSvgColor(options.fill, "#17191f");
        const anchor = options.anchor ? ` text-anchor="${this.escapeXml(options.anchor)}"` : "";
        const text = this.escapeXml(this.fitSvgText(value, width, fontSize));
        return `<text x="${Math.round(x)}" y="${Math.round(y)}" font-family="Arial, 'Noto Sans KR', sans-serif" font-size="${fontSize}" font-weight="${fontWeight}" fill="${fill}"${anchor}>${text}</text>`;
    }

    public fitSvgText(value: any, width: number, fontSize: number = 12) {
        const text = this.compactCellDisplayText(value);
        const availableWidth = Math.max(12, Number(width || 0));
        const maxChars = Math.max(2, Math.floor(availableWidth / Math.max(6, fontSize * 0.72)));
        if (text.length <= maxChars) return text;
        return `${text.slice(0, Math.max(1, maxChars - 3))}...`;
    }

    public sanitizeSvgColor(value: any, fallback: string = "#ffffff") {
        const color = String(value || "").trim();
        if (/^#[0-9A-Fa-f]{3}$/.test(color) || /^#[0-9A-Fa-f]{6}$/.test(color)) return color;
        return fallback;
    }

    public escapeXml(value: any) {
        return String(value === undefined || value === null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&apos;");
    }

    public extractApiData(response: any) {
        const parsed = this.normalizeApiPayloadValue(response);
        if (!parsed) return null;
        if (typeof parsed === "string") return parsed;
        if (typeof parsed !== "object") return null;
        if (this.isScheduleApiPayload(parsed)) return parsed;
        const nestedKeys = ["data", "result", "payload", "body"];
        for (const key of nestedKeys) {
            if (parsed[key] === undefined) continue;
            const nested = this.extractApiData(parsed[key]);
            if (nested !== null && nested !== undefined) return nested;
        }
        return null;
    }

    public getApiResponseMessage(response: any, data: any, fallback: string) {
        const parsedResponse = this.normalizeApiPayloadValue(response);
        if (data && typeof data === "object") {
            if (data.message) return String(data.message);
            if (data.todo) return String(data.todo);
        }
        if (typeof data === "string" && data) return data;
        if (parsedResponse && parsedResponse.message) return String(parsedResponse.message);
        if (parsedResponse && parsedResponse.error) return String(parsedResponse.error);
        return fallback;
    }

    public normalizeApiPayloadValue(value: any) {
        if (typeof value !== "string") return value;
        const text = value.trim();
        if (!text) return value;
        const maybeJson = text[0] === "{" || text[0] === "[";
        if (!maybeJson) return value;
        try {
            return JSON.parse(text);
        } catch (e) {
            return value;
        }
    }

    public extractApiStatusCode(response: any, data: any = null) {
        const parsedResponse = this.normalizeApiPayloadValue(response);
        const candidates = [
            parsedResponse && parsedResponse.code,
            parsedResponse && parsedResponse.statusCode,
            parsedResponse && parsedResponse.httpStatus,
            parsedResponse && parsedResponse.status,
            data && data.code,
            data && data.statusCode
        ];
        for (const candidate of candidates) {
            if (candidate === undefined || candidate === null || candidate === "") continue;
            if (typeof candidate === "number" && Number.isFinite(candidate)) return candidate;
            const text = String(candidate).trim();
            if (/^\d+$/.test(text)) return Number(text);
        }
        return 0;
    }

    public isApiSuccessResponse(response: any, code: number, data: any = null) {
        if (code >= 200 && code < 300) return true;
        const parsedResponse = this.normalizeApiPayloadValue(response);
        if (parsedResponse && (parsedResponse.ok === true || parsedResponse.success === true)) return true;
        return code === 0 && this.isScheduleApiPayload(data);
    }

    public isScheduleApiPayload(value: any) {
        if (!value || typeof value !== "object") return false;
        const payloadKeys = [
            "projects",
            "rows",
            "sync",
            "project",
            "scope",
            "deleted",
            "alreadyDeleted",
            "milestone",
            "milestoneId",
            "projectId",
            "serverRevision",
            "updatedAt",
            "version",
            "conflict",
            "summary",
            "file",
            "export"
        ];
        return payloadKeys.some(key => value[key] !== undefined);
    }

    public getErrorMessage(error: any, fallback: string) {
        if (!error) return fallback;
        if (error.message) return String(error.message);
        return fallback;
    }

    public markLocalSaved(date: Date = new Date()) {
        this.lastLocalSavedAtIso = date.toISOString();
        this.updatedAt = this.formatSavedTime(date);
        this.plannerSummaryRevision += 1;
    }

    public markServerSaved(data: any = {}, fallbackDate: Date = new Date()) {
        const payload = this.extractApiData(data) || data;
        const serverTimestamp = this.extractServerSavedAt(payload);
        const parsed = this.parseServerTimestamp(serverTimestamp) || fallbackDate;
        this.lastServerSavedAtIso = parsed.toISOString();
        this.lastServerSavedAt = this.formatSavedTime(parsed);
        this.lastServerRevision = serverTimestamp || this.lastServerSavedAtIso;
    }

    public extractServerSavedAt(data: any) {
        const payload = this.extractApiData(data) || data;
        if (!payload || typeof payload !== "object") return "";
        if (payload.serverRevision) return String(payload.serverRevision);
        if (payload.updatedAt) return String(payload.updatedAt);
        if (payload.project && payload.project.updatedAt) return String(payload.project.updatedAt);
        if (payload.milestone && payload.milestone.updatedAt) return String(payload.milestone.updatedAt);
        return "";
    }

    public parseServerTimestamp(value: any) {
        const text = String(value || "").trim();
        if (!text) return null;
        const parsed = new Date(text);
        if (Number.isNaN(parsed.getTime())) return null;
        return parsed;
    }

    public formatSavedTime(value: any) {
        const date = value instanceof Date ? value : this.parseServerTimestamp(value);
        const target = date || new Date();
        return target.toLocaleTimeString("ko-KR", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
    }

    public isServerSaveCurrent() {
        if (!this.lastServerSavedAtIso) return false;
        if (!this.lastLocalSavedAtIso) return true;
        return this.lastServerSavedAtIso >= this.lastLocalSavedAtIso;
    }

    public get lastSavedDisplay() {
        if (this.pendingServerSaveCount > 0) return "저장 중";
        if (this.isServerSaveCurrent()) return this.lastServerSavedAt;
        if (this.updatedAt) return this.updatedAt;
        return "자동 저장 대기";
    }

    public get lastSavedDetail() {
        if (this.pendingServerSaveCount > 0) {
            return this.updatedAt ? `로컬 ${this.updatedAt} 저장, 서버 반영 중` : "서버 반영 중입니다.";
        }
        if (this.isServerSaveCurrent()) return "서버 저장 완료 시각";
        if (this.updatedAt) {
            if (this.persistenceStatus === "error" || this.persistenceStatus === "local") {
                const reason = this.getPersistenceFailureReason();
                return reason ? `로컬 저장 완료, 서버 미반영: ${reason}` : "로컬 저장 완료, 서버 미반영";
            }
            return "로컬 백업 저장 시각";
        }
        return "변경 후 자동 저장됩니다.";
    }

    public get hasPersistenceAlert() {
        return (this.persistenceStatus === "error" || this.persistenceStatus === "local")
            && this.hasClearPersistenceReason();
    }

    public get summaryStatusBadgeLabel() {
        if (this.hasPersistenceAlert) return "저장 점검 필요";
        if (this.persistenceStatus === "saving" || this.persistenceStatus === "retrying") return "저장 중";
        if (this.persistenceStatus === "checking") return "저장 확인 중";
        if (this.persistenceStatus === "server") return "저장 정상";
        return "저장 상태";
    }

    public get summaryStatusBadgeAriaLabel() {
        if (this.hasPersistenceAlert) return "저장 상태 점검이 필요합니다. 일정 요약을 열어 확인하세요.";
        return this.summaryStatusBadgeLabel;
    }

    public get persistenceDisplayDetail() {
        const detail = String(this.persistenceDetail || "").trim();
        const serverSaved = this.lastServerSavedAt ? `마지막 서버 저장 ${this.lastServerSavedAt}` : "";
        if (detail && serverSaved && detail.indexOf(serverSaved) < 0) return `${detail} ${serverSaved}`;
        return detail || serverSaved;
    }

    public get persistenceDisplayMessage() {
        const isActiveSave = this.persistenceStatus === "saving" || this.persistenceStatus === "retrying";
        if (isActiveSave && this.pendingServerSaveCount > 1) {
            return `${this.persistenceMessage} ${this.pendingServerSaveCount}건`;
        }
        return this.persistenceMessage;
    }

    public get canRetryServerSave() {
        return (this.persistenceStatus === "error" || this.persistenceStatus === "local")
            && this.pendingServerSaveCount === 0
            && !!(this.lastFailedServerSave && this.lastFailedServerSave.functionName)
            && this.hasClearPersistenceReason();
    }

    public get retryServerSaveTitle() {
        if (!this.lastFailedServerSave) return "서버 저장 재시도";
        return `${this.lastFailedServerSave.label || "서버 저장"} 재시도`;
    }

    public setPersistenceStatus(status: string, message: string, detail: string = "") {
        this.persistenceStatus = status;
        this.persistenceMessage = message;
        this.persistenceDetail = detail;
        this.serverStatusUpdatedAt = new Date().toLocaleTimeString("ko-KR", { hour: "2-digit", minute: "2-digit" });
    }

    public getScheduleSaveActionLabel(functionName: string) {
        const labels: any = {
            load: "서버 데이터 불러오기",
            saveProject: "프로젝트 저장",
            deleteProject: "프로젝트 삭제",
            saveEntry: "일정 저장",
            deleteEntry: "일정 삭제",
            importExcel: "엑셀 가져오기",
            exportExcel: "엑셀 내보내기"
        };
        return labels[functionName] || "서버 저장";
    }

    public getUserPersistenceReason(message: string = "", fallback: string = "서버 저장 상태를 확인하지 못했습니다.") {
        const text = String(message || "").trim();
        if (!text) return fallback;
        const lower = text.toLowerCase();
        const internalPatterns = ["load", "payload", "json", "traceback", "exception", "응답 형식", "호출 실패"];
        const exposesInternalText = internalPatterns.some(pattern => lower.indexOf(pattern) >= 0);
        if (exposesInternalText) return fallback;
        return text;
    }

    public getPersistenceFailureReason() {
        const failedMessage = this.lastFailedServerSave && this.lastFailedServerSave.message
            ? String(this.lastFailedServerSave.message)
            : "";
        const source = failedMessage || String(this.persistenceDetail || "");
        const reason = this.getUserPersistenceReason(source, "");
        return reason
            .replace(/\s*변경 내용은[\s\S]*$/, "")
            .replace(/\s*재시도할 수 있습니다[\s\S]*$/, "")
            .trim();
    }

    public hasClearPersistenceReason() {
        if (this.getPersistenceFailureReason()) return true;
        return !!String(this.persistenceDetail || "").trim();
    }

    public buildLocalPersistenceDetail(message: string = "") {
        const reason = this.getUserPersistenceReason(message, "서버 저장을 사용할 수 없어 로컬 저장으로 전환했습니다.");
        return `${reason} 변경 내용은 로컬 백업에 보관되며 서버에는 아직 반영되지 않습니다. 재시도할 수 있습니다.`;
    }

    public buildServerSaveFailureDetail(functionName: string, result: any) {
        const label = this.getScheduleSaveActionLabel(functionName);
        const reason = this.getUserPersistenceReason(result && result.message ? String(result.message) : "", `${label}을 서버에 저장하지 못했습니다.`);
        return `${reason} 재시도할 수 있습니다. 변경 내용은 로컬에 유지되며 서버에는 아직 반영되지 않았습니다.`;
    }

    public buildServerConflictDetail(functionName: string, result: any) {
        const label = this.getScheduleSaveActionLabel(functionName);
        const conflict = result && result.data && result.data.conflict ? result.data.conflict : null;
        const versionText = conflict && conflict.serverVersion
            ? ` 서버 버전 ${conflict.serverVersion}이 더 최신입니다.`
            : "";
        return `${label} 중 서버의 최신 데이터와 충돌했습니다.${versionText} 변경 내용은 로컬에 유지됩니다. 재시도하거나 새로고침 후 다시 확인해 주세요.`;
    }

    public cloneServerSavePayload(payload: any) {
        try {
            return JSON.parse(JSON.stringify(payload || {}));
        } catch (e) {
            return payload || {};
        }
    }

    public prepareServerSavePayload(functionName: string, payload: any) {
        const prepared = this.cloneServerSavePayload(payload);
        if (functionName === "saveProject") {
            const projectId = prepared && prepared.project ? prepared.project.id : "";
            this.applyProjectExpectedVersion(prepared, projectId);
        } else if (functionName === "deleteProject") {
            this.applyProjectExpectedVersion(prepared, prepared ? prepared.projectId : "");
        } else if (functionName === "saveEntry" || functionName === "deleteEntry") {
            this.applyEntryExpectedVersion(prepared);
        }
        return prepared;
    }

    public applyProjectExpectedVersion(payload: any, projectId: any) {
        const project = this.findProjectById(String(projectId || ""));
        const version = project ? this.numberOrDefault(project.version, 0) : this.numberOrDefault(payload ? payload.expectedVersion : 0, 0);
        if (version > 0) payload.expectedVersion = version;
        else if (payload && payload.expectedVersion !== undefined) delete payload.expectedVersion;
    }

    public applyEntryExpectedVersion(payload: any) {
        if (!payload || !payload.date || !payload.scope) return;
        const row = this.rows.find(item => item.date === payload.date);
        let version = 0;
        if (row && payload.scope === "day") {
            version = this.numberOrDefault(row.dayVersion, 0);
        } else if (row && payload.scope === "cell") {
            const cellVersions = row.cellVersions || {};
            version = this.numberOrDefault(cellVersions[payload.projectId], 0);
        } else {
            version = this.numberOrDefault(payload.expectedVersion, 0);
        }
        if (version > 0) payload.expectedVersion = version;
        else if (payload.expectedVersion !== undefined) delete payload.expectedVersion;
    }

    public rememberFailedServerSave(functionName: string, payload: any, message: string = "") {
        this.lastFailedServerSave = {
            functionName,
            payload: this.cloneServerSavePayload(payload),
            label: this.getScheduleSaveActionLabel(functionName),
            message,
            failedAt: new Date().toISOString()
        };
    }

    public clearFailedServerSave() {
        this.lastFailedServerSave = null;
    }

    public getRetrySuccessHandler(functionName: string, payload: any) {
        if (functionName === "saveProject") {
            return (data: any) => this.applyProjectServerResult(data);
        }
        if (functionName === "saveEntry" || functionName === "deleteEntry") {
            if (payload && payload.scope === "milestone") {
                return functionName === "saveEntry"
                    ? (data: any) => this.applyMilestoneServerResult(data)
                    : null;
            }
            return (data: any) => this.applyEntryServerResult(data, payload, functionName === "deleteEntry");
        }
        return null;
    }

    public async retryLastServerSave() {
        if (!this.canRetryServerSave) return;
        const failed = this.lastFailedServerSave;
        if (failed.functionName === "load") {
            await this.retryServerLoad();
            return;
        }
        const payload = this.cloneServerSavePayload(failed.payload);
        const onSuccess = this.getRetrySuccessHandler(failed.functionName, payload);
        await this.runServerSave(failed.functionName, payload, onSuccess, "retry");
    }

    public async retryServerLoad() {
        const currentSheet = {
            projects: this.projects,
            rows: this.rows,
            milestones: this.milestones,
            viewPrefs: this.viewPrefs,
            projectGroups: this.projectGroups,
            savedViews: this.savedViews
        };
        this.pendingServerSaveCount += 1;
        this.setPersistenceStatus("retrying", "서버 연결 재시도 중", "서버 데이터를 다시 확인합니다. 현재 일정은 로컬 백업에 유지됩니다.");
        await this.service.render();

        const serverResult = await this.loadServerSheet(currentSheet);
        this.pendingServerSaveCount = Math.max(0, this.pendingServerSaveCount - 1);
        if (serverResult.ok && serverResult.sheet) {
            this.applyServerLoadSuccess(serverResult, "retry");
            this.applySheetState(serverResult.sheet);
            this.refreshMetrics();
            this.persistSheet(serverResult.sheet.projects, serverResult.sheet.rows, serverResult.sheet.viewPrefs, serverResult.sheet.projectGroups, serverResult.sheet.savedViews, serverResult.sheet.milestones);
        } else {
            this.serverStorageReady = false;
            this.serverReadOnly = true;
            this.rememberFailedServerSave("load", this.createLoadPayload(currentSheet), serverResult.message || "");
            this.setPersistenceStatus("local", "로컬 저장 사용 중", this.buildLocalPersistenceDetail(serverResult.message));
        }

        await this.service.render();
    }

    public queueProjectSave(project: any) {
        if (!project || !project.id) return;
        const key = String(project.id);
        if (this.projectSaveTimers[key]) window.clearTimeout(this.projectSaveTimers[key]);
        this.projectSaveTimers[key] = window.setTimeout(() => {
            delete this.projectSaveTimers[key];
            void this.saveProjectToServer(project);
        }, 700);
    }

    public clearProjectSaveTimer(projectId: any) {
        const key = String(projectId || "");
        if (!key || !this.projectSaveTimers[key]) return;
        window.clearTimeout(this.projectSaveTimers[key]);
        delete this.projectSaveTimers[key];
    }

    public clearProjectEntrySaveTimers(projectId: any) {
        const suffix = `-${String(projectId || "")}`;
        if (suffix === "-") return;
        Object.keys(this.entrySaveTimers).forEach(key => {
            if (key.indexOf("cell-") !== 0 || !key.endsWith(suffix)) return;
            window.clearTimeout(this.entrySaveTimers[key]);
            delete this.entrySaveTimers[key];
        });
    }

    public clearPendingProjectSaves(projectId: any) {
        this.clearProjectSaveTimer(projectId);
        this.clearProjectEntrySaveTimers(projectId);
    }

    public async saveProjectToServer(project: any) {
        if (!project || !project.id) return;
        const payload: any = {
            project: this.serializeProject(project)
        };
        const expectedVersion = this.numberOrDefault(project.version, 0);
        if (expectedVersion > 0) payload.expectedVersion = expectedVersion;
        await this.runServerSave("saveProject", payload, (data: any) => this.applyProjectServerResult(data));
    }

    public async deleteProjectFromServer(project: any) {
        if (!project || !project.id) return;
        const payload: any = {
            projectId: project.id,
            deleteEntries: true
        };
        const expectedVersion = this.numberOrDefault(project.version, 0);
        if (expectedVersion > 0) payload.expectedVersion = expectedVersion;
        await this.runServerSave("deleteProject", payload);
    }

    public serializeProject(project: any) {
        const projectIndex = this.projects.findIndex(item => item.id === project.id);
        return {
            id: String(project.id || ""),
            name: String(project.name || ""),
            pm: String(project.pm || ""),
            owner: String(project.owner || ""),
            memo: this.normalizeProjectMemo(project.memo === undefined ? project.note : project.memo),
            color: String(project.color || this.palette[0]),
            sortOrder: this.numberOrDefault(project.sortOrder, projectIndex >= 0 ? projectIndex : 0),
            hidden: !!project.hidden,
            favorite: this.isFavoriteProject(project)
        };
    }

    public applyProjectServerResult(data: any) {
        if (!data || !data.project) return;
        const serverProject = data.project;
        const project = this.findProjectById(serverProject.id);
        if (!project) return;
        project.version = this.numberOrDefault(serverProject.version, project.version || 0);
        project.updatedAt = String(serverProject.updatedAt || project.updatedAt || "");
        project.sortOrder = this.numberOrDefault(serverProject.sortOrder === undefined ? serverProject.sort_order : serverProject.sortOrder, project.sortOrder || 0);
        project.hidden = serverProject.hidden === true;
        project.isFavorite = serverProject.isFavorite === true || serverProject.favorite === true;
        project.favorite = project.isFavorite;
        project.memo = this.normalizeProjectMemo(serverProject.memo === undefined ? project.memo : serverProject.memo);
        this.persistSheet(this.projects, this.rows);
    }

    public handleProjectFieldChange(project: any, field: string = "", value: any = null) {
        if (!project || !project.id) return;
        const editableFields = ["name", "pm", "owner", "memo"];
        if (editableFields.indexOf(field) >= 0) {
            const nextValue = field === "memo"
                ? this.normalizeProjectMemo(value)
                : (value === undefined || value === null ? "" : String(value));
            if (String(project[field] || "") === nextValue) return;
            const labels: any = { name: "이름", pm: "PM", owner: "담당", memo: "메모" };
            this.recordScheduleHistory(`${project.name || "프로젝트"} 프로젝트 ${labels[field] || "정보"} 변경`, `project-field-${project.id}-${field}`);
            project[field] = nextValue;
        } else {
            this.recordScheduleHistory(`${project.name || "프로젝트"} 프로젝트 정보 변경`, `project-field-${project.id}`);
        }
        this.queueSaveSheet();
        this.queueProjectSave(project);
    }

    public normalizeProjectMemo(value: any) {
        const text = value === undefined || value === null ? "" : String(value);
        return text.replace(/\r\n/g, "\n").replace(/\r/g, "\n").slice(0, this.projectMemoMaxLength);
    }

    public getProjectMemo(project: any) {
        if (!project) return "";
        return this.normalizeProjectMemo(project.memo === undefined ? project.note : project.memo);
    }

    public getProjectMemoLength(project: any) {
        return this.getProjectMemo(project).length;
    }

    public hasProjectMemo(project: any) {
        return this.getProjectMemo(project).trim().length > 0;
    }

    public getProjectMemoPreview(project: any) {
        const memo = this.getProjectMemo(project).replace(/\s+/g, " ").trim();
        if (!memo) return "메모 없음";
        return memo.length > 46 ? `${memo.slice(0, 46)}...` : memo;
    }

    public getProjectMemoPopoverId(project: any) {
        return `project-memo-popover-${project && project.id ? project.id : "unknown"}`;
    }

    public getProjectMemoTextareaName(project: any) {
        return `project-memo-${project && project.id ? project.id : "unknown"}`;
    }

    public getProjectMemoToggleTitle(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        return this.hasProjectMemo(project)
            ? `${name} 메모: ${this.getProjectMemoPreview(project)}`
            : `${name} 메모 작성`;
    }

    public getProjectMemoToggleAriaLabel(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        return this.hasProjectMemo(project)
            ? `${name} 프로젝트 메모 편집`
            : `${name} 프로젝트 메모 작성`;
    }

    public isProjectMemoPopoverOpen(project: any) {
        return !!(project && project.id && this.activeProjectMemoProjectId === project.id);
    }

    public async toggleProjectMemoPopover(project: any, event: any = null) {
        this.stopProjectMemoEvent(event);
        if (!project || !project.id) return;
        this.activeProjectMemoProjectId = this.isProjectMemoPopoverOpen(project) ? "" : project.id;
        await this.service.render();
    }

    public async closeProjectMemoPopover(event: any = null) {
        this.stopProjectMemoEvent(event);
        if (!this.activeProjectMemoProjectId) return;
        this.activeProjectMemoProjectId = "";
        await this.service.render();
    }

    public handleProjectMemoChange(project: any, value: any) {
        this.handleProjectFieldChange(project, "memo", value);
    }

    public async clearProjectMemo(project: any, event: any = null) {
        this.stopProjectMemoEvent(event);
        if (!project || !this.hasProjectMemo(project)) return;
        this.handleProjectFieldChange(project, "memo", "");
        await this.service.render();
    }

    public async handleProjectMemoKeydown(event: KeyboardEvent) {
        if (!event || event.key !== "Escape") return;
        event.preventDefault();
        event.stopPropagation();
        await this.closeProjectMemoPopover();
    }

    public stopProjectMemoEvent(event: any = null) {
        if (!event) return;
        if (typeof event.preventDefault === "function") event.preventDefault();
        if (typeof event.stopPropagation === "function") event.stopPropagation();
    }

    public queueEntrySave(payload: any) {
        const key = this.entryTimerKey(payload);
        if (!key) return;
        if (this.entrySaveTimers[key]) window.clearTimeout(this.entrySaveTimers[key]);
        this.entrySaveTimers[key] = window.setTimeout(() => {
            delete this.entrySaveTimers[key];
            void this.saveEntryPayloadToServer(payload);
        }, 700);
    }

    public clearEntrySaveTimer(payload: any) {
        const key = this.entryTimerKey(payload);
        if (!key || !this.entrySaveTimers[key]) return;
        window.clearTimeout(this.entrySaveTimers[key]);
        delete this.entrySaveTimers[key];
    }

    public entryTimerKey(payload: any) {
        if (!payload || !payload.date || !payload.scope) return "";
        return payload.scope === "day"
            ? `day-${payload.date}`
            : `cell-${payload.date}-${payload.projectId || ""}`;
    }

    public makeDayEntryPayload(row: any) {
        const payload: any = {
            scope: "day",
            date: row.date,
            note: row.note === undefined || row.note === null ? "" : String(row.note)
        };
        const expectedVersion = this.numberOrDefault(row.dayVersion, 0);
        if (expectedVersion > 0) payload.expectedVersion = expectedVersion;
        return payload;
    }

    public makeCellEntryPayload(row: any, project: any) {
        const cellVersions = row.cellVersions || {};
        const payload: any = {
            scope: "cell",
            date: row.date,
            projectId: project.id,
            value: this.getCellValue(row, project.id),
            comment: ""
        };
        const meta = this.getCellMeta(row, project.id);
        payload.entryType = this.getVisibleCellType(row, project.id);
        payload.taskStatus = this.getVisibleCellStatus(row, project.id);
        payload.dependencies = meta.dependencies;
        payload.scheduleTime = meta.time;
        const expectedVersion = this.numberOrDefault(cellVersions[project.id], 0);
        if (expectedVersion > 0) payload.expectedVersion = expectedVersion;
        return payload;
    }

    public makeMilestoneEntryPayload(milestone: any) {
        const payload: any = {
            scope: "milestone",
            milestone: this.serializeMilestone(milestone)
        };
        const expectedVersion = this.numberOrDefault(milestone && milestone.version, 0);
        if (expectedVersion > 0) payload.expectedVersion = expectedVersion;
        return payload;
    }

    public serializeMilestone(milestone: any) {
        return {
            id: String(milestone && milestone.id ? milestone.id : ""),
            title: String(milestone && milestone.title ? milestone.title : ""),
            date: String(milestone && milestone.date ? milestone.date : ""),
            scope: this.normalizeMilestoneScope(milestone && milestone.scope),
            projectId: milestone && milestone.scope === "project" ? String(milestone.projectId || "") : "",
            color: this.normalizeMilestoneColor(milestone && milestone.color),
            icon: this.normalizeMilestoneIcon(milestone && milestone.icon),
            note: String(milestone && milestone.note ? milestone.note : ""),
            order: this.numberOrDefault(milestone && milestone.order, 0)
        };
    }

    public async saveMilestoneToServer(milestone: any) {
        if (!milestone || !milestone.id) return;
        await this.runServerSave("saveEntry", this.makeMilestoneEntryPayload(milestone), (data: any) => this.applyMilestoneServerResult(data));
    }

    public async deleteMilestoneFromServer(milestone: any) {
        if (!milestone || !milestone.id) return;
        const payload: any = {
            scope: "milestone",
            milestoneId: milestone.id,
            date: milestone.date
        };
        const expectedVersion = this.numberOrDefault(milestone.version, 0);
        if (expectedVersion > 0) payload.expectedVersion = expectedVersion;
        await this.runServerSave("deleteEntry", payload);
    }

    public applyMilestoneServerResult(data: any) {
        if (!data || !data.milestone || !data.milestone.id) return;
        const serverMilestone = data.milestone;
        const milestone = this.findMilestoneById(serverMilestone.id);
        if (!milestone) return;
        milestone.version = this.numberOrDefault(serverMilestone.version, milestone.version || 0);
        milestone.updatedAt = String(serverMilestone.updatedAt || milestone.updatedAt || "");
        this.persistSheet(this.projects, this.rows);
    }

    public async saveEntryPayloadToServer(payload: any) {
        if (!payload) return;
        this.clearEntrySaveTimer(payload);
        const isDay = payload.scope === "day";
        const value = isDay ? String(payload.note || "") : String(payload.value || "");
        const hasCellMeta = !isDay && this.payloadHasExplicitCellMeta(payload);
        const functionName = value.length > 0 || hasCellMeta ? "saveEntry" : "deleteEntry";
        await this.runServerSave(functionName, payload, (data: any) => this.applyEntryServerResult(data, payload, functionName === "deleteEntry"));
    }

    public payloadHasExplicitCellMeta(payload: any) {
        if (!payload || payload.scope !== "cell") return false;
        const meta: any = {
            status: this.normalizeCellStatus(payload.taskStatus || payload.task_status),
            type: this.normalizeCellType(payload.entryType || payload.entry_type),
            time: this.normalizeCellTime(payload.scheduleTime || payload.schedule_time || payload.time),
            dependencies: this.normalizeCellDependencies(payload.dependencies)
        };
        return !this.isDefaultCellMeta(meta);
    }

    public applyEntryServerResult(data: any, payload: any, deleted: boolean) {
        const row = this.rows.find(item => item.date === payload.date);
        if (!row) return;
        if (payload.scope === "day") {
            if (deleted) {
                row.dayVersion = data && data.version !== undefined
                    ? this.numberOrDefault(data.version, row.dayVersion || 0)
                    : 0;
            } else if (data && data.version) {
                row.dayVersion = this.numberOrDefault(data.version, row.dayVersion || 0);
            }
            this.persistSheet(this.projects, this.rows);
            return;
        }

        if (!row.cellVersions) row.cellVersions = {};
        if (deleted) {
            if (data && data.version) {
                row.cellVersions[payload.projectId] = this.numberOrDefault(data.version, row.cellVersions[payload.projectId] || 0);
            } else {
                delete row.cellVersions[payload.projectId];
            }
        } else if (data && data.version) {
            row.cellVersions[payload.projectId] = this.numberOrDefault(data.version, row.cellVersions[payload.projectId] || 0);
        }
        this.persistSheet(this.projects, this.rows);
    }

    public async runServerSave(functionName: string, payload: any, onSuccess: any = null, mode: string = "") {
        const label = this.getScheduleSaveActionLabel(functionName);
        const isRetry = mode === "retry";
        const requestPayload = this.prepareServerSavePayload(functionName, payload);
        const saveSequence = ++this.serverSaveSequence;
        this.pendingServerSaveCount += 1;
        this.setPersistenceStatus(
            isRetry ? "retrying" : "saving",
            isRetry ? "서버 저장 재시도 중" : "서버 저장 중",
            `${label} 요청 중입니다. 실패해도 변경 내용은 로컬에 유지됩니다.`
        );
        await this.service.render();

        const result = await this.callScheduleApi(functionName, requestPayload);
        this.pendingServerSaveCount = Math.max(0, this.pendingServerSaveCount - 1);

        if (result.ok) {
            this.lastSuccessfulServerSaveSequence = Math.max(this.lastSuccessfulServerSaveSequence, saveSequence);
            this.serverStorageReady = true;
            this.serverReadOnly = false;
            if (onSuccess) onSuccess(result.data);
            if (saveSequence >= this.lastFailedServerSaveSequence) {
                this.markServerSaved(result.data);
                this.clearFailedServerSave();
            }
            if (this.pendingServerSaveCount === 0 && saveSequence >= this.lastFailedServerSaveSequence) {
                this.setPersistenceStatus("server", "서버 저장 완료", `${label} 완료. 서버와 로컬 백업이 동기화되었습니다.`);
            }
        } else {
            if (saveSequence < this.lastSuccessfulServerSaveSequence) {
                if (this.pendingServerSaveCount === 0) {
                    this.setPersistenceStatus("server", "동기화 완료", `${label} 완료. 이전 저장 응답은 최신 저장으로 대체되었습니다.`);
                }
                await this.service.render();
                return;
            }
            this.lastFailedServerSaveSequence = Math.max(this.lastFailedServerSaveSequence, saveSequence);
            if (result.code === 501) this.serverStorageReady = false;
            this.rememberFailedServerSave(functionName, requestPayload, result.message || "");
            if (this.pendingServerSaveCount === 0) {
                if (result.code === 409) {
                    this.setPersistenceStatus("error", "서버 저장 충돌", this.buildServerConflictDetail(functionName, result));
                } else {
                    this.setPersistenceStatus("error", "서버 저장 실패", this.buildServerSaveFailureDetail(functionName, result));
                }
            }
        }

        await this.service.render();
    }

    public async toggleScheduleSummary() {
        this.scheduleSummaryExpanded = !this.scheduleSummaryExpanded;
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public async toggleProjectAdd() {
        this.projectAddExpanded = !this.projectAddExpanded;
        if (this.projectAddExpanded) {
            this.setProjectFeedback("", "");
        }
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public async toggleProjectManagement() {
        const willOpen = !this.projectManagementExpanded;
        this.closeAllUtilityWindows();
        if (willOpen) {
            this.markLowerUtilityPanelOpened();
            this.projectManagementExpanded = true;
        }
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public async closeProjectManagement() {
        if (!this.projectManagementExpanded) return;
        this.closeAllUtilityWindows();
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public resetNewProjectForm() {
        this.newProjectName = "";
        this.newProjectPm = "";
        this.newProjectOwner = "";
        this.newProjectColor = "";
    }

    public async cancelProjectAdd() {
        this.resetNewProjectForm();
        this.projectAddExpanded = false;
        this.setProjectFeedback("", "");
        this.saveDashboardPanelState();
        await this.service.render();
    }

    public async addProject() {
        const name = this.newProjectName.trim();
        const pm = this.newProjectPm.trim();
        const owner = this.newProjectOwner.trim();

        if (!name) {
            this.setProjectFeedback("프로젝트명을 입력해 주세요.", "error");
            await this.service.render();
            return;
        }

        if (name.length > 32) {
            this.setProjectFeedback("프로젝트명은 32자 이내로 입력해 주세요.", "error");
            await this.service.render();
            return;
        }

        const duplicate = this.projects.find(project => this.normalizeProjectName(project.name) === this.normalizeProjectName(name));
        if (duplicate) {
            const confirmed = window.confirm(`이미 "${duplicate.name}" 프로젝트가 있습니다. 같은 이름으로 추가할까요?`);
            if (!confirmed) {
                this.setProjectFeedback("중복 프로젝트 추가를 취소했습니다.", "warning");
                await this.service.render();
                return;
            }
        }

        const project = {
            id: this.makeId("project"),
            name,
            pm,
            owner,
            color: this.selectedProjectColor
        };

        this.recordScheduleHistory(`${project.name} 프로젝트 추가`);
        this.projects.push(project);
        this.rows.forEach(row => row.cells[project.id] = "");
        this.resetNewProjectForm();
        this.projectAddExpanded = false;
        this.saveDashboardPanelState();
        this.setProjectFeedback(`${project.name} 프로젝트를 추가했습니다.`, "success");
        await this.saveSheet();
        void this.saveProjectToServer(project);
    }

    public async removeProject(project: any) {
        if (this.projects.length <= 1) return;

        const scheduleCount = this.countProjectSchedules(project);
        const milestoneCount = this.countProjectMilestones(project);
        const removalDetails = [
            scheduleCount > 0 ? `입력된 일정 ${scheduleCount}건` : "",
            milestoneCount > 0 ? `연결 마일스톤 ${milestoneCount}건` : ""
        ].filter(item => item.length > 0).join(", ");
        const message = scheduleCount > 0
            ? `${project.name} 프로젝트를 삭제할까요?\n${removalDetails}이 함께 삭제됩니다. 이 작업은 되돌릴 수 없습니다.`
            : (milestoneCount > 0
                ? `${project.name} 프로젝트를 삭제할까요?\n${removalDetails}이 함께 삭제됩니다. 이 작업은 되돌릴 수 없습니다.`
                : `${project.name} 프로젝트를 삭제할까요?\n입력된 일정과 연결 마일스톤은 없지만 이 작업은 되돌릴 수 없습니다.`);
        if (!window.confirm(message)) return;

        if (this.selectedCell && this.selectedCell.projectId === project.id) {
            this.clearSelectedCellState();
        }
        this.clearActiveCellIfProject(project.id);
        if (this.selectedProjectId === project.id) {
            this.selectedProjectId = "";
            this.resetExportState();
        }
        if (this.activeProjectMemoProjectId === project.id) {
            this.activeProjectMemoProjectId = "";
        }
        this.recordScheduleHistory(`${project.name || "프로젝트"} 프로젝트 삭제`);
        this.clearPendingProjectSaves(project.id);
        this.projects = this.projects.filter(item => item.id !== project.id);
        this.rows.forEach(row => {
            if (row.cells) delete row.cells[project.id];
            if (row.cellMeta) delete row.cellMeta[project.id];
            if (row.cellVersions) delete row.cellVersions[project.id];
            this.removeCellDependenciesForProject(row, project.id);
        });
        this.milestones = normalizeMilestones(
            this.milestones.filter(milestone => !(milestone && milestone.scope === "project" && milestone.projectId === project.id)),
            this.projects
        );
        if (this.selectedMilestoneId && !this.findMilestoneById(this.selectedMilestoneId)) {
            this.resetMilestoneDraft();
        }
        this.setProjectFeedback(`${project.name} 프로젝트를 삭제했습니다.`, "warning");
        await this.saveSheet();
        void this.deleteProjectFromServer(project);
    }

    public async selectNewProjectColor(color: string) {
        this.newProjectColor = color;
        this.setProjectFeedback("", "");
        await this.service.render();
    }

    public async cycleProjectColor(project: any) {
        const currentIndex = this.palette.indexOf(project.color);
        const nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % this.palette.length;
        this.recordScheduleHistory(`${project.name || "프로젝트"} 색상 변경`);
        project.color = this.palette[nextIndex];
        await this.saveSheet();
        void this.saveProjectToServer(project);
    }

    public async toggleProjectHidden(project: any) {
        if (!project || !project.id) return;

        const nextHidden = !this.isProjectHidden(project);
        this.recordScheduleHistory(`${project.name || "프로젝트"} 표시 상태 변경`);
        project.hidden = nextHidden;

        if (nextHidden && this.selectedCell && this.selectedCell.projectId === project.id) {
            this.clearSelectedCellState();
        }
        if (nextHidden) this.clearActiveCellIfProject(project.id);

        this.sanitizeProjectVisibilityFilters(project.id);
        this.setProjectFeedback(
            nextHidden ? `${project.name || "프로젝트"} 행을 숨겼습니다.` : `${project.name || "프로젝트"} 행을 다시 표시합니다.`,
            nextHidden ? "warning" : "success"
        );
        this.resetExportState();
        await this.saveSheet();
        void this.saveProjectToServer(project);
    }

    public sanitizeProjectVisibilityFilters(projectId: string = "") {
        const prefs = normalizeViewPrefs(this.viewPrefs);
        const nextFilters = {
            ...prefs.filters
        };
        let changed = false;

        const selectedId = String(this.selectedProjectId || nextFilters.selectedProjectId || "").trim();
        if (selectedId) {
            const selectedProject = this.findProjectById(selectedId);
            if (!this.isProjectVisible(selectedProject)) {
                this.selectedProjectId = "";
                nextFilters.selectedProjectId = "";
                changed = true;
            }
        }

        if (projectId && this.selectedProjectId === projectId && !this.isProjectVisible(this.findProjectById(projectId))) {
            this.selectedProjectId = "";
            nextFilters.selectedProjectId = "";
            changed = true;
        }

        if (nextFilters.groupId && !this.getFilterProjectGroup(nextFilters.groupId)) {
            nextFilters.groupId = "";
            changed = true;
        }

        if (nextFilters.favoriteOnly === true && !this.hasFavoriteProjects) {
            nextFilters.favoriteOnly = false;
            changed = true;
        }

        if (changed) {
            this.viewPrefs = normalizeViewPrefs({
                ...prefs,
                filters: nextFilters
            });
        }
    }

    public getProjectColumnOrderGroup(project: any) {
        if (!project || !project.id) return null;
        const groupId = this.getProjectAssignedGroupId(project);
        return this.groupProjectOrderGroups.find(group => group && group.id === groupId) || null;
    }

    public canMoveProjectColumn(project: any, direction: string) {
        const group = this.getProjectColumnOrderGroup(project);
        if (!group) return false;
        return this.canMoveProjectWithinGroup(group, project, direction);
    }

    public getProjectColumnMoveAriaLabel(project: any, direction: string) {
        const group = this.getProjectColumnOrderGroup(project);
        return this.getProjectOrderMoveAriaLabel(group, project, direction);
    }

    public async moveProjectColumn(project: any, direction: string) {
        const group = this.getProjectColumnOrderGroup(project);
        if (!group || !this.canMoveProjectWithinGroup(group, project, direction)) return;

        const groupId = String(group.id || "");
        const action = direction === "up" ? "앞으로" : "뒤로";
        this.recordScheduleHistory(`${project.name || "프로젝트"} 행 순서 변경`);
        if (groupId === UNGROUPED_PROJECT_GROUP_ID) {
            this.projects = moveUngroupedProjectInProjectList(this.projects, this.projectGroups, project.id, direction);
        } else {
            this.projectGroups = moveProjectInGroupInState(this.projectGroups, this.projects, groupId, project.id, direction, this.viewPrefs);
        }

        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        this.setProjectFeedback(`${project.name || "프로젝트"} 행을 ${action} 이동했습니다.`, "success");
        await this.service.render();

        if (groupId === UNGROUPED_PROJECT_GROUP_ID) {
            this.projects.forEach(item => this.queueProjectSave(item));
        }
    }

    public isProjectCardDragActive() {
        return !!(this.projectCardDragState && this.projectCardDragState.projectId);
    }

    public isProjectCardDragging(project: any) {
        return !!(project && this.projectCardDragState && this.projectCardDragState.projectId === project.id);
    }

    public isProjectCardDropTarget(project: any, position: string) {
        const state = this.projectCardDragState;
        return !!(project && state && state.targetProjectId === project.id && state.dropPosition === position);
    }

    public getProjectCardDragAriaLabel(project: any) {
        const name = project && project.name ? project.name : "프로젝트";
        return `${name} 카드 드래그 정렬`;
    }

    public startProjectCardDrag(project: any, event: DragEvent) {
        if (!project || !project.id || this.shouldIgnoreProjectCardDrag(event)) {
            if (event) event.preventDefault();
            return;
        }

        const group = this.getProjectColumnOrderGroup(project);
        if (!group) {
            if (event) event.preventDefault();
            return;
        }

        this.projectCardDragState = {
            projectId: project.id,
            groupId: group.id,
            targetProjectId: "",
            dropPosition: "after"
        };

        if (event && event.dataTransfer) {
            event.dataTransfer.effectAllowed = "move";
            event.dataTransfer.setData("text/plain", project.id);
        }
    }

    public handleProjectCardDragOver(project: any, event: DragEvent) {
        if (!project || !project.id || !this.isProjectCardDragActive() || this.isProjectCardDragging(project)) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
        }

        this.projectCardDragState = {
            ...this.projectCardDragState,
            targetProjectId: project.id,
            dropPosition: this.getProjectCardDropPosition(event)
        };
    }

    public handleProjectCardDragLeave(project: any, event: DragEvent) {
        const state = this.projectCardDragState;
        if (!project || !state || state.targetProjectId !== project.id) return;
        const currentTarget = event && event.currentTarget ? event.currentTarget as HTMLElement : null;
        const relatedTarget = event ? (event as any).relatedTarget as Node : null;
        if (currentTarget && relatedTarget && currentTarget.contains(relatedTarget)) return;
        this.projectCardDragState = {
            ...state,
            targetProjectId: "",
            dropPosition: "after"
        };
    }

    public handleProjectCardListDragOver(event: DragEvent) {
        if (!this.isProjectCardDragActive() || this.eventTargetWithinProjectCard(event)) return;
        if (event) {
            event.preventDefault();
            if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
        }
        this.projectCardDragState = {
            ...this.projectCardDragState,
            targetProjectId: "",
            dropPosition: "after"
        };
    }

    public async dropProjectCard(project: any, event: DragEvent) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const state = this.projectCardDragState;
        const sourceProject = state ? this.findProjectById(state.projectId) : null;
        if (!sourceProject || !project || !project.id || sourceProject.id === project.id) {
            this.projectCardDragState = null;
            await this.service.render();
            return;
        }

        const sourceGroup = this.getProjectColumnOrderGroup(sourceProject);
        const targetGroup = this.getProjectColumnOrderGroup(project);
        if (!sourceGroup || !targetGroup) {
            this.projectCardDragState = null;
            await this.service.render();
            return;
        }

        if (String(sourceGroup.id || "") !== String(targetGroup.id || "")) {
            this.projectCardDragState = null;
            this.setProjectFeedback("카드 드래그 정렬은 같은 그룹 안에서만 가능합니다. 그룹 이동은 그룹 배정을 변경해 주세요.", "warning");
            await this.service.render();
            return;
        }

        const groupProjects = this.getGroupOrderProjects(targetGroup);
        const targetIndex = groupProjects.findIndex((item: any) => item && item.id === project.id);
        const dropPosition = state.dropPosition || this.getProjectCardDropPosition(event);
        const rawInsertionIndex = targetIndex + (dropPosition === "after" ? 1 : 0);
        const insertionIndex = this.resolveProjectCardInsertionIndex(groupProjects, sourceProject, rawInsertionIndex);
        const positionLabel = dropPosition === "after" ? "뒤" : "앞";
        await this.applyProjectCardReorder(sourceProject, targetGroup, insertionIndex, `${project.name || "프로젝트"} ${positionLabel}`);
    }

    public async dropProjectCardAtListEnd(event: DragEvent) {
        if (!this.isProjectCardDragActive() || this.eventTargetWithinProjectCard(event)) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const state = this.projectCardDragState;
        const sourceProject = state ? this.findProjectById(state.projectId) : null;
        const sourceGroup = sourceProject ? this.getProjectColumnOrderGroup(sourceProject) : null;
        if (!sourceProject || !sourceGroup) {
            this.projectCardDragState = null;
            await this.service.render();
            return;
        }

        const groupProjects = this.getGroupOrderProjects(sourceGroup);
        const insertionIndex = this.resolveProjectCardInsertionIndex(groupProjects, sourceProject, groupProjects.length);
        await this.applyProjectCardReorder(sourceProject, sourceGroup, insertionIndex, "목록 끝");
    }

    public endProjectCardDrag() {
        this.projectCardDragState = null;
    }

    public shouldIgnoreProjectCardDrag(event: DragEvent) {
        const target = event && event.target ? event.target as HTMLElement : null;
        if (!target || typeof target.closest !== "function") return false;
        if (target.closest(".project-drag-handle")) return false;
        return !!target.closest("input, textarea, select, option, button, a, [contenteditable='true']");
    }

    public eventTargetWithinProjectCard(event: DragEvent) {
        const target = event && event.target ? event.target as HTMLElement : null;
        return !!(target && typeof target.closest === "function" && target.closest(".project-chip"));
    }

    public getProjectCardDropPosition(event: DragEvent) {
        const target = event && event.currentTarget ? event.currentTarget as HTMLElement : null;
        if (!target || typeof target.getBoundingClientRect !== "function") return "after";
        const rect = target.getBoundingClientRect();
        const useHorizontalMidpoint = rect.width >= rect.height;
        const offset = useHorizontalMidpoint ? event.clientX - rect.left : event.clientY - rect.top;
        const midpoint = useHorizontalMidpoint ? rect.width / 2 : rect.height / 2;
        return offset > midpoint ? "after" : "before";
    }

    public resolveProjectCardInsertionIndex(projects: any[], sourceProject: any, rawInsertionIndex: number) {
        const currentIndex = Array.isArray(projects)
            ? projects.findIndex((item: any) => item && sourceProject && item.id === sourceProject.id)
            : -1;
        if (currentIndex < 0) return -1;
        const projectCount = Array.isArray(projects) ? projects.length : 0;
        const numericIndex = Number(rawInsertionIndex);
        let insertionIndex = Number.isFinite(numericIndex)
            ? Math.max(0, Math.min(projectCount, Math.floor(numericIndex)))
            : currentIndex;
        if (currentIndex < insertionIndex) insertionIndex -= 1;
        return insertionIndex;
    }

    public async applyProjectCardReorder(project: any, group: any, insertionIndex: number, targetLabel: string) {
        if (!project || !project.id || !group || insertionIndex < 0) {
            this.projectCardDragState = null;
            await this.service.render();
            return;
        }

        const groupProjects = this.getGroupOrderProjects(group);
        const currentIndex = groupProjects.findIndex((item: any) => item && item.id === project.id);
        if (currentIndex < 0 || currentIndex === insertionIndex) {
            this.projectCardDragState = null;
            await this.service.render();
            return;
        }

        const groupId = String(group.id || "");
        this.recordScheduleHistory(`${project.name || "프로젝트"} 카드 드래그 정렬`);
        if (groupId === UNGROUPED_PROJECT_GROUP_ID) {
            this.projects = moveUngroupedProjectInProjectListToIndex(this.projects, this.projectGroups, project.id, insertionIndex);
        } else {
            this.projectGroups = moveProjectInGroupToIndexInState(this.projectGroups, this.projects, groupId, project.id, insertionIndex, this.viewPrefs);
        }

        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        this.projectCardDragState = null;
        this.setProjectFeedback(`${project.name || "프로젝트"} 카드를 ${targetLabel}으로 이동했습니다.`, "success");
        await this.service.render();

        if (groupId === UNGROUPED_PROJECT_GROUP_ID) {
            this.projects.forEach(item => this.queueProjectSave(item));
        }
    }

    public async addPastDays() {
        await this.extendRows("past");
    }

    public async addFutureDays() {
        await this.extendRows("future");
    }

    public async extendRows(direction: string) {
        if (this.rows.length === 0) {
            this.recordScheduleHistory("일정 기간 확장");
            this.rows = this.defaultRows(this.projects);
            await this.saveSheet();
            return;
        }

        this.recordScheduleHistory(direction === "past" ? "앞 30일 추가" : "뒤 30일 추가");
        const sheet = this.normalizeSheet(this.projects, this.rows);
        this.projects = sheet.projects;
        this.rows = sheet.rows;

        const seenDates = this.createDateSet(this.rows);
        const additions: any[] = [];

        if (direction === "past") {
            const first = this.parseDate(this.rows[0].date);
            for (let offset = this.extensionDays; offset >= 1; offset--) {
                const date = this.addDays(first, -offset);
                const dateKey = this.formatDate(date);
                if (!seenDates[dateKey]) {
                    additions.push(this.buildRow(date, this.projects));
                    seenDates[dateKey] = true;
                }
            }
            this.rows = [...additions, ...this.rows];
        } else {
            const last = this.parseDate(this.rows[this.rows.length - 1].date);
            for (let offset = 1; offset <= this.extensionDays; offset++) {
                const date = this.addDays(last, offset);
                const dateKey = this.formatDate(date);
                if (!seenDates[dateKey]) {
                    additions.push(this.buildRow(date, this.projects));
                    seenDates[dateKey] = true;
                }
            }
            this.rows = [...this.rows, ...additions];
        }

        await this.saveSheet();
    }

    public async resetSheet() {
        if (!window.confirm("일정표를 초기 상태로 되돌릴까요?")) return;
        this.recordScheduleHistory("일정표 초기화");
        this.clearSelectedCellState();
        this.projects = this.defaultProjects();
        this.rows = this.defaultRows(this.projects);
        await this.saveSheet();
    }

    public async moveToToday() {
        await this.navigateCalendar("today");
    }

    public async moveToCurrentWeek() {
        await this.navigateCalendar("week");
    }

    public async scrollToday() {
        await this.moveToToday();
    }

    public scheduleInitialTodayScroll() {
        if (!this.authAllowed) return;
        const today = this.todayKey();
        if (!this.rows.some(row => row && row.date === today)) return;
        setTimeout(() => {
            this.scrollToCalendarDate(today, "start", INITIAL_TODAY_LEADING_ROW_COUNT);
        }, 0);
    }

    public async navigateCalendar(mode: string) {
        const navigationMode = mode === "week" ? "week" : "today";
        const target = resolveCalendarMoveTarget(this.rows, this.visibleRows, this.todayKey(), navigationMode);
        this.scheduleFocusDateKey = navigationMode === "today" ? target.dateKey : "";
        this.scheduleFocusWeekStartKey = target.weekStartKey;
        this.scheduleFocusWeekEndKey = target.weekEndKey;
        this.scheduleFocusMode = navigationMode;
        this.scheduleNavigationStatus = target.found ? (target.fallback ? "warning" : "success") : "error";
        this.scheduleNavigationMessage = this.createCalendarNavigationMessage(target);

        await this.service.render();
        setTimeout(() => {
            this.scrollToCalendarDate(target.scrollDateKey);
        }, 0);
    }

    public createCalendarNavigationMessage(target: any) {
        const dateLabel = this.formatNavigationDateLabel(target.dateKey);
        const weekLabel = this.formatNavigationWeekLabel(target.weekStartKey, target.weekEndKey);
        const scrollDateLabel = this.formatNavigationDateLabel(target.scrollDateKey);

        if (target.mode === "week") {
            if (target.reason === "missing-week") return `이번 주 ${weekLabel}가 일정표 범위에 없습니다. 앞/뒤 30일로 기간을 확장해 주세요.`;
            if (target.reason === "hidden-week") return `이번 주 ${weekLabel}가 현재 보기 옵션 또는 필터에서 모두 숨겨져 있습니다.`;
            return `이번 주 ${weekLabel}를 강조하고 ${scrollDateLabel} 위치로 이동했습니다.`;
        }

        if (target.reason === "missing-date") return `오늘 ${dateLabel}이 일정표 범위에 없습니다. 앞/뒤 30일로 기간을 확장해 주세요.`;
        if (target.reason === "hidden-date") return `오늘 ${dateLabel}이 현재 보기 옵션 또는 필터에서 숨겨져 있습니다.`;
        if (target.reason === "hidden-date-visible-week") return `오늘 ${dateLabel}이 숨겨져 이번 주 표시일 ${scrollDateLabel} 위치로 이동했습니다.`;
        return `오늘 ${dateLabel} 위치로 이동했습니다.`;
    }

    public scrollToCalendarDate(dateKey: string, block: ScrollLogicalPosition = "center", leadingRowCount: number = 0) {
        if (!dateKey) return;
        const selector = `[data-schedule-date="${dateKey}"]`;
        const candidates = Array.prototype.slice.call(document.querySelectorAll(selector)) as HTMLElement[];
        const target = candidates.find(element => this.isVisibleElement(element)) || candidates[0];
        if (!target) return;

        const tableWrap = target.closest(".schedule-table-wrap") as HTMLElement;
        if (tableWrap && block === "start") {
            const header = tableWrap.querySelector("thead") as HTMLElement;
            const wrapRect = tableWrap.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            const headerHeight = header ? header.getBoundingClientRect().height : 0;
            const rowElements = Array.prototype.slice.call(tableWrap.querySelectorAll("tbody tr[data-schedule-date]")) as HTMLElement[];
            const targetIndex = rowElements.indexOf(target);
            const firstLeadingIndex = targetIndex >= 0 ? Math.max(0, targetIndex - Math.max(0, leadingRowCount)) : targetIndex;
            const leadingOffset = targetIndex > 0
                ? rowElements.slice(firstLeadingIndex, targetIndex).reduce((total, row) => total + row.getBoundingClientRect().height, 0)
                : 0;
            const top = Math.max(0, tableWrap.scrollTop + targetRect.top - wrapRect.top - headerHeight - leadingOffset);
            tableWrap.scrollTo({ top, left: 0, behavior: "auto" });
            return;
        }

        if (tableWrap) tableWrap.scrollLeft = 0;
        target.scrollIntoView({ block, inline: "nearest" });
    }

    public isVisibleElement(element: HTMLElement) {
        return !!element && !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    public async activateNote(row: any) {
        await this.activateEditKey(`${row.id}-note`);
    }

    public async activateMobileNote(row: any, event: any = null) {
        if (!row) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.resetCellInlineDraft();
        this.activeEditKey = `${row.id}-note`;
        await this.service.render();
        setTimeout(() => this.focusMobileNoteEditor(row), 0);
    }

    public isMobileNoteEditing(row: any) {
        return !!row && this.activeEditKey === `${row.id}-note`;
    }

    public getMobileNoteEditLabel(row: any) {
        if (this.isMobileNoteEditing(row)) return "개인 메모 편집 중";
        return String(row && row.note ? row.note : "").trim().length > 0 ? "개인 메모 수정" : "개인 메모 추가";
    }

    public focusMobileNoteEditor(row: any) {
        if (!row) return;
        const key = `${row.id}-note`;
        const editors = document.querySelectorAll("[data-mobile-note-edit-key]");
        for (let index = 0; index < editors.length; index++) {
            const editor = editors[index] as HTMLTextAreaElement;
            if (editor.getAttribute("data-mobile-note-edit-key") === key) {
                editor.focus();
                if (typeof editor.setSelectionRange === "function") {
                    const cursor = String(row.note || editor.value || "").length;
                    try {
                        editor.setSelectionRange(cursor, cursor);
                    } catch (e) {
                        // Selection restore is best-effort for detached mobile editors.
                    }
                }
                return;
            }
        }
    }

    public async closeMobileNoteEditor(row: any) {
        if (!this.isMobileNoteEditing(row)) return;
        this.activeEditKey = "";
        await this.service.render();
    }

    public async handleMobileNoteKeydown(row: any, event: KeyboardEvent) {
        if (!row || !event) return;
        if (String(event.key || "") === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            await this.closeMobileNoteEditor(row);
        }
    }

    public handleNoteChange(row: any, value: any) {
        const nextValue = value === undefined || value === null ? "" : String(value);
        if (String(row.note || "") === nextValue) return;
        this.recordScheduleHistory(`${row.dateLabel || row.date || "날짜"} 개인 입력`, `${row.id}-note`);
        row.note = nextValue;
        this.queueSaveSheet();
        this.queueEntrySave(this.makeDayEntryPayload(row));
    }

    public async activateCell(row: any, project: any, event: any = null) {
        if (this.shouldSuppressActivationAfterRangeDrag(row, project, event)) return;
        if (this.shouldExtendCellSelection(event)) {
            this.selectCellRange(row, project);
            await this.service.render();
            this.requestActiveCellScrollIntoView();
            return;
        }
        if (this.shouldToggleCellSelection(event)) {
            this.toggleCellSelection(row, project);
            await this.service.render();
            return;
        }
        await this.openCellInlineEditor(row, project, event);
    }

    public async openCellInlineEditor(row: any, project: any, event: any = null) {
        await this.openCellInlineEditorWithOptions(row, project, event);
    }

    public async openCellInlineEditorWithOptions(row: any, project: any, event: any = null, options: any = {}) {
        if (!row || !project) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.selectedCell || (this.scheduleDetailExpanded && !this.milestonePanelOpen)) this.clearSelectedCellState();
        this.setActiveCell(row, project);
        this.prepareCellInlineDraft(row, project, options);
        this.setClipboardFeedback(`${row.dateLabel || row.date || "날짜"} · ${project.name || "프로젝트"} 셀 편집`, "success");
        await this.activateEditKey(this.getCellKey(row, project));
    }

    public async activateMobileCell(row: any, project: any, event: any = null) {
        if (!row || !project) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.selectedCell || (this.scheduleDetailExpanded && !this.milestonePanelOpen)) this.clearSelectedCellState();
        this.setActiveCell(row, project);
        const key = this.getCellKey(row, project);
        this.prepareCellInlineDraft(row, project, { source: "mobile-card" });
        this.activeEditKey = key;
        this.setClipboardFeedback(`${row.dateLabel || row.date || "날짜"} · ${project.name || "프로젝트"} 모바일 메모 편집`, "success");
        await this.service.render();
        setTimeout(() => this.focusMobileInlineEditor(key), 0);
    }

    public async openMobileCellDetail(row: any, project: any, event: any = null) {
        await this.openCellDetail(row, project, event);
    }

    public isMobileCellInlineEditing(row: any, project: any) {
        if (!row || !project) return false;
        const key = this.getCellKey(row, project);
        return this.activeEditKey === key && this.inlineCellEditKey === key;
    }

    public focusMobileInlineEditor(key: string) {
        const editors = document.querySelectorAll("[data-mobile-edit-key]");
        for (let index = 0; index < editors.length; index++) {
            const editor = editors[index] as HTMLTextAreaElement;
            if (editor.getAttribute("data-mobile-edit-key") === key) {
                editor.focus();
                if (typeof editor.setSelectionRange === "function") {
                    const cursor = String(this.inlineCellDraft || editor.value || "").length;
                    try {
                        editor.setSelectionRange(cursor, cursor);
                    } catch (e) {
                        // Selection restore is best-effort for detached mobile editors.
                    }
                }
                return;
            }
        }
    }

    public focusCellInline(row: any, project: any) {
        if (!row || !project) return;
        if (this.selectedCell || (this.scheduleDetailExpanded && !this.milestonePanelOpen)) this.clearSelectedCellState();
        this.setActiveCell(row, project);
        const key = this.getCellKey(row, project);
        if (this.inlineCellEditKey !== key) this.prepareCellInlineDraft(row, project);
        this.activeEditKey = key;
    }

    public async openCellDetail(row: any, project: any, event: any = null) {
        if (!row || !project) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.inlineCellEditKey) await this.commitActiveCellInlineDraft({ focusCell: false });
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        this.setActiveCell(row, project);
        this.selectCell(row, project);
        this.scheduleDetailExpanded = true;
        this.setClipboardFeedback(`${row.dateLabel || row.date || "날짜"} · ${project.name || "프로젝트"} 상세 일정`, "success");
        await this.service.render();
    }

    public getPrimarySelectedCellForEdit() {
        if (this.selectedCell) {
            const row = this.findRowById(this.selectedCell.rowId);
            const project = this.findProjectById(this.selectedCell.projectId);
            if (row && project) return { row, project };
        }
        const selected = this.getSelectedCellsInVisibleOrder();
        return selected.length > 0 ? { row: selected[0].row, project: selected[0].project } : null;
    }

    public async editSelectedCellInline() {
        const target = this.getPrimarySelectedCellForEdit();
        if (!target) {
            this.setClipboardFeedback("편집할 셀을 선택해 주세요.", "warning");
            await this.service.render();
            return;
        }
        await this.editCellInline(target.row, target.project);
    }

    public async editCellInline(row: any, project: any, event: any = null) {
        await this.openCellInlineEditor(row, project, event);
    }

    public async activateEditKey(key: string) {
        this.activeEditKey = key;
        await this.service.render();
        setTimeout(() => this.focusActiveEditor(key), 0);
    }

    public selectCell(row: any, project: any) {
        this.selectedCell = this.createSelectedCell(row, project);
        this.selectedCellDraft = this.getCellValue(row, project.id);
        this.syncSelectedCellMetaDraft(row, project.id);
        this.selectedCellMessage = "";
        this.setSingleCellSelection(row, project);
        this.setActiveCell(row, project, { select: false });
    }

    public createSelectedCell(row: any, project: any) {
        const meta = this.getCellMeta(row, project.id);
        return {
            key: this.getCellKey(row, project),
            rowId: row.id,
            date: row.date,
            projectId: project.id,
            projectRowId: project.id,
            dateLabel: row.dateLabel,
            weekday: row.weekday,
            projectName: project.name,
            projectPm: project.pm,
            projectOwner: project.owner,
            projectColor: project.color,
            projectGroupName: this.getProjectAssignedGroupName(project),
            status: meta.status,
            type: meta.type
        };
    }

    public get hasSelectedCellSizeTarget() {
        return !!this.selectedCell && !!this.selectedCell.date && !!this.selectedCell.projectId;
    }

    public get selectedCellProjectColumnWidthPx() {
        return this.hasSelectedCellSizeTarget ? resolveProjectColumnWidthPx(this.viewPrefs, this.selectedCell.projectId) : this.projectColumnWidthDefaultPx;
    }

    public get selectedCellDateRowHeightPx() {
        return this.hasSelectedCellSizeTarget ? getRowHeightForDate(this.viewPrefs, this.selectedCell.date) : this.rowHeightDefaultPx;
    }

    public get selectedCellProjectColumnWidthLabel() {
        return this.hasSelectedCellCustomProjectColumnWidth ? "사용자 지정 너비" : "기본 너비";
    }

    public get selectedCellDateRowHeightLabel() {
        return this.hasSelectedCellCustomDateRowHeight ? "사용자 지정 높이" : "기본 높이";
    }

    public get hasSelectedCellCustomProjectColumnWidth() {
        if (!this.hasSelectedCellSizeTarget) return false;
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return Object.prototype.hasOwnProperty.call(prefs.projectColumnWidths, this.selectedCell.projectId);
    }

    public get hasSelectedCellCustomDateRowHeight() {
        if (!this.hasSelectedCellSizeTarget) return false;
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return Object.prototype.hasOwnProperty.call(prefs.rowHeightByDate, this.selectedCell.date);
    }

    public async setSelectedCellProjectColumnWidthPx(widthPx: any) {
        if (!this.hasSelectedCellSizeTarget) return;
        const project = this.findProjectById(this.selectedCell.projectId) || { id: this.selectedCell.projectId, name: this.selectedCell.projectName };
        if (this.persistProjectColumnWidthOverride(project, widthPx, `${this.selectedCell.projectName || "프로젝트"} 컬럼 너비 변경`)) {
            this.selectedCellMessage = "선택 셀의 프로젝트 컬럼 너비를 저장했습니다.";
            await this.service.render();
        }
    }

    public async setSelectedCellDateRowHeightPx(heightPx: any) {
        if (!this.hasSelectedCellSizeTarget) return;
        if (this.persistDateRowHeightOverride(this.selectedCell.date, heightPx, `${this.selectedCell.dateLabel || this.selectedCell.date} 날짜 행 높이 변경`, `date-row-height-${this.selectedCell.date}`)) {
            this.selectedCellMessage = "선택 셀의 날짜 행 높이를 저장했습니다.";
            await this.service.render();
        }
    }

    public async resetSelectedCellProjectColumnWidth() {
        if (!this.hasSelectedCellSizeTarget || !this.hasSelectedCellCustomProjectColumnWidth) return;

        const project = this.findProjectById(this.selectedCell.projectId) || { id: this.selectedCell.projectId, name: this.selectedCell.projectName };
        await this.resetProjectColumnWidth(project);
        this.selectedCellMessage = "선택 셀의 프로젝트 컬럼 너비를 기본값으로 돌렸습니다.";
    }

    public async resetSelectedCellDateRowHeight() {
        if (!this.hasSelectedCellSizeTarget || !this.hasSelectedCellCustomDateRowHeight) return;

        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = clearRowHeightForDate(currentPrefs, this.selectedCell.date);
        this.recordScheduleHistory(`${this.selectedCell.dateLabel || this.selectedCell.date} 날짜 행 높이 기본값`, `date-row-height-${this.selectedCell.date}`);
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        this.selectedCellMessage = "선택 셀의 날짜 행 높이를 기본값으로 돌렸습니다.";
        await this.service.render();
    }

    public getCellKey(row: any, project: any) {
        return `${row.id}-${project.id}`;
    }

    public prepareCellInlineDraft(row: any, project: any, options: any = {}) {
        if (!row || !project) return;
        const key = this.getCellKey(row, project);
        const currentValue = this.getCellValue(row, project.id);
        const replacement = options && options.replace === true
            ? String(options.initialValue === undefined || options.initialValue === null ? "" : options.initialValue)
            : currentValue;
        this.inlineCellEditKey = key;
        this.inlineCellOriginalValue = currentValue;
        this.inlineCellDraft = replacement;
        this.inlineCellStartedByTyping = !!(options && options.startedByTyping === true);
        this.inlineCellSuppressBlurCommit = false;
    }

    public resetCellInlineDraft() {
        this.inlineCellEditKey = "";
        this.inlineCellDraft = "";
        this.inlineCellOriginalValue = "";
        this.inlineCellStartedByTyping = false;
    }

    public getCellInlineDraft(row: any, project: any) {
        if (!row || !project) return "";
        const key = this.getCellKey(row, project);
        return this.inlineCellEditKey === key ? this.inlineCellDraft : this.getCellValue(row, project.id);
    }

    public setCellInlineDraft(row: any, project: any, value: any) {
        if (!row || !project) return;
        const key = this.getCellKey(row, project);
        if (this.inlineCellEditKey !== key) this.prepareCellInlineDraft(row, project);
        this.inlineCellDraft = value === undefined || value === null ? "" : String(value);
        this.inlineCellStartedByTyping = false;
    }

    public async handleCellInlineEditorKeydown(row: any, project: any, event: KeyboardEvent) {
        if (!row || !project || !event) return;
        const key = String(event.key || "");
        if (key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            await this.cancelCellInlineDraft(row, project);
            return;
        }
        if (key === "Enter" && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            event.stopPropagation();
            this.insertCellInlineDraftText(row, project, "\n", event.target);
            return;
        }
        if (key === "Enter" && !event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            event.stopPropagation();
            await this.commitCellInlineDraft(row, project, {
                rowDelta: event.shiftKey ? -1 : 1,
                columnDelta: 0,
                wrapColumns: false
            });
            return;
        }
        if (key === "Tab") {
            event.preventDefault();
            event.stopPropagation();
            await this.commitCellInlineDraft(row, project, {
                rowDelta: 0,
                columnDelta: event.shiftKey ? -1 : 1,
                wrapColumns: true
            });
        }
    }

    public async handleMobileCellInlineEditorKeydown(row: any, project: any, event: KeyboardEvent) {
        if (!row || !project || !event) return;
        const key = String(event.key || "");
        if (key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            await this.cancelMobileCellInlineDraft(row, project);
            return;
        }
        if (key === "Enter" && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            event.stopPropagation();
            this.insertCellInlineDraftText(row, project, "\n", event.target);
            return;
        }
        if (key === "Enter" && !event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            event.stopPropagation();
            await this.commitMobileCellInlineDraft(row, project);
        }
    }

    public insertCellInlineDraftText(row: any, project: any, text: string, target: any = null) {
        if (!row || !project) return;
        const key = this.getCellKey(row, project);
        if (this.inlineCellEditKey !== key) this.prepareCellInlineDraft(row, project);
        const editor = target as HTMLTextAreaElement;
        const currentValue = this.inlineCellDraft || "";
        const start = editor && typeof editor.selectionStart === "number" ? editor.selectionStart : currentValue.length;
        const end = editor && typeof editor.selectionEnd === "number" ? editor.selectionEnd : start;
        const nextValue = currentValue.slice(0, start) + text + currentValue.slice(end);
        const nextCursor = start + text.length;
        this.inlineCellDraft = nextValue;
        this.inlineCellStartedByTyping = false;
        if (editor) {
            editor.value = nextValue;
            setTimeout(() => {
                try {
                    editor.selectionStart = nextCursor;
                    editor.selectionEnd = nextCursor;
                } catch (e) {
                    // Selection restore is best-effort for detached editors.
                }
            }, 0);
        }
    }

    public async commitCellInlineDraft(row: any, project: any, options: any = {}) {
        if (!row || !project) return false;
        const key = this.getCellKey(row, project);
        if (this.inlineCellEditKey !== key) return false;
        const nextValue = this.inlineCellDraft === undefined || this.inlineCellDraft === null ? "" : String(this.inlineCellDraft);
        const navigationGrid = options && (options.rowDelta || options.columnDelta)
            ? this.getActiveCellNavigationGrid()
            : null;
        const target = navigationGrid
            ? this.resolveActiveCellNavigationTarget(Number(options.rowDelta || 0), Number(options.columnDelta || 0), options.wrapColumns === true, navigationGrid)
            : null;

        this.handleCellInlineChange(row, project, nextValue);
        this.resetCellInlineDraft();
        this.activeEditKey = "";

        if (target && target.row && target.project) {
            const previousActiveCell = this.activeCell ? { ...this.activeCell } : null;
            this.setActiveCell(target.row, target.project, { scroll: false, grid: navigationGrid });
            this.syncActiveCellNavigationDom(previousActiveCell, this.activeCell);
            this.focusActiveCellElement(this.activeCell ? this.activeCell.key : "", { immediate: true, scroll: false });
            this.scrollActiveCellIntoView();
            this.requestCellWorkflowRender();
            return true;
        }

        await this.service.render();
        if (!options || options.focusCell !== false) this.focusActiveCellElement(key);
        return true;
    }

    public async commitCellInlineDraftOnBlur(row: any, project: any) {
        if (this.inlineCellSuppressBlurCommit) return;
        await this.commitCellInlineDraft(row, project, { focusCell: false });
    }

    public async commitMobileCellInlineDraft(row: any, project: any) {
        await this.commitCellInlineDraft(row, project, { focusCell: false });
    }

    public async cancelCellInlineDraft(row: any, project: any) {
        if (!row || !project) return;
        const key = this.getCellKey(row, project);
        this.inlineCellSuppressBlurCommit = true;
        this.resetCellInlineDraft();
        this.activeEditKey = "";
        this.setActiveCell(row, project);
        this.setClipboardFeedback("셀 편집을 취소했습니다.", "warning");
        await this.service.render();
        this.focusActiveCellElement(key);
        setTimeout(() => {
            this.inlineCellSuppressBlurCommit = false;
        }, 0);
    }

    public async cancelMobileCellInlineDraft(row: any, project: any) {
        if (!row || !project) return;
        this.inlineCellSuppressBlurCommit = true;
        this.resetCellInlineDraft();
        this.activeEditKey = "";
        this.setActiveCell(row, project);
        this.setClipboardFeedback("모바일 메모 편집을 취소했습니다.", "warning");
        await this.service.render();
        setTimeout(() => {
            this.inlineCellSuppressBlurCommit = false;
        }, 0);
    }

    public async commitActiveCellInlineDraft(options: any = {}) {
        if (!this.inlineCellEditKey) return false;
        let row: any = null;
        let project: any = null;
        for (let rowIndex = 0; rowIndex < this.rows.length; rowIndex++) {
            for (let projectIndex = 0; projectIndex < this.projects.length; projectIndex++) {
                if (this.getCellKey(this.rows[rowIndex], this.projects[projectIndex]) === this.inlineCellEditKey) {
                    row = this.rows[rowIndex];
                    project = this.projects[projectIndex];
                    break;
                }
            }
            if (row && project) break;
        }
        if (!row || !project) {
            this.resetCellInlineDraft();
            this.activeEditKey = "";
            return false;
        }
        return await this.commitCellInlineDraft(row, project, options);
    }

    public isSelectedCell(row: any, project: any) {
        const key = this.getCellKey(row, project);
        return this.selectedCellKeys.indexOf(key) >= 0 || (!!this.selectedCell && this.selectedCell.key === key);
    }

    public handleCellInlineChange(row: any, project: any, value: any) {
        if (!row.cells) row.cells = {};
        const nextValue = value === undefined || value === null ? "" : String(value);
        if (this.getCellValue(row, project.id) === nextValue) return;
        this.recordScheduleHistory(`${project.name || "프로젝트"} 셀 입력`, this.getCellKey(row, project));
        row.cells[project.id] = nextValue;
        if (this.isSelectedCell(row, project)) {
            this.selectedCellDraft = this.getCellValue(row, project.id);
            this.selectedCellMessage = "";
        }
        this.queueSaveSheet();
        this.queueEntrySave(this.makeCellEntryPayload(row, project));
    }

    public async saveSelectedCell() {
        if (!this.selectedCell) return;

        const row = this.findRowById(this.selectedCell.rowId);
        const project = this.findProjectById(this.selectedCell.projectId);
        if (!row || !project) {
            this.clearSelectedCellState();
            await this.service.render();
            return;
        }

        if (!row.cells) row.cells = {};
        const nextValue = this.selectedCellDraft === undefined || this.selectedCellDraft === null ? "" : String(this.selectedCellDraft);
        const currentMeta = this.getCellMeta(row, project.id);
        const nextStatus = this.normalizeCellStatus(this.selectedCellStatus);
        const nextType = this.normalizeCellType(this.selectedCellType);
        const nextTime = this.normalizeCellTime(this.selectedCellTime);
        const dependencyDraft = this.createSelectedCellDependenciesFromDraft(row, project);
        if (!dependencyDraft.valid) {
            this.selectedCellMessage = dependencyDraft.message;
            await this.service.render();
            return;
        }
        const nextDependencies = dependencyDraft.dependencies;
        const changed = this.getCellValue(row, project.id) !== nextValue
            || currentMeta.status !== nextStatus
            || currentMeta.type !== nextType
            || currentMeta.time !== nextTime
            || this.createCellDependenciesSignature(currentMeta.dependencies) !== this.createCellDependenciesSignature(nextDependencies);
        if (changed) {
            this.recordScheduleHistory(`${project.name || "프로젝트"} 상세 편집`);
        }
        row.cells[project.id] = nextValue;
        this.setCellMeta(row, project.id, nextStatus, nextType, nextDependencies, nextTime);
        this.activeEditKey = this.getCellKey(row, project);
        const entryPayload = this.makeCellEntryPayload(row, project);
        await this.saveSheet();
        void this.saveEntryPayloadToServer(entryPayload);

        const savedRow = this.findRowById(row.id);
        const savedProject = this.findProjectById(project.id);
        if (savedRow && savedProject) {
            this.selectedCell = this.createSelectedCell(savedRow, savedProject);
            this.selectedCellDraft = this.getCellValue(savedRow, savedProject.id);
            this.syncSelectedCellMetaDraft(savedRow, savedProject.id);
        }
        const hasSavedContent = savedRow && savedProject ? this.hasCellContent(savedRow, savedProject.id) : this.selectedCellDraft.trim().length > 0;
        this.selectedCellMessage = hasSavedContent
            ? "상세 편집 내용을 저장했습니다."
            : "셀 내용을 비웠습니다.";
        await this.service.render();
    }

    public async clearSelectedCellDraft() {
        this.selectedCellDraft = "";
        this.selectedCellMessage = "";
        await this.service.render();
    }

    public async clearSelectedCellTime() {
        this.selectedCellTime = "";
        this.selectedCellMessage = "";
        await this.service.render();
    }

    public async toggleSelectedCellDependencyEditor() {
        this.selectedCellDependencyEditorOpen = !this.selectedCellDependencyEditorOpen;
        this.selectedCellMessage = "";
        await this.service.render();
    }

    public async clearSelectedCellDependencies() {
        this.selectedCellPredecessorDate = "";
        this.selectedCellPredecessorProjectId = "";
        this.selectedCellSuccessorDate = "";
        this.selectedCellSuccessorProjectId = "";
        this.selectedCellMessage = "";
        await this.service.render();
    }

    public async closeSelectedCell() {
        this.scheduleDetailExpanded = false;
        this.clearSelectedCellState();
        await this.service.render();
    }

    public async openMilestoneEditorForDate(row: any) {
        if (!row || !row.date) return;
        this.prepareMilestoneDraft({
            date: row.date,
            scope: "common",
            projectId: ""
        });
        this.setMilestoneFeedback("공통 마일스톤을 입력하세요.", "");
        await this.service.render();
    }

    public async openMilestoneEditorForCell(row: any, project: any) {
        if (!row || !row.date || !project || !project.id) return;
        this.prepareMilestoneDraft({
            date: row.date,
            scope: "project",
            projectId: project.id
        });
        this.setMilestoneFeedback(`${project.name || "프로젝트"} 마일스톤을 입력하세요.`, "");
        await this.service.render();
    }

    public async editMilestone(milestone: any) {
        if (!milestone || !milestone.id) return;
        this.prepareMilestoneDraft(milestone);
        this.setMilestoneFeedback("마일스톤을 수정 중입니다.", "");
        await this.service.render();
    }

    public async cancelMilestoneEdit() {
        this.resetMilestoneDraft();
        await this.service.render();
    }

    public prepareMilestoneDraft(source: any = {}) {
        const projectId = String(source.projectId || source.project_id || "").trim();
        const scope = source.scope === "project" && this.findProjectById(projectId) ? "project" : "common";
        this.scheduleDetailExpanded = true;
        this.milestonePanelOpen = true;
        this.selectedMilestoneId = String(source.id || "");
        this.milestoneDraftTitle = String(source.title || "");
        this.milestoneDraftDate = this.isValidDate(source.date) ? source.date : this.todayKey();
        this.milestoneDraftScope = scope;
        this.milestoneDraftProjectId = scope === "project" ? projectId : "";
        this.milestoneDraftColor = this.normalizeMilestoneColor(source.color || DEFAULT_MILESTONE_COLOR);
        this.milestoneDraftIcon = this.normalizeMilestoneIcon(source.icon || "flag");
        this.milestoneDraftNote = String(source.note || "");
    }

    public resetMilestoneDraft() {
        this.milestonePanelOpen = false;
        this.selectedMilestoneId = "";
        this.milestoneDraftTitle = "";
        this.milestoneDraftDate = "";
        this.milestoneDraftScope = "common";
        this.milestoneDraftProjectId = "";
        this.milestoneDraftColor = DEFAULT_MILESTONE_COLOR;
        this.milestoneDraftIcon = "flag";
        this.milestoneDraftNote = "";
        this.setMilestoneFeedback("", "");
        if (!this.selectedCell) this.scheduleDetailExpanded = false;
    }

    public setMilestoneFeedback(message: string, status: string = "") {
        this.milestoneMessage = message;
        this.milestoneStatus = status;
    }

    public async selectMilestoneColor(color: string) {
        this.milestoneDraftColor = this.normalizeMilestoneColor(color);
        this.setMilestoneFeedback("", "");
        await this.service.render();
    }

    public async saveMilestone() {
        const milestone = this.createMilestoneFromDraft();
        if (!milestone) {
            await this.service.render();
            return;
        }

        const existing = this.findMilestoneById(milestone.id);
        this.recordScheduleHistory(`${milestone.title || "마일스톤"} 마일스톤 ${existing ? "수정" : "추가"}`);
        const nextMilestones = existing
            ? this.milestones.map(item => item.id === milestone.id ? milestone : item)
            : this.milestones.concat([milestone]);
        this.milestones = normalizeMilestones(nextMilestones, this.projects);
        this.selectedMilestoneId = milestone.id;
        this.milestonePanelOpen = true;
        await this.persistMilestoneState(`${milestone.title} 마일스톤을 저장했습니다.`, "success");
        void this.saveMilestoneToServer(this.findMilestoneById(milestone.id) || milestone);
    }

    public async deleteMilestone(milestone: any) {
        if (!milestone || !milestone.id) return;
        if (typeof window !== "undefined" && !window.confirm(`${milestone.title || "마일스톤"} 마일스톤을 삭제할까요?`)) return;
        this.recordScheduleHistory(`${milestone.title || "마일스톤"} 마일스톤 삭제`);
        this.milestones = normalizeMilestones(this.milestones.filter(item => item.id !== milestone.id), this.projects);
        if (this.selectedMilestoneId === milestone.id) this.resetMilestoneDraft();
        await this.persistMilestoneState(`${milestone.title || "마일스톤"} 마일스톤을 삭제했습니다.`, "warning");
        void this.deleteMilestoneFromServer(milestone);
    }

    public async deleteSelectedMilestone() {
        const milestone = this.findMilestoneById(this.selectedMilestoneId);
        if (milestone) await this.deleteMilestone(milestone);
    }

    public createMilestoneFromDraft() {
        const title = String(this.milestoneDraftTitle || "").trim().replace(/\s+/g, " ");
        if (!title) {
            this.setMilestoneFeedback("마일스톤 제목을 입력해 주세요.", "error");
            return null;
        }
        if (!this.isValidDate(this.milestoneDraftDate)) {
            this.setMilestoneFeedback("마일스톤 날짜를 YYYY-MM-DD로 입력해 주세요.", "error");
            return null;
        }

        const existing = this.findMilestoneById(this.selectedMilestoneId);
        const draftScope = this.normalizeMilestoneScope(this.milestoneDraftScope);
        const projectId = draftScope === "project" ? String(this.milestoneDraftProjectId || "").trim() : "";
        if (draftScope === "project" && !this.findProjectById(projectId)) {
            this.setMilestoneFeedback("프로젝트 마일스톤은 대상 프로젝트를 선택해야 합니다.", "error");
            return null;
        }

        const now = new Date().toISOString();
        return {
            id: existing ? existing.id : this.makeId("ms"),
            title: title.slice(0, 64),
            date: this.milestoneDraftDate,
            scope: draftScope,
            projectId,
            color: this.normalizeMilestoneColor(this.milestoneDraftColor),
            icon: this.normalizeMilestoneIcon(this.milestoneDraftIcon),
            note: String(this.milestoneDraftNote || "").trim().slice(0, 240),
            order: existing ? this.numberOrDefault(existing.order, 0) : this.getNextMilestoneOrder(this.milestoneDraftDate),
            version: existing ? this.numberOrDefault(existing.version, 0) : 0,
            createdAt: existing ? String(existing.createdAt || now) : now,
            updatedAt: now
        };
    }

    public async persistMilestoneState(message: string = "", status: string = "") {
        this.milestones = normalizeMilestones(this.milestones, this.projects);
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups, convenience.savedViews, this.milestones);
        this.markLocalSaved();
        this.refreshMetrics();
        this.resetExportState();
        if (message) this.setMilestoneFeedback(message, status);
        await this.service.render();
    }

    public getNextMilestoneOrder(dateKey: string) {
        return this.milestones.filter(item => item && item.date === dateKey).length;
    }

    public normalizeMilestoneScope(scope: any) {
        const text = String(scope || "").trim();
        return MILESTONE_SCOPE_OPTIONS.indexOf(text) >= 0 ? text : "common";
    }

    public normalizeMilestoneIcon(icon: any) {
        const text = String(icon || "").trim();
        return MILESTONE_ICON_OPTIONS.indexOf(text) >= 0 ? text : "flag";
    }

    public normalizeMilestoneColor(color: any) {
        const text = String(color || "").trim();
        return /^#[0-9A-Fa-f]{6}$/.test(text) ? text : DEFAULT_MILESTONE_COLOR;
    }

    public clearSelectedCellState() {
        this.selectedCell = null;
        this.selectedCellDraft = "";
        this.selectedCellStatus = this.defaultCellStatus;
        this.selectedCellType = this.defaultCellType;
        this.selectedCellTime = "";
        this.selectedCellDependencyEditorOpen = false;
        this.selectedCellPredecessorDate = "";
        this.selectedCellPredecessorProjectId = "";
        this.selectedCellSuccessorDate = "";
        this.selectedCellSuccessorProjectId = "";
        this.selectedCellMessage = "";
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        this.scheduleDetailExpanded = false;
        this.clearCellSelection();
    }

    public findMilestoneById(milestoneId: string) {
        const id = String(milestoneId || "");
        return this.milestones.find(item => item && item.id === id) || null;
    }

    public getMilestonesForDate(dateKey: string) {
        return this.milestones.filter(milestone => milestone && milestone.date === dateKey);
    }

    public getCommonMilestones(row: any) {
        const dateKey = row && row.date ? row.date : "";
        return this.getMilestonesForDate(dateKey).filter(milestone => milestone.scope === "common");
    }

    public getProjectMilestones(row: any, project: any) {
        const dateKey = row && row.date ? row.date : "";
        const projectId = project && project.id ? project.id : "";
        return this.getMilestonesForDate(dateKey).filter(milestone => milestone.scope === "project" && milestone.projectId === projectId);
    }

    public getProjectMilestonesById(projectId: any) {
        const id = String(projectId || "");
        if (!id) return [];
        return this.milestones.filter(milestone => milestone && milestone.scope === "project" && milestone.projectId === id);
    }

    public countProjectMilestones(project: any) {
        return this.getProjectMilestonesById(project && project.id).length;
    }

    public getRowProjectMilestonesForProjectIds(row: any, projectIds: any[] = []) {
        if (!row || !row.date || !Array.isArray(projectIds) || projectIds.length === 0) return [];
        const projectIdSet: any = {};
        projectIds.forEach(projectId => {
            const id = String(projectId || "");
            if (id) projectIdSet[id] = true;
        });
        return this.getMilestonesForDate(row.date)
            .filter(milestone => milestone.scope === "project" && projectIdSet[milestone.projectId] === true);
    }

    public getRowGroupMilestoneCount(row: any, group: any) {
        const projectIds = this.getFilteredGroupProjectIds(group);
        return this.getRowProjectMilestonesForProjectIds(row, projectIds).length;
    }

    public getRowGroupMilestoneCountText(row: any, group: any) {
        return `마일스톤 ${this.getRowGroupMilestoneCount(row, group)}개`;
    }

    public getVisibleMilestonesForRow(row: any, context: any = null) {
        if (!row || !row.date) return [];
        const filterContext = context || this.getVisibleRowFilterContext();
        return this.getMilestonesForDate(row.date).filter(milestone => this.isMilestoneInFilterScope(milestone, filterContext));
    }

    public getVisibleMilestoneCountForRow(row: any, context: any = null) {
        return this.getVisibleMilestonesForRow(row, context).length;
    }

    public isMilestoneInFilterScope(milestone: any, context: any) {
        if (!milestone) return false;
        if ((context.status || context.type) && !context.milestoneOnly) return false;
        const scopedProjectFilter = !!(context.selectedProject || context.favoriteOnly || context.groupId || context.ownerOnly);
        if (!scopedProjectFilter) return true;
        if (milestone.scope === "common") return true;
        const projectIds = Array.isArray(context.projectIds) ? context.projectIds : [];
        return projectIds.indexOf(milestone.projectId) >= 0;
    }

    public milestoneMatchesKeyword(milestone: any, keyword: string) {
        if (!keyword) return true;
        const parts = [
            milestone && milestone.title,
            milestone && milestone.note,
            milestone && milestone.date,
            this.getMilestoneProjectName(milestone),
            this.getMilestoneScopeLabel(milestone)
        ];
        return parts.some(part => this.includesKeyword(part, keyword));
    }

    public getMilestoneProjectName(milestone: any) {
        if (!milestone || milestone.scope !== "project") return "공통";
        const project = this.findProjectById(milestone.projectId);
        return project && project.name ? project.name : "프로젝트";
    }

    public getMilestoneScopeLabel(milestone: any) {
        return milestone && milestone.scope === "project" ? this.getMilestoneProjectName(milestone) : "공통";
    }

    public getMilestoneIconLabel(milestone: any) {
        const icon = milestone && milestone.icon ? milestone.icon : "flag";
        if (icon === "diamond") return "D";
        if (icon === "pin") return "P";
        if (icon === "star") return "S";
        return "F";
    }

    public getMilestoneSummary(milestone: any) {
        if (!milestone) return "";
        const parts = [
            this.getMilestoneScopeLabel(milestone),
            milestone.title,
            milestone.note
        ].filter(part => String(part || "").trim().length > 0);
        return parts.join(" · ");
    }

    public getDateMilestoneSummary(row: any) {
        const count = this.getVisibleMilestoneCountForRow(row);
        return count > 0 ? `마일스톤 ${count}개` : "마일스톤 없음";
    }

    public get milestoneSummaryLabel() {
        const total = this.milestones.length;
        const visible = this.rows.reduce((count, row) => count + this.getVisibleMilestoneCountForRow(row), 0);
        return total > 0 ? `마일스톤 ${visible}/${total}개` : "마일스톤 없음";
    }

    public get hasMilestones() {
        return this.milestones.length > 0;
    }

    public get selectedCellMilestones() {
        if (!this.selectedCell) return [];
        const row = this.findRowById(this.selectedCell.rowId);
        const project = this.findProjectById(this.selectedCell.projectId);
        return row && project ? this.getProjectMilestones(row, project) : [];
    }

    public async openMilestoneEditorForSelectedCell() {
        if (!this.selectedCell) return;
        const row = this.findRowById(this.selectedCell.rowId);
        const project = this.findProjectById(this.selectedCell.projectId);
        await this.openMilestoneEditorForCell(row, project);
    }

    public findRowById(rowId: string) {
        return this.rows.find(row => row.id === rowId) || null;
    }

    public findRowByDate(dateKey: string) {
        const key = String(dateKey || "");
        return this.rows.find(row => row && row.date === key) || null;
    }

    public findProjectById(projectId: string) {
        return this.projects.find(project => project.id === projectId) || null;
    }

    public focusActiveEditor(key: string) {
        const editors = document.querySelectorAll("[data-edit-key]");
        for (let index = 0; index < editors.length; index++) {
            const editor = editors[index] as HTMLTextAreaElement;
            if (editor.getAttribute("data-edit-key") === key) {
                editor.focus();
                if (key === this.inlineCellEditKey && typeof editor.setSelectionRange === "function") {
                    const cursor = String(this.inlineCellDraft || editor.value || "").length;
                    try {
                        editor.setSelectionRange(cursor, cursor);
                    } catch (e) {
                        // Some detached editors do not allow selection updates.
                    }
                }
                return;
            }
        }
    }

    public async setSearchText(value: string) {
        this.searchText = value || "";
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        this.resetExportState();
        await this.service.render();
    }

    public async setSelectedProject(value: string) {
        const project = this.findProjectById(value || "");
        this.selectedProjectId = this.isProjectVisible(project) ? project.id : "";
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        if (this.selectedCell && this.selectedProjectId && this.selectedCell.projectId !== this.selectedProjectId) {
            this.clearSelectedCellState();
        }
        this.resetExportState();
        await this.service.render();
    }

    public async clearSelectedProjectView() {
        await this.setSelectedProject("");
    }

    public async clearFilters() {
        this.searchText = "";
        this.selectedProjectId = "";
        this.activeEditKey = "";
        this.resetCellInlineDraft();
        const prefs = normalizeViewPrefs(this.viewPrefs);
        this.viewPrefs = normalizeViewPrefs({
            ...prefs,
            filters: {
                ...prefs.filters,
                searchText: "",
                selectedProjectId: "",
                quickView: "default",
                dateScope: "",
                ownerOnly: false,
                status: "",
                type: "",
                groupId: "",
                favoriteOnly: false,
                milestoneOnly: false
            }
        });
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.resetExportState();
        await this.service.render();
    }

    public async setRowHeightPreset(presetKey: string) {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setGlobalRowHeightPreset(currentPrefs, presetKey);
        if (nextPrefs.rowHeightPreset === currentPrefs.rowHeightPreset
            && nextPrefs.rowHeightPx === currentPrefs.rowHeightPx) return;

        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        await this.service.render();
    }

    public async setScheduleRowHeightPx(heightPx: any) {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setGlobalRowHeightPx(currentPrefs, heightPx);
        if (nextPrefs.rowHeightPreset === currentPrefs.rowHeightPreset
            && nextPrefs.rowHeightPx === currentPrefs.rowHeightPx) return;

        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        await this.service.render();
    }

    public async resetScheduleRowDensitySettings() {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = normalizeViewPrefs({
            ...currentPrefs,
            rowHeightPreset: "default",
            rowHeightPx: this.rowHeightDefaultPx,
            rowHeightByDate: {},
            density: "standard"
        });
        if (currentPrefs.rowHeightPreset === nextPrefs.rowHeightPreset
            && currentPrefs.rowHeightPx === nextPrefs.rowHeightPx
            && currentPrefs.density === nextPrefs.density
            && JSON.stringify(currentPrefs.rowHeightByDate) === JSON.stringify(nextPrefs.rowHeightByDate)) return;

        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        await this.service.render();
    }

    public async setDateRowHeight(row: any, selection: string) {
        if (!row || !row.date) return;

        const selected = String(selection || "inherit");
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = selected === "inherit"
            ? clearRowHeightForDate(currentPrefs, row.date)
            : this.buildDateRowHeightPrefs(currentPrefs, row.date, selected);

        if (this.applyDateRowHeightPrefs(nextPrefs, currentPrefs)) await this.service.render();
    }

    public async setDateRowHeightPx(row: any, heightPx: any) {
        if (!row || !row.date) return;
        const label = `${row.dateLabel || row.date} 날짜 행 높이 변경`;
        if (this.persistDateRowHeightOverride(row.date, heightPx, label, `date-row-height-${row.date}`)) await this.service.render();
    }

    public async resetDateRowHeight(row: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.cleanupDateRowHeightDrag();
        this.clearResizeDoubleClickGesture(row && row.date ? `date-row-height-${row.date}` : "");
        if (!row || !row.date || !this.hasDateRowHeightOverride(row)) return;

        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = clearRowHeightForDate(currentPrefs, row.date);
        if (JSON.stringify(nextPrefs.rowHeightByDate) === JSON.stringify(currentPrefs.rowHeightByDate)) return;

        this.recordScheduleHistory(`${row.dateLabel || row.date} 날짜 행 높이 기본값`, `date-row-height-${row.date}`);
        this.viewPrefs = nextPrefs;
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        await this.service.render();
    }

    public applyDateRowHeightPrefs(nextPrefs: any, currentPrefs: any = normalizeViewPrefs(this.viewPrefs)) {
        if (JSON.stringify(nextPrefs.rowHeightByDate) === JSON.stringify(currentPrefs.rowHeightByDate)) return false;

        this.viewPrefs = normalizeViewPrefs(nextPrefs);
        const convenience = this.normalizeCurrentConvenienceState();
        this.persistSheet(this.projects, this.rows, convenience.viewPrefs, convenience.projectGroups);
        this.markLocalSaved();
        this.resetExportState();
        return true;
    }

    public persistDateRowHeightOverride(dateKey: string, heightPx: any, historyLabel: string = "", historyKey: string = "") {
        const currentPrefs = normalizeViewPrefs(this.viewPrefs);
        const nextPrefs = setRowHeightForDate(currentPrefs, dateKey, clampRowHeightPx(heightPx));
        if (JSON.stringify(nextPrefs.rowHeightByDate) !== JSON.stringify(currentPrefs.rowHeightByDate) && historyLabel) {
            this.recordScheduleHistory(historyLabel, historyKey || `date-row-height-${dateKey}`);
        }
        return this.applyDateRowHeightPrefs(nextPrefs, currentPrefs);
    }

    public buildDateRowHeightPrefs(viewPrefs: any, dateKey: string, presetKey: string) {
        const preset = (ROW_HEIGHT_PRESETS as any)[presetKey];
        if (!preset) return normalizeViewPrefs(viewPrefs);
        return setRowHeightForDate(viewPrefs, dateKey, preset.px);
    }

    public startDateRowHeightDrag(row: any, event: PointerEvent) {
        if (!row || !row.date || !event) return;
        const resizeKey = `date-row-height-${row.date}`;
        if (event.detail > 1) {
            void this.resetDateRowHeight(row, event);
            return;
        }
        if (this.isResizeDoubleClickGesture(resizeKey, event)) {
            void this.resetDateRowHeight(row, event);
            return;
        }
        if (event.button !== undefined && event.button !== 0) return;

        this.cleanupDateRowHeightDrag();

        const handleElement = event.currentTarget as HTMLElement;
        const rowElement = handleElement && handleElement.closest ? handleElement.closest("tr") as HTMLElement : null;
        const startHeight = this.getRowHeightPxForRow(row);
        const startY = event.clientY;
        const body = document.body;

        this.rowHeightDragState = {
            dateKey: row.date,
            rowId: row.id,
            dateLabel: row.dateLabel || row.date,
            startHeight,
            currentHeight: startHeight,
            startY,
            rowElement,
            handleElement,
            previousBodyCursor: body ? body.style.cursor : "",
            previousBodyUserSelect: body ? body.style.userSelect : ""
        };
        this.isRowHeightDragging = true;

        if (rowElement) rowElement.classList.add("is-row-height-dragging");
        if (handleElement) {
            handleElement.classList.add("is-dragging");
            handleElement.setAttribute("data-resize-tooltip", "높이 조절 중");
            handleElement.setAttribute("aria-valuetext", "높이 조절 중");
        }
        if (body) {
            body.classList.add("is-schedule-row-height-dragging");
            body.style.cursor = "row-resize";
            body.style.userSelect = "none";
        }

        this.rowHeightPointerMoveHandler = (moveEvent: PointerEvent) => this.updateDateRowHeightDrag(moveEvent);
        this.rowHeightPointerUpHandler = (upEvent: PointerEvent) => this.finishDateRowHeightDrag(upEvent);
        this.rowHeightPointerCancelHandler = (cancelEvent: PointerEvent) => this.finishDateRowHeightDrag(cancelEvent);
        document.addEventListener("pointermove", this.rowHeightPointerMoveHandler, { passive: false });
        document.addEventListener("pointerup", this.rowHeightPointerUpHandler, { passive: false });
        document.addEventListener("pointercancel", this.rowHeightPointerCancelHandler, { passive: false });

        event.preventDefault();
        event.stopPropagation();
    }

    public handleDateRowHeightHandleClick(row: any, event: any) {
        if (!event || event.detail < 2) return;
        void this.resetDateRowHeight(row, event);
    }

    public updateDateRowHeightDrag(event: PointerEvent) {
        const state = this.rowHeightDragState;
        if (!state || !event) return;

        const nextHeight = clampRowHeightPx(state.startHeight + event.clientY - state.startY);
        state.currentHeight = nextHeight;
        if (state.rowElement) state.rowElement.style.setProperty("--schedule-row-height", `${nextHeight}px`);
        if (state.handleElement) {
            state.handleElement.setAttribute("aria-valuenow", String(nextHeight));
            state.handleElement.setAttribute("aria-valuetext", "높이 조절 중");
            state.handleElement.setAttribute("data-resize-tooltip", "높이 조절 중");
        }

        event.preventDefault();
        event.stopPropagation();
    }

    public finishDateRowHeightDrag(event: PointerEvent) {
        const state = this.rowHeightDragState;
        if (!state) return;

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const shouldPersist = state.currentHeight !== state.startHeight;
        const changed = shouldPersist
            ? this.persistDateRowHeightOverride(state.dateKey, state.currentHeight, `${state.dateLabel || state.dateKey} 날짜 행 높이 변경`, `date-row-height-${state.dateKey}`)
            : false;
        this.cleanupDateRowHeightDrag();
        if (changed) void this.service.render();
    }

    public cleanupDateRowHeightDrag() {
        const state = this.rowHeightDragState;
        if (this.rowHeightPointerMoveHandler) document.removeEventListener("pointermove", this.rowHeightPointerMoveHandler);
        if (this.rowHeightPointerUpHandler) document.removeEventListener("pointerup", this.rowHeightPointerUpHandler);
        if (this.rowHeightPointerCancelHandler) document.removeEventListener("pointercancel", this.rowHeightPointerCancelHandler);

        if (state && state.rowElement) state.rowElement.classList.remove("is-row-height-dragging");
        if (state && state.handleElement) state.handleElement.classList.remove("is-dragging");
        if (document.body) {
            document.body.classList.remove("is-schedule-row-height-dragging");
            if (state) {
                document.body.style.cursor = state.previousBodyCursor || "";
                document.body.style.userSelect = state.previousBodyUserSelect || "";
            }
        }

        this.rowHeightPointerMoveHandler = null;
        this.rowHeightPointerUpHandler = null;
        this.rowHeightPointerCancelHandler = null;
        this.rowHeightDragState = null;
        this.isRowHeightDragging = false;
    }

    public async handleDateRowHeightHandleKeydown(row: any, event: KeyboardEvent) {
        if (!row || !row.date || !event) return;

        const currentHeight = this.getRowHeightPxForRow(row);
        const step = event.shiftKey ? this.rowHeightKeyboardStepPx * 2 : this.rowHeightKeyboardStepPx;
        let nextHeight = currentHeight;

        if (event.key === "ArrowUp" || event.key === "ArrowLeft") nextHeight = currentHeight - step;
        else if (event.key === "ArrowDown" || event.key === "ArrowRight") nextHeight = currentHeight + step;
        else if (event.key === "PageUp") nextHeight = currentHeight - (step * 3);
        else if (event.key === "PageDown") nextHeight = currentHeight + (step * 3);
        else if (event.key === "Home") nextHeight = this.rowHeightMinPx;
        else if (event.key === "End") nextHeight = this.rowHeightMaxPx;
        else return;

        event.preventDefault();
        event.stopPropagation();
        if (this.persistDateRowHeightOverride(row.date, nextHeight)) await this.service.render();
    }

    public isRowHeightPresetSelected(presetKey: string) {
        return this.scheduleRowHeightPx === getRowHeightPresetPx(presetKey);
    }

    public hasDateRowHeightOverride(row: any) {
        if (!row || !row.date) return false;
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return Object.prototype.hasOwnProperty.call(prefs.rowHeightByDate, row.date);
    }

    public isDateRowHeightDragging(row: any) {
        return !!this.rowHeightDragState && !!row && this.rowHeightDragState.dateKey === row.date;
    }

    public getRowHeightStyle(row: any) {
        return {
            "--schedule-row-height": `${this.getRowHeightPxForRow(row)}px`
        };
    }

    public getMobileRowHeightStyle(row: any) {
        return {
            "--schedule-row-height": `${Math.max(this.mobileRowHeightMinPx, this.getRowHeightPxForRow(row))}px`
        };
    }

    public getRowHeightPxForRow(row: any) {
        return getRowHeightForDate(this.viewPrefs, row && row.date ? row.date : "");
    }

    public getDateRowHeightSelection(row: any) {
        if (!this.hasDateRowHeightOverride(row)) return "inherit";
        const height = this.getRowHeightPxForRow(row);
        const presetKey = getRowHeightPresetKeyByPx(height);
        return presetKey || `custom:${height}`;
    }

    public hasCustomDateRowHeight(row: any) {
        return this.hasDateRowHeightOverride(row) && !getRowHeightPresetKeyByPx(this.getRowHeightPxForRow(row));
    }

    public getCustomDateRowHeightOptionValue(row: any) {
        return `custom:${this.getRowHeightPxForRow(row)}`;
    }

    public getDateRowHeightLabel(row: any) {
        if (!this.hasDateRowHeightOverride(row)) return `전역 ${this.scheduleRowHeightLabel}`;

        const height = this.getRowHeightPxForRow(row);
        const presetKey = getRowHeightPresetKeyByPx(height);
        return presetKey ? this.getRowHeightPresetLabel(presetKey) : "직접 지정";
    }

    public getDateRowHeightBadgeLabel(row: any) {
        return this.hasDateRowHeightOverride(row) ? `개별 ${this.getDateRowHeightLabel(row)}` : "";
    }

    public getDateRowHeightAriaLabel(row: any) {
        const dateLabel = row && row.dateLabel ? row.dateLabel : "날짜";
        return `${dateLabel} 행 높이 선택, 현재 ${this.getDateRowHeightLabel(row)}`;
    }

    public getDateRowHeightHandleAriaLabel(row: any) {
        const dateLabel = row && row.dateLabel ? row.dateLabel : "날짜";
        return `${dateLabel} 행 높이 드래그 조정, 현재 ${this.getDateRowHeightValueText(row)}`;
    }

    public getDateRowHeightValueText(row: any) {
        return this.hasDateRowHeightOverride(row) ? this.getDateRowHeightLabel(row) : "기본 높이";
    }

    public getDateRowHeightResizeTooltip(row: any) {
        if (this.isDateRowHeightDragging(row) && this.rowHeightDragState) {
            const currentHeight = this.rowHeightDragState.currentHeight;
            return currentHeight >= 0 ? "높이 조절 중" : "높이 조절 중";
        }
        return "드래그로 높이 조절";
    }

    public getRowHeightPresetLabel(presetKey: string) {
        const option = this.rowHeightPresetOptions.find((item: any) => item.key === presetKey);
        return option ? option.label : "기본";
    }

    public getRowHeightLabelFromPrefs(viewPrefs: any) {
        const prefs = normalizeViewPrefs(viewPrefs);
        const presetKey = getRowHeightPresetKeyByPx(prefs.rowHeightPx);
        return presetKey ? this.getRowHeightPresetLabel(presetKey) : "직접 지정";
    }

    public get scheduleRowHeightLabel() {
        return this.getRowHeightLabelFromPrefs(this.viewPrefs);
    }

    public get scheduleRowDensitySummaryLabel() {
        return `행 ${this.scheduleRowHeightLabel} · 밀도 ${this.getScheduleCellDensityLabel()}`;
    }

    public get scheduleRowHeightDensity() {
        const height = this.scheduleRowHeightPx;
        if (height < getRowHeightPresetPx("default")) return "compact";
        if (height > getRowHeightPresetPx("default")) return "spacious";
        return "default";
    }

    public get isScheduleRowDensityDefault() {
        const prefs = normalizeViewPrefs(this.viewPrefs);
        return prefs.rowHeightPreset === "default"
            && prefs.rowHeightPx === this.rowHeightDefaultPx
            && prefs.density === "standard"
            && Object.keys(prefs.rowHeightByDate || {}).length === 0;
    }

    public getDateRowHeightDensity(row: any) {
        if (!this.hasDateRowHeightOverride(row)) return "";

        const height = this.getRowHeightPxForRow(row);
        const presetKey = getRowHeightPresetKeyByPx(height);
        if (presetKey) return presetKey;
        if (height < getRowHeightPresetPx("default")) return "compact";
        if (height > getRowHeightPresetPx("default")) return "spacious";
        return "default";
    }

    public getMobileRowHeightDensity(row: any) {
        return this.getDateRowHeightDensity(row) || this.scheduleRowHeightDensity;
    }

    public getScheduleCellDensityLabel() {
        return this.getCellDensityLabel(this.scheduleCellDensity);
    }

    public getCellDensityLabel(density: string) {
        const option = this.cellDensityOptions.find((item: any) => item.key === density);
        return option ? option.label : "기본";
    }

    public getMobileDisplayDensityLabel(row: any) {
        const heightLabel = this.hasDateRowHeightOverride(row)
            ? `개별 ${this.getDateRowHeightLabel(row)}`
            : this.getDateRowHeightLabel(row);
        return `행 ${heightLabel} · 밀도 ${this.getScheduleCellDensityLabel()}`;
    }

    public getMobileDayAriaLabel(row: any) {
        const parts = [
            this.getHolidayAriaLabel(row),
            `${this.getMobileRowEntryCount(row)}건`,
            this.getMobileDisplayDensityLabel(row)
        ];
        return parts.filter(part => String(part || "").trim().length > 0).join(", ");
    }

    public trackByDate(index: number, row: any) {
        return row.id || index;
    }

    public trackByProject(index: number, project: any) {
        return project.id || index;
    }

    public trackByProjectGroup(index: number, group: any) {
        return group.id || index;
    }

    public trackByProjectRowItem(index: number, rowItem: any) {
        return rowItem && rowItem.id ? rowItem.id : index;
    }

    public trackByMilestone(index: number, milestone: any) {
        return milestone && milestone.id ? milestone.id : index;
    }

    public trackByPlannerSummaryItem(index: number, item: any) {
        return item && item.id ? item.id : index;
    }

    public get rangeLabel() {
        if (this.rows.length === 0) return "-";
        const first = this.rows[0].dateLabel;
        const last = this.rows[this.rows.length - 1].dateLabel;
        return `${first} - ${last}`;
    }

    public get filledCount() {
        return this.filledEntryCount;
    }

    public get hasActiveFilters() {
        const context = this.getVisibleRowFilterContext();
        return context.keyword.length > 0
            || !!context.selectedProject
            || context.quickView !== "default"
            || !!context.dateScope
            || !!context.ownerOnly
            || !!context.favoriteOnly
            || !!context.milestoneOnly
            || !!context.status
            || !!context.type
            || !!context.groupId
            || context.hideWeekends
            || context.hideEmptyRows;
    }

    public get hasToolbarFilters() {
        const context = this.getVisibleRowFilterContext();
        return context.keyword.length > 0
            || !!context.selectedProject
            || context.quickView !== "default"
            || !!context.dateScope
            || !!context.ownerOnly
            || !!context.favoriteOnly
            || !!context.milestoneOnly
            || !!context.status
            || !!context.type
            || !!context.groupId;
    }

    public get searchFilterSummaryLabel() {
        const context = this.getVisibleRowFilterContext();
        const parts: string[] = [];
        if (context.keyword) parts.push(`검색 ${context.keyword}`);
        if (context.selectedProject) parts.push(context.selectedProject.name || "프로젝트 선택");
        if (this.hasToolbarFilters && parts.length === 0) parts.push("필터 적용");
        return parts.length > 0 ? parts.slice(0, 2).join(" · ") : `${this.visibleRows.length}/${this.rows.length}행`;
    }

    public get scheduleRowHeightPreset() {
        return normalizeViewPrefs(this.viewPrefs).rowHeightPreset;
    }

    public get scheduleRowHeightPx() {
        return getGlobalRowHeightPx(this.viewPrefs);
    }

    public get scheduleBoardStyle() {
        const defaultDetailPercent = Math.max(100 - SCHEDULE_LAYOUT_TABLE_DEFAULT_PERCENT, 12);
        const colors = this.scheduleCellColors;
        return {
            "--schedule-row-height": `${this.scheduleRowHeightPx}px`,
            "--schedule-date-column-width": `${this.scheduleDateColumnWidthPx}px`,
            "--schedule-note-column-width": `${this.noteColumnWidthPx}px`,
            "--schedule-table-width": `${this.scheduleTableWidthPx}px`,
            "--schedule-project-header-row-height": `${this.projectHeaderRowHeightPx}px`,
            "--schedule-table-head-height": `${this.scheduleTableHeadHeightPx}px`,
            "--schedule-table-fr": `${SCHEDULE_LAYOUT_TABLE_DEFAULT_PERCENT}fr`,
            "--schedule-detail-fr": `${defaultDetailPercent}fr`,
            "--schedule-table-height": `${SCHEDULE_LAYOUT_TABLE_HEIGHT_PX}px`,
            "--schedule-print-table-width": `${this.schedulePrintTableWidthPx}px`,
            "--schedule-print-scale": `${this.schedulePrintScale}`,
            "--schedule-color-base-cell": colors.baseCell,
            "--schedule-color-personal-cell": colors.personalCell,
            "--schedule-color-project-header-cell": colors.projectHeaderCell,
            "--schedule-color-project-cell": colors.projectCell,
            "--schedule-color-weekend-cell": colors.weekendCell,
            "--schedule-color-holiday-cell": colors.holidayCell,
            "--schedule-color-today-cell": colors.todayCell,
            "--schedule-color-filled-cell": colors.filledCell,
            "--schedule-color-selected-cell": colors.selectedCell,
            "--schedule-color-row-highlight": colors.rowHighlight,
            "--schedule-color-column-highlight": colors.columnHighlight,
            "--schedule-color-status-badge": colors.statusBadge,
            "--schedule-color-status-badge-text": this.getReadableScheduleCellTextColor(colors.statusBadge),
            "--schedule-color-type-badge": colors.typeBadge,
            "--schedule-color-type-badge-text": this.getReadableScheduleCellTextColor(colors.typeBadge),
            "--schedule-color-dependency-badge": colors.dependencyBadge,
            "--schedule-color-dependency-badge-text": this.getReadableScheduleCellTextColor(colors.dependencyBadge),
            "--schedule-color-time-badge": colors.timeBadge,
            "--schedule-color-time-badge-text": this.getReadableScheduleCellTextColor(colors.timeBadge),
            "--schedule-color-milestone-badge": colors.milestoneBadge,
            "--schedule-color-milestone-badge-text": this.getReadableScheduleCellTextColor(colors.milestoneBadge),
            "--schedule-color-selection-border": colors.selectionBorder,
            "--schedule-color-selection-anchor": colors.selectionAnchor,
            "--schedule-color-active-cell-border": colors.activeCellBorder,
            "--schedule-color-dependency-risk": colors.dependencyRisk,
            "--schedule-color-dependency-delay": colors.dependencyDelay
        };
    }

    public get scheduleRowHeightStyle() {
        return this.scheduleBoardStyle;
    }

    public get selectedCellCharacterCount() {
        return this.selectedCellDraft.length;
    }

    public get importCanRequestPreview() {
        return !!this.importFile && this.isAllowedImportExtension(this.importFile.extension) && !this.importBusy;
    }

    public get hasImportRowsPreview() {
        return this.importRowsPreview && this.importRowsPreview.rows && this.importRowsPreview.rows.length > 0;
    }

    public get canExportSchedule() {
        return !this.exportBusy && this.visibleProjectCount > 0 && this.rows.length > 0 && this.visibleRows.length > 0;
    }

    public get canPrintExportSchedule() {
        return !this.printExportBusy && this.visibleProjectCount > 0 && this.rows.length > 0 && this.visibleRows.length > 0 && this.scheduleTableColumns.length > 0;
    }

    public get scheduleTransferSummaryLabel() {
        const rowCount = this.visibleRows.length;
        const totalRows = this.rows.length;
        const rowText = this.hasActiveFilters ? `필터 적용 ${rowCount}/${totalRows}행` : `현재 표시 ${rowCount}/${totalRows}행`;
        return `${rowText} · 표시 프로젝트 ${this.visibleProjectCount}개`;
    }

    public get exportScopeLabel() {
        const rowCount = this.visibleRows.length;
        const totalRows = this.rows.length;
        const filterText = this.hasActiveFilters ? `필터 적용 ${rowCount}/${totalRows}행` : `전체 ${totalRows}행`;
        return `현재 표시 행 기준: ${filterText}, 표시 프로젝트 ${this.getExportProjects().length}개`;
    }

    public get printExportScopeLabel() {
        const rows = this.getPrintExportRows();
        const columns = this.getPrintExportColumns();
        const filterText = this.hasActiveFilters ? `필터 적용 ${rows.length}/${this.rows.length}행` : `현재 표시 ${rows.length}/${this.rows.length}행`;
        return `${filterText} · 개인/프로젝트 ${columns.length + 1}열 · 인쇄 배율 ${this.schedulePrintScalePercent}%`;
    }

    public get printExportViewSummary() {
        const labels = this.getPrintExportFilterLabels();
        const collapsedCount = this.scheduleTableProjectGroups.filter(group => this.isProjectGroupCollapsed(group)).length;
        const hiddenText = this.hiddenProjectCount > 0 ? `숨김 프로젝트 ${this.hiddenProjectCount}개` : "숨김 없음";
        return `현재 보기 기준: ${labels.join(", ")} · ${hiddenText} · 접힘 그룹 ${collapsedCount}개 · 정렬 반영 · 셀 크기 반영 · 프로젝트 열 ${this.getCustomProjectColumnWidthCount()}개 · 날짜 행 ${this.getCustomDateRowHeightCount()}개`;
    }

    public get plannerFilterContext() {
        return this.getVisibleRowFilterContext();
    }

    public get plannerSummarySummaryLabel() {
        if (!this.plannerSummaryExpanded) return "Timeline/Workload";
        const data = this.getPlannerSummaryData();
        return `Timeline ${data.timeline.totalItems}개 · Workload ${data.workload.totalItems}명`;
    }

    public get plannerTimelineData() {
        return this.getPlannerSummaryData().timeline;
    }

    public get plannerTimelineItems() {
        return this.plannerTimelineData.items || [];
    }

    public get plannerWorkloadData() {
        return this.getPlannerSummaryData().workload;
    }

    public get plannerWorkloadItems() {
        return this.plannerWorkloadData.items || [];
    }

    public get plannerHasTimelineData() {
        return this.plannerTimelineItems.length > 0 || (this.plannerTimelineData.commonMilestones || []).length > 0;
    }

    public get plannerHasWorkloadData() {
        return this.plannerWorkloadItems.length > 0;
    }

    public get plannerTimelineRangeLabel() {
        const data = this.plannerTimelineData;
        if (!data.axisStart || !data.axisEnd) return "표시할 기간 없음";
        return `${data.axisStart} - ${data.axisEnd}`;
    }

    public get plannerWorkloadRangeLabel() {
        const data = this.plannerWorkloadData;
        if (!data.weekStartKey || !data.nextWeekEndKey) return "주간 기준 없음";
        return `${data.weekStartKey} - ${data.nextWeekEndKey}`;
    }

    public get plannerTimelineTruncatedLabel() {
        const count = this.plannerTimelineData.truncatedCount || 0;
        return count > 0 ? `프로젝트 ${count}개 더 있음` : "";
    }

    public get plannerWorkloadTruncatedLabel() {
        const count = this.plannerWorkloadData.truncatedCount || 0;
        return count > 0 ? `담당자 ${count}명 더 있음` : "";
    }

    public getPlannerSummaryData() {
        const context = this.plannerFilterContext;
        const rows = this.visibleRows;
        const projects = this.getPlannerSummaryProjects(context);
        const key = this.createPlannerSummaryCacheKey(rows, projects, context);
        if (this.plannerSummaryCache.key === key && this.plannerSummaryCache.data) {
            return this.plannerSummaryCache.data;
        }

        const data = {
            filterContext: context,
            timeline: buildScheduleTimelineData({
                rows,
                projects,
                milestones: this.milestones,
                context,
                maxProjects: 10
            }),
            workload: buildScheduleWorkloadSummary({
                rows,
                projects,
                context,
                maxPeople: 10
            })
        };
        this.plannerSummaryCache = { key, data };
        return data;
    }

    public getPlannerSummaryProjects(context: any = null) {
        const filterContext = context || this.plannerFilterContext;
        return this.getFilterCandidateProjects(filterContext);
    }

    public createPlannerSummaryCacheKey(rows: any[], projects: any[], context: any) {
        const rowSignature = (rows || []).map(row => {
            const cells = row && row.cells ? row.cells : {};
            const cellMeta = row && row.cellMeta ? row.cellMeta : {};
            return [
                row && row.date,
                row && row.note,
                (projects || []).map(project => [project.id, cells[project.id], cellMeta[project.id]])
            ];
        });
        const projectSignature = (projects || []).map(project => [project.id, project.name, project.pm, project.owner, project.color]);
        const milestoneSignature = (this.milestones || []).map(milestone => [milestone.id, milestone.date, milestone.scope, milestone.projectId, milestone.title, milestone.updatedAt]);
        return JSON.stringify({
            revision: this.plannerSummaryRevision,
            context,
            rows: rowSignature,
            projects: projectSignature,
            milestones: milestoneSignature
        });
    }

    public getPlannerTimelineItemMeta(item: any) {
        if (!item) return "";
        const people = [item.pm ? `PM ${item.pm}` : "", item.owner ? `담당 ${item.owner}` : ""].filter(part => part.length > 0).join(" · ");
        const counts = [`일정 ${item.entryCount}건`];
        if (item.delayedCount > 0) counts.push(`지연 ${item.delayedCount}건`);
        if (item.dependencyCount > 0) counts.push(`의존성 ${item.dependencyCount}건`);
        return [people, counts.join(" · ")].filter(part => part.length > 0).join(" · ");
    }

    public getPlannerTimelineBarLabel(item: any) {
        if (!item || !item.startDate || !item.endDate) return "일정 span 없음";
        return `${item.label} ${item.startDate}부터 ${item.endDate}까지 ${item.entryCount}건`;
    }

    public getPlannerWorkloadLevelClass(item: any) {
        if (!item) return "is-calm";
        if (item.delayedCount > 0) return "is-risk";
        if (item.thisWeekCount + item.nextWeekCount >= 6) return "is-busy";
        return "is-calm";
    }

    public async editPlannerMilestone(marker: any) {
        const milestone = marker && marker.id ? this.findMilestoneById(marker.id) : null;
        if (!milestone) return;
        await this.editMilestone(milestone);
    }

    public get schedulePrintTableWidthPx() {
        return this.scheduleDateColumnWidthPx
            + this.noteColumnWidthPx
            + this.getPrintExportColumns().reduce((total, column) => total + this.getScheduleColumnWidthPx(column), 0);
    }

    public get schedulePrintScale() {
        const printableLandscapeWidthPx = 1040;
        const width = Math.max(1, this.schedulePrintTableWidthPx);
        const scale = printableLandscapeWidthPx / width;
        return Math.max(0.28, Math.min(1, Math.floor(scale * 100) / 100));
    }

    public get schedulePrintScalePercent() {
        return Math.round(this.schedulePrintScale * 100);
    }

    public get selectedProject() {
        if (!this.selectedProjectId) return null;
        const project = this.projects.find(project => project.id === this.selectedProjectId) || null;
        return this.isProjectVisible(project) ? project : null;
    }

    public get selectedProjectViewSummary() {
        const project = this.selectedProject;
        if (!project) return "";
        return `선택 프로젝트만 표시 · ${this.scheduleTableColumnCount}열 · ${this.visibleRows.length}/${this.rows.length}행`;
    }

    public get visibleRows() {
        const context = this.getVisibleRowFilterContext();
        return this.rows.filter(row => this.matchesVisibleRow(row, context));
    }

    public get mobileRows() {
        return this.visibleRows.filter(row => this.hasMobileRowContent(row) || this.isScheduleFocusDate(row) || this.isScheduleFocusWeek(row));
    }

    public isScheduleFocusDate(row: any) {
        return !!row && !!row.date && !!this.scheduleFocusDateKey && row.date === this.scheduleFocusDateKey;
    }

    public isScheduleFocusWeek(row: any) {
        return !!row && !!row.date && !!this.scheduleFocusWeekStartKey && isDateKeyInKoreaWeek(row.date, this.scheduleFocusWeekStartKey);
    }

    public getRowWeekStartKey(row: any) {
        return row && row.date ? getKoreaWeekStartKey(row.date) : "";
    }

    public isCalendarJumpTodayActive() {
        return this.scheduleFocusMode === "today" && this.scheduleFocusDateKey === this.todayKey();
    }

    public isCalendarJumpWeekActive() {
        return this.scheduleFocusMode === "week" && !!this.scheduleFocusWeekStartKey && this.scheduleFocusWeekStartKey === getKoreaWeekStartKey(this.todayKey());
    }

    public formatNavigationWeekLabel(startKey: string, endKey: string) {
        if (!startKey || !endKey) return "-";
        return `${this.formatNavigationDateLabel(startKey)} - ${this.formatNavigationDateLabel(endKey)}`;
    }

    public formatNavigationDateLabel(dateKey: string) {
        if (!this.isValidDate(dateKey)) return "-";
        const date = this.parseDate(dateKey);
        return `${this.formatDisplayDate(date)}(${this.getWeekday(date)})`;
    }

    public get mobileListEmptyMessage() {
        if (this.visibleRows.length === 0) return "검색 결과가 없습니다.";
        if (this.hasActiveFilters) return "필터에 맞는 입력 일정이 없습니다.";
        return "입력된 일정이 없습니다.";
    }

    public get mobileListEmptyHint() {
        if (this.visibleRows.length === 0) return "검색어 또는 프로젝트 필터를 확인하세요.";
        if (this.hasActiveFilters) return "조건에 맞는 날짜는 있지만 입력된 일정이 없습니다.";
        return "프로젝트 메모가 있는 날짜만 표시됩니다.";
    }

    public hasMobileRowContent(row: any) {
        if (!row) return false;
        if (String(row.note || "").trim().length > 0) return true;
        if (this.getVisibleMilestoneCountForRow(row) > 0) return true;
        return this.scheduleMobileProjectColumns.some(project => this.hasMobileProjectEntry(row, project));
    }

    public hasMobileProjectEntry(row: any, project: any) {
        if (!row || !project) return false;
        return this.getCellText(row, project.id).length > 0 || this.hasExplicitCellMeta(row, project.id);
    }

    public getMobileRowEntryCount(row: any) {
        if (!row) return 0;
        return this.scheduleProjectGroupsWithUngrouped.reduce((total, group) => total + this.getMobileGroupEntryCount(row, group), 0)
            + this.getVisibleMilestoneCountForRow(row);
    }

    public shouldShowMobileProjectEntry(row: any, project: any, context: any = null) {
        if (!this.isProjectVisible(project) || !this.hasMobileProjectEntry(row, project)) return false;

        const filterContext = context || this.getVisibleRowFilterContext();
        const projectIds = filterContext && Array.isArray(filterContext.projectIds) ? filterContext.projectIds : [];
        const hasScopedProjectFilter = !!(filterContext && (filterContext.selectedProject || filterContext.groupId || filterContext.favoriteOnly || filterContext.ownerOnly));
        if (projectIds.length > 0 && projectIds.indexOf(project.id) < 0) return false;
        if (projectIds.length === 0 && hasScopedProjectFilter) return false;

        const meta = this.getCellMeta(row, project.id);
        if (filterContext.status && meta.status !== filterContext.status) return false;
        if (filterContext.type && meta.type !== filterContext.type) return false;

        const keyword = filterContext.keyword || "";
        if (keyword) {
            if (this.includesKeyword(row.note, keyword)) return true;
            const cellText = this.getCellText(row, project.id);
            const dependencyText = this.getCellDependencySearchText(row, project.id);
            return this.includesKeyword(cellText, keyword)
                || this.includesKeyword(project.name, keyword)
                || this.includesKeyword(dependencyText, keyword);
        }

        return true;
    }

    public getMobileCellPreview(row: any, projectId: string) {
        return this.getCellPreviewTitle(row, projectId);
    }

    public getCellPreviewTitle(row: any, projectId: string) {
        const lines = this.getCellTextLines(row, projectId);
        return lines.length > 0 ? lines[0] : "메모 없음";
    }

    public getCellPreviewBody(row: any, projectId: string) {
        const lines = this.getCellTextLines(row, projectId);
        if (lines.length <= 1) return "";
        return this.compactCellDisplayText(lines.slice(1).join(" "));
    }

    public hasCellPreviewBody(row: any, projectId: string) {
        return this.getCellPreviewBody(row, projectId).length > 0;
    }

    public getCellTextLines(row: any, projectId: string) {
        return this.getCellText(row, projectId)
            .split(/\r?\n/)
            .map(line => this.compactCellDisplayText(line))
            .filter(line => line.length > 0);
    }

    public compactCellDisplayText(value: any) {
        return String(value || "").replace(/\s+/g, " ").trim();
    }

    public getCellTimeText(row: any, projectId: string) {
        const metaTime = this.normalizeCellTime(this.getCellMeta(row, projectId).time);
        if (metaTime) return metaTime;

        const text = this.getCellText(row, projectId);
        if (!text) return "";

        const rangeMatch = text.match(/(?:오전|오후)?\s*\d{1,2}(?::\d{2})?\s*(?:시|분)?\s*(?:-|~|부터|to)\s*(?:오전|오후)?\s*\d{1,2}(?::\d{2})?\s*(?:시|분)?/i);
        if (rangeMatch && rangeMatch[0]) return this.compactCellDisplayText(rangeMatch[0]);

        const singleMatch = text.match(/(?:오전|오후)?\s*\d{1,2}:\d{2}|(?:오전|오후)\s*\d{1,2}\s*시(?:\s*\d{1,2}\s*분)?|\d{1,2}\s*시(?:\s*\d{1,2}\s*분)?/);
        return singleMatch && singleMatch[0] ? this.compactCellDisplayText(singleMatch[0]) : "";
    }

    public getCellPreviewAriaLabel(row: any, project: any) {
        const projectId = project && project.id ? project.id : "";
        const status = this.getVisibleCellStatus(row, projectId);
        const type = this.getVisibleCellType(row, projectId);
        const timeText = this.getCellTimeText(row, projectId);
        const parts = [
            row && row.dateLabel ? row.dateLabel : "",
            project && project.name ? project.name : "프로젝트",
            this.getCellPreviewTitle(row, projectId),
            status,
            type,
            this.getCellDependencySearchText(row, projectId),
            timeText
        ].filter(part => String(part || "").trim().length > 0);
        return `${parts.join(" ")} 상세 편집`;
    }

    public getCellPreviewTooltip(row: any, project: any) {
        const projectId = project && project.id ? project.id : "";
        const status = this.getVisibleCellStatus(row, projectId);
        const type = this.getVisibleCellType(row, projectId);
        const timeText = this.getCellTimeText(row, projectId);
        const state = this.getCellDependencyState(row, projectId);
        const dependencyText = this.getCellDependencySummary(row, projectId, state.issues);
        const summary = [status, type, state.label, timeText].filter(part => !!part).join(" · ");
        const body = this.getCellText(row, projectId);
        return [project && project.name ? project.name : "", summary, dependencyText, body].filter(part => !!part).join("\n");
    }

    public getVisibleRowFilterContext() {
        const prefs = normalizeViewPrefs(this.viewPrefs);
        const filters = prefs.filters || {};
        const selectedProjectId = this.selectedProjectId;
        const selectedProject = selectedProjectId
            ? this.visibleProjects.find(project => project.id === selectedProjectId) || null
            : null;
        const group = this.getFilterProjectGroup(filters.groupId);
        const quickView = normalizeScheduleQuickViewKey(filters.quickView);
        const dateScope = this.normalizeQuickViewDateScope(filters.dateScope);
        const ownerOnly = filters.ownerOnly === true;
        const favoriteOnly = filters.favoriteOnly === true && this.hasFavoriteProjects;
        const milestoneOnly = filters.milestoneOnly === true && this.hasMilestones;
        let projectIds = this.getFilterProjectIds(selectedProject, group, favoriteOnly);
        if (ownerOnly) projectIds = this.getMyAssignedProjectIds(projectIds);
        const todayKey = this.todayKey();
        const weekStartKey = getKoreaWeekStartKey(todayKey);

        return {
            keyword: this.normalizeSearchKeyword(this.searchText),
            quickView,
            dateScope,
            ownerOnly,
            todayKey,
            weekStartKey,
            selectedProject,
            favoriteOnly,
            milestoneOnly,
            group,
            groupId: group ? group.id : "",
            projectIds,
            status: this.normalizeFilterOption(filters.status, this.cellStatusOptions),
            type: this.normalizeFilterOption(filters.type, this.cellTypeOptions),
            hideWeekends: prefs.options.showWeekends === false,
            hideEmptyRows: prefs.options.showEmptyRows === false || prefs.filters.hideEmptyRows === true
        };
    }

    public getFilterProjectGroup(groupId: any) {
        const id = String(groupId || "").trim();
        if (!id) return null;
        return this.visibleProjectGroupsWithUngrouped.find(group => group && group.id === id) || null;
    }

    public getFilterProjectIds(project: any, group: any, favoriteOnly: boolean = false) {
        const allProjectIds = this.visibleProjects
            .map(item => item && item.id ? item.id : "")
            .filter(id => id.length > 0);
        let groupProjectIds = group ? this.getVisibleGroupProjectIds(group) : allProjectIds;
        if (favoriteOnly) {
            groupProjectIds = groupProjectIds.filter(projectId => this.isFavoriteProject(this.findProjectById(projectId)));
        }
        if (!project || !project.id) return groupProjectIds;
        return groupProjectIds.indexOf(project.id) >= 0 ? [project.id] : [];
    }

    public normalizeFilterOption(value: any, options: string[]) {
        const text = String(value || "").trim();
        return options.indexOf(text) >= 0 ? text : "";
    }

    public matchesVisibleRow(row: any, context: any) {
        if (!row) return false;
        if (!this.matchesQuickViewDateScope(row, context)) return false;
        if (context.hideWeekends && row.isWeekend === true) return false;
        if (context.milestoneOnly) {
            const matchingMilestones = this.getVisibleMilestonesForRow(row, context)
                .filter(milestone => this.milestoneMatchesKeyword(milestone, context.keyword));
            if (matchingMilestones.length === 0) return false;
        }
        if (!this.matchesRowFilters(row, context.keyword, context.selectedProject, context)) return false;
        if (context.hideEmptyRows && this.isVisibleRowEmpty(row, context)) return false;
        return true;
    }

    public isVisibleRowEmpty(row: any, context: any) {
        const hasEntry = this.getFilterCandidateProjects(context)
            .some(project => this.rowProjectMatchesEntryFilters(row, project, context));
        if (hasEntry) return false;
        if (this.getVisibleMilestonesForRow(row, context).length > 0) return false;

        const hasScopedEntryFilter = !!(context.selectedProject || context.favoriteOnly || context.ownerOnly || context.groupId || context.status || context.type || context.milestoneOnly);
        if (hasScopedEntryFilter) return true;

        return String(row && row.note ? row.note : "").trim().length === 0;
    }

    public getFilterCandidateProjects(context: any) {
        const ids = context && Array.isArray(context.projectIds)
            ? context.projectIds
            : this.visibleProjects.map(project => project && project.id ? project.id : "");
        const idSet: any = {};
        ids.forEach((id: any) => {
            const key = String(id || "").trim();
            if (key) idSet[key] = true;
        });
        return this.visibleProjects.filter(project => project && idSet[project.id] === true);
    }

    public rowProjectMatchesEntryFilters(row: any, project: any, context: any) {
        if (!row || !this.isProjectVisible(project) || !this.hasCellContent(row, project.id)) return false;
        if (context.status && this.getVisibleCellStatus(row, project.id) !== context.status) return false;
        if (context.type && this.getVisibleCellType(row, project.id) !== context.type) return false;
        return true;
    }

    public shouldDimCompletedCell(row: any, projectId: string) {
        return this.dimCompletedEntriesOption && this.isCompletedScheduleEntry(row, projectId);
    }

    public isCompletedScheduleEntry(row: any, projectId: string) {
        if (!this.hasCellContent(row, projectId)) return false;
        return this.getCellMeta(row, projectId).status === "완료";
    }

    public getHolidayInfo(row: any): CalendarHolidayInfo {
        const dateKey = row && row.date ? row.date : "";
        if (!dateKey) return getCalendarHolidayInfo("");
        if (!this.holidayInfoCache[dateKey]) {
            this.holidayInfoCache[dateKey] = getCalendarHolidayInfo(dateKey);
        }
        return this.holidayInfoCache[dateKey];
    }

    public getHolidayClassName(row: any) {
        return this.getHolidayInfo(row).className;
    }

    public isHoliday(row: any) {
        return this.getHolidayInfo(row).isHoliday;
    }

    public isSubstituteHoliday(row: any) {
        return this.getHolidayInfo(row).isSubstitute;
    }

    public getHolidayBadge(row: any) {
        return this.getHolidayInfo(row).badge;
    }

    public getHolidayTitle(row: any) {
        return this.getHolidayInfo(row).title;
    }

    public getHolidayAriaLabel(row: any) {
        return this.getHolidayInfo(row).ariaLabel;
    }

    public matchesRowFilters(row: any, keyword: string, project: any, context: any = null) {
        if (!row) return false;
        const filterContext = context || {
            selectedProject: project,
            projectIds: project && project.id ? [project.id] : this.visibleProjects.map(item => item.id),
            status: "",
            type: "",
            groupId: "",
            favoriteOnly: false,
            ownerOnly: false,
            milestoneOnly: false
        };
        const candidateProjects = this.getFilterCandidateProjects(filterContext);
        const matchingProjects = candidateProjects.filter(item => this.rowProjectMatchesEntryFilters(row, item, filterContext));
        const matchingMilestones = this.getVisibleMilestonesForRow(row, filterContext)
            .filter(milestone => this.milestoneMatchesKeyword(milestone, keyword));
        const hasScopedEntryFilter = !!(project || filterContext.favoriteOnly || filterContext.ownerOnly || filterContext.groupId || filterContext.status || filterContext.type || filterContext.milestoneOnly);

        if (filterContext.milestoneOnly) return matchingMilestones.length > 0;

        if (hasScopedEntryFilter) {
            if (matchingProjects.length === 0 && matchingMilestones.length === 0) return false;
            if (!keyword) return true;
            if (this.includesKeyword(row.note, keyword)) return true;
            if (matchingMilestones.length > 0) return true;
            return matchingProjects.some(item => {
                const cellText = this.getCellText(row, item.id);
                const dependencyText = this.getCellDependencySearchText(row, item.id);
                const baseMatches = this.includesKeyword(cellText, keyword) || this.includesKeyword(item.name, keyword);
                return baseMatches || this.includesKeyword(dependencyText, keyword);
            });
        }

        if (!keyword) return true;
        if (this.includesKeyword(row.note, keyword)) return true;
        if (matchingMilestones.length > 0) return true;
        return candidateProjects.some(item => {
            if (!this.hasCellContent(row, item.id)) return false;
            const cellText = this.getCellText(row, item.id);
            const dependencyText = this.getCellDependencySearchText(row, item.id);
            const baseMatches = this.includesKeyword(cellText, keyword) || this.includesKeyword(item.name, keyword);
            return baseMatches || this.includesKeyword(dependencyText, keyword);
        });
    }

    public refreshMetrics() {
        const counts: any = {};
        this.projects.forEach(project => counts[project.id] = 0);

        this.filledEntryCount = this.rows.reduce((total, row) => {
            const noteCount = String(row.note || "").trim().length > 0 ? 1 : 0;
            const cellCount = this.projects.filter(project => {
                const hasValue = this.hasCellContent(row, project.id);
                if (hasValue) counts[project.id] = (counts[project.id] || 0) + 1;
                return hasValue;
            }).length;
            return total + noteCount + cellCount;
        }, 0);
        this.projectScheduleCounts = counts;
    }

    public get selectedProjectColor() {
        return this.newProjectColor || this.getNextProjectColor();
    }

    public get selectedNewGroupColor() {
        return this.newGroupColor || this.getNextGroupColor();
    }

    public get projectGroupAssignmentOptions() {
        return [{
            id: UNGROUPED_PROJECT_GROUP_ID,
            name: "미분류"
        }].concat(this.projectGroups.map(group => ({
            id: group.id,
            name: group.name || "프로젝트 그룹"
        })));
    }

    public get ungroupedProjectCount() {
        const group = this.scheduleProjectGroupsWithUngrouped.find(item => item.id === UNGROUPED_PROJECT_GROUP_ID);
        return group && Array.isArray(group.projectIds) ? group.projectIds.length : 0;
    }

    public get scheduledProjectCount() {
        return this.projects.filter(project => this.getProjectScheduleCount(project) > 0).length;
    }

    public getNextProjectColor() {
        const usedColors = this.projects.map(project => project.color);
        const unusedColor = this.palette.find(color => usedColors.indexOf(color) < 0);
        return unusedColor || this.palette[this.projects.length % this.palette.length];
    }

    public getNextGroupColor() {
        const usedColors = this.projectGroups.map(group => group.color);
        const unusedColor = this.palette.find(color => usedColors.indexOf(color) < 0);
        return unusedColor || this.palette[this.projectGroups.length % this.palette.length] || DEFAULT_PROJECT_GROUP_COLOR;
    }

    public normalizeProjectName(value: any) {
        return String(value || "").trim().replace(/\s+/g, " ").toLowerCase();
    }

    public countProjectSchedules(project: any) {
        if (!project || !project.id) return 0;
        return this.rows.filter(row => this.hasCellContent(row, project.id)).length;
    }

    public getProjectScheduleCount(project: any) {
        if (!project || !project.id) return 0;
        return this.projectScheduleCounts[project.id] || 0;
    }

    public getCellText(row: any, projectId: string) {
        return this.getCellValue(row, projectId).trim();
    }

    public getCellValue(row: any, projectId: string) {
        const cells = row && row.cells ? row.cells : {};
        return this.extractCellMemo(cells[projectId]);
    }

    public extractCellMemo(value: any) {
        if (value && typeof value === "object" && !Array.isArray(value)) {
            if (value.memo !== undefined && value.memo !== null) return String(value.memo);
            if (value.value !== undefined && value.value !== null) return String(value.value);
            if (value.body !== undefined && value.body !== null) return String(value.body);
            return "";
        }
        return value === undefined || value === null ? "" : String(value);
    }

    public hasCellContent(row: any, projectId: string) {
        return this.getCellText(row, projectId).length > 0 || this.hasExplicitCellMeta(row, projectId);
    }

    public hasExplicitCellMeta(row: any, projectId: string) {
        return !this.isDefaultCellMeta(this.getCellMeta(row, projectId));
    }

    public getCellMeta(row: any, projectId: string) {
        const cells = row && row.cells ? row.cells : {};
        const metaMap = row && row.cellMeta ? row.cellMeta : {};
        return this.normalizeCellMeta(cells[projectId], metaMap[projectId]);
    }

    public getVisibleCellStatus(row: any, projectId: string) {
        const status = this.getCellMeta(row, projectId).status;
        return status !== this.defaultCellStatus ? status : "";
    }

    public getVisibleCellType(row: any, projectId: string) {
        const type = this.getCellMeta(row, projectId).type;
        return type !== this.defaultCellType ? type : "";
    }

    public shouldShowCellStatusBadge(row: any, projectId: string) {
        return this.getVisibleCellStatus(row, projectId).length > 0;
    }

    public shouldShowCellTypeBadge(row: any, projectId: string) {
        return this.getVisibleCellType(row, projectId).length > 0;
    }

    public normalizeCellMeta(rawCell: any, rawMeta: any = null) {
        const cell = rawCell && typeof rawCell === "object" && !Array.isArray(rawCell) ? rawCell : {};
        const meta = rawMeta && typeof rawMeta === "object" && !Array.isArray(rawMeta) ? rawMeta : {};
        const statusSource = meta.status !== undefined ? meta.status : (cell.taskStatus !== undefined ? cell.taskStatus : cell.status);
        const typeSource = meta.type !== undefined ? meta.type : (
            meta.entryType !== undefined ? meta.entryType : (
                meta.entry_type !== undefined ? meta.entry_type : (
                    cell.type !== undefined ? cell.type : (
                        cell.entryType !== undefined ? cell.entryType : cell.entry_type
                    )
                )
            )
        );
        const dependencySource = meta.dependencies !== undefined ? meta.dependencies : (
            cell.dependencies !== undefined ? cell.dependencies : (
                meta.predecessors !== undefined || meta.successors !== undefined || meta.predecessor !== undefined || meta.successor !== undefined
                    ? meta
                    : cell
            )
        );
        const timeSource = meta.time !== undefined ? meta.time : (
            meta.scheduleTime !== undefined ? meta.scheduleTime : (
                meta.schedule_time !== undefined ? meta.schedule_time : (
                    cell.time !== undefined ? cell.time : (
                        cell.scheduleTime !== undefined ? cell.scheduleTime : cell.schedule_time
                    )
                )
            )
        );
        return {
            status: this.normalizeCellStatus(statusSource),
            type: this.normalizeCellType(typeSource),
            time: this.normalizeCellTime(timeSource),
            dependencies: this.normalizeCellDependencies(dependencySource)
        };
    }

    public normalizeCellDependencies(input: any = {}) {
        const source = input && typeof input === "object" && !Array.isArray(input) ? input : {};
        return {
            predecessors: this.normalizeCellDependencyList(
                source.predecessors !== undefined
                    ? source.predecessors
                    : (source.predecessor !== undefined ? source.predecessor : this.createLegacyCellDependencySource(source, "predecessor"))
            ),
            successors: this.normalizeCellDependencyList(
                source.successors !== undefined
                    ? source.successors
                    : (source.successor !== undefined ? source.successor : this.createLegacyCellDependencySource(source, "successor"))
            )
        };
    }

    public createLegacyCellDependencySource(source: any, prefix: string) {
        if (!source || typeof source !== "object") return [];
        const date = source[`${prefix}Date`] || source[`${prefix}_date`] || "";
        const projectId = source[`${prefix}ProjectId`] || source[`${prefix}_project_id`] || "";
        return date || projectId ? [{ date, projectId }] : [];
    }

    public normalizeCellDependencyList(input: any) {
        const list = Array.isArray(input) ? input : (input ? [input] : []);
        const seen: any = {};
        return list
            .map(item => this.normalizeCellDependencyRef(item))
            .filter(item => {
                if (!item) return false;
                const key = `${item.date}::${item.projectId}`;
                if (seen[key]) return false;
                seen[key] = true;
                return true;
            });
    }

    public normalizeCellDependencyRef(input: any) {
        const source = input && typeof input === "object" && !Array.isArray(input) ? input : {};
        const date = String(source.date || source.targetDate || source.dateKey || "").trim();
        const projectId = String(source.projectId || source.project_id || source.targetProjectId || source.target_project_id || "").trim();
        if (!this.isValidDate(date) || !projectId) return null;
        return { date, projectId };
    }

    public normalizeCellStatus(value: any) {
        const text = String(value || "").trim();
        return this.cellStatusOptions.indexOf(text) >= 0 ? text : this.defaultCellStatus;
    }

    public normalizeCellType(value: any) {
        const text = String(value || "").trim();
        return this.cellTypeOptions.indexOf(text) >= 0 ? text : this.defaultCellType;
    }

    public normalizeCellTime(value: any) {
        const text = String(value || "").trim();
        if (!text) return "";
        const match = text.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
        if (!match) return "";
        const hour = Number(match[1]);
        const minute = Number(match[2]);
        if (!Number.isFinite(hour) || !Number.isFinite(minute) || hour < 0 || hour > 23 || minute < 0 || minute > 59) return "";
        return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
    }

    public isDefaultCellMeta(meta: any) {
        const status = meta && meta.status ? meta.status : this.defaultCellStatus;
        const type = meta && meta.type ? meta.type : this.defaultCellType;
        const time = this.normalizeCellTime(meta && meta.time ? meta.time : "");
        const dependencies = this.normalizeCellDependencies(meta && meta.dependencies ? meta.dependencies : {});
        return status === this.defaultCellStatus && type === this.defaultCellType && !time && !this.hasCellDependencies(dependencies);
    }

    public setCellMeta(row: any, projectId: string, status: any, type: any, dependencies: any = {}, time: any = "") {
        if (!row.cellMeta) row.cellMeta = {};
        const normalizedDependencies = this.normalizeCellDependencies(dependencies);
        const normalizedTime = this.normalizeCellTime(time);
        const normalizedStatus = this.normalizeCellStatus(status);
        const normalizedType = this.normalizeCellType(type);
        const meta = {
            status: normalizedStatus,
            type: normalizedType,
            time: normalizedTime,
            dependencies: normalizedDependencies
        };
        if (normalizedStatus === this.defaultCellStatus) delete meta.status;
        if (normalizedType === this.defaultCellType) delete meta.type;
        if (!normalizedTime) delete meta.time;
        if (!this.hasCellDependencies(normalizedDependencies)) delete meta.dependencies;
        if (this.isDefaultCellMeta(meta)) {
            delete row.cellMeta[projectId];
            return;
        }
        row.cellMeta[projectId] = meta;
    }

    public hasCellDependencies(dependencies: any) {
        const normalized = this.normalizeCellDependencies(dependencies);
        return normalized.predecessors.length > 0 || normalized.successors.length > 0;
    }

    public getFirstCellDependency(dependencies: any, key: string) {
        const normalized = this.normalizeCellDependencies(dependencies);
        const list = key === "successors" ? normalized.successors : normalized.predecessors;
        return list.length > 0 ? list[0] : null;
    }

    public createCellDependenciesSignature(dependencies: any) {
        return JSON.stringify(this.normalizeCellDependencies(dependencies));
    }

    public createSelectedCellDependenciesFromDraft(row: any, project: any) {
        const predecessors: any[] = [];
        const successors: any[] = [];
        const predecessor = this.createDraftDependencyRef(this.selectedCellPredecessorDate, this.selectedCellPredecessorProjectId, "선행", row, project);
        if (!predecessor.valid) return predecessor;
        if (predecessor.ref) predecessors.push(predecessor.ref);

        const successor = this.createDraftDependencyRef(this.selectedCellSuccessorDate, this.selectedCellSuccessorProjectId, "후속", row, project);
        if (!successor.valid) return successor;
        if (successor.ref) successors.push(successor.ref);

        return {
            valid: true,
            dependencies: this.normalizeCellDependencies({ predecessors, successors }),
            message: ""
        };
    }

    public createDraftDependencyRef(dateValue: any, projectIdValue: any, label: string, row: any, project: any) {
        const date = String(dateValue || "").trim();
        const projectId = String(projectIdValue || "").trim();
        if (!date && !projectId) return { valid: true, ref: null, message: "" };
        if (!this.isValidDate(date) || !projectId) {
            return { valid: false, ref: null, message: `${label} 일정은 날짜와 프로젝트를 함께 선택해 주세요.` };
        }
        if (!this.findProjectById(projectId)) {
            return { valid: false, ref: null, message: `${label} 일정 프로젝트를 찾을 수 없습니다.` };
        }
        if (row && project && row.date === date && project.id === projectId) {
            return { valid: false, ref: null, message: "자기 자신은 의존성으로 지정할 수 없습니다." };
        }
        return { valid: true, ref: { date, projectId }, message: "" };
    }

    public removeCellDependenciesForProject(row: any, removedProjectId: string) {
        if (!row || !row.cellMeta || !removedProjectId) return;
        Object.keys(row.cellMeta).forEach(projectId => {
            const meta = this.getCellMeta(row, projectId);
            const dependencies = this.normalizeCellDependencies(meta.dependencies);
            const nextDependencies = {
                predecessors: dependencies.predecessors.filter((item: any) => item.projectId !== removedProjectId),
                successors: dependencies.successors.filter((item: any) => item.projectId !== removedProjectId)
            };
            if (this.createCellDependenciesSignature(dependencies) === this.createCellDependenciesSignature(nextDependencies)) return;
            this.setCellMeta(row, projectId, meta.status, meta.type, nextDependencies, meta.time);
        });
    }

    public getCellDependencyState(row: any, projectId: string) {
        const meta = this.getCellMeta(row, projectId);
        const dependencies = this.normalizeCellDependencies(meta.dependencies);
        const count = dependencies.predecessors.length + dependencies.successors.length;
        if (count === 0) {
            return { severity: "none", label: "", title: "", count, issues: [] };
        }

        const issues: any[] = [];
        const today = this.todayKey();
        dependencies.predecessors.forEach((dependency: any) => {
            const dependencyProject = this.findProjectById(dependency.projectId);
            const dependencyRow = this.findRowByDate(dependency.date);
            if (!dependencyProject || !dependencyRow) {
                issues.push({ severity: "risk", label: "선행 누락", ref: dependency });
                return;
            }
            if (row && row.date && dependency.date > row.date) {
                issues.push({ severity: "delay", label: "선행 날짜 충돌", ref: dependency });
            }
            const dependencyMeta = this.getCellMeta(dependencyRow, dependency.projectId);
            if (dependencyMeta.status === "지연") {
                issues.push({ severity: "delay", label: "선행 지연", ref: dependency });
            } else if (dependency.date <= today && dependencyMeta.status !== "완료") {
                issues.push({ severity: "risk", label: "선행 미완료", ref: dependency });
            }
        });
        dependencies.successors.forEach((dependency: any) => {
            const dependencyProject = this.findProjectById(dependency.projectId);
            const dependencyRow = this.findRowByDate(dependency.date);
            if (!dependencyProject || !dependencyRow) {
                issues.push({ severity: "risk", label: "후속 누락", ref: dependency });
                return;
            }
            if (row && row.date && dependency.date < row.date) {
                issues.push({ severity: "delay", label: "후속 날짜 충돌", ref: dependency });
            }
        });

        const hasDelay = issues.some(issue => issue.severity === "delay");
        const hasRisk = issues.some(issue => issue.severity === "risk");
        const severity = hasDelay ? "delay" : (hasRisk ? "risk" : "linked");
        const label = severity === "delay" ? "지연 위험" : (severity === "risk" ? "위험" : "의존");
        return {
            severity,
            label,
            title: this.getCellDependencySummary(row, projectId, issues),
            count,
            issues
        };
    }

    public hasCellDependencyDelay(row: any, projectId: string) {
        return this.getCellDependencyState(row, projectId).severity === "delay";
    }

    public hasCellDependencyRisk(row: any, projectId: string) {
        const severity = this.getCellDependencyState(row, projectId).severity;
        return severity === "delay" || severity === "risk";
    }

    public getCellDependencyBadgeLabel(row: any, projectId: string) {
        return this.getCellDependencyState(row, projectId).label;
    }

    public getCellDependencySummary(row: any, projectId: string, issues: any[] = []) {
        const meta = this.getCellMeta(row, projectId);
        const dependencies = this.normalizeCellDependencies(meta.dependencies);
        const predecessorText = dependencies.predecessors.map((item: any) => this.formatDependencyRef(item)).join(", ");
        const successorText = dependencies.successors.map((item: any) => this.formatDependencyRef(item)).join(", ");
        const issueText = issues.length > 0 ? issues.map(issue => issue.label).filter((item, index, items) => items.indexOf(item) === index).join(", ") : "";
        return [
            predecessorText ? `선행: ${predecessorText}` : "",
            successorText ? `후속: ${successorText}` : "",
            issueText ? `상태: ${issueText}` : ""
        ].filter(part => part.length > 0).join(" · ");
    }

    public formatDependencyRef(ref: any) {
        if (!ref) return "";
        const project = this.findProjectById(ref.projectId);
        const projectName = project && project.name ? project.name : ref.projectId;
        return `${ref.date} ${projectName}`;
    }

    public getCellDependencySearchText(row: any, projectId: string) {
        const state = this.getCellDependencyState(row, projectId);
        if (state.severity === "none") return "";
        return ["의존성", state.label, state.title].filter(part => !!part).join(" ");
    }

    public getSelectedCellDependencySummary() {
        if (!this.selectedCell) return "";
        const row = this.findRowById(this.selectedCell.rowId);
        if (!row) return "";
        const state = this.getCellDependencyState(row, this.selectedCell.projectId);
        return state.severity === "none" ? "의존성 없음" : state.title;
    }

    public getRowGroupDependencyAlertCount(row: any, group: any) {
        const projectIds = this.getFilteredGroupProjectIds(group);
        return projectIds.filter(projectId => this.hasCellDependencyRisk(row, projectId)).length;
    }

    public getRowGroupDependencyAlertText(row: any, group: any) {
        return `의존성 위험 ${this.getRowGroupDependencyAlertCount(row, group)}개`;
    }

    public getProjectDependencyAlertCount(project: any) {
        if (!project || !project.id) return 0;
        return this.rows.filter(row => this.hasCellDependencyRisk(row, project.id)).length;
    }

    public getProjectDependencyAlertText(project: any) {
        const projectName = project && project.name ? project.name : "프로젝트";
        return `${projectName} 의존성 위험 ${this.getProjectDependencyAlertCount(project)}건`;
    }

    public getDependencyAlertCount(rows: any[] = this.rows, projects: any[] = this.visibleProjects) {
        return (rows || []).reduce((total, row) => {
            return total + (projects || []).filter(project => project && this.hasCellDependencyRisk(row, project.id)).length;
        }, 0);
    }

    public getDependencyExportText(row: any, projects: any[]) {
        return (projects || [])
            .map(project => {
                if (!project || !project.id) return "";
                const state = this.getCellDependencyState(row, project.id);
                if (state.severity === "none") return "";
                const projectName = project.name || project.id;
                const label = state.label ? `[${state.label}] ` : "";
                return `${projectName}: ${label}${state.title}`;
            })
            .filter(part => part.length > 0)
            .join("; ");
    }

    public normalizeSearchKeyword(value: any) {
        return String(value || "").trim().toLowerCase();
    }

    public includesKeyword(value: any, keyword: string) {
        if (!keyword) return true;
        return String(value || "").toLowerCase().indexOf(keyword) >= 0;
    }

    public numberOrDefault(value: any, fallback: number) {
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? numberValue : fallback;
    }

    public clampNumber(value: number, min: number, max: number) {
        if (max < min) return min;
        return Math.min(Math.max(value, min), max);
    }

    public setProjectFeedback(message: string, status: string) {
        this.projectFormMessage = message;
        this.projectFormStatus = status;
    }

    public makeId(prefix: string) {
        return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    public todayKey() {
        return getKoreaDateKey(new Date());
    }

    public parseDate(value: string) {
        const parts = value.split("-").map(part => parseInt(part, 10));
        return new Date(parts[0], parts[1] - 1, parts[2]);
    }

    public isValidDate(value: any) {
        if (typeof value !== "string") return false;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
        const date = this.parseDate(value);
        return this.formatDate(date) === value;
    }

    public createDateSet(rows: any[]) {
        const seenDates: any = {};
        rows.forEach(row => {
            if (row && row.date) seenDates[row.date] = true;
        });
        return seenDates;
    }

    public addDays(date: Date, amount: number) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
    }

    public formatDate(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    public formatDisplayDate(date: Date) {
        return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
    }

    public getWeekday(date: Date) {
        return ["일", "월", "화", "수", "목", "금", "토"][date.getDay()];
    }
}

export default PageCalenderComponent;